var ob = Object.defineProperty;
var ab = (e, r, t) => r in e ? ob(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t;
var ne = (e, r, t) => ab(e, typeof r != "symbol" ? r + "" : r, t);
import { jsx as S, jsxs as K, Fragment as Wu } from "react/jsx-runtime";
import * as U from "react";
import A, { memo as Vr, forwardRef as ot, useState as Se, useRef as ye, useEffect as Ye, useCallback as se, useLayoutEffect as Ga, useMemo as Ve, createContext as Ya, useContext as $o, Component as bt, Fragment as Yi, useId as Bu, Children as bp, useReducer as yp, isValidElement as ib, cloneElement as Vu, useImperativeHandle as wp, createRef as kn, createElement as sb } from "react";
import { Button as Pt, IconButton as Zn, FormControl as to, FormLabel as ro, InputGroup as no, InputLeftElement as Cp, Text as gt, Input as Ha, Textarea as lb, InputRightAddon as ub, FormHelperText as oo, Tooltip as cb, Flex as Rt, Tag as db, TagLabel as fb, Box as je, Icon as Bn, InputRightElement as Sp, Menu as Po, MenuButton as Ro, MenuList as Oo, MenuItem as To, useToast as pb, Progress as hb, Alert as gb, AlertIcon as mb, SimpleGrid as xp, RadioGroup as vb, Stack as bb, Radio as yb, Heading as wb, Modal as Ip, ModalOverlay as Dp, ModalContent as _p, ModalHeader as Cb, ModalCloseButton as kp, ModalBody as Ep, ModalFooter as Sb, useMediaQuery as xb, Tbody as Ib, Tr as fl, Td as li, Skeleton as Ca, Checkbox as Kc, Table as Db, Thead as _b, Th as ed, chakra as td, useDisclosure as kb, Image as Eb, keyframes as Mp, Tab as Mb, ChakraProvider as Ab } from "@chakra-ui/react";
import { colors as j, rounded as Is, field as nr, inputWidth as ao, fontWeight as io, fontSize as Xe, requiredAsteriskColor as dn, formColors as Yt, inputHeight as tr, zummaTheme as Pb } from "./theme.js";
import { inputContainerHeight as fF, inputPadding as pF, padding as hF, specialBoxStyles as gF } from "./theme.js";
import { jsx as he, css as Ap, keyframes as Pp, ThemeContext as Rb } from "@emotion/react";
import * as Ob from "react-dom";
import Tb, { createPortal as Fb } from "react-dom";
import rd from "@emotion/styled";
const Dr = {
  size: "sm",
  gap: 2,
  fontSize: {
    base: "0.875rem"
  },
  fontWeight: 600,
  px: {
    base: 3,
    md: 4
  },
  py: {
    base: 2
  }
}, Hi = Vr(
  ot(({ variant: e = "default", ...r }, t) => {
    const n = {
      bg: "rgba(0, 0, 0, 0.04)",
      borderColor: j.text[4],
      color: j.text[2],
      _hover: {
        bg: "rgba(0, 0, 0, 0.08)",
        color: j.text[1]
      },
      _active: {
        bg: "rgba(0, 0, 0, 0.12)"
      }
    }, o = e === "tertiary" ? {
      bg: j.tertiary[3],
      borderColor: j.tertiary[1],
      color: j.text[1],
      _hover: {
        bg: j.tertiary[3],
        color: j.tertiary[1]
      },
      _active: {
        bg: "transparent"
      }
    } : {}, a = e === "dotted" ? {
      borderStyle: "dashed",
      bg: "transparent",
      borderColor: j.text[4],
      color: j.text[2],
      _hover: {
        borderColor: j.text[1]
      },
      _active: {
        bg: "transparent"
      }
    } : {}, i = e === "approve" ? {
      bg: "#48BB78",
      borderColor: "#38A169",
      color: "white",
      _hover: {
        bg: "#38A169",
        color: "white"
      },
      _active: {
        bg: "#2F855A"
      }
    } : {}, s = e === "deny" ? {
      bg: "#F56565",
      borderColor: "#E53E3E",
      color: "white",
      _hover: {
        bg: "#E53E3E",
        color: "white"
      },
      _active: {
        bg: "#C53030"
      }
    } : {}, l = e === "primary" ? {
      bg: j.primary[2],
      borderColor: j.primary[1],
      color: j.text[1],
      _hover: {
        bg: j.primary[3],
        opacity: 0.9
      },
      _active: {
        bg: j.primary[1],
        opacity: 0.8
      }
    } : {}, u = e === "apply" ? {
      bg: j.apply[2],
      borderColor: j.apply[2],
      color: "white",
      _hover: {
        bg: j.apply[1],
        opacity: 0.9
      },
      _active: {
        bg: j.apply[2],
        opacity: 0.8
      }
    } : {}, c = e === "default" ? n : {};
    return /* @__PURE__ */ S(
      Pt,
      {
        ref: t,
        minWidth: { base: 160 },
        size: Dr.size,
        fontSize: Dr.fontSize,
        fontWeight: Dr.fontWeight,
        px: Dr.px,
        py: Dr.py,
        gap: Dr.gap,
        border: 1.5,
        rounded: "4px",
        transition: "transform 0.1s",
        _focusVisible: { ring: 0.4 },
        ...n,
        ...c,
        ...o,
        ...a,
        ...i,
        ...s,
        ...l,
        ...u,
        ...r
      }
    );
  })
);
Hi.displayName = "Button";
const Nb = Vr(
  ot(({ variant: e = "default", ...r }, t) => {
    const n = {
      bg: "rgba(0, 0, 0, 0.04)",
      borderColor: j.text[4],
      color: j.text[2],
      _hover: {
        bg: "rgba(0, 0, 0, 0.08)",
        color: j.text[1]
      },
      _active: {
        bg: "rgba(0, 0, 0, 0.12)"
      }
    }, o = e === "tertiary" ? {
      bg: j.tertiary[2],
      borderColor: j.tertiary[1],
      color: j.text[1],
      _hover: {
        bg: j.tertiary[3],
        opacity: 0.9
      },
      _active: {
        bg: j.tertiary[1],
        opacity: 0.8
      }
    } : {}, a = e === "primary" ? {
      bg: j.primary[2],
      borderColor: j.primary[1],
      color: j.text[1],
      _hover: {
        bg: j.primary[3],
        opacity: 0.9
      },
      _active: {
        bg: j.primary[1],
        opacity: 0.8
      }
    } : {}, i = e === "deny" ? {
      bg: "#F56565",
      borderColor: "#E53E3E",
      color: "white",
      _hover: {
        bg: "#E53E3E",
        color: "white"
      },
      _active: {
        bg: "#C53030"
      }
    } : {}, s = e === "apply" ? {
      bg: j.apply[2],
      borderColor: j.apply[2],
      color: "white",
      _hover: {
        bg: j.apply[1],
        opacity: 0.9
      },
      _active: {
        bg: j.apply[2],
        opacity: 0.8
      }
    } : {};
    return /* @__PURE__ */ S(
      Zn,
      {
        ref: t,
        maxWidth: { sm: "fit-content" },
        size: Dr.size,
        fontSize: Dr.fontSize,
        fontWeight: Dr.fontWeight,
        py: Dr.py,
        border: 1.5,
        rounded: Is.button,
        transition: "transform 0.1s",
        _focusVisible: { ring: 0.4 },
        ...n,
        ...o,
        ...a,
        ...i,
        ...s,
        ...r
      }
    );
  })
);
Nb.displayName = "IconButton";
var Rp = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, nd = A.createContext && /* @__PURE__ */ A.createContext(Rp), Lb = ["attr", "size", "title"];
function Wb(e, r) {
  if (e == null) return {};
  var t, n, o = Bb(e, r);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function Bb(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.indexOf(n) !== -1) continue;
    t[n] = e[n];
  }
  return t;
}
function zi() {
  return zi = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, zi.apply(null, arguments);
}
function od(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function $i(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? od(Object(t), !0).forEach(function(n) {
      Vb(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : od(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Vb(e, r, t) {
  return (r = Gb(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Gb(e) {
  var r = Yb(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Yb(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (typeof n != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Op(e) {
  return e && e.map((r, t) => /* @__PURE__ */ A.createElement(r.tag, $i({
    key: t
  }, r.attr), Op(r.child)));
}
function lr(e) {
  return (r) => /* @__PURE__ */ A.createElement(Hb, zi({
    attr: $i({}, e.attr)
  }, r), Op(e.child));
}
function Hb(e) {
  var r = (t) => {
    var {
      attr: n,
      size: o,
      title: a
    } = e, i = Wb(e, Lb), s = o || t.size || "1em", l;
    return t.className && (l = t.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ A.createElement("svg", zi({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, t.attr, n, i, {
      className: l,
      style: $i($i({
        color: e.color || t.color
      }, t.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), a && /* @__PURE__ */ A.createElement("title", null, a), e.children);
  };
  return nd !== void 0 ? /* @__PURE__ */ A.createElement(nd.Consumer, null, (t) => r(t)) : r(Rp);
}
function Tp(e) {
  return lr({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M313.941 216H12c-6.627 0-12 5.373-12 12v56c0 6.627 5.373 12 12 12h301.941v46.059c0 21.382 25.851 32.09 40.971 16.971l86.059-86.059c9.373-9.373 9.373-24.569 0-33.941l-86.059-86.059c-15.119-15.119-40.971-4.411-40.971 16.971V216z" }, child: [] }] })(e);
}
function Fp(e) {
  return lr({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M134.059 296H436c6.627 0 12-5.373 12-12v-56c0-6.627-5.373-12-12-12H134.059v-46.059c0-21.382-25.851-32.09-40.971-16.971L7.029 239.029c-9.373 9.373-9.373 24.569 0 33.941l86.059 86.059c15.119 15.119 40.971 4.411 40.971-16.971V296z" }, child: [] }] })(e);
}
function zb(e) {
  return lr({ attr: { viewBox: "0 0 576 512" }, child: [{ tag: "path", attr: { d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" }, child: [] }] })(e);
}
function Np(e) {
  return lr({ attr: { viewBox: "0 0 448 512" }, child: [{ tag: "path", attr: { d: "M12 192h424c6.6 0 12 5.4 12 12v260c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V204c0-6.6 5.4-12 12-12zm436-44v-36c0-26.5-21.5-48-48-48h-48V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H160V12c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v52H48C21.5 64 0 85.5 0 112v36c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12z" }, child: [] }] })(e);
}
const JT = ({ placeholder: e, size: r = "md", addClass: t, type: n = "text", name: o, helperText: a, label: i, id: s, leftChildren: l, rightChildren: u, isDisabled: c, onChange: d, isInvalid: f = !1, value: p, onFocus: h, onBlur: g, limit: m, isReadOnly: v, isRequired: y, onKeyDownCapture: C, trimOnChange: I, ariaDescribedBy: b }) => {
  const [D, x] = Se(!1), _ = n === "currency", E = _ ? "number" : n, R = (L) => {
    m && L.target.value.length > m || (I && (L.target.value = L.target.value.trim()), d && d(L));
  };
  return /* @__PURE__ */ K(
    to,
    {
      width: ao,
      minH: nr.inputContainerHeight,
      id: s,
      isDisabled: c,
      isInvalid: f,
      children: [
        /* @__PURE__ */ K(
          ro,
          {
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            children: [
              i,
              " ",
              y ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ K(
          no,
          {
            maxH: "100%",
            padding: 0,
            children: [
              (l || _) && /* @__PURE__ */ S(
                Cp,
                {
                  maxH: "100%",
                  pointerEvents: "none",
                  padding: 0,
                  children: l || /* @__PURE__ */ S(
                    gt,
                    {
                      maxH: "100%",
                      padding: 0,
                      color: j.neutralDark,
                      fontSize: Xe.input,
                      fontWeight: "normal",
                      children: "$"
                    }
                  )
                }
              ),
              ["text", "number", "password", "currency"].includes(n) ? /* @__PURE__ */ S(
                Ha,
                {
                  onKeyDownCapture: C,
                  height: tr,
                  isReadOnly: v,
                  isInvalid: f,
                  id: s,
                  value: p ?? "",
                  size: r,
                  name: o,
                  errorBorderColor: Yt.error.border,
                  focusBorderColor: Yt.default.focus.border,
                  className: t,
                  placeholder: e,
                  type: n === "password" ? D ? "text" : "password" : E,
                  isDisabled: c,
                  onChange: R,
                  onFocus: h,
                  onBlur: g,
                  "aria-describedby": b,
                  _focus: {
                    borderColor: "none"
                  }
                }
              ) : /* @__PURE__ */ S(
                lb,
                {
                  onKeyDownCapture: C,
                  height: tr,
                  isReadOnly: v,
                  isInvalid: f,
                  id: s,
                  value: p ?? "",
                  name: o,
                  resize: "none",
                  errorBorderColor: Yt.error.border,
                  focusBorderColor: Yt.default.focus.border,
                  className: t,
                  placeholder: e,
                  isDisabled: c,
                  onChange: R,
                  onFocus: h,
                  onBlur: g,
                  _focus: {
                    borderColor: "none"
                  }
                }
              ),
              n === "password" && /* @__PURE__ */ S(
                ub,
                {
                  backgroundColor: D ? Yt.default.hover.backgroundColor : j.gray88,
                  onClick: () => x(!D),
                  p: "0",
                  height: tr,
                  children: /* @__PURE__ */ S(
                    Pt,
                    {
                      borderRightRadius: "sm",
                      borderTopLeftRadius: "none",
                      borderBottomLeftRadius: "none",
                      variant: "solid",
                      height: tr,
                      minHeight: tr,
                      _hover: {
                        backgroundColor: D ? Yt.default.hover.backgroundColor : j.gray88
                      },
                      backgroundColor: D ? Yt.default.hover.backgroundColor : j.gray88,
                      onClick: () => x(!D),
                      children: /* @__PURE__ */ S(zb, {})
                    }
                  )
                }
              ),
              u
            ]
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: a })
      ]
    }
  );
}, QT = ({ placeholder: e = "0.00", size: r = "md", addClass: t, name: n, helperText: o, label: a, id: i, isDisabled: s, onChange: l, isInvalid: u = !1, value: c, onFocus: d, onBlur: f, isReadOnly: p, isRequired: h, currency: g = "$", decimals: m = 2, min: v, max: y, allowNegative: C = !1, ariaDescribedBy: I }) => {
  const [b, D] = Se(""), [x, _] = Se(!1), E = ye(null), R = (P) => {
    if (P === null || isNaN(P)) return "";
    const H = P.toFixed(m).split(".");
    return H[0] = H[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","), H.join(".");
  }, L = (P) => {
    if (!P) return null;
    const B = P.replace(/[^\d.-]/g, "").replace(/(?!^)-/g, "").replace(/\./g, (re, W, F) => F.indexOf(".") === W ? "." : "");
    if (!B || B === "-" || B === ".") return null;
    const H = parseFloat(B);
    return isNaN(H) || !C && H < 0 ? null : v !== void 0 && H < v ? v : y !== void 0 && H > y ? y : H;
  };
  Ye(() => {
    const P = typeof c == "string" ? L(c) : c ?? null;
    x || D(P !== null ? R(P) : "");
  }, [c, x, m]);
  const G = (P) => {
    const B = P.target.value;
    D(B);
    const H = L(B);
    l && l(H);
  }, V = (P) => {
    _(!0);
    const B = L(b);
    B !== null && D(B.toString()), d && d(P);
  }, O = (P) => {
    _(!1);
    const B = L(b);
    D(B !== null ? R(B) : ""), f && f(P);
  }, N = (P) => {
    var H;
    if (!["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight", "Home", "End"].includes(P.key)) {
      if (P.key === "." && m > 0) {
        b.includes(".") && P.preventDefault();
        return;
      }
      if (P.key === "-" && C) {
        (b.includes("-") || (((H = E.current) == null ? void 0 : H.selectionStart) ?? 0) > 0) && P.preventDefault();
        return;
      }
      (P.ctrlKey || P.metaKey) && ["a", "c", "v", "x", "z"].includes(P.key.toLowerCase()) || /^\d$/.test(P.key) || P.preventDefault();
    }
  };
  return /* @__PURE__ */ K(
    to,
    {
      width: ao,
      minH: nr.inputContainerHeight,
      id: i,
      isDisabled: s,
      isInvalid: u,
      children: [
        /* @__PURE__ */ K(
          ro,
          {
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            children: [
              a,
              " ",
              h ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ K(
          no,
          {
            maxH: "100%",
            padding: 0,
            children: [
              /* @__PURE__ */ S(
                Cp,
                {
                  maxH: "100%",
                  pointerEvents: "none",
                  padding: 0,
                  children: /* @__PURE__ */ S(
                    gt,
                    {
                      maxH: "100%",
                      padding: 0,
                      color: j.neutralDark,
                      fontSize: Xe.input,
                      fontWeight: "normal",
                      children: g
                    }
                  )
                }
              ),
              /* @__PURE__ */ S(
                Ha,
                {
                  ref: E,
                  height: tr,
                  isReadOnly: p,
                  isInvalid: u,
                  id: i,
                  value: b,
                  size: r,
                  name: n,
                  errorBorderColor: Yt.error.border,
                  focusBorderColor: Yt.default.focus.border,
                  className: t,
                  placeholder: e,
                  type: "text",
                  inputMode: "decimal",
                  isDisabled: s,
                  onChange: G,
                  onFocus: V,
                  onBlur: O,
                  onKeyDown: N,
                  "aria-describedby": I,
                  _focus: {
                    borderColor: "none"
                  }
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: o })
      ]
    }
  );
};
function Un(e) {
  "@babel/helpers - typeof";
  return Un = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(r) {
    return typeof r;
  } : function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Un(e);
}
function $b(e, r) {
  if (Un(e) != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var n = t.call(e, r);
    if (Un(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
function Lp(e) {
  var r = $b(e, "string");
  return Un(r) == "symbol" ? r : r + "";
}
function So(e, r, t) {
  return (r = Lp(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function ad(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function ce(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? ad(Object(t), !0).forEach(function(n) {
      So(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ad(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function Xb(e) {
  if (Array.isArray(e)) return e;
}
function jb(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n, o, a, i, s = [], l = !0, u = !1;
    try {
      if (a = (t = t.call(e)).next, r === 0) {
        if (Object(t) !== t) return;
        l = !1;
      } else for (; !(l = (n = a.call(t)).done) && (s.push(n.value), s.length !== r); l = !0) ;
    } catch (c) {
      u = !0, o = c;
    } finally {
      try {
        if (!l && t.return != null && (i = t.return(), Object(i) !== i)) return;
      } finally {
        if (u) throw o;
      }
    }
    return s;
  }
}
function ql(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = Array(r); t < r; t++) n[t] = e[t];
  return n;
}
function Wp(e, r) {
  if (e) {
    if (typeof e == "string") return ql(e, r);
    var t = {}.toString.call(e).slice(8, -1);
    return t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set" ? Array.from(e) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? ql(e, r) : void 0;
  }
}
function Zb() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yt(e, r) {
  return Xb(e) || jb(e, r) || Wp(e, r) || Zb();
}
function Ub(e, r) {
  if (e == null) return {};
  var t = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (r.indexOf(n) !== -1) continue;
    t[n] = e[n];
  }
  return t;
}
function br(e, r) {
  if (e == null) return {};
  var t, n, o = Ub(e, r);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (n = 0; n < a.length; n++) t = a[n], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
var Jb = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Ds(e) {
  var r = e.defaultInputValue, t = r === void 0 ? "" : r, n = e.defaultMenuIsOpen, o = n === void 0 ? !1 : n, a = e.defaultValue, i = a === void 0 ? null : a, s = e.inputValue, l = e.menuIsOpen, u = e.onChange, c = e.onInputChange, d = e.onMenuClose, f = e.onMenuOpen, p = e.value, h = br(e, Jb), g = Se(s !== void 0 ? s : t), m = yt(g, 2), v = m[0], y = m[1], C = Se(l !== void 0 ? l : o), I = yt(C, 2), b = I[0], D = I[1], x = Se(p !== void 0 ? p : i), _ = yt(x, 2), E = _[0], R = _[1], L = se(function(H, re) {
    typeof u == "function" && u(H, re), R(H);
  }, [u]), G = se(function(H, re) {
    var W;
    typeof c == "function" && (W = c(H, re)), y(W !== void 0 ? W : H);
  }, [c]), V = se(function() {
    typeof f == "function" && f(), D(!0);
  }, [f]), O = se(function() {
    typeof d == "function" && d(), D(!1);
  }, [d]), N = s !== void 0 ? s : v, P = l !== void 0 ? l : b, B = p !== void 0 ? p : E;
  return ce(ce({}, h), {}, {
    inputValue: N,
    menuIsOpen: P,
    onChange: L,
    onInputChange: G,
    onMenuClose: O,
    onMenuOpen: V,
    value: B
  });
}
function pe() {
  return pe = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) ({}).hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, pe.apply(null, arguments);
}
function Qb(e, r) {
  if (!(e instanceof r)) throw new TypeError("Cannot call a class as a function");
}
function id(e, r) {
  for (var t = 0; t < r.length; t++) {
    var n = r[t];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Lp(n.key), n);
  }
}
function qb(e, r, t) {
  return r && id(e.prototype, r), t && id(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Kl(e, r) {
  return Kl = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, n) {
    return t.__proto__ = n, t;
  }, Kl(e, r);
}
function Kb(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(r && r.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), r && Kl(e, r);
}
function Xi(e) {
  return Xi = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, Xi(e);
}
function Bp() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Bp = function() {
    return !!e;
  })();
}
function e0(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function t0(e, r) {
  if (r && (Un(r) == "object" || typeof r == "function")) return r;
  if (r !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return e0(e);
}
function r0(e) {
  var r = Bp();
  return function() {
    var t, n = Xi(e);
    if (r) {
      var o = Xi(this).constructor;
      t = Reflect.construct(n, arguments, o);
    } else t = n.apply(this, arguments);
    return t0(this, t);
  };
}
function n0(e) {
  if (Array.isArray(e)) return ql(e);
}
function o0(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function a0() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Do(e) {
  return n0(e) || o0(e) || Wp(e) || a0();
}
function i0(e, r) {
  return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
const Fo = Math.min, Hn = Math.max, ji = Math.round, ui = Math.floor, Rr = (e) => ({
  x: e,
  y: e
}), s0 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, l0 = {
  start: "end",
  end: "start"
};
function u0(e, r, t) {
  return Hn(e, Fo(r, t));
}
function _s(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function No(e) {
  return e.split("-")[0];
}
function za(e) {
  return e.split("-")[1];
}
function c0(e) {
  return e === "x" ? "y" : "x";
}
function Gu(e) {
  return e === "y" ? "height" : "width";
}
const d0 = /* @__PURE__ */ new Set(["top", "bottom"]);
function Vn(e) {
  return d0.has(No(e)) ? "y" : "x";
}
function Yu(e) {
  return c0(Vn(e));
}
function f0(e, r, t) {
  t === void 0 && (t = !1);
  const n = za(e), o = Yu(e), a = Gu(o);
  let i = o === "x" ? n === (t ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return r.reference[a] > r.floating[a] && (i = Zi(i)), [i, Zi(i)];
}
function p0(e) {
  const r = Zi(e);
  return [eu(e), r, eu(r)];
}
function eu(e) {
  return e.replace(/start|end/g, (r) => l0[r]);
}
const sd = ["left", "right"], ld = ["right", "left"], h0 = ["top", "bottom"], g0 = ["bottom", "top"];
function m0(e, r, t) {
  switch (e) {
    case "top":
    case "bottom":
      return t ? r ? ld : sd : r ? sd : ld;
    case "left":
    case "right":
      return r ? h0 : g0;
    default:
      return [];
  }
}
function v0(e, r, t, n) {
  const o = za(e);
  let a = m0(No(e), t === "start", n);
  return o && (a = a.map((i) => i + "-" + o), r && (a = a.concat(a.map(eu)))), a;
}
function Zi(e) {
  return e.replace(/left|right|bottom|top/g, (r) => s0[r]);
}
function b0(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vp(e) {
  return typeof e != "number" ? b0(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ui(e) {
  const {
    x: r,
    y: t,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: t,
    left: r,
    right: r + n,
    bottom: t + o,
    x: r,
    y: t
  };
}
function ud(e, r, t) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = Vn(r), i = Yu(r), s = Gu(i), l = No(r), u = a === "y", c = n.x + n.width / 2 - o.width / 2, d = n.y + n.height / 2 - o.height / 2, f = n[s] / 2 - o[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: c,
        y: n.y - o.height
      };
      break;
    case "bottom":
      p = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      p = {
        x: n.x + n.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: n.x - o.width,
        y: d
      };
      break;
    default:
      p = {
        x: n.x,
        y: n.y
      };
  }
  switch (za(r)) {
    case "start":
      p[i] -= f * (t && u ? -1 : 1);
      break;
    case "end":
      p[i] += f * (t && u ? -1 : 1);
      break;
  }
  return p;
}
const y0 = async (e, r, t) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = t, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(r));
  let u = await i.getElementRects({
    reference: e,
    floating: r,
    strategy: o
  }), {
    x: c,
    y: d
  } = ud(u, n, l), f = n, p = {}, h = 0;
  for (let g = 0; g < s.length; g++) {
    const {
      name: m,
      fn: v
    } = s[g], {
      x: y,
      y: C,
      data: I,
      reset: b
    } = await v({
      x: c,
      y: d,
      initialPlacement: n,
      placement: f,
      strategy: o,
      middlewareData: p,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: r
      }
    });
    c = y ?? c, d = C ?? d, p = {
      ...p,
      [m]: {
        ...p[m],
        ...I
      }
    }, b && h <= 50 && (h++, typeof b == "object" && (b.placement && (f = b.placement), b.rects && (u = b.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: r,
      strategy: o
    }) : b.rects), {
      x: c,
      y: d
    } = ud(u, f, l)), g = -1);
  }
  return {
    x: c,
    y: d,
    placement: f,
    strategy: o,
    middlewareData: p
  };
};
async function w0(e, r) {
  var t;
  r === void 0 && (r = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = _s(r, e), h = Vp(p), m = s[f ? d === "floating" ? "reference" : "floating" : d], v = Ui(await a.getClippingRect({
    element: (t = await (a.isElement == null ? void 0 : a.isElement(m))) == null || t ? m : m.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), y = d === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), I = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = Ui(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: C,
    strategy: l
  }) : y);
  return {
    top: (v.top - b.top + h.top) / I.y,
    bottom: (b.bottom - v.bottom + h.bottom) / I.y,
    left: (v.left - b.left + h.left) / I.x,
    right: (b.right - v.right + h.right) / I.x
  };
}
const C0 = (e) => ({
  name: "arrow",
  options: e,
  async fn(r) {
    const {
      x: t,
      y: n,
      placement: o,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = r, {
      element: u,
      padding: c = 0
    } = _s(e, r) || {};
    if (u == null)
      return {};
    const d = Vp(c), f = {
      x: t,
      y: n
    }, p = Yu(o), h = Gu(p), g = await i.getDimensions(u), m = p === "y", v = m ? "top" : "left", y = m ? "bottom" : "right", C = m ? "clientHeight" : "clientWidth", I = a.reference[h] + a.reference[p] - f[p] - a.floating[h], b = f[p] - a.reference[p], D = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let x = D ? D[C] : 0;
    (!x || !await (i.isElement == null ? void 0 : i.isElement(D))) && (x = s.floating[C] || a.floating[h]);
    const _ = I / 2 - b / 2, E = x / 2 - g[h] / 2 - 1, R = Fo(d[v], E), L = Fo(d[y], E), G = R, V = x - g[h] - L, O = x / 2 - g[h] / 2 + _, N = u0(G, O, V), P = !l.arrow && za(o) != null && O !== N && a.reference[h] / 2 - (O < G ? R : L) - g[h] / 2 < 0, B = P ? O < G ? O - G : O - V : 0;
    return {
      [p]: f[p] + B,
      data: {
        [p]: N,
        centerOffset: O - N - B,
        ...P && {
          alignmentOffset: B
        }
      },
      reset: P
    };
  }
}), S0 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(r) {
      var t, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = r, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: g = !0,
        ...m
      } = _s(e, r);
      if ((t = a.arrow) != null && t.alignmentOffset)
        return {};
      const v = No(o), y = Vn(s), C = No(s) === s, I = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), b = f || (C || !g ? [Zi(s)] : p0(s)), D = h !== "none";
      !f && D && b.push(...v0(s, g, h, I));
      const x = [s, ...b], _ = await w0(r, m), E = [];
      let R = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && E.push(_[v]), d) {
        const O = f0(o, i, I);
        E.push(_[O[0]], _[O[1]]);
      }
      if (R = [...R, {
        placement: o,
        overflows: E
      }], !E.every((O) => O <= 0)) {
        var L, G;
        const O = (((L = a.flip) == null ? void 0 : L.index) || 0) + 1, N = x[O];
        if (N && (!(d === "alignment" ? y !== Vn(N) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        R.every((H) => Vn(H.placement) === y ? H.overflows[0] > 0 : !0)))
          return {
            data: {
              index: O,
              overflows: R
            },
            reset: {
              placement: N
            }
          };
        let P = (G = R.filter((B) => B.overflows[0] <= 0).sort((B, H) => B.overflows[1] - H.overflows[1])[0]) == null ? void 0 : G.placement;
        if (!P)
          switch (p) {
            case "bestFit": {
              var V;
              const B = (V = R.filter((H) => {
                if (D) {
                  const re = Vn(H.placement);
                  return re === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  re === "y";
                }
                return !0;
              }).map((H) => [H.placement, H.overflows.filter((re) => re > 0).reduce((re, W) => re + W, 0)]).sort((H, re) => H[1] - re[1])[0]) == null ? void 0 : V[0];
              B && (P = B);
              break;
            }
            case "initialPlacement":
              P = s;
              break;
          }
        if (o !== P)
          return {
            reset: {
              placement: P
            }
          };
      }
      return {};
    }
  };
}, x0 = /* @__PURE__ */ new Set(["left", "top"]);
async function I0(e, r) {
  const {
    placement: t,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = No(t), s = za(t), l = Vn(t) === "y", u = x0.has(i) ? -1 : 1, c = a && l ? -1 : 1, d = _s(r, e);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof h == "number" && (p = s === "end" ? h * -1 : h), l ? {
    x: p * c,
    y: f * u
  } : {
    x: f * u,
    y: p * c
  };
}
const D0 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(r) {
      var t, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = r, l = await I0(r, e);
      return i === ((t = s.offset) == null ? void 0 : t.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
};
function ks() {
  return typeof window < "u";
}
function Xo(e) {
  return Gp(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function $t(e) {
  var r;
  return (e == null || (r = e.ownerDocument) == null ? void 0 : r.defaultView) || window;
}
function Gr(e) {
  var r;
  return (r = (Gp(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : r.documentElement;
}
function Gp(e) {
  return ks() ? e instanceof Node || e instanceof $t(e).Node : !1;
}
function _t(e) {
  return ks() ? e instanceof Element || e instanceof $t(e).Element : !1;
}
function Nr(e) {
  return ks() ? e instanceof HTMLElement || e instanceof $t(e).HTMLElement : !1;
}
function cd(e) {
  return !ks() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof $t(e).ShadowRoot;
}
const _0 = /* @__PURE__ */ new Set(["inline", "contents"]);
function $a(e) {
  const {
    overflow: r,
    overflowX: t,
    overflowY: n,
    display: o
  } = or(e);
  return /auto|scroll|overlay|hidden|clip/.test(r + n + t) && !_0.has(o);
}
const k0 = /* @__PURE__ */ new Set(["table", "td", "th"]);
function E0(e) {
  return k0.has(Xo(e));
}
const M0 = [":popover-open", ":modal"];
function Es(e) {
  return M0.some((r) => {
    try {
      return e.matches(r);
    } catch {
      return !1;
    }
  });
}
const A0 = ["transform", "translate", "scale", "rotate", "perspective"], P0 = ["transform", "translate", "scale", "rotate", "perspective", "filter"], R0 = ["paint", "layout", "strict", "content"];
function Hu(e) {
  const r = zu(), t = _t(e) ? or(e) : e;
  return A0.some((n) => t[n] ? t[n] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !r && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !r && (t.filter ? t.filter !== "none" : !1) || P0.some((n) => (t.willChange || "").includes(n)) || R0.some((n) => (t.contain || "").includes(n));
}
function O0(e) {
  let r = En(e);
  for (; Nr(r) && !Lo(r); ) {
    if (Hu(r))
      return r;
    if (Es(r))
      return null;
    r = En(r);
  }
  return null;
}
function zu() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const T0 = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Lo(e) {
  return T0.has(Xo(e));
}
function or(e) {
  return $t(e).getComputedStyle(e);
}
function Ms(e) {
  return _t(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function En(e) {
  if (Xo(e) === "html")
    return e;
  const r = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    cd(e) && e.host || // Fallback.
    Gr(e)
  );
  return cd(r) ? r.host : r;
}
function Yp(e) {
  const r = En(e);
  return Lo(r) ? e.ownerDocument ? e.ownerDocument.body : e.body : Nr(r) && $a(r) ? r : Yp(r);
}
function Ea(e, r, t) {
  var n;
  r === void 0 && (r = []), t === void 0 && (t = !0);
  const o = Yp(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = $t(o);
  if (a) {
    const s = tu(i);
    return r.concat(i, i.visualViewport || [], $a(o) ? o : [], s && t ? Ea(s) : []);
  }
  return r.concat(o, Ea(o, [], t));
}
function tu(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Hp(e) {
  const r = or(e);
  let t = parseFloat(r.width) || 0, n = parseFloat(r.height) || 0;
  const o = Nr(e), a = o ? e.offsetWidth : t, i = o ? e.offsetHeight : n, s = ji(t) !== a || ji(n) !== i;
  return s && (t = a, n = i), {
    width: t,
    height: n,
    $: s
  };
}
function $u(e) {
  return _t(e) ? e : e.contextElement;
}
function _o(e) {
  const r = $u(e);
  if (!Nr(r))
    return Rr(1);
  const t = r.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = Hp(r);
  let i = (a ? ji(t.width) : t.width) / n, s = (a ? ji(t.height) : t.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const F0 = /* @__PURE__ */ Rr(0);
function zp(e) {
  const r = $t(e);
  return !zu() || !r.visualViewport ? F0 : {
    x: r.visualViewport.offsetLeft,
    y: r.visualViewport.offsetTop
  };
}
function N0(e, r, t) {
  return r === void 0 && (r = !1), !t || r && t !== $t(e) ? !1 : r;
}
function Jn(e, r, t, n) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  const o = e.getBoundingClientRect(), a = $u(e);
  let i = Rr(1);
  r && (n ? _t(n) && (i = _o(n)) : i = _o(e));
  const s = N0(a, t, n) ? zp(a) : Rr(0);
  let l = (o.left + s.x) / i.x, u = (o.top + s.y) / i.y, c = o.width / i.x, d = o.height / i.y;
  if (a) {
    const f = $t(a), p = n && _t(n) ? $t(n) : n;
    let h = f, g = tu(h);
    for (; g && n && p !== h; ) {
      const m = _o(g), v = g.getBoundingClientRect(), y = or(g), C = v.left + (g.clientLeft + parseFloat(y.paddingLeft)) * m.x, I = v.top + (g.clientTop + parseFloat(y.paddingTop)) * m.y;
      l *= m.x, u *= m.y, c *= m.x, d *= m.y, l += C, u += I, h = $t(g), g = tu(h);
    }
  }
  return Ui({
    width: c,
    height: d,
    x: l,
    y: u
  });
}
function As(e, r) {
  const t = Ms(e).scrollLeft;
  return r ? r.left + t : Jn(Gr(e)).left + t;
}
function $p(e, r) {
  const t = e.getBoundingClientRect(), n = t.left + r.scrollLeft - As(e, t), o = t.top + r.scrollTop;
  return {
    x: n,
    y: o
  };
}
function L0(e) {
  let {
    elements: r,
    rect: t,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = Gr(n), s = r ? Es(r.floating) : !1;
  if (n === i || s && a)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Rr(1);
  const c = Rr(0), d = Nr(n);
  if ((d || !d && !a) && ((Xo(n) !== "body" || $a(i)) && (l = Ms(n)), Nr(n))) {
    const p = Jn(n);
    u = _o(n), c.x = p.x + n.clientLeft, c.y = p.y + n.clientTop;
  }
  const f = i && !d && !a ? $p(i, l) : Rr(0);
  return {
    width: t.width * u.x,
    height: t.height * u.y,
    x: t.x * u.x - l.scrollLeft * u.x + c.x + f.x,
    y: t.y * u.y - l.scrollTop * u.y + c.y + f.y
  };
}
function W0(e) {
  return Array.from(e.getClientRects());
}
function B0(e) {
  const r = Gr(e), t = Ms(e), n = e.ownerDocument.body, o = Hn(r.scrollWidth, r.clientWidth, n.scrollWidth, n.clientWidth), a = Hn(r.scrollHeight, r.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -t.scrollLeft + As(e);
  const s = -t.scrollTop;
  return or(n).direction === "rtl" && (i += Hn(r.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
const dd = 25;
function V0(e, r) {
  const t = $t(e), n = Gr(e), o = t.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const c = zu();
    (!c || c && r === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  const u = As(n);
  if (u <= 0) {
    const c = n.ownerDocument, d = c.body, f = getComputedStyle(d), p = c.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, h = Math.abs(n.clientWidth - d.clientWidth - p);
    h <= dd && (a -= h);
  } else u <= dd && (a += u);
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
const G0 = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Y0(e, r) {
  const t = Jn(e, !0, r === "fixed"), n = t.top + e.clientTop, o = t.left + e.clientLeft, a = Nr(e) ? _o(e) : Rr(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, u = n * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function fd(e, r, t) {
  let n;
  if (r === "viewport")
    n = V0(e, t);
  else if (r === "document")
    n = B0(Gr(e));
  else if (_t(r))
    n = Y0(r, t);
  else {
    const o = zp(e);
    n = {
      x: r.x - o.x,
      y: r.y - o.y,
      width: r.width,
      height: r.height
    };
  }
  return Ui(n);
}
function Xp(e, r) {
  const t = En(e);
  return t === r || !_t(t) || Lo(t) ? !1 : or(t).position === "fixed" || Xp(t, r);
}
function H0(e, r) {
  const t = r.get(e);
  if (t)
    return t;
  let n = Ea(e, [], !1).filter((s) => _t(s) && Xo(s) !== "body"), o = null;
  const a = or(e).position === "fixed";
  let i = a ? En(e) : e;
  for (; _t(i) && !Lo(i); ) {
    const s = or(i), l = Hu(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && G0.has(o.position) || $a(i) && !l && Xp(e, i)) ? n = n.filter((c) => c !== i) : o = s, i = En(i);
  }
  return r.set(e, n), n;
}
function z0(e) {
  let {
    element: r,
    boundary: t,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...t === "clippingAncestors" ? Es(r) ? [] : H0(r, this._c) : [].concat(t), n], s = i[0], l = i.reduce((u, c) => {
    const d = fd(r, c, o);
    return u.top = Hn(d.top, u.top), u.right = Fo(d.right, u.right), u.bottom = Fo(d.bottom, u.bottom), u.left = Hn(d.left, u.left), u;
  }, fd(r, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function $0(e) {
  const {
    width: r,
    height: t
  } = Hp(e);
  return {
    width: r,
    height: t
  };
}
function X0(e, r, t) {
  const n = Nr(r), o = Gr(r), a = t === "fixed", i = Jn(e, !0, a, r);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Rr(0);
  function u() {
    l.x = As(o);
  }
  if (n || !n && !a)
    if ((Xo(r) !== "body" || $a(o)) && (s = Ms(r)), n) {
      const p = Jn(r, !0, a, r);
      l.x = p.x + r.clientLeft, l.y = p.y + r.clientTop;
    } else o && u();
  a && !n && o && u();
  const c = o && !n && !a ? $p(o, s) : Rr(0), d = i.left + s.scrollLeft - l.x - c.x, f = i.top + s.scrollTop - l.y - c.y;
  return {
    x: d,
    y: f,
    width: i.width,
    height: i.height
  };
}
function pl(e) {
  return or(e).position === "static";
}
function pd(e, r) {
  if (!Nr(e) || or(e).position === "fixed")
    return null;
  if (r)
    return r(e);
  let t = e.offsetParent;
  return Gr(e) === t && (t = t.ownerDocument.body), t;
}
function jp(e, r) {
  const t = $t(e);
  if (Es(e))
    return t;
  if (!Nr(e)) {
    let o = En(e);
    for (; o && !Lo(o); ) {
      if (_t(o) && !pl(o))
        return o;
      o = En(o);
    }
    return t;
  }
  let n = pd(e, r);
  for (; n && E0(n) && pl(n); )
    n = pd(n, r);
  return n && Lo(n) && pl(n) && !Hu(n) ? t : n || O0(e) || t;
}
const j0 = async function(e) {
  const r = this.getOffsetParent || jp, t = this.getDimensions, n = await t(e.floating);
  return {
    reference: X0(e.reference, await r(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function Z0(e) {
  return or(e).direction === "rtl";
}
const U0 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: L0,
  getDocumentElement: Gr,
  getClippingRect: z0,
  getOffsetParent: jp,
  getElementRects: j0,
  getClientRects: W0,
  getDimensions: $0,
  getScale: _o,
  isElement: _t,
  isRTL: Z0
};
function Zp(e, r) {
  return e.x === r.x && e.y === r.y && e.width === r.width && e.height === r.height;
}
function J0(e, r) {
  let t = null, n;
  const o = Gr(e);
  function a() {
    var s;
    clearTimeout(n), (s = t) == null || s.disconnect(), t = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = e.getBoundingClientRect(), {
      left: c,
      top: d,
      width: f,
      height: p
    } = u;
    if (s || r(), !f || !p)
      return;
    const h = ui(d), g = ui(o.clientWidth - (c + f)), m = ui(o.clientHeight - (d + p)), v = ui(c), C = {
      rootMargin: -h + "px " + -g + "px " + -m + "px " + -v + "px",
      threshold: Hn(0, Fo(1, l)) || 1
    };
    let I = !0;
    function b(D) {
      const x = D[0].intersectionRatio;
      if (x !== l) {
        if (!I)
          return i();
        x ? i(!1, x) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      x === 1 && !Zp(u, e.getBoundingClientRect()) && i(), I = !1;
    }
    try {
      t = new IntersectionObserver(b, {
        ...C,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(b, C);
    }
    t.observe(e);
  }
  return i(!0), a;
}
function Up(e, r, t, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = $u(e), c = o || a ? [...u ? Ea(u) : [], ...Ea(r)] : [];
  c.forEach((v) => {
    o && v.addEventListener("scroll", t, {
      passive: !0
    }), a && v.addEventListener("resize", t);
  });
  const d = u && s ? J0(u, t) : null;
  let f = -1, p = null;
  i && (p = new ResizeObserver((v) => {
    let [y] = v;
    y && y.target === u && p && (p.unobserve(r), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var C;
      (C = p) == null || C.observe(r);
    })), t();
  }), u && !l && p.observe(u), p.observe(r));
  let h, g = l ? Jn(e) : null;
  l && m();
  function m() {
    const v = Jn(e);
    g && !Zp(g, v) && t(), g = v, h = requestAnimationFrame(m);
  }
  return t(), () => {
    var v;
    c.forEach((y) => {
      o && y.removeEventListener("scroll", t), a && y.removeEventListener("resize", t);
    }), d == null || d(), (v = p) == null || v.disconnect(), p = null, l && cancelAnimationFrame(h);
  };
}
const Q0 = D0, q0 = S0, hd = C0, K0 = (e, r, t) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: U0,
    ...t
  }, a = {
    ...o.platform,
    _c: n
  };
  return y0(e, r, {
    ...o,
    platform: a
  });
};
var ru = Ga, ey = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], Ji = function() {
};
function ty(e, r) {
  return r ? r[0] === "-" ? e + r : e + "__" + r : e;
}
function ry(e, r) {
  for (var t = arguments.length, n = new Array(t > 2 ? t - 2 : 0), o = 2; o < t; o++)
    n[o - 2] = arguments[o];
  var a = [].concat(n);
  if (r && e)
    for (var i in r)
      r.hasOwnProperty(i) && r[i] && a.push("".concat(ty(e, i)));
  return a.filter(function(s) {
    return s;
  }).map(function(s) {
    return String(s).trim();
  }).join(" ");
}
var Qi = function(r) {
  return fy(r) ? r.filter(Boolean) : Un(r) === "object" && r !== null ? [r] : [];
}, Jp = function(r) {
  r.className, r.clearValue, r.cx, r.getStyles, r.getClassNames, r.getValue, r.hasValue, r.isMulti, r.isRtl, r.options, r.selectOption, r.selectProps, r.setValue, r.theme;
  var t = br(r, ey);
  return ce({}, t);
}, lt = function(r, t, n) {
  var o = r.cx, a = r.getStyles, i = r.getClassNames, s = r.className;
  return {
    css: a(t, r),
    className: o(n ?? {}, i(t, r), s)
  };
};
function ny(e, r, t) {
  if (t) {
    var n = t(e, r);
    if (typeof n == "string") return n;
  }
  return e;
}
function Ps(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function oy(e) {
  return Ps(e) ? window.innerHeight : e.clientHeight;
}
function Qp(e) {
  return Ps(e) ? window.pageYOffset : e.scrollTop;
}
function qi(e, r) {
  if (Ps(e)) {
    window.scrollTo(0, r);
    return;
  }
  e.scrollTop = r;
}
function ay(e) {
  var r = getComputedStyle(e), t = r.position === "absolute", n = /(auto|scroll)/;
  if (r.position === "fixed") return document.documentElement;
  for (var o = e; o = o.parentElement; )
    if (r = getComputedStyle(o), !(t && r.position === "static") && n.test(r.overflow + r.overflowY + r.overflowX))
      return o;
  return document.documentElement;
}
function iy(e, r, t, n) {
  return t * ((e = e / n - 1) * e * e + 1) + r;
}
function ci(e, r) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Ji, o = Qp(e), a = r - o, i = 10, s = 0;
  function l() {
    s += i;
    var u = iy(s, o, a, t);
    qi(e, u), s < t ? window.requestAnimationFrame(l) : n(e);
  }
  l();
}
function gd(e, r) {
  var t = e.getBoundingClientRect(), n = r.getBoundingClientRect(), o = r.offsetHeight / 3;
  n.bottom + o > t.bottom ? qi(e, Math.min(r.offsetTop + r.clientHeight - e.offsetHeight + o, e.scrollHeight)) : n.top - o < t.top && qi(e, Math.max(r.offsetTop - o, 0));
}
function sy(e) {
  var r = e.getBoundingClientRect();
  return {
    bottom: r.bottom,
    height: r.height,
    left: r.left,
    right: r.right,
    top: r.top,
    width: r.width
  };
}
function md() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function ly() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var qp = !1, uy = {
  get passive() {
    return qp = !0;
  }
}, di = typeof window < "u" ? window : {};
di.addEventListener && di.removeEventListener && (di.addEventListener("p", Ji, uy), di.removeEventListener("p", Ji, !1));
var cy = qp;
function dy(e) {
  return e != null;
}
function fy(e) {
  return Array.isArray(e);
}
function va(e, r, t) {
  return e ? r : t;
}
var py = function(r) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)
    n[o - 1] = arguments[o];
  var a = Object.entries(r).filter(function(i) {
    var s = yt(i, 1), l = s[0];
    return !n.includes(l);
  });
  return a.reduce(function(i, s) {
    var l = yt(s, 2), u = l[0], c = l[1];
    return i[u] = c, i;
  }, {});
}, hy = ["children", "innerProps"], gy = ["children", "innerProps"];
function my(e) {
  var r = e.maxHeight, t = e.menuEl, n = e.minHeight, o = e.placement, a = e.shouldScroll, i = e.isFixedPosition, s = e.controlHeight, l = ay(t), u = {
    placement: "bottom",
    maxHeight: r
  };
  if (!t || !t.offsetParent) return u;
  var c = l.getBoundingClientRect(), d = c.height, f = t.getBoundingClientRect(), p = f.bottom, h = f.height, g = f.top, m = t.offsetParent.getBoundingClientRect(), v = m.top, y = i ? window.innerHeight : oy(l), C = Qp(l), I = parseInt(getComputedStyle(t).marginBottom, 10), b = parseInt(getComputedStyle(t).marginTop, 10), D = v - b, x = y - g, _ = D + C, E = d - C - g, R = p - y + C + I, L = C + g - b, G = 160;
  switch (o) {
    case "auto":
    case "bottom":
      if (x >= h)
        return {
          placement: "bottom",
          maxHeight: r
        };
      if (E >= h && !i)
        return a && ci(l, R, G), {
          placement: "bottom",
          maxHeight: r
        };
      if (!i && E >= n || i && x >= n) {
        a && ci(l, R, G);
        var V = i ? x - I : E - I;
        return {
          placement: "bottom",
          maxHeight: V
        };
      }
      if (o === "auto" || i) {
        var O = r, N = i ? D : _;
        return N >= n && (O = Math.min(N - I - s, r)), {
          placement: "top",
          maxHeight: O
        };
      }
      if (o === "bottom")
        return a && qi(l, R), {
          placement: "bottom",
          maxHeight: r
        };
      break;
    case "top":
      if (D >= h)
        return {
          placement: "top",
          maxHeight: r
        };
      if (_ >= h && !i)
        return a && ci(l, L, G), {
          placement: "top",
          maxHeight: r
        };
      if (!i && _ >= n || i && D >= n) {
        var P = r;
        return (!i && _ >= n || i && D >= n) && (P = i ? D - b : _ - b), a && ci(l, L, G), {
          placement: "top",
          maxHeight: P
        };
      }
      return {
        placement: "bottom",
        maxHeight: r
      };
    default:
      throw new Error('Invalid placement provided "'.concat(o, '".'));
  }
  return u;
}
function vy(e) {
  var r = {
    bottom: "top",
    top: "bottom"
  };
  return e ? r[e] : "bottom";
}
var Kp = function(r) {
  return r === "auto" ? "bottom" : r;
}, by = function(r, t) {
  var n, o = r.placement, a = r.theme, i = a.borderRadius, s = a.spacing, l = a.colors;
  return ce((n = {
    label: "menu"
  }, So(n, vy(o), "100%"), So(n, "position", "absolute"), So(n, "width", "100%"), So(n, "zIndex", 1), n), t ? {} : {
    backgroundColor: l.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: s.menuGutter,
    marginTop: s.menuGutter
  });
}, eh = /* @__PURE__ */ Ya(null), yy = function(r) {
  var t = r.children, n = r.minMenuHeight, o = r.maxMenuHeight, a = r.menuPlacement, i = r.menuPosition, s = r.menuShouldScrollIntoView, l = r.theme, u = $o(eh) || {}, c = u.setPortalPlacement, d = ye(null), f = Se(o), p = yt(f, 2), h = p[0], g = p[1], m = Se(null), v = yt(m, 2), y = v[0], C = v[1], I = l.spacing.controlHeight;
  return ru(function() {
    var b = d.current;
    if (b) {
      var D = i === "fixed", x = s && !D, _ = my({
        maxHeight: o,
        menuEl: b,
        minHeight: n,
        placement: a,
        shouldScroll: x,
        isFixedPosition: D,
        controlHeight: I
      });
      g(_.maxHeight), C(_.placement), c == null || c(_.placement);
    }
  }, [o, a, i, s, n, c, I]), t({
    ref: d,
    placerProps: ce(ce({}, r), {}, {
      placement: y || Kp(a),
      maxHeight: h
    })
  });
}, wy = function(r) {
  var t = r.children, n = r.innerRef, o = r.innerProps;
  return he("div", pe({}, lt(r, "menu", {
    menu: !0
  }), {
    ref: n
  }, o), t);
}, Cy = wy, Sy = function(r, t) {
  var n = r.maxHeight, o = r.theme.spacing.baseUnit;
  return ce({
    maxHeight: n,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, t ? {} : {
    paddingBottom: o,
    paddingTop: o
  });
}, xy = function(r) {
  var t = r.children, n = r.innerProps, o = r.innerRef, a = r.isMulti;
  return he("div", pe({}, lt(r, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": a
  }), {
    ref: o
  }, n), t);
}, th = function(r, t) {
  var n = r.theme, o = n.spacing.baseUnit, a = n.colors;
  return ce({
    textAlign: "center"
  }, t ? {} : {
    color: a.neutral40,
    padding: "".concat(o * 2, "px ").concat(o * 3, "px")
  });
}, Iy = th, Dy = th, _y = function(r) {
  var t = r.children, n = t === void 0 ? "No options" : t, o = r.innerProps, a = br(r, hy);
  return he("div", pe({}, lt(ce(ce({}, a), {}, {
    children: n,
    innerProps: o
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), o), n);
}, ky = function(r) {
  var t = r.children, n = t === void 0 ? "Loading..." : t, o = r.innerProps, a = br(r, gy);
  return he("div", pe({}, lt(ce(ce({}, a), {}, {
    children: n,
    innerProps: o
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), o), n);
}, Ey = function(r) {
  var t = r.rect, n = r.offset, o = r.position;
  return {
    left: t.left,
    position: o,
    top: n,
    width: t.width,
    zIndex: 1
  };
}, My = function(r) {
  var t = r.appendTo, n = r.children, o = r.controlElement, a = r.innerProps, i = r.menuPlacement, s = r.menuPosition, l = ye(null), u = ye(null), c = Se(Kp(i)), d = yt(c, 2), f = d[0], p = d[1], h = Ve(function() {
    return {
      setPortalPlacement: p
    };
  }, []), g = Se(null), m = yt(g, 2), v = m[0], y = m[1], C = se(function() {
    if (o) {
      var x = sy(o), _ = s === "fixed" ? 0 : window.pageYOffset, E = x[f] + _;
      (E !== (v == null ? void 0 : v.offset) || x.left !== (v == null ? void 0 : v.rect.left) || x.width !== (v == null ? void 0 : v.rect.width)) && y({
        offset: E,
        rect: x
      });
    }
  }, [o, s, f, v == null ? void 0 : v.offset, v == null ? void 0 : v.rect.left, v == null ? void 0 : v.rect.width]);
  ru(function() {
    C();
  }, [C]);
  var I = se(function() {
    typeof u.current == "function" && (u.current(), u.current = null), o && l.current && (u.current = Up(o, l.current, C, {
      elementResize: "ResizeObserver" in window
    }));
  }, [o, C]);
  ru(function() {
    I();
  }, [I]);
  var b = se(function(x) {
    l.current = x, I();
  }, [I]);
  if (!t && s !== "fixed" || !v) return null;
  var D = he("div", pe({
    ref: b
  }, lt(ce(ce({}, r), {}, {
    offset: v.offset,
    position: s,
    rect: v.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), a), n);
  return he(eh.Provider, {
    value: h
  }, t ? /* @__PURE__ */ Fb(D, t) : D);
}, Ay = function(r) {
  var t = r.isDisabled, n = r.isRtl;
  return {
    label: "container",
    direction: n ? "rtl" : void 0,
    pointerEvents: t ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, Py = function(r) {
  var t = r.children, n = r.innerProps, o = r.isDisabled, a = r.isRtl;
  return he("div", pe({}, lt(r, "container", {
    "--is-disabled": o,
    "--is-rtl": a
  }), n), t);
}, Ry = function(r, t) {
  var n = r.theme.spacing, o = r.isMulti, a = r.hasValue, i = r.selectProps.controlShouldRenderValue;
  return ce({
    alignItems: "center",
    display: o && a && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, t ? {} : {
    padding: "".concat(n.baseUnit / 2, "px ").concat(n.baseUnit * 2, "px")
  });
}, Oy = function(r) {
  var t = r.children, n = r.innerProps, o = r.isMulti, a = r.hasValue;
  return he("div", pe({}, lt(r, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": o,
    "value-container--has-value": a
  }), n), t);
}, Ty = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Fy = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "indicatorsContainer", {
    indicators: !0
  }), n), t);
}, vd, Ny = ["size"], Ly = ["innerProps", "isRtl", "size"];
function Wy() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var By = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Wy
}, rh = function(r) {
  var t = r.size, n = br(r, Ny);
  return he("svg", pe({
    height: t,
    width: t,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: By
  }, n));
}, Xu = function(r) {
  return he(rh, pe({
    size: 20
  }, r), he("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, nh = function(r) {
  return he(rh, pe({
    size: 20
  }, r), he("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, oh = function(r, t) {
  var n = r.isFocused, o = r.theme, a = o.spacing.baseUnit, i = o.colors;
  return ce({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, t ? {} : {
    color: n ? i.neutral60 : i.neutral20,
    padding: a * 2,
    ":hover": {
      color: n ? i.neutral80 : i.neutral40
    }
  });
}, Vy = oh, Gy = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), n), t || he(nh, null));
}, Yy = oh, Hy = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), n), t || he(Xu, null));
}, zy = function(r, t) {
  var n = r.isDisabled, o = r.theme, a = o.spacing.baseUnit, i = o.colors;
  return ce({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, t ? {} : {
    backgroundColor: n ? i.neutral10 : i.neutral20,
    marginBottom: a * 2,
    marginTop: a * 2
  });
}, $y = function(r) {
  var t = r.innerProps;
  return he("span", pe({}, t, lt(r, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Xy = Pp(vd || (vd = i0([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), jy = function(r, t) {
  var n = r.isFocused, o = r.size, a = r.theme, i = a.colors, s = a.spacing.baseUnit;
  return ce({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: o,
    lineHeight: 1,
    marginRight: o,
    textAlign: "center",
    verticalAlign: "middle"
  }, t ? {} : {
    color: n ? i.neutral60 : i.neutral20,
    padding: s * 2
  });
}, hl = function(r) {
  var t = r.delay, n = r.offset;
  return he("span", {
    css: /* @__PURE__ */ Ap({
      animation: "".concat(Xy, " 1s ease-in-out ").concat(t, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: n ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Zy = function(r) {
  var t = r.innerProps, n = r.isRtl, o = r.size, a = o === void 0 ? 4 : o, i = br(r, Ly);
  return he("div", pe({}, lt(ce(ce({}, i), {}, {
    innerProps: t,
    isRtl: n,
    size: a
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), t), he(hl, {
    delay: 0,
    offset: n
  }), he(hl, {
    delay: 160,
    offset: !0
  }), he(hl, {
    delay: 320,
    offset: !n
  }));
}, Uy = function(r, t) {
  var n = r.isDisabled, o = r.isFocused, a = r.theme, i = a.colors, s = a.borderRadius, l = a.spacing;
  return ce({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: l.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, t ? {} : {
    backgroundColor: n ? i.neutral5 : i.neutral0,
    borderColor: n ? i.neutral10 : o ? i.primary : i.neutral20,
    borderRadius: s,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: o ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: o ? i.primary : i.neutral30
    }
  });
}, Jy = function(r) {
  var t = r.children, n = r.isDisabled, o = r.isFocused, a = r.innerRef, i = r.innerProps, s = r.menuIsOpen;
  return he("div", pe({
    ref: a
  }, lt(r, "control", {
    control: !0,
    "control--is-disabled": n,
    "control--is-focused": o,
    "control--menu-is-open": s
  }), i, {
    "aria-disabled": n || void 0
  }), t);
}, Qy = Jy, qy = ["data"], Ky = function(r, t) {
  var n = r.theme.spacing;
  return t ? {} : {
    paddingBottom: n.baseUnit * 2,
    paddingTop: n.baseUnit * 2
  };
}, ew = function(r) {
  var t = r.children, n = r.cx, o = r.getStyles, a = r.getClassNames, i = r.Heading, s = r.headingProps, l = r.innerProps, u = r.label, c = r.theme, d = r.selectProps;
  return he("div", pe({}, lt(r, "group", {
    group: !0
  }), l), he(i, pe({}, s, {
    selectProps: d,
    theme: c,
    getStyles: o,
    getClassNames: a,
    cx: n
  }), u), he("div", null, t));
}, tw = function(r, t) {
  var n = r.theme, o = n.colors, a = n.spacing;
  return ce({
    label: "group",
    cursor: "default",
    display: "block"
  }, t ? {} : {
    color: o.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: a.baseUnit * 3,
    paddingRight: a.baseUnit * 3,
    textTransform: "uppercase"
  });
}, rw = function(r) {
  var t = Jp(r);
  t.data;
  var n = br(t, qy);
  return he("div", pe({}, lt(r, "groupHeading", {
    "group-heading": !0
  }), n));
}, nw = ew, ow = ["innerRef", "isDisabled", "isHidden", "inputClassName"], aw = function(r, t) {
  var n = r.isDisabled, o = r.value, a = r.theme, i = a.spacing, s = a.colors;
  return ce(ce({
    visibility: n ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: o ? "translateZ(0)" : ""
  }, iw), t ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: s.neutral80
  });
}, ah = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, iw = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": ce({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, ah)
}, sw = function(r) {
  return ce({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: r ? 0 : 1,
    width: "100%"
  }, ah);
}, lw = function(r) {
  var t = r.cx, n = r.value, o = Jp(r), a = o.innerRef, i = o.isDisabled, s = o.isHidden, l = o.inputClassName, u = br(o, ow);
  return he("div", pe({}, lt(r, "input", {
    "input-container": !0
  }), {
    "data-value": n || ""
  }), he("input", pe({
    className: t({
      input: !0
    }, l),
    ref: a,
    style: sw(s),
    disabled: i
  }, u)));
}, uw = lw, cw = function(r, t) {
  var n = r.theme, o = n.spacing, a = n.borderRadius, i = n.colors;
  return ce({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, t ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: a / 2,
    margin: o.baseUnit / 2
  });
}, dw = function(r, t) {
  var n = r.theme, o = n.borderRadius, a = n.colors, i = r.cropWithEllipsis;
  return ce({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, t ? {} : {
    borderRadius: o / 2,
    color: a.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, fw = function(r, t) {
  var n = r.theme, o = n.spacing, a = n.borderRadius, i = n.colors, s = r.isFocused;
  return ce({
    alignItems: "center",
    display: "flex"
  }, t ? {} : {
    borderRadius: a / 2,
    backgroundColor: s ? i.dangerLight : void 0,
    paddingLeft: o.baseUnit,
    paddingRight: o.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, ih = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", n, t);
}, pw = ih, hw = ih;
function gw(e) {
  var r = e.children, t = e.innerProps;
  return he("div", pe({
    role: "button"
  }, t), r || he(Xu, {
    size: 14
  }));
}
var mw = function(r) {
  var t = r.children, n = r.components, o = r.data, a = r.innerProps, i = r.isDisabled, s = r.removeProps, l = r.selectProps, u = n.Container, c = n.Label, d = n.Remove;
  return he(u, {
    data: o,
    innerProps: ce(ce({}, lt(r, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), a),
    selectProps: l
  }, he(c, {
    data: o,
    innerProps: ce({}, lt(r, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: l
  }, t), he(d, {
    data: o,
    innerProps: ce(ce({}, lt(r, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(t || "option")
    }, s),
    selectProps: l
  }));
}, vw = mw, bw = function(r, t) {
  var n = r.isDisabled, o = r.isFocused, a = r.isSelected, i = r.theme, s = i.spacing, l = i.colors;
  return ce({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, t ? {} : {
    backgroundColor: a ? l.primary : o ? l.primary25 : "transparent",
    color: n ? l.neutral20 : a ? l.neutral0 : "inherit",
    padding: "".concat(s.baseUnit * 2, "px ").concat(s.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: n ? void 0 : a ? l.primary : l.primary50
    }
  });
}, yw = function(r) {
  var t = r.children, n = r.isDisabled, o = r.isFocused, a = r.isSelected, i = r.innerRef, s = r.innerProps;
  return he("div", pe({}, lt(r, "option", {
    option: !0,
    "option--is-disabled": n,
    "option--is-focused": o,
    "option--is-selected": a
  }), {
    ref: i,
    "aria-disabled": n
  }, s), t);
}, ww = yw, Cw = function(r, t) {
  var n = r.theme, o = n.spacing, a = n.colors;
  return ce({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, t ? {} : {
    color: a.neutral50,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, Sw = function(r) {
  var t = r.children, n = r.innerProps;
  return he("div", pe({}, lt(r, "placeholder", {
    placeholder: !0
  }), n), t);
}, xw = Sw, Iw = function(r, t) {
  var n = r.isDisabled, o = r.theme, a = o.spacing, i = o.colors;
  return ce({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, t ? {} : {
    color: n ? i.neutral40 : i.neutral80,
    marginLeft: a.baseUnit / 2,
    marginRight: a.baseUnit / 2
  });
}, Dw = function(r) {
  var t = r.children, n = r.isDisabled, o = r.innerProps;
  return he("div", pe({}, lt(r, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": n
  }), o), t);
}, _w = Dw, kw = {
  ClearIndicator: Hy,
  Control: Qy,
  DropdownIndicator: Gy,
  DownChevron: nh,
  CrossIcon: Xu,
  Group: nw,
  GroupHeading: rw,
  IndicatorsContainer: Fy,
  IndicatorSeparator: $y,
  Input: uw,
  LoadingIndicator: Zy,
  Menu: Cy,
  MenuList: xy,
  MenuPortal: My,
  LoadingMessage: ky,
  NoOptionsMessage: _y,
  MultiValue: vw,
  MultiValueContainer: pw,
  MultiValueLabel: hw,
  MultiValueRemove: gw,
  Option: ww,
  Placeholder: xw,
  SelectContainer: Py,
  SingleValue: _w,
  ValueContainer: Oy
}, Ew = function(r) {
  return ce(ce({}, kw), r.components);
}, bd = Number.isNaN || function(r) {
  return typeof r == "number" && r !== r;
};
function Mw(e, r) {
  return !!(e === r || bd(e) && bd(r));
}
function Aw(e, r) {
  if (e.length !== r.length)
    return !1;
  for (var t = 0; t < e.length; t++)
    if (!Mw(e[t], r[t]))
      return !1;
  return !0;
}
function Pw(e, r) {
  r === void 0 && (r = Aw);
  var t = null;
  function n() {
    for (var o = [], a = 0; a < arguments.length; a++)
      o[a] = arguments[a];
    if (t && t.lastThis === this && r(o, t.lastArgs))
      return t.lastResult;
    var i = e.apply(this, o);
    return t = {
      lastResult: i,
      lastArgs: o,
      lastThis: this
    }, i;
  }
  return n.clear = function() {
    t = null;
  }, n;
}
function Rw() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ow = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: Rw
}, Tw = function(r) {
  return he("span", pe({
    css: Ow
  }, r));
}, yd = Tw, Fw = {
  guidance: function(r) {
    var t = r.isSearchable, n = r.isMulti, o = r.tabSelectsValue, a = r.context, i = r.isInitialFocus;
    switch (a) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(o ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(r["aria-label"] || "Select", " is focused ").concat(t ? ",type to refine list" : "", ", press Down to open the menu, ").concat(n ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(r) {
    var t = r.action, n = r.label, o = n === void 0 ? "" : n, a = r.labels, i = r.isDisabled;
    switch (t) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(o, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(a.length > 1 ? "s" : "", " ").concat(a.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(o, " is disabled. Select another option.") : "option ".concat(o, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(r) {
    var t = r.context, n = r.focused, o = r.options, a = r.label, i = a === void 0 ? "" : a, s = r.selectValue, l = r.isDisabled, u = r.isSelected, c = r.isAppleDevice, d = function(g, m) {
      return g && g.length ? "".concat(g.indexOf(m) + 1, " of ").concat(g.length) : "";
    };
    if (t === "value" && s)
      return "value ".concat(i, " focused, ").concat(d(s, n), ".");
    if (t === "menu" && c) {
      var f = l ? " disabled" : "", p = "".concat(u ? " selected" : "").concat(f);
      return "".concat(i).concat(p, ", ").concat(d(o, n), ".");
    }
    return "";
  },
  onFilter: function(r) {
    var t = r.inputValue, n = r.resultsMessage;
    return "".concat(n).concat(t ? " for search term " + t : "", ".");
  }
}, Nw = function(r) {
  var t = r.ariaSelection, n = r.focusedOption, o = r.focusedValue, a = r.focusableOptions, i = r.isFocused, s = r.selectValue, l = r.selectProps, u = r.id, c = r.isAppleDevice, d = l.ariaLiveMessages, f = l.getOptionLabel, p = l.inputValue, h = l.isMulti, g = l.isOptionDisabled, m = l.isSearchable, v = l.menuIsOpen, y = l.options, C = l.screenReaderStatus, I = l.tabSelectsValue, b = l.isLoading, D = l["aria-label"], x = l["aria-live"], _ = Ve(function() {
    return ce(ce({}, Fw), d || {});
  }, [d]), E = Ve(function() {
    var N = "";
    if (t && _.onChange) {
      var P = t.option, B = t.options, H = t.removedValue, re = t.removedValues, W = t.value, F = function(ie) {
        return Array.isArray(ie) ? null : ie;
      }, $ = H || P || F(W), Y = $ ? f($) : "", X = B || re || void 0, te = X ? X.map(f) : [], q = ce({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: $ && g($, s),
        label: Y,
        labels: te
      }, t);
      N = _.onChange(q);
    }
    return N;
  }, [t, _, g, s, f]), R = Ve(function() {
    var N = "", P = n || o, B = !!(n && s && s.includes(n));
    if (P && _.onFocus) {
      var H = {
        focused: P,
        label: f(P),
        isDisabled: g(P, s),
        isSelected: B,
        options: a,
        context: P === n ? "menu" : "value",
        selectValue: s,
        isAppleDevice: c
      };
      N = _.onFocus(H);
    }
    return N;
  }, [n, o, f, g, _, a, s, c]), L = Ve(function() {
    var N = "";
    if (v && y.length && !b && _.onFilter) {
      var P = C({
        count: a.length
      });
      N = _.onFilter({
        inputValue: p,
        resultsMessage: P
      });
    }
    return N;
  }, [a, p, v, _, y, C, b]), G = (t == null ? void 0 : t.action) === "initial-input-focus", V = Ve(function() {
    var N = "";
    if (_.guidance) {
      var P = o ? "value" : v ? "menu" : "input";
      N = _.guidance({
        "aria-label": D,
        context: P,
        isDisabled: n && g(n, s),
        isMulti: h,
        isSearchable: m,
        tabSelectsValue: I,
        isInitialFocus: G
      });
    }
    return N;
  }, [D, n, o, h, g, m, v, _, s, I, G]), O = he(Yi, null, he("span", {
    id: "aria-selection"
  }, E), he("span", {
    id: "aria-focused"
  }, R), he("span", {
    id: "aria-results"
  }, L), he("span", {
    id: "aria-guidance"
  }, V));
  return he(Yi, null, he(yd, {
    id: u
  }, G && O), he(yd, {
    "aria-live": x,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !G && O));
}, Lw = Nw, nu = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Ww = new RegExp("[" + nu.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), sh = {};
for (var gl = 0; gl < nu.length; gl++)
  for (var ml = nu[gl], vl = 0; vl < ml.letters.length; vl++)
    sh[ml.letters[vl]] = ml.base;
var lh = function(r) {
  return r.replace(Ww, function(t) {
    return sh[t];
  });
}, Bw = Pw(lh), wd = function(r) {
  return r.replace(/^\s+|\s+$/g, "");
}, Vw = function(r) {
  return "".concat(r.label, " ").concat(r.value);
}, Gw = function(r) {
  return function(t, n) {
    if (t.data.__isNew__) return !0;
    var o = ce({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Vw,
      trim: !0,
      matchFrom: "any"
    }, r), a = o.ignoreCase, i = o.ignoreAccents, s = o.stringify, l = o.trim, u = o.matchFrom, c = l ? wd(n) : n, d = l ? wd(s(t)) : s(t);
    return a && (c = c.toLowerCase(), d = d.toLowerCase()), i && (c = Bw(c), d = lh(d)), u === "start" ? d.substr(0, c.length) === c : d.indexOf(c) > -1;
  };
}, Yw = ["innerRef"];
function Hw(e) {
  var r = e.innerRef, t = br(e, Yw), n = py(t, "onExited", "in", "enter", "exit", "appear");
  return he("input", pe({
    ref: r
  }, n, {
    css: /* @__PURE__ */ Ap({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgUmVmIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgcmVtb3ZlUHJvcHMgfSBmcm9tICcuLi91dGlscyc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIER1bW15SW5wdXQoe1xuICBpbm5lclJlZixcbiAgLi4ucHJvcHNcbn06IEpTWC5JbnRyaW5zaWNFbGVtZW50c1snaW5wdXQnXSAmIHtcbiAgcmVhZG9ubHkgaW5uZXJSZWY6IFJlZjxIVE1MSW5wdXRFbGVtZW50Pjtcbn0pIHtcbiAgLy8gUmVtb3ZlIGFuaW1hdGlvbiBwcm9wcyBub3QgbWVhbnQgZm9yIEhUTUwgZWxlbWVudHNcbiAgY29uc3QgZmlsdGVyZWRQcm9wcyA9IHJlbW92ZVByb3BzKFxuICAgIHByb3BzLFxuICAgICdvbkV4aXRlZCcsXG4gICAgJ2luJyxcbiAgICAnZW50ZXInLFxuICAgICdleGl0JyxcbiAgICAnYXBwZWFyJ1xuICApO1xuXG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLmZpbHRlcmVkUHJvcHN9XG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdkdW1teUlucHV0JyxcbiAgICAgICAgLy8gZ2V0IHJpZCBvZiBhbnkgZGVmYXVsdCBzdHlsZXNcbiAgICAgICAgYmFja2dyb3VuZDogMCxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHRoaXMgaGlkZXMgdGhlIGZsYXNoaW5nIGN1cnNvclxuICAgICAgICBjYXJldENvbG9yOiAndHJhbnNwYXJlbnQnLFxuICAgICAgICBmb250U2l6ZTogJ2luaGVyaXQnLFxuICAgICAgICBncmlkQXJlYTogJzEgLyAxIC8gMiAvIDMnLFxuICAgICAgICBvdXRsaW5lOiAwLFxuICAgICAgICBwYWRkaW5nOiAwLFxuICAgICAgICAvLyBpbXBvcnRhbnQhIHdpdGhvdXQgYHdpZHRoYCBicm93c2VycyB3b24ndCBhbGxvdyBmb2N1c1xuICAgICAgICB3aWR0aDogMSxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIGRlc2t0b3BcbiAgICAgICAgY29sb3I6ICd0cmFuc3BhcmVudCcsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBtb2JpbGUgd2hpbHN0IG1haW50YWluaW5nIFwic2Nyb2xsIGludG8gdmlld1wiIGJlaGF2aW91clxuICAgICAgICBsZWZ0OiAtMTAwLFxuICAgICAgICBvcGFjaXR5OiAwLFxuICAgICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgICAgdHJhbnNmb3JtOiAnc2NhbGUoLjAxKScsXG4gICAgICB9fVxuICAgIC8+XG4gICk7XG59XG4iXX0= */")
  }));
}
var zw = function(r) {
  r.cancelable && r.preventDefault(), r.stopPropagation();
};
function $w(e) {
  var r = e.isEnabled, t = e.onBottomArrive, n = e.onBottomLeave, o = e.onTopArrive, a = e.onTopLeave, i = ye(!1), s = ye(!1), l = ye(0), u = ye(null), c = se(function(m, v) {
    if (u.current !== null) {
      var y = u.current, C = y.scrollTop, I = y.scrollHeight, b = y.clientHeight, D = u.current, x = v > 0, _ = I - b - C, E = !1;
      _ > v && i.current && (n && n(m), i.current = !1), x && s.current && (a && a(m), s.current = !1), x && v > _ ? (t && !i.current && t(m), D.scrollTop = I, E = !0, i.current = !0) : !x && -v > C && (o && !s.current && o(m), D.scrollTop = 0, E = !0, s.current = !0), E && zw(m);
    }
  }, [t, n, o, a]), d = se(function(m) {
    c(m, m.deltaY);
  }, [c]), f = se(function(m) {
    l.current = m.changedTouches[0].clientY;
  }, []), p = se(function(m) {
    var v = l.current - m.changedTouches[0].clientY;
    c(m, v);
  }, [c]), h = se(function(m) {
    if (m) {
      var v = cy ? {
        passive: !1
      } : !1;
      m.addEventListener("wheel", d, v), m.addEventListener("touchstart", f, v), m.addEventListener("touchmove", p, v);
    }
  }, [p, f, d]), g = se(function(m) {
    m && (m.removeEventListener("wheel", d, !1), m.removeEventListener("touchstart", f, !1), m.removeEventListener("touchmove", p, !1));
  }, [p, f, d]);
  return Ye(function() {
    if (r) {
      var m = u.current;
      return h(m), function() {
        g(m);
      };
    }
  }, [r, h, g]), function(m) {
    u.current = m;
  };
}
var Cd = ["boxSizing", "height", "overflow", "paddingRight", "position"], Sd = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function xd(e) {
  e.preventDefault();
}
function Id(e) {
  e.stopPropagation();
}
function Dd() {
  var e = this.scrollTop, r = this.scrollHeight, t = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : t === r && (this.scrollTop = e - 1);
}
function _d() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var kd = !!(typeof window < "u" && window.document && window.document.createElement), ia = 0, mo = {
  capture: !1,
  passive: !1
};
function Xw(e) {
  var r = e.isEnabled, t = e.accountForScrollbars, n = t === void 0 ? !0 : t, o = ye({}), a = ye(null), i = se(function(l) {
    if (kd) {
      var u = document.body, c = u && u.style;
      if (n && Cd.forEach(function(h) {
        var g = c && c[h];
        o.current[h] = g;
      }), n && ia < 1) {
        var d = parseInt(o.current.paddingRight, 10) || 0, f = document.body ? document.body.clientWidth : 0, p = window.innerWidth - f + d || 0;
        Object.keys(Sd).forEach(function(h) {
          var g = Sd[h];
          c && (c[h] = g);
        }), c && (c.paddingRight = "".concat(p, "px"));
      }
      u && _d() && (u.addEventListener("touchmove", xd, mo), l && (l.addEventListener("touchstart", Dd, mo), l.addEventListener("touchmove", Id, mo))), ia += 1;
    }
  }, [n]), s = se(function(l) {
    if (kd) {
      var u = document.body, c = u && u.style;
      ia = Math.max(ia - 1, 0), n && ia < 1 && Cd.forEach(function(d) {
        var f = o.current[d];
        c && (c[d] = f);
      }), u && _d() && (u.removeEventListener("touchmove", xd, mo), l && (l.removeEventListener("touchstart", Dd, mo), l.removeEventListener("touchmove", Id, mo)));
    }
  }, [n]);
  return Ye(function() {
    if (r) {
      var l = a.current;
      return i(l), function() {
        s(l);
      };
    }
  }, [r, i, s]), function(l) {
    a.current = l;
  };
}
function jw() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Zw = function(r) {
  var t = r.target;
  return t.ownerDocument.activeElement && t.ownerDocument.activeElement.blur();
}, Uw = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: jw
};
function Jw(e) {
  var r = e.children, t = e.lockEnabled, n = e.captureEnabled, o = n === void 0 ? !0 : n, a = e.onBottomArrive, i = e.onBottomLeave, s = e.onTopArrive, l = e.onTopLeave, u = $w({
    isEnabled: o,
    onBottomArrive: a,
    onBottomLeave: i,
    onTopArrive: s,
    onTopLeave: l
  }), c = Xw({
    isEnabled: t
  }), d = function(p) {
    u(p), c(p);
  };
  return he(Yi, null, t && he("div", {
    onClick: Zw,
    css: Uw
  }), r(d));
}
function Qw() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var qw = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Qw
}, Kw = function(r) {
  var t = r.name, n = r.onFocus;
  return he("input", {
    required: !0,
    name: t,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: n,
    css: qw,
    value: "",
    onChange: function() {
    }
  });
}, eC = Kw;
function ju(e) {
  var r;
  return typeof window < "u" && window.navigator != null ? e.test(((r = window.navigator.userAgentData) === null || r === void 0 ? void 0 : r.platform) || window.navigator.platform) : !1;
}
function tC() {
  return ju(/^iPhone/i);
}
function uh() {
  return ju(/^Mac/i);
}
function rC() {
  return ju(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  uh() && navigator.maxTouchPoints > 1;
}
function nC() {
  return tC() || rC();
}
function oC() {
  return uh() || nC();
}
var aC = function(r) {
  return r.label;
}, ch = function(r) {
  return r.label;
}, dh = function(r) {
  return r.value;
}, iC = function(r) {
  return !!r.isDisabled;
}, sC = {
  clearIndicator: Yy,
  container: Ay,
  control: Uy,
  dropdownIndicator: Vy,
  group: Ky,
  groupHeading: tw,
  indicatorsContainer: Ty,
  indicatorSeparator: zy,
  input: aw,
  loadingIndicator: jy,
  loadingMessage: Dy,
  menu: by,
  menuList: Sy,
  menuPortal: Ey,
  multiValue: cw,
  multiValueLabel: dw,
  multiValueRemove: fw,
  noOptionsMessage: Iy,
  option: bw,
  placeholder: Cw,
  singleValue: Iw,
  valueContainer: Ry
}, lC = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, uC = 4, fh = 4, cC = 38, dC = fh * 2, fC = {
  baseUnit: fh,
  controlHeight: cC,
  menuGutter: dC
}, bl = {
  borderRadius: uC,
  colors: lC,
  spacing: fC
}, pC = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: md(),
  captureMenuScroll: !md(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Gw(),
  formatGroupLabel: aC,
  getOptionLabel: ch,
  getOptionValue: dh,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: iC,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !ly(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(r) {
    var t = r.count;
    return "".concat(t, " result").concat(t !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function Ed(e, r, t, n) {
  var o = gh(e, r, t), a = mh(e, r, t), i = hh(e, r), s = Ki(e, r);
  return {
    type: "option",
    data: r,
    isDisabled: o,
    isSelected: a,
    label: i,
    value: s,
    index: n
  };
}
function Ei(e, r) {
  return e.options.map(function(t, n) {
    if ("options" in t) {
      var o = t.options.map(function(i, s) {
        return Ed(e, i, r, s);
      }).filter(function(i) {
        return Ad(e, i);
      });
      return o.length > 0 ? {
        type: "group",
        data: t,
        options: o,
        index: n
      } : void 0;
    }
    var a = Ed(e, t, r, n);
    return Ad(e, a) ? a : void 0;
  }).filter(dy);
}
function ph(e) {
  return e.reduce(function(r, t) {
    return t.type === "group" ? r.push.apply(r, Do(t.options.map(function(n) {
      return n.data;
    }))) : r.push(t.data), r;
  }, []);
}
function Md(e, r) {
  return e.reduce(function(t, n) {
    return n.type === "group" ? t.push.apply(t, Do(n.options.map(function(o) {
      return {
        data: o.data,
        id: "".concat(r, "-").concat(n.index, "-").concat(o.index)
      };
    }))) : t.push({
      data: n.data,
      id: "".concat(r, "-").concat(n.index)
    }), t;
  }, []);
}
function hC(e, r) {
  return ph(Ei(e, r));
}
function Ad(e, r) {
  var t = e.inputValue, n = t === void 0 ? "" : t, o = r.data, a = r.isSelected, i = r.label, s = r.value;
  return (!bh(e) || !a) && vh(e, {
    label: i,
    value: s,
    data: o
  }, n);
}
function gC(e, r) {
  var t = e.focusedValue, n = e.selectValue, o = n.indexOf(t);
  if (o > -1) {
    var a = r.indexOf(t);
    if (a > -1)
      return t;
    if (o < r.length)
      return r[o];
  }
  return null;
}
function mC(e, r) {
  var t = e.focusedOption;
  return t && r.indexOf(t) > -1 ? t : r[0];
}
var yl = function(r, t) {
  var n, o = (n = r.find(function(a) {
    return a.data === t;
  })) === null || n === void 0 ? void 0 : n.id;
  return o || null;
}, hh = function(r, t) {
  return r.getOptionLabel(t);
}, Ki = function(r, t) {
  return r.getOptionValue(t);
};
function gh(e, r, t) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(r, t) : !1;
}
function mh(e, r, t) {
  if (t.indexOf(r) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(r, t);
  var n = Ki(e, r);
  return t.some(function(o) {
    return Ki(e, o) === n;
  });
}
function vh(e, r, t) {
  return e.filterOption ? e.filterOption(r, t) : !0;
}
var bh = function(r) {
  var t = r.hideSelectedOptions, n = r.isMulti;
  return t === void 0 ? n : t;
}, vC = 1, Xa = /* @__PURE__ */ function(e) {
  Kb(t, e);
  var r = r0(t);
  function t(n) {
    var o;
    if (Qb(this, t), o = r.call(this, n), o.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: ""
    }, o.blockOptionHover = !1, o.isComposing = !1, o.commonProps = void 0, o.initialTouchX = 0, o.initialTouchY = 0, o.openAfterFocus = !1, o.scrollToFocusedOptionOnUpdate = !1, o.userIsDragging = void 0, o.isAppleDevice = oC(), o.controlRef = null, o.getControlRef = function(l) {
      o.controlRef = l;
    }, o.focusedOptionRef = null, o.getFocusedOptionRef = function(l) {
      o.focusedOptionRef = l;
    }, o.menuListRef = null, o.getMenuListRef = function(l) {
      o.menuListRef = l;
    }, o.inputRef = null, o.getInputRef = function(l) {
      o.inputRef = l;
    }, o.focus = o.focusInput, o.blur = o.blurInput, o.onChange = function(l, u) {
      var c = o.props, d = c.onChange, f = c.name;
      u.name = f, o.ariaOnChange(l, u), d(l, u);
    }, o.setValue = function(l, u, c) {
      var d = o.props, f = d.closeMenuOnSelect, p = d.isMulti, h = d.inputValue;
      o.onInputChange("", {
        action: "set-value",
        prevInputValue: h
      }), f && (o.setState({
        inputIsHiddenAfterUpdate: !p
      }), o.onMenuClose()), o.setState({
        clearFocusValueOnUpdate: !0
      }), o.onChange(l, {
        action: u,
        option: c
      });
    }, o.selectOption = function(l) {
      var u = o.props, c = u.blurInputOnSelect, d = u.isMulti, f = u.name, p = o.state.selectValue, h = d && o.isOptionSelected(l, p), g = o.isOptionDisabled(l, p);
      if (h) {
        var m = o.getOptionValue(l);
        o.setValue(p.filter(function(v) {
          return o.getOptionValue(v) !== m;
        }), "deselect-option", l);
      } else if (!g)
        d ? o.setValue([].concat(Do(p), [l]), "select-option", l) : o.setValue(l, "select-option");
      else {
        o.ariaOnChange(l, {
          action: "select-option",
          option: l,
          name: f
        });
        return;
      }
      c && o.blurInput();
    }, o.removeValue = function(l) {
      var u = o.props.isMulti, c = o.state.selectValue, d = o.getOptionValue(l), f = c.filter(function(h) {
        return o.getOptionValue(h) !== d;
      }), p = va(u, f, f[0] || null);
      o.onChange(p, {
        action: "remove-value",
        removedValue: l
      }), o.focusInput();
    }, o.clearValue = function() {
      var l = o.state.selectValue;
      o.onChange(va(o.props.isMulti, [], null), {
        action: "clear",
        removedValues: l
      });
    }, o.popValue = function() {
      var l = o.props.isMulti, u = o.state.selectValue, c = u[u.length - 1], d = u.slice(0, u.length - 1), f = va(l, d, d[0] || null);
      o.onChange(f, {
        action: "pop-value",
        removedValue: c
      });
    }, o.getFocusedOptionId = function(l) {
      return yl(o.state.focusableOptionsWithIds, l);
    }, o.getFocusableOptionsWithIds = function() {
      return Md(Ei(o.props, o.state.selectValue), o.getElementId("option"));
    }, o.getValue = function() {
      return o.state.selectValue;
    }, o.cx = function() {
      for (var l = arguments.length, u = new Array(l), c = 0; c < l; c++)
        u[c] = arguments[c];
      return ry.apply(void 0, [o.props.classNamePrefix].concat(u));
    }, o.getOptionLabel = function(l) {
      return hh(o.props, l);
    }, o.getOptionValue = function(l) {
      return Ki(o.props, l);
    }, o.getStyles = function(l, u) {
      var c = o.props.unstyled, d = sC[l](u, c);
      d.boxSizing = "border-box";
      var f = o.props.styles[l];
      return f ? f(d, u) : d;
    }, o.getClassNames = function(l, u) {
      var c, d;
      return (c = (d = o.props.classNames)[l]) === null || c === void 0 ? void 0 : c.call(d, u);
    }, o.getElementId = function(l) {
      return "".concat(o.state.instancePrefix, "-").concat(l);
    }, o.getComponents = function() {
      return Ew(o.props);
    }, o.buildCategorizedOptions = function() {
      return Ei(o.props, o.state.selectValue);
    }, o.getCategorizedOptions = function() {
      return o.props.menuIsOpen ? o.buildCategorizedOptions() : [];
    }, o.buildFocusableOptions = function() {
      return ph(o.buildCategorizedOptions());
    }, o.getFocusableOptions = function() {
      return o.props.menuIsOpen ? o.buildFocusableOptions() : [];
    }, o.ariaOnChange = function(l, u) {
      o.setState({
        ariaSelection: ce({
          value: l
        }, u)
      });
    }, o.onMenuMouseDown = function(l) {
      l.button === 0 && (l.stopPropagation(), l.preventDefault(), o.focusInput());
    }, o.onMenuMouseMove = function(l) {
      o.blockOptionHover = !1;
    }, o.onControlMouseDown = function(l) {
      if (!l.defaultPrevented) {
        var u = o.props.openMenuOnClick;
        o.state.isFocused ? o.props.menuIsOpen ? l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && o.onMenuClose() : u && o.openMenu("first") : (u && (o.openAfterFocus = !0), o.focusInput()), l.target.tagName !== "INPUT" && l.target.tagName !== "TEXTAREA" && l.preventDefault();
      }
    }, o.onDropdownIndicatorMouseDown = function(l) {
      if (!(l && l.type === "mousedown" && l.button !== 0) && !o.props.isDisabled) {
        var u = o.props, c = u.isMulti, d = u.menuIsOpen;
        o.focusInput(), d ? (o.setState({
          inputIsHiddenAfterUpdate: !c
        }), o.onMenuClose()) : o.openMenu("first"), l.preventDefault();
      }
    }, o.onClearIndicatorMouseDown = function(l) {
      l && l.type === "mousedown" && l.button !== 0 || (o.clearValue(), l.preventDefault(), o.openAfterFocus = !1, l.type === "touchend" ? o.focusInput() : setTimeout(function() {
        return o.focusInput();
      }));
    }, o.onScroll = function(l) {
      typeof o.props.closeMenuOnScroll == "boolean" ? l.target instanceof HTMLElement && Ps(l.target) && o.props.onMenuClose() : typeof o.props.closeMenuOnScroll == "function" && o.props.closeMenuOnScroll(l) && o.props.onMenuClose();
    }, o.onCompositionStart = function() {
      o.isComposing = !0;
    }, o.onCompositionEnd = function() {
      o.isComposing = !1;
    }, o.onTouchStart = function(l) {
      var u = l.touches, c = u && u.item(0);
      c && (o.initialTouchX = c.clientX, o.initialTouchY = c.clientY, o.userIsDragging = !1);
    }, o.onTouchMove = function(l) {
      var u = l.touches, c = u && u.item(0);
      if (c) {
        var d = Math.abs(c.clientX - o.initialTouchX), f = Math.abs(c.clientY - o.initialTouchY), p = 5;
        o.userIsDragging = d > p || f > p;
      }
    }, o.onTouchEnd = function(l) {
      o.userIsDragging || (o.controlRef && !o.controlRef.contains(l.target) && o.menuListRef && !o.menuListRef.contains(l.target) && o.blurInput(), o.initialTouchX = 0, o.initialTouchY = 0);
    }, o.onControlTouchEnd = function(l) {
      o.userIsDragging || o.onControlMouseDown(l);
    }, o.onClearIndicatorTouchEnd = function(l) {
      o.userIsDragging || o.onClearIndicatorMouseDown(l);
    }, o.onDropdownIndicatorTouchEnd = function(l) {
      o.userIsDragging || o.onDropdownIndicatorMouseDown(l);
    }, o.handleInputChange = function(l) {
      var u = o.props.inputValue, c = l.currentTarget.value;
      o.setState({
        inputIsHiddenAfterUpdate: !1
      }), o.onInputChange(c, {
        action: "input-change",
        prevInputValue: u
      }), o.props.menuIsOpen || o.onMenuOpen();
    }, o.onInputFocus = function(l) {
      o.props.onFocus && o.props.onFocus(l), o.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (o.openAfterFocus || o.props.openMenuOnFocus) && o.openMenu("first"), o.openAfterFocus = !1;
    }, o.onInputBlur = function(l) {
      var u = o.props.inputValue;
      if (o.menuListRef && o.menuListRef.contains(document.activeElement)) {
        o.inputRef.focus();
        return;
      }
      o.props.onBlur && o.props.onBlur(l), o.onInputChange("", {
        action: "input-blur",
        prevInputValue: u
      }), o.onMenuClose(), o.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, o.onOptionHover = function(l) {
      if (!(o.blockOptionHover || o.state.focusedOption === l)) {
        var u = o.getFocusableOptions(), c = u.indexOf(l);
        o.setState({
          focusedOption: l,
          focusedOptionId: c > -1 ? o.getFocusedOptionId(l) : null
        });
      }
    }, o.shouldHideSelectedOptions = function() {
      return bh(o.props);
    }, o.onValueInputFocus = function(l) {
      l.preventDefault(), l.stopPropagation(), o.focus();
    }, o.onKeyDown = function(l) {
      var u = o.props, c = u.isMulti, d = u.backspaceRemovesValue, f = u.escapeClearsValue, p = u.inputValue, h = u.isClearable, g = u.isDisabled, m = u.menuIsOpen, v = u.onKeyDown, y = u.tabSelectsValue, C = u.openMenuOnFocus, I = o.state, b = I.focusedOption, D = I.focusedValue, x = I.selectValue;
      if (!g && !(typeof v == "function" && (v(l), l.defaultPrevented))) {
        switch (o.blockOptionHover = !0, l.key) {
          case "ArrowLeft":
            if (!c || p) return;
            o.focusValue("previous");
            break;
          case "ArrowRight":
            if (!c || p) return;
            o.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (p) return;
            if (D)
              o.removeValue(D);
            else {
              if (!d) return;
              c ? o.popValue() : h && o.clearValue();
            }
            break;
          case "Tab":
            if (o.isComposing || l.shiftKey || !m || !y || !b || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            C && o.isOptionSelected(b, x))
              return;
            o.selectOption(b);
            break;
          case "Enter":
            if (l.keyCode === 229)
              break;
            if (m) {
              if (!b || o.isComposing) return;
              o.selectOption(b);
              break;
            }
            return;
          case "Escape":
            m ? (o.setState({
              inputIsHiddenAfterUpdate: !1
            }), o.onInputChange("", {
              action: "menu-close",
              prevInputValue: p
            }), o.onMenuClose()) : h && f && o.clearValue();
            break;
          case " ":
            if (p)
              return;
            if (!m) {
              o.openMenu("first");
              break;
            }
            if (!b) return;
            o.selectOption(b);
            break;
          case "ArrowUp":
            m ? o.focusOption("up") : o.openMenu("last");
            break;
          case "ArrowDown":
            m ? o.focusOption("down") : o.openMenu("first");
            break;
          case "PageUp":
            if (!m) return;
            o.focusOption("pageup");
            break;
          case "PageDown":
            if (!m) return;
            o.focusOption("pagedown");
            break;
          case "Home":
            if (!m) return;
            o.focusOption("first");
            break;
          case "End":
            if (!m) return;
            o.focusOption("last");
            break;
          default:
            return;
        }
        l.preventDefault();
      }
    }, o.state.instancePrefix = "react-select-" + (o.props.instanceId || ++vC), o.state.selectValue = Qi(n.value), n.menuIsOpen && o.state.selectValue.length) {
      var a = o.getFocusableOptionsWithIds(), i = o.buildFocusableOptions(), s = i.indexOf(o.state.selectValue[0]);
      o.state.focusableOptionsWithIds = a, o.state.focusedOption = i[s], o.state.focusedOptionId = yl(a, i[s]);
    }
    return o;
  }
  return qb(t, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && gd(this.menuListRef, this.focusedOptionRef);
    }
  }, {
    key: "componentDidUpdate",
    value: function(o) {
      var a = this.props, i = a.isDisabled, s = a.menuIsOpen, l = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (l && !i && o.isDisabled || // ensure focus is on the Input when the menu opens
      l && s && !o.menuIsOpen) && this.focusInput(), l && i && !o.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !l && !i && o.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (gd(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(o, a) {
      this.props.onInputChange(o, a);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(o) {
      var a = this, i = this.state, s = i.selectValue, l = i.isFocused, u = this.buildFocusableOptions(), c = o === "first" ? 0 : u.length - 1;
      if (!this.props.isMulti) {
        var d = u.indexOf(s[0]);
        d > -1 && (c = d);
      }
      this.scrollToFocusedOptionOnUpdate = !(l && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: u[c],
        focusedOptionId: this.getFocusedOptionId(u[c])
      }, function() {
        return a.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(o) {
      var a = this.state, i = a.selectValue, s = a.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var l = i.indexOf(s);
        s || (l = -1);
        var u = i.length - 1, c = -1;
        if (i.length) {
          switch (o) {
            case "previous":
              l === 0 ? c = 0 : l === -1 ? c = u : c = l - 1;
              break;
            case "next":
              l > -1 && l < u && (c = l + 1);
              break;
          }
          this.setState({
            inputIsHidden: c !== -1,
            focusedValue: i[c]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", a = this.props.pageSize, i = this.state.focusedOption, s = this.getFocusableOptions();
      if (s.length) {
        var l = 0, u = s.indexOf(i);
        i || (u = -1), o === "up" ? l = u > 0 ? u - 1 : s.length - 1 : o === "down" ? l = (u + 1) % s.length : o === "pageup" ? (l = u - a, l < 0 && (l = 0)) : o === "pagedown" ? (l = u + a, l > s.length - 1 && (l = s.length - 1)) : o === "last" && (l = s.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: s[l],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(s[l])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(bl) : ce(ce({}, bl), this.props.theme) : bl;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var o = this.clearValue, a = this.cx, i = this.getStyles, s = this.getClassNames, l = this.getValue, u = this.selectOption, c = this.setValue, d = this.props, f = d.isMulti, p = d.isRtl, h = d.options, g = this.hasValue();
      return {
        clearValue: o,
        cx: a,
        getStyles: i,
        getClassNames: s,
        getValue: l,
        hasValue: g,
        isMulti: f,
        isRtl: p,
        options: h,
        selectOption: u,
        selectProps: d,
        setValue: c,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var o = this.state.selectValue;
      return o.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var o = this.props, a = o.isClearable, i = o.isMulti;
      return a === void 0 ? i : a;
    }
  }, {
    key: "isOptionDisabled",
    value: function(o, a) {
      return gh(this.props, o, a);
    }
  }, {
    key: "isOptionSelected",
    value: function(o, a) {
      return mh(this.props, o, a);
    }
  }, {
    key: "filterOption",
    value: function(o, a) {
      return vh(this.props, o, a);
    }
  }, {
    key: "formatOptionLabel",
    value: function(o, a) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, s = this.state.selectValue;
        return this.props.formatOptionLabel(o, {
          context: a,
          inputValue: i,
          selectValue: s
        });
      } else
        return this.getOptionLabel(o);
    }
  }, {
    key: "formatGroupLabel",
    value: function(o) {
      return this.props.formatGroupLabel(o);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var o = this.props, a = o.isDisabled, i = o.isSearchable, s = o.inputId, l = o.inputValue, u = o.tabIndex, c = o.form, d = o.menuIsOpen, f = o.required, p = this.getComponents(), h = p.Input, g = this.state, m = g.inputIsHidden, v = g.ariaSelection, y = this.commonProps, C = s || this.getElementId("input"), I = ce(ce(ce({
          "aria-autocomplete": "list",
          "aria-expanded": d,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": f,
          role: "combobox",
          "aria-activedescendant": this.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, d && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (v == null ? void 0 : v.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ U.createElement(h, pe({}, y, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: C,
          innerRef: this.getInputRef,
          isDisabled: a,
          isHidden: m,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: u,
          form: c,
          type: "text",
          value: l
        }, I)) : /* @__PURE__ */ U.createElement(Hw, pe({
          id: C,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: Ji,
          onFocus: this.onInputFocus,
          disabled: a,
          tabIndex: u,
          inputMode: "none",
          form: c,
          value: ""
        }, I));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var o = this, a = this.getComponents(), i = a.MultiValue, s = a.MultiValueContainer, l = a.MultiValueLabel, u = a.MultiValueRemove, c = a.SingleValue, d = a.Placeholder, f = this.commonProps, p = this.props, h = p.controlShouldRenderValue, g = p.isDisabled, m = p.isMulti, v = p.inputValue, y = p.placeholder, C = this.state, I = C.selectValue, b = C.focusedValue, D = C.isFocused;
      if (!this.hasValue() || !h)
        return v ? null : /* @__PURE__ */ U.createElement(d, pe({}, f, {
          key: "placeholder",
          isDisabled: g,
          isFocused: D,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), y);
      if (m)
        return I.map(function(_, E) {
          var R = _ === b, L = "".concat(o.getOptionLabel(_), "-").concat(o.getOptionValue(_));
          return /* @__PURE__ */ U.createElement(i, pe({}, f, {
            components: {
              Container: s,
              Label: l,
              Remove: u
            },
            isFocused: R,
            isDisabled: g,
            key: L,
            index: E,
            removeProps: {
              onClick: function() {
                return o.removeValue(_);
              },
              onTouchEnd: function() {
                return o.removeValue(_);
              },
              onMouseDown: function(V) {
                V.preventDefault();
              }
            },
            data: _
          }), o.formatOptionLabel(_, "value"));
        });
      if (v)
        return null;
      var x = I[0];
      return /* @__PURE__ */ U.createElement(c, pe({}, f, {
        data: x,
        isDisabled: g
      }), this.formatOptionLabel(x, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var o = this.getComponents(), a = o.ClearIndicator, i = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, c = this.state.isFocused;
      if (!this.isClearable() || !a || l || !this.hasValue() || u)
        return null;
      var d = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ U.createElement(a, pe({}, i, {
        innerProps: d,
        isFocused: c
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var o = this.getComponents(), a = o.LoadingIndicator, i = this.commonProps, s = this.props, l = s.isDisabled, u = s.isLoading, c = this.state.isFocused;
      if (!a || !u) return null;
      var d = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ U.createElement(a, pe({}, i, {
        innerProps: d,
        isDisabled: l,
        isFocused: c
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator, i = o.IndicatorSeparator;
      if (!a || !i) return null;
      var s = this.commonProps, l = this.props.isDisabled, u = this.state.isFocused;
      return /* @__PURE__ */ U.createElement(i, pe({}, s, {
        isDisabled: l,
        isFocused: u
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var o = this.getComponents(), a = o.DropdownIndicator;
      if (!a) return null;
      var i = this.commonProps, s = this.props.isDisabled, l = this.state.isFocused, u = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ U.createElement(a, pe({}, i, {
        innerProps: u,
        isDisabled: s,
        isFocused: l
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var o = this, a = this.getComponents(), i = a.Group, s = a.GroupHeading, l = a.Menu, u = a.MenuList, c = a.MenuPortal, d = a.LoadingMessage, f = a.NoOptionsMessage, p = a.Option, h = this.commonProps, g = this.state.focusedOption, m = this.props, v = m.captureMenuScroll, y = m.inputValue, C = m.isLoading, I = m.loadingMessage, b = m.minMenuHeight, D = m.maxMenuHeight, x = m.menuIsOpen, _ = m.menuPlacement, E = m.menuPosition, R = m.menuPortalTarget, L = m.menuShouldBlockScroll, G = m.menuShouldScrollIntoView, V = m.noOptionsMessage, O = m.onMenuScrollToTop, N = m.onMenuScrollToBottom;
      if (!x) return null;
      var P = function(Y, X) {
        var te = Y.type, q = Y.data, ue = Y.isDisabled, ie = Y.isSelected, be = Y.label, ge = Y.value, Pe = g === q, Z = ue ? void 0 : function() {
          return o.onOptionHover(q);
        }, at = ue ? void 0 : function() {
          return o.selectOption(q);
        }, xt = "".concat(o.getElementId("option"), "-").concat(X), Et = {
          id: xt,
          onClick: at,
          onMouseMove: Z,
          onMouseOver: Z,
          tabIndex: -1,
          role: "option",
          "aria-selected": o.isAppleDevice ? void 0 : ie
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ U.createElement(p, pe({}, h, {
          innerProps: Et,
          data: q,
          isDisabled: ue,
          isSelected: ie,
          key: xt,
          label: be,
          type: te,
          value: ge,
          isFocused: Pe,
          innerRef: Pe ? o.getFocusedOptionRef : void 0
        }), o.formatOptionLabel(Y.data, "menu"));
      }, B;
      if (this.hasOptions())
        B = this.getCategorizedOptions().map(function($) {
          if ($.type === "group") {
            var Y = $.data, X = $.options, te = $.index, q = "".concat(o.getElementId("group"), "-").concat(te), ue = "".concat(q, "-heading");
            return /* @__PURE__ */ U.createElement(i, pe({}, h, {
              key: q,
              data: Y,
              options: X,
              Heading: s,
              headingProps: {
                id: ue,
                data: $.data
              },
              label: o.formatGroupLabel($.data)
            }), $.options.map(function(ie) {
              return P(ie, "".concat(te, "-").concat(ie.index));
            }));
          } else if ($.type === "option")
            return P($, "".concat($.index));
        });
      else if (C) {
        var H = I({
          inputValue: y
        });
        if (H === null) return null;
        B = /* @__PURE__ */ U.createElement(d, h, H);
      } else {
        var re = V({
          inputValue: y
        });
        if (re === null) return null;
        B = /* @__PURE__ */ U.createElement(f, h, re);
      }
      var W = {
        minMenuHeight: b,
        maxMenuHeight: D,
        menuPlacement: _,
        menuPosition: E,
        menuShouldScrollIntoView: G
      }, F = /* @__PURE__ */ U.createElement(yy, pe({}, h, W), function($) {
        var Y = $.ref, X = $.placerProps, te = X.placement, q = X.maxHeight;
        return /* @__PURE__ */ U.createElement(l, pe({}, h, W, {
          innerRef: Y,
          innerProps: {
            onMouseDown: o.onMenuMouseDown,
            onMouseMove: o.onMenuMouseMove
          },
          isLoading: C,
          placement: te
        }), /* @__PURE__ */ U.createElement(Jw, {
          captureEnabled: v,
          onTopArrive: O,
          onBottomArrive: N,
          lockEnabled: L
        }, function(ue) {
          return /* @__PURE__ */ U.createElement(u, pe({}, h, {
            innerRef: function(be) {
              o.getMenuListRef(be), ue(be);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": h.isMulti,
              id: o.getElementId("listbox")
            },
            isLoading: C,
            maxHeight: q,
            focusedOption: g
          }), B);
        }));
      });
      return R || E === "fixed" ? /* @__PURE__ */ U.createElement(c, pe({}, h, {
        appendTo: R,
        controlElement: this.controlRef,
        menuPlacement: _,
        menuPosition: E
      }), F) : F;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var o = this, a = this.props, i = a.delimiter, s = a.isDisabled, l = a.isMulti, u = a.name, c = a.required, d = this.state.selectValue;
      if (c && !this.hasValue() && !s)
        return /* @__PURE__ */ U.createElement(eC, {
          name: u,
          onFocus: this.onValueInputFocus
        });
      if (!(!u || s))
        if (l)
          if (i) {
            var f = d.map(function(g) {
              return o.getOptionValue(g);
            }).join(i);
            return /* @__PURE__ */ U.createElement("input", {
              name: u,
              type: "hidden",
              value: f
            });
          } else {
            var p = d.length > 0 ? d.map(function(g, m) {
              return /* @__PURE__ */ U.createElement("input", {
                key: "i-".concat(m),
                name: u,
                type: "hidden",
                value: o.getOptionValue(g)
              });
            }) : /* @__PURE__ */ U.createElement("input", {
              name: u,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ U.createElement("div", null, p);
          }
        else {
          var h = d[0] ? this.getOptionValue(d[0]) : "";
          return /* @__PURE__ */ U.createElement("input", {
            name: u,
            type: "hidden",
            value: h
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var o = this.commonProps, a = this.state, i = a.ariaSelection, s = a.focusedOption, l = a.focusedValue, u = a.isFocused, c = a.selectValue, d = this.getFocusableOptions();
      return /* @__PURE__ */ U.createElement(Lw, pe({}, o, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: s,
        focusedValue: l,
        isFocused: u,
        selectValue: c,
        focusableOptions: d,
        isAppleDevice: this.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var o = this.getComponents(), a = o.Control, i = o.IndicatorsContainer, s = o.SelectContainer, l = o.ValueContainer, u = this.props, c = u.className, d = u.id, f = u.isDisabled, p = u.menuIsOpen, h = this.state.isFocused, g = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ U.createElement(s, pe({}, g, {
        className: c,
        innerProps: {
          id: d,
          onKeyDown: this.onKeyDown
        },
        isDisabled: f,
        isFocused: h
      }), this.renderLiveRegion(), /* @__PURE__ */ U.createElement(a, pe({}, g, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: f,
        isFocused: h,
        menuIsOpen: p
      }), /* @__PURE__ */ U.createElement(l, pe({}, g, {
        isDisabled: f
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ U.createElement(i, pe({}, g, {
        isDisabled: f
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(o, a) {
      var i = a.prevProps, s = a.clearFocusValueOnUpdate, l = a.inputIsHiddenAfterUpdate, u = a.ariaSelection, c = a.isFocused, d = a.prevWasFocused, f = a.instancePrefix, p = o.options, h = o.value, g = o.menuIsOpen, m = o.inputValue, v = o.isMulti, y = Qi(h), C = {};
      if (i && (h !== i.value || p !== i.options || g !== i.menuIsOpen || m !== i.inputValue)) {
        var I = g ? hC(o, y) : [], b = g ? Md(Ei(o, y), "".concat(f, "-option")) : [], D = s ? gC(a, y) : null, x = mC(a, I), _ = yl(b, x);
        C = {
          selectValue: y,
          focusedOption: x,
          focusedOptionId: _,
          focusableOptionsWithIds: b,
          focusedValue: D,
          clearFocusValueOnUpdate: !1
        };
      }
      var E = l != null && o !== i ? {
        inputIsHidden: l,
        inputIsHiddenAfterUpdate: void 0
      } : {}, R = u, L = c && d;
      return c && !L && (R = {
        value: va(v, y, y[0] || null),
        options: y,
        action: "initial-input-focus"
      }, L = !d), (u == null ? void 0 : u.action) === "initial-input-focus" && (R = null), ce(ce(ce({}, C), E), {}, {
        prevProps: o,
        ariaSelection: R,
        prevWasFocused: L
      });
    }
  }]), t;
}(bt);
Xa.defaultProps = pC;
var bC = /* @__PURE__ */ ot(function(e, r) {
  var t = Ds(e);
  return /* @__PURE__ */ U.createElement(Xa, pe({
    ref: r
  }, t));
}), yC = bC;
function wC(e, r) {
  return `${e} returned \`undefined\`. Seems you forgot to wrap component within ${r}`;
}
function ja(e = {}) {
  const {
    name: r,
    strict: t = !0,
    hookName: n = "useContext",
    providerName: o = "Provider",
    errorMessage: a,
    defaultValue: i
  } = e, s = Ya(i);
  s.displayName = r;
  function l() {
    var u;
    const c = $o(s);
    if (!c && t) {
      const d = new Error(
        a ?? wC(n, o)
      );
      throw d.name = "ContextError", (u = Error.captureStackTrace) == null || u.call(Error, d, l), d;
    }
    return c;
  }
  return [s.Provider, l, s];
}
function CC(e, r) {
  if (e != null) {
    if (typeof e == "function") {
      e(r);
      return;
    }
    try {
      e.current = r;
    } catch {
      throw new Error(`Cannot assign value '${r}' to ref '${e}'`);
    }
  }
}
function Ma(...e) {
  return (r) => {
    e.forEach((t) => {
      CC(t, r);
    });
  };
}
function jo() {
  const e = $o(
    Rb
  );
  if (!e)
    throw Error(
      "useTheme: `theme` is undefined. Seems you forgot to wrap your app in `<ChakraProvider />` or `<ThemeProvider />`"
    );
  return e;
}
var yh = Ya({});
yh.displayName = "ColorModeContext";
function Zu() {
  const e = $o(yh);
  if (e === void 0)
    throw new Error("useColorMode must be used within a ColorModeProvider");
  return e;
}
function Pd(e, r) {
  const { colorMode: t } = Zu();
  return t === "dark" ? r : e;
}
var SC = globalThis != null && globalThis.document ? Ga : Ye;
function xC() {
  const e = Zu(), r = jo();
  return { ...e, theme: r };
}
var Qn = (...e) => e.filter(Boolean).join(" ");
function tn(e) {
  const r = typeof e;
  return e != null && (r === "object" || r === "function") && !Array.isArray(e);
}
function yn(e, ...r) {
  return IC(e) ? e(...r) : e;
}
var IC = (e) => typeof e == "function", mn = (e) => e ? "" : void 0, wl = (e) => e ? !0 : void 0;
function Rd(...e) {
  return function(t) {
    e.some((n) => (n == null || n(t), t == null ? void 0 : t.defaultPrevented));
  };
}
var fi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Uu(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var es = { exports: {} };
es.exports;
(function(e, r) {
  var t = 200, n = "__lodash_hash_undefined__", o = 800, a = 16, i = 9007199254740991, s = "[object Arguments]", l = "[object Array]", u = "[object AsyncFunction]", c = "[object Boolean]", d = "[object Date]", f = "[object Error]", p = "[object Function]", h = "[object GeneratorFunction]", g = "[object Map]", m = "[object Number]", v = "[object Null]", y = "[object Object]", C = "[object Proxy]", I = "[object RegExp]", b = "[object Set]", D = "[object String]", x = "[object Undefined]", _ = "[object WeakMap]", E = "[object ArrayBuffer]", R = "[object DataView]", L = "[object Float32Array]", G = "[object Float64Array]", V = "[object Int8Array]", O = "[object Int16Array]", N = "[object Int32Array]", P = "[object Uint8Array]", B = "[object Uint8ClampedArray]", H = "[object Uint16Array]", re = "[object Uint32Array]", W = /[\\^$.*+?()[\]{}|]/g, F = /^\[object .+?Constructor\]$/, $ = /^(?:0|[1-9]\d*)$/, Y = {};
  Y[L] = Y[G] = Y[V] = Y[O] = Y[N] = Y[P] = Y[B] = Y[H] = Y[re] = !0, Y[s] = Y[l] = Y[E] = Y[c] = Y[R] = Y[d] = Y[f] = Y[p] = Y[g] = Y[m] = Y[y] = Y[I] = Y[b] = Y[D] = Y[_] = !1;
  var X = typeof fi == "object" && fi && fi.Object === Object && fi, te = typeof self == "object" && self && self.Object === Object && self, q = X || te || Function("return this")(), ue = r && !r.nodeType && r, ie = ue && !0 && e && !e.nodeType && e, be = ie && ie.exports === ue, ge = be && X.process, Pe = function() {
    try {
      var w = ie && ie.require && ie.require("util").types;
      return w || ge && ge.binding && ge.binding("util");
    } catch {
    }
  }(), Z = Pe && Pe.isTypedArray;
  function at(w, M, T) {
    switch (T.length) {
      case 0:
        return w.call(M);
      case 1:
        return w.call(M, T[0]);
      case 2:
        return w.call(M, T[0], T[1]);
      case 3:
        return w.call(M, T[0], T[1], T[2]);
    }
    return w.apply(M, T);
  }
  function xt(w, M) {
    for (var T = -1, le = Array(w); ++T < w; )
      le[T] = M(T);
    return le;
  }
  function Et(w) {
    return function(M) {
      return w(M);
    };
  }
  function zr(w, M) {
    return w == null ? void 0 : w[M];
  }
  function Lt(w, M) {
    return function(T) {
      return w(M(T));
    };
  }
  var Wt = Array.prototype, Mt = Function.prototype, Re = Object.prototype, Ut = q["__core-js_shared__"], Bt = Mt.toString, Vt = Re.hasOwnProperty, J = function() {
    var w = /[^.]+$/.exec(Ut && Ut.keys && Ut.keys.IE_PROTO || "");
    return w ? "Symbol(src)_1." + w : "";
  }(), fe = Re.toString, Ze = Bt.call(Object), it = RegExp(
    "^" + Bt.call(Vt).replace(W, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), ct = be ? q.Buffer : void 0, hn = q.Symbol, $r = q.Uint8Array;
  ct && ct.allocUnsafe;
  var uo = Lt(Object.getPrototypeOf, Object), co = Object.create, ta = Re.propertyIsEnumerable, fo = Wt.splice, dr = hn ? hn.toStringTag : void 0, gn = function() {
    try {
      var w = ol(Object, "defineProperty");
      return w({}, "", {}), w;
    } catch {
    }
  }(), ra = ct ? ct.isBuffer : void 0, po = Math.max, tl = Date.now, Yc = ol(q, "Map"), na = ol(Object, "create"), ov = /* @__PURE__ */ function() {
    function w() {
    }
    return function(M) {
      if (!Fn(M))
        return {};
      if (co)
        return co(M);
      w.prototype = M;
      var T = new w();
      return w.prototype = void 0, T;
    };
  }();
  function Tn(w) {
    var M = -1, T = w == null ? 0 : w.length;
    for (this.clear(); ++M < T; ) {
      var le = w[M];
      this.set(le[0], le[1]);
    }
  }
  function av() {
    this.__data__ = na ? na(null) : {}, this.size = 0;
  }
  function iv(w) {
    var M = this.has(w) && delete this.__data__[w];
    return this.size -= M ? 1 : 0, M;
  }
  function sv(w) {
    var M = this.__data__;
    if (na) {
      var T = M[w];
      return T === n ? void 0 : T;
    }
    return Vt.call(M, w) ? M[w] : void 0;
  }
  function lv(w) {
    var M = this.__data__;
    return na ? M[w] !== void 0 : Vt.call(M, w);
  }
  function uv(w, M) {
    var T = this.__data__;
    return this.size += this.has(w) ? 0 : 1, T[w] = na && M === void 0 ? n : M, this;
  }
  Tn.prototype.clear = av, Tn.prototype.delete = iv, Tn.prototype.get = sv, Tn.prototype.has = lv, Tn.prototype.set = uv;
  function Xr(w) {
    var M = -1, T = w == null ? 0 : w.length;
    for (this.clear(); ++M < T; ) {
      var le = w[M];
      this.set(le[0], le[1]);
    }
  }
  function cv() {
    this.__data__ = [], this.size = 0;
  }
  function dv(w) {
    var M = this.__data__, T = oi(M, w);
    if (T < 0)
      return !1;
    var le = M.length - 1;
    return T == le ? M.pop() : fo.call(M, T, 1), --this.size, !0;
  }
  function fv(w) {
    var M = this.__data__, T = oi(M, w);
    return T < 0 ? void 0 : M[T][1];
  }
  function pv(w) {
    return oi(this.__data__, w) > -1;
  }
  function hv(w, M) {
    var T = this.__data__, le = oi(T, w);
    return le < 0 ? (++this.size, T.push([w, M])) : T[le][1] = M, this;
  }
  Xr.prototype.clear = cv, Xr.prototype.delete = dv, Xr.prototype.get = fv, Xr.prototype.has = pv, Xr.prototype.set = hv;
  function ho(w) {
    var M = -1, T = w == null ? 0 : w.length;
    for (this.clear(); ++M < T; ) {
      var le = w[M];
      this.set(le[0], le[1]);
    }
  }
  function gv() {
    this.size = 0, this.__data__ = {
      hash: new Tn(),
      map: new (Yc || Xr)(),
      string: new Tn()
    };
  }
  function mv(w) {
    var M = ii(this, w).delete(w);
    return this.size -= M ? 1 : 0, M;
  }
  function vv(w) {
    return ii(this, w).get(w);
  }
  function bv(w) {
    return ii(this, w).has(w);
  }
  function yv(w, M) {
    var T = ii(this, w), le = T.size;
    return T.set(w, M), this.size += T.size == le ? 0 : 1, this;
  }
  ho.prototype.clear = gv, ho.prototype.delete = mv, ho.prototype.get = vv, ho.prototype.has = bv, ho.prototype.set = yv;
  function go(w) {
    var M = this.__data__ = new Xr(w);
    this.size = M.size;
  }
  function wv() {
    this.__data__ = new Xr(), this.size = 0;
  }
  function Cv(w) {
    var M = this.__data__, T = M.delete(w);
    return this.size = M.size, T;
  }
  function Sv(w) {
    return this.__data__.get(w);
  }
  function xv(w) {
    return this.__data__.has(w);
  }
  function Iv(w, M) {
    var T = this.__data__;
    if (T instanceof Xr) {
      var le = T.__data__;
      if (!Yc || le.length < t - 1)
        return le.push([w, M]), this.size = ++T.size, this;
      T = this.__data__ = new ho(le);
    }
    return T.set(w, M), this.size = T.size, this;
  }
  go.prototype.clear = wv, go.prototype.delete = Cv, go.prototype.get = Sv, go.prototype.has = xv, go.prototype.set = Iv;
  function Dv(w, M) {
    var T = sl(w), le = !T && il(w), De = !T && !le && jc(w), ze = !T && !le && !De && Uc(w), Ke = T || le || De || ze, Oe = Ke ? xt(w.length, String) : [], et = Oe.length;
    for (var fr in w)
      Ke && // Safari 9 has enumerable `arguments.length` in strict mode.
      (fr == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      De && (fr == "offset" || fr == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      ze && (fr == "buffer" || fr == "byteLength" || fr == "byteOffset") || // Skip index properties.
      $c(fr, et)) || Oe.push(fr);
    return Oe;
  }
  function rl(w, M, T) {
    (T !== void 0 && !si(w[M], T) || T === void 0 && !(M in w)) && nl(w, M, T);
  }
  function _v(w, M, T) {
    var le = w[M];
    (!(Vt.call(w, M) && si(le, T)) || T === void 0 && !(M in w)) && nl(w, M, T);
  }
  function oi(w, M) {
    for (var T = w.length; T--; )
      if (si(w[T][0], M))
        return T;
    return -1;
  }
  function nl(w, M, T) {
    M == "__proto__" && gn ? gn(w, M, {
      configurable: !0,
      enumerable: !0,
      value: T,
      writable: !0
    }) : w[M] = T;
  }
  var kv = Vv();
  function ai(w) {
    return w == null ? w === void 0 ? x : v : dr && dr in Object(w) ? Gv(w) : jv(w);
  }
  function Hc(w) {
    return oa(w) && ai(w) == s;
  }
  function Ev(w) {
    if (!Fn(w) || $v(w))
      return !1;
    var M = ul(w) ? it : F;
    return M.test(Qv(w));
  }
  function Mv(w) {
    return oa(w) && Zc(w.length) && !!Y[ai(w)];
  }
  function Av(w) {
    if (!Fn(w))
      return Xv(w);
    var M = Xc(w), T = [];
    for (var le in w)
      le == "constructor" && (M || !Vt.call(w, le)) || T.push(le);
    return T;
  }
  function zc(w, M, T, le, De) {
    w !== M && kv(M, function(ze, Ke) {
      if (De || (De = new go()), Fn(ze))
        Pv(w, M, Ke, T, zc, le, De);
      else {
        var Oe = le ? le(al(w, Ke), ze, Ke + "", w, M, De) : void 0;
        Oe === void 0 && (Oe = ze), rl(w, Ke, Oe);
      }
    }, Jc);
  }
  function Pv(w, M, T, le, De, ze, Ke) {
    var Oe = al(w, T), et = al(M, T), fr = Ke.get(et);
    if (fr) {
      rl(w, T, fr);
      return;
    }
    var Gt = ze ? ze(Oe, et, T + "", w, M, Ke) : void 0, aa = Gt === void 0;
    if (aa) {
      var cl = sl(et), dl = !cl && jc(et), qc = !cl && !dl && Uc(et);
      Gt = et, cl || dl || qc ? sl(Oe) ? Gt = Oe : qv(Oe) ? Gt = Lv(Oe) : dl ? (aa = !1, Gt = Tv(et)) : qc ? (aa = !1, Gt = Nv(et)) : Gt = [] : Kv(et) || il(et) ? (Gt = Oe, il(Oe) ? Gt = eb(Oe) : (!Fn(Oe) || ul(Oe)) && (Gt = Yv(et))) : aa = !1;
    }
    aa && (Ke.set(et, Gt), De(Gt, et, le, ze, Ke), Ke.delete(et)), rl(w, T, Gt);
  }
  function Rv(w, M) {
    return Uv(Zv(w, M, Qc), w + "");
  }
  var Ov = gn ? function(w, M) {
    return gn(w, "toString", {
      configurable: !0,
      enumerable: !1,
      value: rb(M),
      writable: !0
    });
  } : Qc;
  function Tv(w, M) {
    return w.slice();
  }
  function Fv(w) {
    var M = new w.constructor(w.byteLength);
    return new $r(M).set(new $r(w)), M;
  }
  function Nv(w, M) {
    var T = Fv(w.buffer);
    return new w.constructor(T, w.byteOffset, w.length);
  }
  function Lv(w, M) {
    var T = -1, le = w.length;
    for (M || (M = Array(le)); ++T < le; )
      M[T] = w[T];
    return M;
  }
  function Wv(w, M, T, le) {
    var De = !T;
    T || (T = {});
    for (var ze = -1, Ke = M.length; ++ze < Ke; ) {
      var Oe = M[ze], et = void 0;
      et === void 0 && (et = w[Oe]), De ? nl(T, Oe, et) : _v(T, Oe, et);
    }
    return T;
  }
  function Bv(w) {
    return Rv(function(M, T) {
      var le = -1, De = T.length, ze = De > 1 ? T[De - 1] : void 0, Ke = De > 2 ? T[2] : void 0;
      for (ze = w.length > 3 && typeof ze == "function" ? (De--, ze) : void 0, Ke && Hv(T[0], T[1], Ke) && (ze = De < 3 ? void 0 : ze, De = 1), M = Object(M); ++le < De; ) {
        var Oe = T[le];
        Oe && w(M, Oe, le, ze);
      }
      return M;
    });
  }
  function Vv(w) {
    return function(M, T, le) {
      for (var De = -1, ze = Object(M), Ke = le(M), Oe = Ke.length; Oe--; ) {
        var et = Ke[++De];
        if (T(ze[et], et, ze) === !1)
          break;
      }
      return M;
    };
  }
  function ii(w, M) {
    var T = w.__data__;
    return zv(M) ? T[typeof M == "string" ? "string" : "hash"] : T.map;
  }
  function ol(w, M) {
    var T = zr(w, M);
    return Ev(T) ? T : void 0;
  }
  function Gv(w) {
    var M = Vt.call(w, dr), T = w[dr];
    try {
      w[dr] = void 0;
      var le = !0;
    } catch {
    }
    var De = fe.call(w);
    return le && (M ? w[dr] = T : delete w[dr]), De;
  }
  function Yv(w) {
    return typeof w.constructor == "function" && !Xc(w) ? ov(uo(w)) : {};
  }
  function $c(w, M) {
    var T = typeof w;
    return M = M ?? i, !!M && (T == "number" || T != "symbol" && $.test(w)) && w > -1 && w % 1 == 0 && w < M;
  }
  function Hv(w, M, T) {
    if (!Fn(T))
      return !1;
    var le = typeof M;
    return (le == "number" ? ll(T) && $c(M, T.length) : le == "string" && M in T) ? si(T[M], w) : !1;
  }
  function zv(w) {
    var M = typeof w;
    return M == "string" || M == "number" || M == "symbol" || M == "boolean" ? w !== "__proto__" : w === null;
  }
  function $v(w) {
    return !!J && J in w;
  }
  function Xc(w) {
    var M = w && w.constructor, T = typeof M == "function" && M.prototype || Re;
    return w === T;
  }
  function Xv(w) {
    var M = [];
    if (w != null)
      for (var T in Object(w))
        M.push(T);
    return M;
  }
  function jv(w) {
    return fe.call(w);
  }
  function Zv(w, M, T) {
    return M = po(M === void 0 ? w.length - 1 : M, 0), function() {
      for (var le = arguments, De = -1, ze = po(le.length - M, 0), Ke = Array(ze); ++De < ze; )
        Ke[De] = le[M + De];
      De = -1;
      for (var Oe = Array(M + 1); ++De < M; )
        Oe[De] = le[De];
      return Oe[M] = T(Ke), at(w, this, Oe);
    };
  }
  function al(w, M) {
    if (!(M === "constructor" && typeof w[M] == "function") && M != "__proto__")
      return w[M];
  }
  var Uv = Jv(Ov);
  function Jv(w) {
    var M = 0, T = 0;
    return function() {
      var le = tl(), De = a - (le - T);
      if (T = le, De > 0) {
        if (++M >= o)
          return arguments[0];
      } else
        M = 0;
      return w.apply(void 0, arguments);
    };
  }
  function Qv(w) {
    if (w != null) {
      try {
        return Bt.call(w);
      } catch {
      }
      try {
        return w + "";
      } catch {
      }
    }
    return "";
  }
  function si(w, M) {
    return w === M || w !== w && M !== M;
  }
  var il = Hc(/* @__PURE__ */ function() {
    return arguments;
  }()) ? Hc : function(w) {
    return oa(w) && Vt.call(w, "callee") && !ta.call(w, "callee");
  }, sl = Array.isArray;
  function ll(w) {
    return w != null && Zc(w.length) && !ul(w);
  }
  function qv(w) {
    return oa(w) && ll(w);
  }
  var jc = ra || nb;
  function ul(w) {
    if (!Fn(w))
      return !1;
    var M = ai(w);
    return M == p || M == h || M == u || M == C;
  }
  function Zc(w) {
    return typeof w == "number" && w > -1 && w % 1 == 0 && w <= i;
  }
  function Fn(w) {
    var M = typeof w;
    return w != null && (M == "object" || M == "function");
  }
  function oa(w) {
    return w != null && typeof w == "object";
  }
  function Kv(w) {
    if (!oa(w) || ai(w) != y)
      return !1;
    var M = uo(w);
    if (M === null)
      return !0;
    var T = Vt.call(M, "constructor") && M.constructor;
    return typeof T == "function" && T instanceof T && Bt.call(T) == Ze;
  }
  var Uc = Z ? Et(Z) : Mv;
  function eb(w) {
    return Wv(w, Jc(w));
  }
  function Jc(w) {
    return ll(w) ? Dv(w) : Av(w);
  }
  var tb = Bv(function(w, M, T, le) {
    zc(w, M, T, le);
  });
  function rb(w) {
    return function() {
      return w;
    };
  }
  function Qc(w) {
    return w;
  }
  function nb() {
    return !1;
  }
  e.exports = tb;
})(es, es.exports);
var DC = es.exports;
const qr = /* @__PURE__ */ Uu(DC);
var _C = (e) => /!(important)?$/.test(e), Od = (e) => typeof e == "string" ? e.replace(/!(important)?$/, "").trim() : e, kC = (e, r) => (t) => {
  const n = String(r), o = _C(n), a = Od(n), i = e ? `${e}.${a}` : a;
  let s = tn(t.__cssMap) && i in t.__cssMap ? t.__cssMap[i].varRef : r;
  return s = Od(s), o ? `${s} !important` : s;
};
function Ju(e) {
  const { scale: r, transform: t, compose: n } = e;
  return (a, i) => {
    var s;
    const l = kC(r, a)(i);
    let u = (s = t == null ? void 0 : t(l, i)) != null ? s : l;
    return n && (u = n(u, i)), u;
  };
}
var pi = (...e) => (r) => e.reduce((t, n) => n(t), r);
function Jt(e, r) {
  return (t) => {
    const n = { property: t, scale: e };
    return n.transform = Ju({
      scale: e,
      transform: r
    }), n;
  };
}
var EC = ({ rtl: e, ltr: r }) => (t) => t.direction === "rtl" ? e : r;
function MC(e) {
  const { property: r, scale: t, transform: n } = e;
  return {
    scale: t,
    property: EC(r),
    transform: t ? Ju({
      scale: t,
      compose: n
    }) : n
  };
}
var wh = [
  "rotate(var(--chakra-rotate, 0))",
  "scaleX(var(--chakra-scale-x, 1))",
  "scaleY(var(--chakra-scale-y, 1))",
  "skewX(var(--chakra-skew-x, 0))",
  "skewY(var(--chakra-skew-y, 0))"
];
function AC() {
  return [
    "translateX(var(--chakra-translate-x, 0))",
    "translateY(var(--chakra-translate-y, 0))",
    ...wh
  ].join(" ");
}
function PC() {
  return [
    "translate3d(var(--chakra-translate-x, 0), var(--chakra-translate-y, 0), 0)",
    ...wh
  ].join(" ");
}
var RC = {
  "--chakra-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-sepia": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-drop-shadow": "var(--chakra-empty,/*!*/ /*!*/)",
  filter: [
    "var(--chakra-blur)",
    "var(--chakra-brightness)",
    "var(--chakra-contrast)",
    "var(--chakra-grayscale)",
    "var(--chakra-hue-rotate)",
    "var(--chakra-invert)",
    "var(--chakra-saturate)",
    "var(--chakra-sepia)",
    "var(--chakra-drop-shadow)"
  ].join(" ")
}, OC = {
  backdropFilter: [
    "var(--chakra-backdrop-blur)",
    "var(--chakra-backdrop-brightness)",
    "var(--chakra-backdrop-contrast)",
    "var(--chakra-backdrop-grayscale)",
    "var(--chakra-backdrop-hue-rotate)",
    "var(--chakra-backdrop-invert)",
    "var(--chakra-backdrop-opacity)",
    "var(--chakra-backdrop-saturate)",
    "var(--chakra-backdrop-sepia)"
  ].join(" "),
  "--chakra-backdrop-blur": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-brightness": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-contrast": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-grayscale": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-hue-rotate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-invert": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-opacity": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-saturate": "var(--chakra-empty,/*!*/ /*!*/)",
  "--chakra-backdrop-sepia": "var(--chakra-empty,/*!*/ /*!*/)"
};
function TC(e) {
  return {
    "--chakra-ring-offset-shadow": "var(--chakra-ring-inset) 0 0 0 var(--chakra-ring-offset-width) var(--chakra-ring-offset-color)",
    "--chakra-ring-shadow": "var(--chakra-ring-inset) 0 0 0 calc(var(--chakra-ring-width) + var(--chakra-ring-offset-width)) var(--chakra-ring-color)",
    "--chakra-ring-width": e,
    boxShadow: [
      "var(--chakra-ring-offset-shadow)",
      "var(--chakra-ring-shadow)",
      "var(--chakra-shadow, 0 0 #0000)"
    ].join(", ")
  };
}
var FC = {
  "row-reverse": {
    space: "--chakra-space-x-reverse",
    divide: "--chakra-divide-x-reverse"
  },
  "column-reverse": {
    space: "--chakra-space-y-reverse",
    divide: "--chakra-divide-y-reverse"
  }
}, ou = {
  "to-t": "to top",
  "to-tr": "to top right",
  "to-r": "to right",
  "to-br": "to bottom right",
  "to-b": "to bottom",
  "to-bl": "to bottom left",
  "to-l": "to left",
  "to-tl": "to top left"
}, NC = new Set(Object.values(ou)), au = /* @__PURE__ */ new Set([
  "none",
  "-moz-initial",
  "inherit",
  "initial",
  "revert",
  "unset"
]), LC = (e) => e.trim();
function WC(e, r) {
  if (e == null || au.has(e))
    return e;
  if (!(iu(e) || au.has(e)))
    return `url('${e}')`;
  const o = /(^[a-z-A-Z]+)\((.*)\)/g.exec(e), a = o == null ? void 0 : o[1], i = o == null ? void 0 : o[2];
  if (!a || !i)
    return e;
  const s = a.includes("-gradient") ? a : `${a}-gradient`, [l, ...u] = i.split(",").map(LC).filter(Boolean);
  if ((u == null ? void 0 : u.length) === 0)
    return e;
  const c = l in ou ? ou[l] : l;
  u.unshift(c);
  const d = u.map((f) => {
    if (NC.has(f))
      return f;
    const p = f.indexOf(" "), [h, g] = p !== -1 ? [f.substr(0, p), f.substr(p + 1)] : [f], m = iu(g) ? g : g && g.split(" "), v = `colors.${h}`, y = v in r.__cssMap ? r.__cssMap[v].varRef : h;
    return m ? [
      y,
      ...Array.isArray(m) ? m : [m]
    ].join(" ") : y;
  });
  return `${s}(${d.join(", ")})`;
}
var iu = (e) => typeof e == "string" && e.includes("(") && e.includes(")"), BC = (e, r) => WC(e, r ?? {});
function VC(e) {
  return /^var\(--.+\)$/.test(e);
}
var GC = (e) => {
  const r = parseFloat(e.toString()), t = e.toString().replace(String(r), "");
  return { unitless: !t, value: r, unit: t };
}, Cr = (e) => (r) => `${e}(${r})`, Ie = {
  filter(e) {
    return e !== "auto" ? e : RC;
  },
  backdropFilter(e) {
    return e !== "auto" ? e : OC;
  },
  ring(e) {
    return TC(Ie.px(e));
  },
  bgClip(e) {
    return e === "text" ? { color: "transparent", backgroundClip: "text" } : { backgroundClip: e };
  },
  transform(e) {
    return e === "auto" ? AC() : e === "auto-gpu" ? PC() : e;
  },
  vh(e) {
    return e === "$100vh" ? "var(--chakra-vh)" : e;
  },
  px(e) {
    if (e == null)
      return e;
    const { unitless: r } = GC(e);
    return r || typeof e == "number" ? `${e}px` : e;
  },
  fraction(e) {
    return typeof e != "number" || e > 1 ? e : `${e * 100}%`;
  },
  float(e, r) {
    const t = { left: "right", right: "left" };
    return r.direction === "rtl" ? t[e] : e;
  },
  degree(e) {
    if (VC(e) || e == null)
      return e;
    const r = typeof e == "string" && !e.endsWith("deg");
    return typeof e == "number" || r ? `${e}deg` : e;
  },
  gradient: BC,
  blur: Cr("blur"),
  opacity: Cr("opacity"),
  brightness: Cr("brightness"),
  contrast: Cr("contrast"),
  dropShadow: Cr("drop-shadow"),
  grayscale: Cr("grayscale"),
  hueRotate: (e) => Cr("hue-rotate")(Ie.degree(e)),
  invert: Cr("invert"),
  saturate: Cr("saturate"),
  sepia: Cr("sepia"),
  bgImage(e) {
    return e == null || iu(e) || au.has(e) ? e : `url(${e})`;
  },
  outline(e) {
    const r = String(e) === "0" || String(e) === "none";
    return e !== null && r ? { outline: "2px solid transparent", outlineOffset: "2px" } : { outline: e };
  },
  flexDirection(e) {
    var r;
    const { space: t, divide: n } = (r = FC[e]) != null ? r : {}, o = { flexDirection: e };
    return t && (o[t] = 1), n && (o[n] = 1), o;
  }
}, k = {
  borderWidths: Jt("borderWidths"),
  borderStyles: Jt("borderStyles"),
  colors: Jt("colors"),
  borders: Jt("borders"),
  gradients: Jt("gradients", Ie.gradient),
  radii: Jt("radii", Ie.px),
  space: Jt("space", pi(Ie.vh, Ie.px)),
  spaceT: Jt("space", pi(Ie.vh, Ie.px)),
  degreeT(e) {
    return { property: e, transform: Ie.degree };
  },
  prop(e, r, t) {
    return {
      property: e,
      scale: r,
      ...r && {
        transform: Ju({ scale: r, transform: t })
      }
    };
  },
  propT(e, r) {
    return { property: e, transform: r };
  },
  sizes: Jt("sizes", pi(Ie.vh, Ie.px)),
  sizesT: Jt("sizes", pi(Ie.vh, Ie.fraction)),
  shadows: Jt("shadows"),
  logical: MC,
  blur: Jt("blur", Ie.blur)
}, Mi = {
  background: k.colors("background"),
  backgroundColor: k.colors("backgroundColor"),
  backgroundImage: k.gradients("backgroundImage"),
  backgroundSize: !0,
  backgroundPosition: !0,
  backgroundRepeat: !0,
  backgroundAttachment: !0,
  backgroundClip: { transform: Ie.bgClip },
  bgSize: k.prop("backgroundSize"),
  bgPosition: k.prop("backgroundPosition"),
  bg: k.colors("background"),
  bgColor: k.colors("backgroundColor"),
  bgPos: k.prop("backgroundPosition"),
  bgRepeat: k.prop("backgroundRepeat"),
  bgAttachment: k.prop("backgroundAttachment"),
  bgGradient: k.gradients("backgroundImage"),
  bgClip: { transform: Ie.bgClip }
};
Object.assign(Mi, {
  bgImage: Mi.backgroundImage,
  bgImg: Mi.backgroundImage
});
var Te = {
  border: k.borders("border"),
  borderWidth: k.borderWidths("borderWidth"),
  borderStyle: k.borderStyles("borderStyle"),
  borderColor: k.colors("borderColor"),
  borderRadius: k.radii("borderRadius"),
  borderTop: k.borders("borderTop"),
  borderBlockStart: k.borders("borderBlockStart"),
  borderTopLeftRadius: k.radii("borderTopLeftRadius"),
  borderStartStartRadius: k.logical({
    scale: "radii",
    property: {
      ltr: "borderTopLeftRadius",
      rtl: "borderTopRightRadius"
    }
  }),
  borderEndStartRadius: k.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomLeftRadius",
      rtl: "borderBottomRightRadius"
    }
  }),
  borderTopRightRadius: k.radii("borderTopRightRadius"),
  borderStartEndRadius: k.logical({
    scale: "radii",
    property: {
      ltr: "borderTopRightRadius",
      rtl: "borderTopLeftRadius"
    }
  }),
  borderEndEndRadius: k.logical({
    scale: "radii",
    property: {
      ltr: "borderBottomRightRadius",
      rtl: "borderBottomLeftRadius"
    }
  }),
  borderRight: k.borders("borderRight"),
  borderInlineEnd: k.borders("borderInlineEnd"),
  borderBottom: k.borders("borderBottom"),
  borderBlockEnd: k.borders("borderBlockEnd"),
  borderBottomLeftRadius: k.radii("borderBottomLeftRadius"),
  borderBottomRightRadius: k.radii("borderBottomRightRadius"),
  borderLeft: k.borders("borderLeft"),
  borderInlineStart: {
    property: "borderInlineStart",
    scale: "borders"
  },
  borderInlineStartRadius: k.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopLeftRadius", "borderBottomLeftRadius"],
      rtl: ["borderTopRightRadius", "borderBottomRightRadius"]
    }
  }),
  borderInlineEndRadius: k.logical({
    scale: "radii",
    property: {
      ltr: ["borderTopRightRadius", "borderBottomRightRadius"],
      rtl: ["borderTopLeftRadius", "borderBottomLeftRadius"]
    }
  }),
  borderX: k.borders(["borderLeft", "borderRight"]),
  borderInline: k.borders("borderInline"),
  borderY: k.borders(["borderTop", "borderBottom"]),
  borderBlock: k.borders("borderBlock"),
  borderTopWidth: k.borderWidths("borderTopWidth"),
  borderBlockStartWidth: k.borderWidths("borderBlockStartWidth"),
  borderTopColor: k.colors("borderTopColor"),
  borderBlockStartColor: k.colors("borderBlockStartColor"),
  borderTopStyle: k.borderStyles("borderTopStyle"),
  borderBlockStartStyle: k.borderStyles("borderBlockStartStyle"),
  borderBottomWidth: k.borderWidths("borderBottomWidth"),
  borderBlockEndWidth: k.borderWidths("borderBlockEndWidth"),
  borderBottomColor: k.colors("borderBottomColor"),
  borderBlockEndColor: k.colors("borderBlockEndColor"),
  borderBottomStyle: k.borderStyles("borderBottomStyle"),
  borderBlockEndStyle: k.borderStyles("borderBlockEndStyle"),
  borderLeftWidth: k.borderWidths("borderLeftWidth"),
  borderInlineStartWidth: k.borderWidths("borderInlineStartWidth"),
  borderLeftColor: k.colors("borderLeftColor"),
  borderInlineStartColor: k.colors("borderInlineStartColor"),
  borderLeftStyle: k.borderStyles("borderLeftStyle"),
  borderInlineStartStyle: k.borderStyles("borderInlineStartStyle"),
  borderRightWidth: k.borderWidths("borderRightWidth"),
  borderInlineEndWidth: k.borderWidths("borderInlineEndWidth"),
  borderRightColor: k.colors("borderRightColor"),
  borderInlineEndColor: k.colors("borderInlineEndColor"),
  borderRightStyle: k.borderStyles("borderRightStyle"),
  borderInlineEndStyle: k.borderStyles("borderInlineEndStyle"),
  borderTopRadius: k.radii(["borderTopLeftRadius", "borderTopRightRadius"]),
  borderBottomRadius: k.radii([
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ]),
  borderLeftRadius: k.radii(["borderTopLeftRadius", "borderBottomLeftRadius"]),
  borderRightRadius: k.radii([
    "borderTopRightRadius",
    "borderBottomRightRadius"
  ])
};
Object.assign(Te, {
  rounded: Te.borderRadius,
  roundedTop: Te.borderTopRadius,
  roundedTopLeft: Te.borderTopLeftRadius,
  roundedTopRight: Te.borderTopRightRadius,
  roundedTopStart: Te.borderStartStartRadius,
  roundedTopEnd: Te.borderStartEndRadius,
  roundedBottom: Te.borderBottomRadius,
  roundedBottomLeft: Te.borderBottomLeftRadius,
  roundedBottomRight: Te.borderBottomRightRadius,
  roundedBottomStart: Te.borderEndStartRadius,
  roundedBottomEnd: Te.borderEndEndRadius,
  roundedLeft: Te.borderLeftRadius,
  roundedRight: Te.borderRightRadius,
  roundedStart: Te.borderInlineStartRadius,
  roundedEnd: Te.borderInlineEndRadius,
  borderStart: Te.borderInlineStart,
  borderEnd: Te.borderInlineEnd,
  borderTopStartRadius: Te.borderStartStartRadius,
  borderTopEndRadius: Te.borderStartEndRadius,
  borderBottomStartRadius: Te.borderEndStartRadius,
  borderBottomEndRadius: Te.borderEndEndRadius,
  borderStartRadius: Te.borderInlineStartRadius,
  borderEndRadius: Te.borderInlineEndRadius,
  borderStartWidth: Te.borderInlineStartWidth,
  borderEndWidth: Te.borderInlineEndWidth,
  borderStartColor: Te.borderInlineStartColor,
  borderEndColor: Te.borderInlineEndColor,
  borderStartStyle: Te.borderInlineStartStyle,
  borderEndStyle: Te.borderInlineEndStyle
});
var YC = {
  color: k.colors("color"),
  textColor: k.colors("color"),
  fill: k.colors("fill"),
  stroke: k.colors("stroke")
}, su = {
  boxShadow: k.shadows("boxShadow"),
  mixBlendMode: !0,
  blendMode: k.prop("mixBlendMode"),
  backgroundBlendMode: !0,
  bgBlendMode: k.prop("backgroundBlendMode"),
  opacity: !0
};
Object.assign(su, {
  shadow: su.boxShadow
});
var HC = {
  filter: { transform: Ie.filter },
  blur: k.blur("--chakra-blur"),
  brightness: k.propT("--chakra-brightness", Ie.brightness),
  contrast: k.propT("--chakra-contrast", Ie.contrast),
  hueRotate: k.propT("--chakra-hue-rotate", Ie.hueRotate),
  invert: k.propT("--chakra-invert", Ie.invert),
  saturate: k.propT("--chakra-saturate", Ie.saturate),
  dropShadow: k.propT("--chakra-drop-shadow", Ie.dropShadow),
  backdropFilter: { transform: Ie.backdropFilter },
  backdropBlur: k.blur("--chakra-backdrop-blur"),
  backdropBrightness: k.propT(
    "--chakra-backdrop-brightness",
    Ie.brightness
  ),
  backdropContrast: k.propT("--chakra-backdrop-contrast", Ie.contrast),
  backdropHueRotate: k.propT(
    "--chakra-backdrop-hue-rotate",
    Ie.hueRotate
  ),
  backdropInvert: k.propT("--chakra-backdrop-invert", Ie.invert),
  backdropSaturate: k.propT("--chakra-backdrop-saturate", Ie.saturate)
}, ts = {
  alignItems: !0,
  alignContent: !0,
  justifyItems: !0,
  justifyContent: !0,
  flexWrap: !0,
  flexDirection: { transform: Ie.flexDirection },
  flex: !0,
  flexFlow: !0,
  flexGrow: !0,
  flexShrink: !0,
  flexBasis: k.sizes("flexBasis"),
  justifySelf: !0,
  alignSelf: !0,
  order: !0,
  placeItems: !0,
  placeContent: !0,
  placeSelf: !0,
  gap: k.space("gap"),
  rowGap: k.space("rowGap"),
  columnGap: k.space("columnGap")
};
Object.assign(ts, {
  flexDir: ts.flexDirection
});
var Ch = {
  gridGap: k.space("gridGap"),
  gridColumnGap: k.space("gridColumnGap"),
  gridRowGap: k.space("gridRowGap"),
  gridColumn: !0,
  gridRow: !0,
  gridAutoFlow: !0,
  gridAutoColumns: !0,
  gridColumnStart: !0,
  gridColumnEnd: !0,
  gridRowStart: !0,
  gridRowEnd: !0,
  gridAutoRows: !0,
  gridTemplate: !0,
  gridTemplateColumns: !0,
  gridTemplateRows: !0,
  gridTemplateAreas: !0,
  gridArea: !0
}, zC = {
  appearance: !0,
  cursor: !0,
  resize: !0,
  userSelect: !0,
  pointerEvents: !0,
  outline: { transform: Ie.outline },
  outlineOffset: !0,
  outlineColor: k.colors("outlineColor")
}, qt = {
  width: k.sizesT("width"),
  inlineSize: k.sizesT("inlineSize"),
  height: k.sizes("height"),
  blockSize: k.sizes("blockSize"),
  boxSize: k.sizes(["width", "height"]),
  minWidth: k.sizes("minWidth"),
  minInlineSize: k.sizes("minInlineSize"),
  minHeight: k.sizes("minHeight"),
  minBlockSize: k.sizes("minBlockSize"),
  maxWidth: k.sizes("maxWidth"),
  maxInlineSize: k.sizes("maxInlineSize"),
  maxHeight: k.sizes("maxHeight"),
  maxBlockSize: k.sizes("maxBlockSize"),
  overflow: !0,
  overflowX: !0,
  overflowY: !0,
  overscrollBehavior: !0,
  overscrollBehaviorX: !0,
  overscrollBehaviorY: !0,
  display: !0,
  aspectRatio: !0,
  hideFrom: {
    scale: "breakpoints",
    transform: (e, r) => {
      var t, n, o;
      return { [`@media screen and (min-width: ${(o = (n = (t = r.__breakpoints) == null ? void 0 : t.get(e)) == null ? void 0 : n.minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  hideBelow: {
    scale: "breakpoints",
    transform: (e, r) => {
      var t, n, o;
      return { [`@media screen and (max-width: ${(o = (n = (t = r.__breakpoints) == null ? void 0 : t.get(e)) == null ? void 0 : n._minW) != null ? o : e})`]: { display: "none" } };
    }
  },
  verticalAlign: !0,
  boxSizing: !0,
  boxDecorationBreak: !0,
  float: k.propT("float", Ie.float),
  objectFit: !0,
  objectPosition: !0,
  visibility: !0,
  isolation: !0
};
Object.assign(qt, {
  w: qt.width,
  h: qt.height,
  minW: qt.minWidth,
  maxW: qt.maxWidth,
  minH: qt.minHeight,
  maxH: qt.maxHeight,
  overscroll: qt.overscrollBehavior,
  overscrollX: qt.overscrollBehaviorX,
  overscrollY: qt.overscrollBehaviorY
});
var $C = {
  listStyleType: !0,
  listStylePosition: !0,
  listStylePos: k.prop("listStylePosition"),
  listStyleImage: !0,
  listStyleImg: k.prop("listStyleImage")
};
function XC(e, r, t, n) {
  const o = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < o.length && e; n += 1)
    e = e[o[n]];
  return e === void 0 ? t : e;
}
var jC = (e) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (n, o, a, i) => {
    if (typeof n > "u")
      return e(n, o, a);
    r.has(n) || r.set(n, /* @__PURE__ */ new Map());
    const s = r.get(n);
    if (s.has(o))
      return s.get(o);
    const l = e(n, o, a, i);
    return s.set(o, l), l;
  };
}, ZC = jC(XC), UC = {
  border: "0px",
  clip: "rect(0, 0, 0, 0)",
  width: "1px",
  height: "1px",
  margin: "-1px",
  padding: "0px",
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
}, JC = {
  position: "static",
  width: "auto",
  height: "auto",
  clip: "auto",
  padding: "0",
  margin: "0",
  overflow: "visible",
  whiteSpace: "normal"
}, Cl = (e, r, t) => {
  const n = {}, o = ZC(e, r, {});
  for (const a in o)
    a in t && t[a] != null || (n[a] = o[a]);
  return n;
}, QC = {
  srOnly: {
    transform(e) {
      return e === !0 ? UC : e === "focusable" ? JC : {};
    }
  },
  layerStyle: {
    processResult: !0,
    transform: (e, r, t) => Cl(r, `layerStyles.${e}`, t)
  },
  textStyle: {
    processResult: !0,
    transform: (e, r, t) => Cl(r, `textStyles.${e}`, t)
  },
  apply: {
    processResult: !0,
    transform: (e, r, t) => Cl(r, e, t)
  }
}, Sa = {
  position: !0,
  pos: k.prop("position"),
  zIndex: k.prop("zIndex", "zIndices"),
  inset: k.spaceT("inset"),
  insetX: k.spaceT(["left", "right"]),
  insetInline: k.spaceT("insetInline"),
  insetY: k.spaceT(["top", "bottom"]),
  insetBlock: k.spaceT("insetBlock"),
  top: k.spaceT("top"),
  insetBlockStart: k.spaceT("insetBlockStart"),
  bottom: k.spaceT("bottom"),
  insetBlockEnd: k.spaceT("insetBlockEnd"),
  left: k.spaceT("left"),
  insetInlineStart: k.logical({
    scale: "space",
    property: { ltr: "left", rtl: "right" }
  }),
  right: k.spaceT("right"),
  insetInlineEnd: k.logical({
    scale: "space",
    property: { ltr: "right", rtl: "left" }
  })
};
Object.assign(Sa, {
  insetStart: Sa.insetInlineStart,
  insetEnd: Sa.insetInlineEnd
});
var qC = {
  ring: { transform: Ie.ring },
  ringColor: k.colors("--chakra-ring-color"),
  ringOffset: k.prop("--chakra-ring-offset-width"),
  ringOffsetColor: k.colors("--chakra-ring-offset-color"),
  ringInset: k.prop("--chakra-ring-inset")
}, Ue = {
  margin: k.spaceT("margin"),
  marginTop: k.spaceT("marginTop"),
  marginBlockStart: k.spaceT("marginBlockStart"),
  marginRight: k.spaceT("marginRight"),
  marginInlineEnd: k.spaceT("marginInlineEnd"),
  marginBottom: k.spaceT("marginBottom"),
  marginBlockEnd: k.spaceT("marginBlockEnd"),
  marginLeft: k.spaceT("marginLeft"),
  marginInlineStart: k.spaceT("marginInlineStart"),
  marginX: k.spaceT(["marginInlineStart", "marginInlineEnd"]),
  marginInline: k.spaceT("marginInline"),
  marginY: k.spaceT(["marginTop", "marginBottom"]),
  marginBlock: k.spaceT("marginBlock"),
  padding: k.space("padding"),
  paddingTop: k.space("paddingTop"),
  paddingBlockStart: k.space("paddingBlockStart"),
  paddingRight: k.space("paddingRight"),
  paddingBottom: k.space("paddingBottom"),
  paddingBlockEnd: k.space("paddingBlockEnd"),
  paddingLeft: k.space("paddingLeft"),
  paddingInlineStart: k.space("paddingInlineStart"),
  paddingInlineEnd: k.space("paddingInlineEnd"),
  paddingX: k.space(["paddingInlineStart", "paddingInlineEnd"]),
  paddingInline: k.space("paddingInline"),
  paddingY: k.space(["paddingTop", "paddingBottom"]),
  paddingBlock: k.space("paddingBlock")
};
Object.assign(Ue, {
  m: Ue.margin,
  mt: Ue.marginTop,
  mr: Ue.marginRight,
  me: Ue.marginInlineEnd,
  marginEnd: Ue.marginInlineEnd,
  mb: Ue.marginBottom,
  ml: Ue.marginLeft,
  ms: Ue.marginInlineStart,
  marginStart: Ue.marginInlineStart,
  mx: Ue.marginX,
  my: Ue.marginY,
  p: Ue.padding,
  pt: Ue.paddingTop,
  py: Ue.paddingY,
  px: Ue.paddingX,
  pb: Ue.paddingBottom,
  pl: Ue.paddingLeft,
  ps: Ue.paddingInlineStart,
  paddingStart: Ue.paddingInlineStart,
  pr: Ue.paddingRight,
  pe: Ue.paddingInlineEnd,
  paddingEnd: Ue.paddingInlineEnd
});
var KC = {
  textDecorationColor: k.colors("textDecorationColor"),
  textDecoration: !0,
  textDecor: { property: "textDecoration" },
  textDecorationLine: !0,
  textDecorationStyle: !0,
  textDecorationThickness: !0,
  textUnderlineOffset: !0,
  textShadow: k.shadows("textShadow")
}, e1 = {
  clipPath: !0,
  transform: k.propT("transform", Ie.transform),
  transformOrigin: !0,
  translateX: k.spaceT("--chakra-translate-x"),
  translateY: k.spaceT("--chakra-translate-y"),
  skewX: k.degreeT("--chakra-skew-x"),
  skewY: k.degreeT("--chakra-skew-y"),
  scaleX: k.prop("--chakra-scale-x"),
  scaleY: k.prop("--chakra-scale-y"),
  scale: k.prop(["--chakra-scale-x", "--chakra-scale-y"]),
  rotate: k.degreeT("--chakra-rotate")
}, t1 = {
  transition: !0,
  transitionDelay: !0,
  animation: !0,
  willChange: !0,
  transitionDuration: k.prop("transitionDuration", "transition.duration"),
  transitionProperty: k.prop("transitionProperty", "transition.property"),
  transitionTimingFunction: k.prop(
    "transitionTimingFunction",
    "transition.easing"
  )
}, r1 = {
  fontFamily: k.prop("fontFamily", "fonts"),
  fontSize: k.prop("fontSize", "fontSizes", Ie.px),
  fontWeight: k.prop("fontWeight", "fontWeights"),
  lineHeight: k.prop("lineHeight", "lineHeights"),
  letterSpacing: k.prop("letterSpacing", "letterSpacings"),
  textAlign: !0,
  fontStyle: !0,
  textIndent: !0,
  wordBreak: !0,
  overflowWrap: !0,
  textOverflow: !0,
  textTransform: !0,
  whiteSpace: !0,
  isTruncated: {
    transform(e) {
      if (e === !0)
        return {
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        };
    }
  },
  noOfLines: {
    static: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      display: "-webkit-box",
      WebkitBoxOrient: "vertical",
      //@ts-ignore
      WebkitLineClamp: "var(--chakra-line-clamp)"
    },
    property: "--chakra-line-clamp"
  }
}, n1 = {
  scrollBehavior: !0,
  scrollSnapAlign: !0,
  scrollSnapStop: !0,
  scrollSnapType: !0,
  // scroll margin
  scrollMargin: k.spaceT("scrollMargin"),
  scrollMarginTop: k.spaceT("scrollMarginTop"),
  scrollMarginBottom: k.spaceT("scrollMarginBottom"),
  scrollMarginLeft: k.spaceT("scrollMarginLeft"),
  scrollMarginRight: k.spaceT("scrollMarginRight"),
  scrollMarginX: k.spaceT(["scrollMarginLeft", "scrollMarginRight"]),
  scrollMarginY: k.spaceT(["scrollMarginTop", "scrollMarginBottom"]),
  // scroll padding
  scrollPadding: k.spaceT("scrollPadding"),
  scrollPaddingTop: k.spaceT("scrollPaddingTop"),
  scrollPaddingBottom: k.spaceT("scrollPaddingBottom"),
  scrollPaddingLeft: k.spaceT("scrollPaddingLeft"),
  scrollPaddingRight: k.spaceT("scrollPaddingRight"),
  scrollPaddingX: k.spaceT(["scrollPaddingLeft", "scrollPaddingRight"]),
  scrollPaddingY: k.spaceT(["scrollPaddingTop", "scrollPaddingBottom"])
};
function Sh(e) {
  return tn(e) && e.reference ? e.reference : String(e);
}
var Rs = (e, ...r) => r.map(Sh).join(` ${e} `).replace(/calc/g, ""), Td = (...e) => `calc(${Rs("+", ...e)})`, Fd = (...e) => `calc(${Rs("-", ...e)})`, lu = (...e) => `calc(${Rs("*", ...e)})`, Nd = (...e) => `calc(${Rs("/", ...e)})`, Ld = (e) => {
  const r = Sh(e);
  return r != null && !Number.isNaN(parseFloat(r)) ? String(r).startsWith("-") ? String(r).slice(1) : `-${r}` : lu(r, -1);
}, sa = Object.assign(
  (e) => ({
    add: (...r) => sa(Td(e, ...r)),
    subtract: (...r) => sa(Fd(e, ...r)),
    multiply: (...r) => sa(lu(e, ...r)),
    divide: (...r) => sa(Nd(e, ...r)),
    negate: () => sa(Ld(e)),
    toString: () => e.toString()
  }),
  {
    add: Td,
    subtract: Fd,
    multiply: lu,
    divide: Nd,
    negate: Ld
  }
);
function o1(e) {
  const r = parseFloat(e.toString()), t = e.toString().replace(String(r), "");
  return { unitless: !t, value: r, unit: t };
}
function Wd(e) {
  if (e == null)
    return e;
  const { unitless: r } = o1(e);
  return r || typeof e == "number" ? `${e}px` : e;
}
function a1(e, r) {
  const t = ["@media screen"];
  return e && t.push("and", `(min-width: ${Wd(e)})`), r && t.push("and", `(max-width: ${Wd(r)})`), t.join(" ");
}
var St = {
  hover: (e, r) => `${e}:hover ${r}, ${e}[data-hover] ${r}`,
  focus: (e, r) => `${e}:focus ${r}, ${e}[data-focus] ${r}`,
  focusVisible: (e, r) => `${e}:focus-visible ${r}`,
  focusWithin: (e, r) => `${e}:focus-within ${r}`,
  active: (e, r) => `${e}:active ${r}, ${e}[data-active] ${r}`,
  disabled: (e, r) => `${e}:disabled ${r}, ${e}[data-disabled] ${r}`,
  invalid: (e, r) => `${e}:invalid ${r}, ${e}[data-invalid] ${r}`,
  checked: (e, r) => `${e}:checked ${r}, ${e}[data-checked] ${r}`,
  placeholderShown: (e, r) => `${e}:placeholder-shown ${r}`
}, vn = (e) => xh((r) => e(r, "&"), "[role=group]", "[data-group]", ".group"), jr = (e) => xh((r) => e(r, "~ &"), "[data-peer]", ".peer"), xh = (e, ...r) => r.map(e).join(", "), Qu = {
  /**
   * Styles for CSS selector `&:hover`
   */
  _hover: "&:hover, &[data-hover]",
  /**
   * Styles for CSS Selector `&:active`
   */
  _active: "&:active, &[data-active]",
  /**
   * Styles for CSS selector `&:focus`
   *
   */
  _focus: "&:focus, &[data-focus]",
  /**
   * Styles for the highlighted state.
   */
  _highlighted: "&[data-highlighted]",
  /**
   * Styles to apply when a child of this element has received focus
   * - CSS Selector `&:focus-within`
   */
  _focusWithin: "&:focus-within",
  /**
   * Styles to apply when this element has received focus via tabbing
   * - CSS Selector `&:focus-visible`
   */
  _focusVisible: "&:focus-visible, &[data-focus-visible]",
  /**
   * Styles to apply when this element is disabled. The passed styles are applied to these CSS selectors:
   * - `&[aria-disabled=true]`
   * - `&:disabled`
   * - `&[data-disabled]`
   * - `&[disabled]`
   */
  _disabled: "&:disabled, &[disabled], &[aria-disabled=true], &[data-disabled]",
  /**
   * Styles for CSS Selector `&:readonly`
   */
  _readOnly: "&[aria-readonly=true], &[readonly], &[data-readonly]",
  /**
   * Styles for CSS selector `&::before`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _before={{content:`""` }}/>
   * ```
   */
  _before: "&::before",
  /**
   * Styles for CSS selector `&::after`
   *
   * NOTE:When using this, ensure the `content` is wrapped in a backtick.
   * @example
   * ```jsx
   * <Box _after={{content:`""` }}/>
   * ```
   */
  _after: "&::after",
  /**
   * Styles for CSS selector `&:empty`
   */
  _empty: "&:empty",
  /**
   * Styles to apply when the ARIA attribute `aria-expanded` is `true`
   * - CSS selector `&[aria-expanded=true]`
   */
  _expanded: "&[aria-expanded=true], &[data-expanded]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `true`
   * - CSS selector `&[aria-checked=true]`
   */
  _checked: "&[aria-checked=true], &[data-checked]",
  /**
   * Styles to apply when the ARIA attribute `aria-grabbed` is `true`
   * - CSS selector `&[aria-grabbed=true]`
   */
  _grabbed: "&[aria-grabbed=true], &[data-grabbed]",
  /**
   * Styles for CSS Selector `&[aria-pressed=true]`
   * Typically used to style the current "pressed" state of toggle buttons
   */
  _pressed: "&[aria-pressed=true], &[data-pressed]",
  /**
   * Styles to apply when the ARIA attribute `aria-invalid` is `true`
   * - CSS selector `&[aria-invalid=true]`
   */
  _invalid: "&[aria-invalid=true], &[data-invalid]",
  /**
   * Styles for the valid state
   * - CSS selector `&[data-valid], &[data-state=valid]`
   */
  _valid: "&[data-valid], &[data-state=valid]",
  /**
   * Styles for CSS Selector `&[aria-busy=true]` or `&[data-loading=true]`.
   * Useful for styling loading states
   */
  _loading: "&[data-loading], &[aria-busy=true]",
  /**
   * Styles to apply when the ARIA attribute `aria-selected` is `true`
   *
   * - CSS selector `&[aria-selected=true]`
   */
  _selected: "&[aria-selected=true], &[data-selected]",
  /**
   * Styles for CSS Selector `[hidden=true]`
   */
  _hidden: "&[hidden], &[data-hidden]",
  /**
   * Styles for CSS Selector `&:-webkit-autofill`
   */
  _autofill: "&:-webkit-autofill",
  /**
   * Styles for CSS Selector `&:nth-child(even)`
   */
  _even: "&:nth-of-type(even)",
  /**
   * Styles for CSS Selector `&:nth-child(odd)`
   */
  _odd: "&:nth-of-type(odd)",
  /**
   * Styles for CSS Selector `&:first-of-type`
   */
  _first: "&:first-of-type",
  /**
   * Styles for CSS selector `&::first-letter`
   *
   * NOTE: This selector is only applied for block-level elements and not preceded by an image or table.
   * @example
   * ```jsx
   * <Text _firstLetter={{ textDecoration: 'underline' }}>Once upon a time</Text>
   * ```
   */
  _firstLetter: "&::first-letter",
  /**
   * Styles for CSS Selector `&:last-of-type`
   */
  _last: "&:last-of-type",
  /**
   * Styles for CSS Selector `&:not(:first-of-type)`
   */
  _notFirst: "&:not(:first-of-type)",
  /**
   * Styles for CSS Selector `&:not(:last-of-type)`
   */
  _notLast: "&:not(:last-of-type)",
  /**
   * Styles for CSS Selector `&:visited`
   */
  _visited: "&:visited",
  /**
   * Used to style the active link in a navigation
   * Styles for CSS Selector `&[aria-current=page]`
   */
  _activeLink: "&[aria-current=page]",
  /**
   * Used to style the current step within a process
   * Styles for CSS Selector `&[aria-current=step]`
   */
  _activeStep: "&[aria-current=step]",
  /**
   * Styles to apply when the ARIA attribute `aria-checked` is `mixed`
   * - CSS selector `&[aria-checked=mixed]`
   */
  _indeterminate: "&:indeterminate, &[aria-checked=mixed], &[data-indeterminate]",
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is hovered
   */
  _groupHover: vn(St.hover),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is hovered
   */
  _peerHover: jr(St.hover),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is focused
   */
  _groupFocus: vn(St.focus),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is focused
   */
  _peerFocus: jr(St.focus),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` has visible focus
   */
  _groupFocusVisible: vn(St.focusVisible),
  /**
   * Styles to apply when a sibling element with `.peer`or `data-peer` has visible focus
   */
  _peerFocusVisible: jr(St.focusVisible),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is active
   */
  _groupActive: vn(St.active),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is active
   */
  _peerActive: jr(St.active),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is disabled
   */
  _groupDisabled: vn(St.disabled),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is disabled
   */
  _peerDisabled: jr(St.disabled),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` is invalid
   */
  _groupInvalid: vn(St.invalid),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` is invalid
   */
  _peerInvalid: jr(St.invalid),
  /**
   * Styles to apply when a parent element with `.group`, `data-group` or `role=group` is checked
   */
  _groupChecked: vn(St.checked),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` is checked
   */
  _peerChecked: jr(St.checked),
  /**
   *  Styles to apply when a parent element with `.group`, `data-group` or `role=group` has focus within
   */
  _groupFocusWithin: vn(St.focusWithin),
  /**
   *  Styles to apply when a sibling element with `.peer` or `data-peer` has focus within
   */
  _peerFocusWithin: jr(St.focusWithin),
  /**
   * Styles to apply when a sibling element with `.peer` or `data-peer` has placeholder shown
   */
  _peerPlaceholderShown: jr(St.placeholderShown),
  /**
   * Styles for CSS Selector `&::placeholder`.
   */
  _placeholder: "&::placeholder",
  /**
   * Styles for CSS Selector `&:placeholder-shown`.
   */
  _placeholderShown: "&:placeholder-shown",
  /**
   * Styles for CSS Selector `&:fullscreen`.
   */
  _fullScreen: "&:fullscreen",
  /**
   * Styles for CSS Selector `&::selection`
   */
  _selection: "&::selection",
  /**
   * Styles for CSS Selector `[dir=rtl] &`
   * It is applied when a parent element or this element has `dir="rtl"`
   */
  _rtl: "[dir=rtl] &, &[dir=rtl]",
  /**
   * Styles for CSS Selector `[dir=ltr] &`
   * It is applied when a parent element or this element has `dir="ltr"`
   */
  _ltr: "[dir=ltr] &, &[dir=ltr]",
  /**
   * Styles for CSS Selector `@media (prefers-color-scheme: dark)`
   * It is used when the user has requested the system use a light or dark color theme.
   */
  _mediaDark: "@media (prefers-color-scheme: dark)",
  /**
   * Styles for CSS Selector `@media (prefers-reduced-motion: reduce)`
   * It is used when the user has requested the system to reduce the amount of animations.
   */
  _mediaReduceMotion: "@media (prefers-reduced-motion: reduce)",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _dark: ".chakra-ui-dark &:not([data-theme]),[data-theme=dark] &:not([data-theme]),&[data-theme=dark]",
  /**
   * Styles for when `data-theme` is applied to any parent of
   * this component or element.
   */
  _light: ".chakra-ui-light &:not([data-theme]),[data-theme=light] &:not([data-theme]),&[data-theme=light]",
  /**
   * Styles for the CSS Selector `&[data-orientation=horizontal]`
   */
  _horizontal: "&[data-orientation=horizontal]",
  /**
   * Styles for the CSS Selector `&[data-orientation=vertical]`
   */
  _vertical: "&[data-orientation=vertical]"
}, i1 = Object.keys(
  Qu
);
function s1(e, r = []) {
  const t = Object.assign({}, e);
  for (const n of r)
    n in t && delete t[n];
  return t;
}
var qu = qr(
  {},
  Mi,
  Te,
  YC,
  ts,
  qt,
  HC,
  qC,
  zC,
  Ch,
  QC,
  Sa,
  su,
  Ue,
  n1,
  r1,
  KC,
  e1,
  $C,
  t1
);
Object.assign({}, Ue, qt, ts, Ch, Sa);
var l1 = [...Object.keys(qu), ...i1], u1 = { ...qu, ...Qu }, c1 = (e) => e in u1, d1 = (e) => (r) => {
  if (!r.__breakpoints)
    return e;
  const { isResponsive: t, toArrayValue: n, media: o } = r.__breakpoints, a = {};
  for (const i in e) {
    let s = yn(e[i], r);
    if (s == null)
      continue;
    if (s = tn(s) && t(s) ? n(s) : s, !Array.isArray(s)) {
      a[i] = s;
      continue;
    }
    const l = s.slice(0, o.length).length;
    for (let u = 0; u < l; u += 1) {
      const c = o == null ? void 0 : o[u];
      if (!c) {
        a[i] = s[u];
        continue;
      }
      a[c] = a[c] || {}, s[u] != null && (a[c][i] = s[u]);
    }
  }
  return a;
};
function f1(e) {
  const r = [];
  let t = "", n = !1;
  for (let o = 0; o < e.length; o++) {
    const a = e[o];
    a === "(" ? (n = !0, t += a) : a === ")" ? (n = !1, t += a) : a === "," && !n ? (r.push(t), t = "") : t += a;
  }
  return t = t.trim(), t && r.push(t), r;
}
function p1(e) {
  return /^var\(--.+\)$/.test(e);
}
var h1 = (e, r) => e.startsWith("--") && typeof r == "string" && !p1(r), g1 = (e, r) => {
  var t, n;
  if (r == null)
    return r;
  const o = (l) => {
    var u, c;
    return (c = (u = e.__cssMap) == null ? void 0 : u[l]) == null ? void 0 : c.varRef;
  }, a = (l) => {
    var u;
    return (u = o(l)) != null ? u : l;
  }, [i, s] = f1(r);
  return r = (n = (t = o(i)) != null ? t : a(s)) != null ? n : a(r), r;
};
function m1(e) {
  const { configs: r = {}, pseudos: t = {}, theme: n } = e, o = (a, i = !1) => {
    var s, l, u;
    const c = yn(a, n), d = d1(c)(n);
    let f = {};
    for (let p in d) {
      const h = d[p];
      let g = yn(h, n);
      p in t && (p = t[p]), h1(p, g) && (g = g1(n, g));
      let m = r[p];
      if (m === !0 && (m = { property: p }), tn(g)) {
        f[p] = (s = f[p]) != null ? s : {}, f[p] = qr(
          {},
          f[p],
          o(g, !0)
        );
        continue;
      }
      let v = (u = (l = m == null ? void 0 : m.transform) == null ? void 0 : l.call(m, g, n, c)) != null ? u : g;
      v = m != null && m.processResult ? o(v, !0) : v;
      const y = yn(m == null ? void 0 : m.property, n);
      if (!i && (m != null && m.static)) {
        const C = yn(m.static, n);
        f = qr({}, f, C);
      }
      if (y && Array.isArray(y)) {
        for (const C of y)
          f[C] = v;
        continue;
      }
      if (y) {
        y === "&" && tn(v) ? f = qr({}, f, v) : f[y] = v;
        continue;
      }
      if (tn(v)) {
        f = qr({}, f, v);
        continue;
      }
      f[p] = v;
    }
    return f;
  };
  return o;
}
var v1 = (e) => (r) => m1({
  theme: r,
  pseudos: Qu,
  configs: qu
})(e);
function b1(e, r) {
  if (Array.isArray(e))
    return e;
  if (tn(e))
    return r(e);
  if (e != null)
    return [e];
}
function y1(e, r) {
  for (let t = r + 1; t < e.length; t++)
    if (e[t] != null)
      return t;
  return -1;
}
function w1(e) {
  const r = e.__breakpoints;
  return function(n, o, a, i) {
    var s, l;
    if (!r)
      return;
    const u = {}, c = b1(a, r.toArrayValue);
    if (!c)
      return u;
    const d = c.length, f = d === 1, p = !!n.parts;
    for (let h = 0; h < d; h++) {
      const g = r.details[h], m = r.details[y1(c, h)], v = a1(g.minW, m == null ? void 0 : m._minW), y = yn((s = n[o]) == null ? void 0 : s[c[h]], i);
      if (y) {
        if (p) {
          (l = n.parts) == null || l.forEach((C) => {
            qr(u, {
              [C]: f ? y[C] : { [v]: y[C] }
            });
          });
          continue;
        }
        if (!p) {
          f ? qr(u, y) : u[v] = y;
          continue;
        }
        u[v] = y;
      }
    }
    return u;
  };
}
function C1(e) {
  return (r) => {
    var t;
    const { variant: n, size: o, theme: a } = r, i = w1(a);
    return qr(
      {},
      yn((t = e.baseStyle) != null ? t : {}, r),
      i(e, "sizes", o, r),
      i(e, "variants", n, r)
    );
  };
}
function Os(e) {
  return s1(e, ["styleConfig", "size", "variant", "colorScheme"]);
}
function S1(e, r) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    r.includes(n) || (t[n] = e[n]);
  }), t;
}
function x1(e, r, t, n) {
  const o = typeof r == "string" ? r.split(".") : [r];
  for (n = 0; n < o.length && e; n += 1)
    e = e[o[n]];
  return e === void 0 ? t : e;
}
var I1 = (e) => {
  const r = /* @__PURE__ */ new WeakMap();
  return (n, o, a, i) => {
    if (typeof n > "u")
      return e(n, o, a);
    r.has(n) || r.set(n, /* @__PURE__ */ new Map());
    const s = r.get(n);
    if (s.has(o))
      return s.get(o);
    const l = e(n, o, a, i);
    return s.set(o, l), l;
  };
}, D1 = I1(x1);
function Ih(e, r) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const o = e[n];
    r(o, n, e) && (t[n] = o);
  }), t;
}
var Dh = (e) => Ih(e, (r) => r != null);
function _1(e) {
  return typeof e == "function";
}
process.env.NODE_ENV;
process.env.NODE_ENV;
function k1(e, ...r) {
  return _1(e) ? e(...r) : e;
}
var E1 = typeof Element < "u", M1 = typeof Map == "function", A1 = typeof Set == "function", P1 = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function Ai(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var t, n, o;
    if (Array.isArray(e)) {
      if (t = e.length, t != r.length) return !1;
      for (n = t; n-- !== 0; )
        if (!Ai(e[n], r[n])) return !1;
      return !0;
    }
    var a;
    if (M1 && e instanceof Map && r instanceof Map) {
      if (e.size !== r.size) return !1;
      for (a = e.entries(); !(n = a.next()).done; )
        if (!r.has(n.value[0])) return !1;
      for (a = e.entries(); !(n = a.next()).done; )
        if (!Ai(n.value[1], r.get(n.value[0]))) return !1;
      return !0;
    }
    if (A1 && e instanceof Set && r instanceof Set) {
      if (e.size !== r.size) return !1;
      for (a = e.entries(); !(n = a.next()).done; )
        if (!r.has(n.value[0])) return !1;
      return !0;
    }
    if (P1 && ArrayBuffer.isView(e) && ArrayBuffer.isView(r)) {
      if (t = e.length, t != r.length) return !1;
      for (n = t; n-- !== 0; )
        if (e[n] !== r[n]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof r.valueOf == "function") return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof r.toString == "function") return e.toString() === r.toString();
    if (o = Object.keys(e), t = o.length, t !== Object.keys(r).length) return !1;
    for (n = t; n-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[n])) return !1;
    if (E1 && e instanceof Element) return !1;
    for (n = t; n-- !== 0; )
      if (!((o[n] === "_owner" || o[n] === "__v" || o[n] === "__o") && e.$$typeof) && !Ai(e[o[n]], r[o[n]]))
        return !1;
    return !0;
  }
  return e !== e && r !== r;
}
var R1 = function(r, t) {
  try {
    return Ai(r, t);
  } catch (n) {
    if ((n.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw n;
  }
};
const O1 = /* @__PURE__ */ Uu(R1);
function _h(e, r = {}) {
  var t;
  const { styleConfig: n, ...o } = r, { theme: a, colorMode: i } = xC(), s = e ? D1(a, `components.${e}`) : void 0, l = n || s, u = qr(
    { theme: a, colorMode: i },
    (t = l == null ? void 0 : l.defaultProps) != null ? t : {},
    Dh(S1(o, ["children"]))
  ), c = ye({});
  if (l) {
    const f = C1(l)(u);
    O1(c.current, f) || (c.current = f);
  }
  return c.current;
}
function Ts(e, r = {}) {
  return _h(e, r);
}
function Lr(e, r = {}) {
  return _h(e, r);
}
var T1 = /* @__PURE__ */ new Set([
  ...l1,
  "textStyle",
  "layerStyle",
  "apply",
  "noOfLines",
  "focusBorderColor",
  "errorBorderColor",
  "as",
  "__css",
  "css",
  "sx"
]), F1 = /* @__PURE__ */ new Set([
  "htmlWidth",
  "htmlHeight",
  "htmlSize",
  "htmlTranslate"
]);
function N1(e) {
  return F1.has(e) || !T1.has(e);
}
function L1(e, ...r) {
  if (e == null)
    throw new TypeError("Cannot convert undefined or null to object");
  const t = { ...e };
  for (const n of r)
    if (n != null)
      for (const o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (o in t && delete t[o], t[o] = n[o]);
  return t;
}
var Bd, W1 = (Bd = rd.default) != null ? Bd : rd, B1 = ({ baseStyle: e }) => (r) => {
  const { theme: t, css: n, __css: o, sx: a, ...i } = r, s = Ih(i, (d, f) => c1(f)), l = k1(e, r), u = L1(
    {},
    o,
    l,
    Dh(s),
    a
  ), c = v1(u)(r.theme);
  return n ? [c, n] : c;
};
function Sl(e, r) {
  const { baseStyle: t, ...n } = r ?? {};
  n.shouldForwardProp || (n.shouldForwardProp = N1);
  const o = B1({ baseStyle: t }), a = W1(
    e,
    n
  )(o);
  return A.forwardRef(function(l, u) {
    const { colorMode: c, forced: d } = Zu();
    return A.createElement(a, {
      ref: u,
      "data-theme": d ? c : void 0,
      ...l
    });
  });
}
function V1() {
  const e = /* @__PURE__ */ new Map();
  return new Proxy(Sl, {
    /**
     * @example
     * const Div = chakra("div")
     * const WithChakra = chakra(AnotherComponent)
     */
    apply(r, t, n) {
      return Sl(...n);
    },
    /**
     * @example
     * <chakra.div />
     */
    get(r, t) {
      return e.has(t) || e.set(t, Sl(t)), e.get(t);
    }
  });
}
var ar = V1();
function Pn(e) {
  return ot(e);
}
var [G1, Y1] = ja({
  name: "FormControlStylesContext",
  errorMessage: `useFormControlStyles returned is 'undefined'. Seems you forgot to wrap the components in "<FormControl />" `
}), [H1, kh] = ja({
  strict: !1,
  name: "FormControlContext"
});
function z1(e) {
  const {
    id: r,
    isRequired: t,
    isInvalid: n,
    isDisabled: o,
    isReadOnly: a,
    ...i
  } = e, s = Bu(), l = r || `field-${s}`, u = `${l}-label`, c = `${l}-feedback`, d = `${l}-helptext`, [f, p] = Se(!1), [h, g] = Se(!1), [m, v] = Se(!1), y = se(
    (x = {}, _ = null) => ({
      id: d,
      ...x,
      /**
       * Notify the field context when the help text is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: Ma(_, (E) => {
        E && g(!0);
      })
    }),
    [d]
  ), C = se(
    (x = {}, _ = null) => ({
      ...x,
      ref: _,
      "data-focus": mn(m),
      "data-disabled": mn(o),
      "data-invalid": mn(n),
      "data-readonly": mn(a),
      id: x.id !== void 0 ? x.id : u,
      htmlFor: x.htmlFor !== void 0 ? x.htmlFor : l
    }),
    [l, o, m, n, a, u]
  ), I = se(
    (x = {}, _ = null) => ({
      id: c,
      ...x,
      /**
       * Notify the field context when the error message is rendered on screen,
       * so we can apply the correct `aria-describedby` to the field (e.g. input, textarea).
       */
      ref: Ma(_, (E) => {
        E && p(!0);
      }),
      "aria-live": "polite"
    }),
    [c]
  ), b = se(
    (x = {}, _ = null) => ({
      ...x,
      ...i,
      ref: _,
      role: "group",
      "data-focus": mn(m),
      "data-disabled": mn(o),
      "data-invalid": mn(n),
      "data-readonly": mn(a)
    }),
    [i, o, m, n, a]
  ), D = se(
    (x = {}, _ = null) => ({
      ...x,
      ref: _,
      role: "presentation",
      "aria-hidden": !0,
      children: x.children || "*"
    }),
    []
  );
  return {
    isRequired: !!t,
    isInvalid: !!n,
    isReadOnly: !!a,
    isDisabled: !!o,
    isFocused: !!m,
    onFocus: () => v(!0),
    onBlur: () => v(!1),
    hasFeedbackText: f,
    setHasFeedbackText: p,
    hasHelpText: h,
    setHasHelpText: g,
    id: l,
    labelId: u,
    feedbackId: c,
    helpTextId: d,
    htmlProps: i,
    getHelpTextProps: y,
    getErrorMessageProps: I,
    getRootProps: b,
    getLabelProps: C,
    getRequiredIndicatorProps: D
  };
}
var $1 = Pn(
  function(r, t) {
    const n = Lr("Form", r), o = Os(r), {
      getRootProps: a,
      htmlProps: i,
      ...s
    } = z1(o), l = Qn("chakra-form-control", r.className);
    return /* @__PURE__ */ S(H1, { value: s, children: /* @__PURE__ */ S(G1, { value: n, children: /* @__PURE__ */ S(
      ar.div,
      {
        ...a({}, t),
        className: l,
        __css: n.container
      }
    ) }) });
  }
);
$1.displayName = "FormControl";
var X1 = Pn(
  function(r, t) {
    const n = kh(), o = Y1(), a = Qn("chakra-form__helper-text", r.className);
    return /* @__PURE__ */ S(
      ar.div,
      {
        ...n == null ? void 0 : n.getHelpTextProps(r, t),
        __css: o.helperText,
        className: a
      }
    );
  }
);
X1.displayName = "FormHelperText";
var Vd = {
  path: /* @__PURE__ */ K("g", { stroke: "currentColor", strokeWidth: "1.5", children: [
    /* @__PURE__ */ S(
      "path",
      {
        strokeLinecap: "round",
        fill: "none",
        d: "M9,9a3,3,0,1,1,4,2.829,1.5,1.5,0,0,0-1,1.415V14.25"
      }
    ),
    /* @__PURE__ */ S(
      "path",
      {
        fill: "currentColor",
        strokeLinecap: "round",
        d: "M12,17.25a.375.375,0,1,0,.375.375A.375.375,0,0,0,12,17.25h0"
      }
    ),
    /* @__PURE__ */ S("circle", { fill: "none", strokeMiterlimit: "10", cx: "12", cy: "12", r: "11.25" })
  ] }),
  viewBox: "0 0 24 24"
}, Za = Pn((e, r) => {
  const {
    as: t,
    viewBox: n,
    color: o = "currentColor",
    focusable: a = !1,
    children: i,
    className: s,
    __css: l,
    ...u
  } = e, c = Qn("chakra-icon", s), d = Ts("Icon", e), f = {
    w: "1em",
    h: "1em",
    display: "inline-block",
    lineHeight: "1em",
    flexShrink: 0,
    color: o,
    ...l,
    ...d
  }, p = {
    ref: r,
    focusable: a,
    className: c,
    __css: f
  }, h = n ?? Vd.viewBox;
  if (t && typeof t != "string")
    return /* @__PURE__ */ S(ar.svg, { as: t, ...p, ...u });
  const g = i ?? Vd.path;
  return /* @__PURE__ */ S(ar.svg, { verticalAlign: "middle", viewBox: h, ...p, ...u, children: g });
});
Za.displayName = "Icon";
function Fs(e) {
  const {
    viewBox: r = "0 0 24 24",
    d: t,
    displayName: n,
    defaultProps: o = {}
  } = e, a = bp.toArray(e.path), i = Pn((s, l) => /* @__PURE__ */ S(Za, { ref: l, viewBox: r, ...o, ...s, children: a.length ? a : /* @__PURE__ */ S("path", { fill: "currentColor", d: t }) }));
  return i.displayName = n, i;
}
function j1(e) {
  const { isDisabled: r, isInvalid: t, isReadOnly: n, isRequired: o, ...a } = Z1(e);
  return {
    ...a,
    disabled: r,
    readOnly: n,
    required: o,
    "aria-invalid": wl(t),
    "aria-required": wl(o),
    "aria-readonly": wl(n)
  };
}
function Z1(e) {
  var r, t, n;
  const o = kh(), {
    id: a,
    disabled: i,
    readOnly: s,
    required: l,
    isRequired: u,
    isInvalid: c,
    isReadOnly: d,
    isDisabled: f,
    onFocus: p,
    onBlur: h,
    ...g
  } = e, m = e["aria-describedby"] ? [e["aria-describedby"]] : [];
  return o != null && o.hasFeedbackText && (o != null && o.isInvalid) && m.push(o.feedbackId), o != null && o.hasHelpText && m.push(o.helpTextId), {
    ...g,
    "aria-describedby": m.join(" ") || void 0,
    id: a ?? (o == null ? void 0 : o.id),
    isDisabled: (r = i ?? f) != null ? r : o == null ? void 0 : o.isDisabled,
    isReadOnly: (t = s ?? d) != null ? t : o == null ? void 0 : o.isReadOnly,
    isRequired: (n = l ?? u) != null ? n : o == null ? void 0 : o.isRequired,
    isInvalid: c ?? (o == null ? void 0 : o.isInvalid),
    onFocus: Rd(o == null ? void 0 : o.onFocus, p),
    onBlur: Rd(o == null ? void 0 : o.onBlur, h)
  };
}
var Eh = Object.freeze([
  "base",
  "sm",
  "md",
  "lg",
  "xl",
  "2xl"
]);
function U1(e, r = Eh) {
  const t = {};
  return e.forEach((n, o) => {
    const a = r[o];
    n != null && (t[a] = n);
  }), t;
}
var mt = ar("div");
mt.displayName = "Box";
var Mh = Pn(function(r, t) {
  const { size: n, centerContent: o = !0, ...a } = r;
  return /* @__PURE__ */ S(
    mt,
    {
      ref: t,
      boxSize: n,
      __css: {
        ...o ? { display: "flex", alignItems: "center", justifyContent: "center" } : {},
        flexShrink: 0,
        flexGrow: 0
      },
      ...a
    }
  );
});
Mh.displayName = "Square";
var J1 = Pn(function(r, t) {
  const { size: n, ...o } = r;
  return /* @__PURE__ */ S(Mh, { size: n, ref: t, borderRadius: "9999px", ...o });
});
J1.displayName = "Circle";
var Ah = Pn(function(r, t) {
  const {
    borderLeftWidth: n,
    borderBottomWidth: o,
    borderTopWidth: a,
    borderRightWidth: i,
    borderWidth: s,
    borderStyle: l,
    borderColor: u,
    ...c
  } = Ts("Divider", r), {
    className: d,
    orientation: f = "horizontal",
    __css: p,
    ...h
  } = Os(r), g = {
    vertical: {
      borderLeftWidth: n || i || s || "1px",
      height: "100%"
    },
    horizontal: {
      borderBottomWidth: o || a || s || "1px",
      width: "100%"
    }
  };
  return /* @__PURE__ */ S(
    ar.hr,
    {
      ref: t,
      "aria-orientation": f,
      ...h,
      __css: {
        ...c,
        border: "0",
        borderColor: u,
        borderStyle: l,
        ...g[f],
        ...p
      },
      className: Qn("chakra-divider", d)
    }
  );
});
Ah.displayName = "Divider";
var Ph = Ya({
  getDocument() {
    return document;
  },
  getWindow() {
    return window;
  }
});
Ph.displayName = "EnvironmentContext";
function Q1({ defer: e } = {}) {
  const [, r] = yp((t) => t + 1, 0);
  return SC(() => {
    e && r();
  }, [e]), $o(Ph);
}
function q1(e, r = {}) {
  const { ssr: t = !0, fallback: n } = r, { getWindow: o } = Q1(), a = Array.isArray(e) ? e : [e];
  let i = Array.isArray(n) ? n : [n];
  i = i.filter((u) => u != null);
  const [s, l] = Se(() => a.map((u, c) => ({
    media: u,
    matches: t ? !!i[c] : o().matchMedia(u).matches
  })));
  return Ye(() => {
    const u = o();
    l(
      a.map((f) => ({
        media: f,
        matches: u.matchMedia(f).matches
      }))
    );
    const c = a.map((f) => u.matchMedia(f)), d = (f) => {
      l((p) => p.slice().map((h) => h.media === f.media ? { ...h, matches: f.matches } : h));
    };
    return c.forEach((f) => {
      typeof f.addListener == "function" ? f.addListener(d) : f.addEventListener("change", d);
    }), () => {
      c.forEach((f) => {
        typeof f.removeListener == "function" ? f.removeListener(d) : f.removeEventListener("change", d);
      });
    };
  }, [o]), s.map((u) => u.matches);
}
function K1(e, r, t = Eh) {
  let n = Object.keys(e).indexOf(r);
  if (n !== -1)
    return e[r];
  let o = t.indexOf(r);
  for (; o >= 0; ) {
    const a = t[o];
    if (e.hasOwnProperty(a)) {
      n = o;
      break;
    }
    o -= 1;
  }
  if (n !== -1) {
    const a = t[n];
    return e[a];
  }
}
function eS(e) {
  var r, t;
  const n = tn(e) ? e : { fallback: e ?? "base" }, a = jo().__breakpoints.details.map(
    ({ minMaxQuery: u, breakpoint: c }) => ({
      breakpoint: c,
      query: u.replace("@media screen and ", "")
    })
  ), i = a.map((u) => u.breakpoint === n.fallback), l = q1(
    a.map((u) => u.query),
    { fallback: i, ssr: n.ssr }
  ).findIndex((u) => u == !0);
  return (t = (r = a[l]) == null ? void 0 : r.breakpoint) != null ? t : n.fallback;
}
function tS(e, r) {
  var t;
  const n = tn(r) ? r : { fallback: r ?? "base" }, o = eS(n), a = jo();
  if (!o)
    return;
  const i = Array.from(((t = a.__breakpoints) == null ? void 0 : t.keys) || []), s = Array.isArray(e) ? Object.fromEntries(
    Object.entries(U1(e, i)).map(
      ([l, u]) => [l, u]
    )
  ) : e;
  return K1(s, o, i);
}
var rS = Pp({
  "0%": {
    transform: "rotate(0deg)"
  },
  "100%": {
    transform: "rotate(360deg)"
  }
}), Rh = Pn((e, r) => {
  const t = Ts("Spinner", e), {
    label: n = "Loading...",
    thickness: o = "2px",
    speed: a = "0.45s",
    emptyColor: i = "transparent",
    className: s,
    ...l
  } = Os(e), u = Qn("chakra-spinner", s), c = {
    display: "inline-block",
    borderColor: "currentColor",
    borderStyle: "solid",
    borderRadius: "99999px",
    borderWidth: o,
    borderBottomColor: i,
    borderLeftColor: i,
    animation: `${rS} ${a} linear infinite`,
    ...t
  };
  return /* @__PURE__ */ S(
    ar.div,
    {
      ref: r,
      __css: c,
      className: u,
      ...l,
      children: n && /* @__PURE__ */ S(ar.span, { srOnly: !0, children: n })
    }
  );
});
Rh.displayName = "Spinner";
var nS = Object.defineProperty, oS = (e, r, t) => r in e ? nS(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, st = (e, r, t) => (oS(e, typeof r != "symbol" ? r + "" : r, t), t);
function Gd(e) {
  return e.sort((r, t) => {
    const n = r.compareDocumentPosition(t);
    if (n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY)
      return -1;
    if (n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS)
      return 1;
    if (n & Node.DOCUMENT_POSITION_DISCONNECTED || n & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC)
      throw Error("Cannot sort the given nodes.");
    return 0;
  });
}
var aS = (e) => typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
function Yd(e, r, t) {
  let n = e + 1;
  return t && n >= r && (n = 0), n;
}
function Hd(e, r, t) {
  let n = e - 1;
  return t && n < 0 && (n = r), n;
}
var uu = typeof window < "u" ? Ga : Ye, rs = (e) => e, iS = class {
  constructor() {
    st(this, "descendants", /* @__PURE__ */ new Map()), st(this, "register", (e) => {
      if (e != null)
        return aS(e) ? this.registerNode(e) : (r) => {
          this.registerNode(r, e);
        };
    }), st(this, "unregister", (e) => {
      this.descendants.delete(e);
      const r = Gd(Array.from(this.descendants.keys()));
      this.assignIndex(r);
    }), st(this, "destroy", () => {
      this.descendants.clear();
    }), st(this, "assignIndex", (e) => {
      this.descendants.forEach((r) => {
        const t = e.indexOf(r.node);
        r.index = t, r.node.dataset.index = r.index.toString();
      });
    }), st(this, "count", () => this.descendants.size), st(this, "enabledCount", () => this.enabledValues().length), st(this, "values", () => Array.from(this.descendants.values()).sort((r, t) => r.index - t.index)), st(this, "enabledValues", () => this.values().filter((e) => !e.disabled)), st(this, "item", (e) => {
      if (this.count() !== 0)
        return this.values()[e];
    }), st(this, "enabledItem", (e) => {
      if (this.enabledCount() !== 0)
        return this.enabledValues()[e];
    }), st(this, "first", () => this.item(0)), st(this, "firstEnabled", () => this.enabledItem(0)), st(this, "last", () => this.item(this.descendants.size - 1)), st(this, "lastEnabled", () => {
      const e = this.enabledValues().length - 1;
      return this.enabledItem(e);
    }), st(this, "indexOf", (e) => {
      var r, t;
      return e && (t = (r = this.descendants.get(e)) == null ? void 0 : r.index) != null ? t : -1;
    }), st(this, "enabledIndexOf", (e) => e == null ? -1 : this.enabledValues().findIndex((r) => r.node.isSameNode(e))), st(this, "next", (e, r = !0) => {
      const t = Yd(e, this.count(), r);
      return this.item(t);
    }), st(this, "nextEnabled", (e, r = !0) => {
      const t = this.item(e);
      if (!t)
        return;
      const n = this.enabledIndexOf(t.node), o = Yd(
        n,
        this.enabledCount(),
        r
      );
      return this.enabledItem(o);
    }), st(this, "prev", (e, r = !0) => {
      const t = Hd(e, this.count() - 1, r);
      return this.item(t);
    }), st(this, "prevEnabled", (e, r = !0) => {
      const t = this.item(e);
      if (!t)
        return;
      const n = this.enabledIndexOf(t.node), o = Hd(
        n,
        this.enabledCount() - 1,
        r
      );
      return this.enabledItem(o);
    }), st(this, "registerNode", (e, r) => {
      if (!e || this.descendants.has(e))
        return;
      const t = Array.from(this.descendants.keys()).concat(e), n = Gd(t);
      r != null && r.disabled && (r.disabled = !!r.disabled);
      const o = { node: e, index: -1, ...r };
      this.descendants.set(e, o), this.assignIndex(n);
    });
  }
};
function sS() {
  const e = ye(new iS());
  return uu(() => () => e.current.destroy()), e.current;
}
var [lS, Oh] = ja({
  name: "DescendantsProvider",
  errorMessage: "useDescendantsContext must be used within DescendantsProvider"
});
function uS(e) {
  const r = Oh(), [t, n] = Se(-1), o = ye(null);
  uu(() => () => {
    o.current && r.unregister(o.current);
  }, []), uu(() => {
    if (!o.current)
      return;
    const i = Number(o.current.dataset.index);
    t != i && !Number.isNaN(i) && n(i);
  });
  const a = rs(e ? r.register(e) : r.register);
  return {
    descendants: r,
    index: t,
    enabledIndex: r.enabledIndexOf(o.current),
    register: Ma(a, o)
  };
}
function cS() {
  return [
    rs(lS),
    () => rs(Oh()),
    () => sS(),
    (o) => uS(o)
  ];
}
function Th(e) {
  return e != null && typeof e == "object" && "nodeType" in e && e.nodeType === Node.ELEMENT_NODE;
}
function Fh(e) {
  var r;
  if (!Th(e))
    return !1;
  const t = (r = e.ownerDocument.defaultView) != null ? r : window;
  return e instanceof t.HTMLElement;
}
function dS(e) {
  var r, t;
  return (t = (r = Nh(e)) == null ? void 0 : r.defaultView) != null ? t : window;
}
function Nh(e) {
  return Th(e) ? e.ownerDocument : document;
}
function fS(e) {
  return Nh(e).activeElement;
}
var Lh = (e) => e.hasAttribute("tabindex"), pS = (e) => Lh(e) && e.tabIndex === -1;
function hS(e) {
  return !!e.getAttribute("disabled") || !!e.getAttribute("aria-disabled");
}
function Wh(e) {
  return e.parentElement && Wh(e.parentElement) ? !0 : e.hidden;
}
function gS(e) {
  const r = e.getAttribute("contenteditable");
  return r !== "false" && r != null;
}
function mS(e) {
  if (!Fh(e) || Wh(e) || hS(e))
    return !1;
  const { localName: r } = e;
  if (["input", "select", "textarea", "button"].indexOf(r) >= 0)
    return !0;
  const n = {
    a: () => e.hasAttribute("href"),
    audio: () => e.hasAttribute("controls"),
    video: () => e.hasAttribute("controls")
  };
  return r in n ? n[r]() : gS(e) ? !0 : Lh(e);
}
function vS(e) {
  return e ? Fh(e) && mS(e) && !pS(e) : !1;
}
function ns(e, r = []) {
  const t = ye(e);
  return Ye(() => {
    t.current = e;
  }), se((...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, r);
}
function bS(e, r, t, n) {
  const o = ns(t);
  return Ye(() => {
    const a = typeof e == "function" ? e() : e ?? document;
    if (!(!t || !a))
      return a.addEventListener(r, o, n), () => {
        a.removeEventListener(r, o, n);
      };
  }, [r, e, n, o, t]), () => {
    const a = typeof e == "function" ? e() : e ?? document;
    a == null || a.removeEventListener(r, o, n);
  };
}
function Bh(e, r) {
  const t = ye(!1), n = ye(!1);
  Ye(() => {
    if (t.current && n.current)
      return e();
    n.current = !0;
  }, r), Ye(() => (t.current = !0, () => {
    t.current = !1;
  }), []);
}
function yS(e) {
  const r = e.current;
  if (!r)
    return !1;
  const t = fS(r);
  return !t || r.contains(t) ? !1 : !!vS(t);
}
function wS(e, r) {
  const { visible: t, focusRef: n } = r, o = !t;
  Bh(() => {
    if (!o || yS(e))
      return;
    const a = (n == null ? void 0 : n.current) || e.current;
    let i;
    if (a)
      return i = requestAnimationFrame(() => {
        a.focus({ preventScroll: !0 });
      }), () => {
        cancelAnimationFrame(i);
      };
  }, [o, e, n]);
}
var la = (e, r) => ({
  var: e,
  varRef: r ? `var(${e}, ${r})` : `var(${e})`
}), zt = {
  arrowSize: la("--popper-arrow-size", "8px"),
  arrowSizeHalf: la("--popper-arrow-size-half"),
  arrowBg: la("--popper-arrow-bg"),
  transformOrigin: la("--popper-transform-origin"),
  arrowOffset: la("--popper-arrow-offset")
};
function CS(e) {
  if (e.includes("top"))
    return "1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("bottom"))
    return "-1px -1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("right"))
    return "-1px 1px 0px 0 var(--popper-arrow-shadow-color)";
  if (e.includes("left"))
    return "1px -1px 0px 0 var(--popper-arrow-shadow-color)";
}
var SS = {
  top: "bottom center",
  "top-start": "bottom left",
  "top-end": "bottom right",
  bottom: "top center",
  "bottom-start": "top left",
  "bottom-end": "top right",
  left: "right center",
  "left-start": "right top",
  "left-end": "right bottom",
  right: "left center",
  "right-start": "left top",
  "right-end": "left bottom"
}, xS = (e) => SS[e], zd = {
  scroll: !0,
  resize: !0
};
function IS(e) {
  let r;
  return typeof e == "object" ? r = {
    enabled: !0,
    options: { ...zd, ...e }
  } : r = {
    enabled: e,
    options: zd
  }, r;
}
var DS = {
  name: "matchWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({ state: e }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  },
  effect: ({ state: e }) => () => {
    const r = e.elements.reference;
    e.elements.popper.style.width = `${r.offsetWidth}px`;
  }
}, _S = {
  name: "transformOrigin",
  enabled: !0,
  phase: "write",
  fn: ({ state: e }) => {
    $d(e);
  },
  effect: ({ state: e }) => () => {
    $d(e);
  }
}, $d = (e) => {
  e.elements.popper.style.setProperty(
    zt.transformOrigin.var,
    xS(e.placement)
  );
}, kS = {
  name: "positionArrow",
  enabled: !0,
  phase: "afterWrite",
  fn: ({ state: e }) => {
    ES(e);
  }
}, ES = (e) => {
  var r;
  if (!e.placement)
    return;
  const t = MS(e.placement);
  if ((r = e.elements) != null && r.arrow && t) {
    Object.assign(e.elements.arrow.style, {
      [t.property]: t.value,
      width: zt.arrowSize.varRef,
      height: zt.arrowSize.varRef,
      zIndex: -1
    });
    const n = {
      [zt.arrowSizeHalf.var]: `calc(${zt.arrowSize.varRef} / 2 - 1px)`,
      [zt.arrowOffset.var]: `calc(${zt.arrowSizeHalf.varRef} * -1)`
    };
    for (const o in n)
      e.elements.arrow.style.setProperty(o, n[o]);
  }
}, MS = (e) => {
  if (e.startsWith("top"))
    return { property: "bottom", value: zt.arrowOffset.varRef };
  if (e.startsWith("bottom"))
    return { property: "top", value: zt.arrowOffset.varRef };
  if (e.startsWith("left"))
    return { property: "right", value: zt.arrowOffset.varRef };
  if (e.startsWith("right"))
    return { property: "left", value: zt.arrowOffset.varRef };
}, AS = {
  name: "innerArrow",
  enabled: !0,
  phase: "main",
  requires: ["arrow"],
  fn: ({ state: e }) => {
    Xd(e);
  },
  effect: ({ state: e }) => () => {
    Xd(e);
  }
}, Xd = (e) => {
  if (!e.elements.arrow)
    return;
  const r = e.elements.arrow.querySelector(
    "[data-popper-arrow-inner]"
  );
  if (!r)
    return;
  const t = CS(e.placement);
  t && r.style.setProperty("--popper-arrow-default-shadow", t), Object.assign(r.style, {
    transform: "rotate(45deg)",
    background: zt.arrowBg.varRef,
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    position: "absolute",
    zIndex: "inherit",
    boxShadow: "var(--popper-arrow-shadow, var(--popper-arrow-default-shadow))"
  });
}, PS = {
  "start-start": { ltr: "left-start", rtl: "right-start" },
  "start-end": { ltr: "left-end", rtl: "right-end" },
  "end-start": { ltr: "right-start", rtl: "left-start" },
  "end-end": { ltr: "right-end", rtl: "left-end" },
  start: { ltr: "left", rtl: "right" },
  end: { ltr: "right", rtl: "left" }
}, RS = {
  "auto-start": "auto-end",
  "auto-end": "auto-start",
  "top-start": "top-end",
  "top-end": "top-start",
  "bottom-start": "bottom-end",
  "bottom-end": "bottom-start"
};
function OS(e, r = "ltr") {
  var t, n;
  const o = ((t = PS[e]) == null ? void 0 : t[r]) || e;
  return r === "ltr" ? o : (n = RS[e]) != null ? n : o;
}
var Ft = "top", ir = "bottom", sr = "right", Nt = "left", Ku = "auto", Ua = [Ft, ir, sr, Nt], Wo = "start", Aa = "end", TS = "clippingParents", Vh = "viewport", ua = "popper", FS = "reference", jd = /* @__PURE__ */ Ua.reduce(function(e, r) {
  return e.concat([r + "-" + Wo, r + "-" + Aa]);
}, []), Gh = /* @__PURE__ */ [].concat(Ua, [Ku]).reduce(function(e, r) {
  return e.concat([r, r + "-" + Wo, r + "-" + Aa]);
}, []), NS = "beforeRead", LS = "read", WS = "afterRead", BS = "beforeMain", VS = "main", GS = "afterMain", YS = "beforeWrite", HS = "write", zS = "afterWrite", $S = [NS, LS, WS, BS, VS, GS, YS, HS, zS];
function Wr(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function Xt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var r = e.ownerDocument;
    return r && r.defaultView || window;
  }
  return e;
}
function qn(e) {
  var r = Xt(e).Element;
  return e instanceof r || e instanceof Element;
}
function rr(e) {
  var r = Xt(e).HTMLElement;
  return e instanceof r || e instanceof HTMLElement;
}
function ec(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var r = Xt(e).ShadowRoot;
  return e instanceof r || e instanceof ShadowRoot;
}
function XS(e) {
  var r = e.state;
  Object.keys(r.elements).forEach(function(t) {
    var n = r.styles[t] || {}, o = r.attributes[t] || {}, a = r.elements[t];
    !rr(a) || !Wr(a) || (Object.assign(a.style, n), Object.keys(o).forEach(function(i) {
      var s = o[i];
      s === !1 ? a.removeAttribute(i) : a.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function jS(e) {
  var r = e.state, t = {
    popper: {
      position: r.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(r.elements.popper.style, t.popper), r.styles = t, r.elements.arrow && Object.assign(r.elements.arrow.style, t.arrow), function() {
    Object.keys(r.elements).forEach(function(n) {
      var o = r.elements[n], a = r.attributes[n] || {}, i = Object.keys(r.styles.hasOwnProperty(n) ? r.styles[n] : t[n]), s = i.reduce(function(l, u) {
        return l[u] = "", l;
      }, {});
      !rr(o) || !Wr(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const ZS = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: XS,
  effect: jS,
  requires: ["computeStyles"]
};
function Or(e) {
  return e.split("-")[0];
}
var zn = Math.max, os = Math.min, Bo = Math.round;
function cu() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(r) {
    return r.brand + "/" + r.version;
  }).join(" ") : navigator.userAgent;
}
function Yh() {
  return !/^((?!chrome|android).)*safari/i.test(cu());
}
function Vo(e, r, t) {
  r === void 0 && (r = !1), t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), o = 1, a = 1;
  r && rr(e) && (o = e.offsetWidth > 0 && Bo(n.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && Bo(n.height) / e.offsetHeight || 1);
  var i = qn(e) ? Xt(e) : window, s = i.visualViewport, l = !Yh() && t, u = (n.left + (l && s ? s.offsetLeft : 0)) / o, c = (n.top + (l && s ? s.offsetTop : 0)) / a, d = n.width / o, f = n.height / a;
  return {
    width: d,
    height: f,
    top: c,
    right: u + d,
    bottom: c + f,
    left: u,
    x: u,
    y: c
  };
}
function tc(e) {
  var r = Vo(e), t = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(r.width - t) <= 1 && (t = r.width), Math.abs(r.height - n) <= 1 && (n = r.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: t,
    height: n
  };
}
function Hh(e, r) {
  var t = r.getRootNode && r.getRootNode();
  if (e.contains(r))
    return !0;
  if (t && ec(t)) {
    var n = r;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function ln(e) {
  return Xt(e).getComputedStyle(e);
}
function US(e) {
  return ["table", "td", "th"].indexOf(Wr(e)) >= 0;
}
function Rn(e) {
  return ((qn(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Ns(e) {
  return Wr(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (ec(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Rn(e)
  );
}
function Zd(e) {
  return !rr(e) || // https://github.com/popperjs/popper-core/issues/837
  ln(e).position === "fixed" ? null : e.offsetParent;
}
function JS(e) {
  var r = /firefox/i.test(cu()), t = /Trident/i.test(cu());
  if (t && rr(e)) {
    var n = ln(e);
    if (n.position === "fixed")
      return null;
  }
  var o = Ns(e);
  for (ec(o) && (o = o.host); rr(o) && ["html", "body"].indexOf(Wr(o)) < 0; ) {
    var a = ln(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || r && a.willChange === "filter" || r && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Ja(e) {
  for (var r = Xt(e), t = Zd(e); t && US(t) && ln(t).position === "static"; )
    t = Zd(t);
  return t && (Wr(t) === "html" || Wr(t) === "body" && ln(t).position === "static") ? r : t || JS(e) || r;
}
function rc(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function xa(e, r, t) {
  return zn(e, os(r, t));
}
function QS(e, r, t) {
  var n = xa(e, r, t);
  return n > t ? t : n;
}
function zh() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function $h(e) {
  return Object.assign({}, zh(), e);
}
function Xh(e, r) {
  return r.reduce(function(t, n) {
    return t[n] = e, t;
  }, {});
}
var qS = function(r, t) {
  return r = typeof r == "function" ? r(Object.assign({}, t.rects, {
    placement: t.placement
  })) : r, $h(typeof r != "number" ? r : Xh(r, Ua));
};
function KS(e) {
  var r, t = e.state, n = e.name, o = e.options, a = t.elements.arrow, i = t.modifiersData.popperOffsets, s = Or(t.placement), l = rc(s), u = [Nt, sr].indexOf(s) >= 0, c = u ? "height" : "width";
  if (!(!a || !i)) {
    var d = qS(o.padding, t), f = tc(a), p = l === "y" ? Ft : Nt, h = l === "y" ? ir : sr, g = t.rects.reference[c] + t.rects.reference[l] - i[l] - t.rects.popper[c], m = i[l] - t.rects.reference[l], v = Ja(a), y = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, C = g / 2 - m / 2, I = d[p], b = y - f[c] - d[h], D = y / 2 - f[c] / 2 + C, x = xa(I, D, b), _ = l;
    t.modifiersData[n] = (r = {}, r[_] = x, r.centerOffset = x - D, r);
  }
}
function ex(e) {
  var r = e.state, t = e.options, n = t.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = r.elements.popper.querySelector(o), !o) || Hh(r.elements.popper, o) && (r.elements.arrow = o));
}
const tx = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: KS,
  effect: ex,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Go(e) {
  return e.split("-")[1];
}
var rx = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function nx(e, r) {
  var t = e.x, n = e.y, o = r.devicePixelRatio || 1;
  return {
    x: Bo(t * o) / o || 0,
    y: Bo(n * o) / o || 0
  };
}
function Ud(e) {
  var r, t = e.popper, n = e.popperRect, o = e.placement, a = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, u = e.adaptive, c = e.roundOffsets, d = e.isFixed, f = i.x, p = f === void 0 ? 0 : f, h = i.y, g = h === void 0 ? 0 : h, m = typeof c == "function" ? c({
    x: p,
    y: g
  }) : {
    x: p,
    y: g
  };
  p = m.x, g = m.y;
  var v = i.hasOwnProperty("x"), y = i.hasOwnProperty("y"), C = Nt, I = Ft, b = window;
  if (u) {
    var D = Ja(t), x = "clientHeight", _ = "clientWidth";
    if (D === Xt(t) && (D = Rn(t), ln(D).position !== "static" && s === "absolute" && (x = "scrollHeight", _ = "scrollWidth")), D = D, o === Ft || (o === Nt || o === sr) && a === Aa) {
      I = ir;
      var E = d && D === b && b.visualViewport ? b.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        D[x]
      );
      g -= E - n.height, g *= l ? 1 : -1;
    }
    if (o === Nt || (o === Ft || o === ir) && a === Aa) {
      C = sr;
      var R = d && D === b && b.visualViewport ? b.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        D[_]
      );
      p -= R - n.width, p *= l ? 1 : -1;
    }
  }
  var L = Object.assign({
    position: s
  }, u && rx), G = c === !0 ? nx({
    x: p,
    y: g
  }, Xt(t)) : {
    x: p,
    y: g
  };
  if (p = G.x, g = G.y, l) {
    var V;
    return Object.assign({}, L, (V = {}, V[I] = y ? "0" : "", V[C] = v ? "0" : "", V.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + p + "px, " + g + "px)" : "translate3d(" + p + "px, " + g + "px, 0)", V));
  }
  return Object.assign({}, L, (r = {}, r[I] = y ? g + "px" : "", r[C] = v ? p + "px" : "", r.transform = "", r));
}
function ox(e) {
  var r = e.state, t = e.options, n = t.gpuAcceleration, o = n === void 0 ? !0 : n, a = t.adaptive, i = a === void 0 ? !0 : a, s = t.roundOffsets, l = s === void 0 ? !0 : s, u = {
    placement: Or(r.placement),
    variation: Go(r.placement),
    popper: r.elements.popper,
    popperRect: r.rects.popper,
    gpuAcceleration: o,
    isFixed: r.options.strategy === "fixed"
  };
  r.modifiersData.popperOffsets != null && (r.styles.popper = Object.assign({}, r.styles.popper, Ud(Object.assign({}, u, {
    offsets: r.modifiersData.popperOffsets,
    position: r.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), r.modifiersData.arrow != null && (r.styles.arrow = Object.assign({}, r.styles.arrow, Ud(Object.assign({}, u, {
    offsets: r.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-placement": r.placement
  });
}
const ax = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: ox,
  data: {}
};
var hi = {
  passive: !0
};
function ix(e) {
  var r = e.state, t = e.instance, n = e.options, o = n.scroll, a = o === void 0 ? !0 : o, i = n.resize, s = i === void 0 ? !0 : i, l = Xt(r.elements.popper), u = [].concat(r.scrollParents.reference, r.scrollParents.popper);
  return a && u.forEach(function(c) {
    c.addEventListener("scroll", t.update, hi);
  }), s && l.addEventListener("resize", t.update, hi), function() {
    a && u.forEach(function(c) {
      c.removeEventListener("scroll", t.update, hi);
    }), s && l.removeEventListener("resize", t.update, hi);
  };
}
const sx = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ix,
  data: {}
};
var lx = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Pi(e) {
  return e.replace(/left|right|bottom|top/g, function(r) {
    return lx[r];
  });
}
var ux = {
  start: "end",
  end: "start"
};
function Jd(e) {
  return e.replace(/start|end/g, function(r) {
    return ux[r];
  });
}
function nc(e) {
  var r = Xt(e), t = r.pageXOffset, n = r.pageYOffset;
  return {
    scrollLeft: t,
    scrollTop: n
  };
}
function oc(e) {
  return Vo(Rn(e)).left + nc(e).scrollLeft;
}
function cx(e, r) {
  var t = Xt(e), n = Rn(e), o = t.visualViewport, a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    var u = Yh();
    (u || !u && r === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s + oc(e),
    y: l
  };
}
function dx(e) {
  var r, t = Rn(e), n = nc(e), o = (r = e.ownerDocument) == null ? void 0 : r.body, a = zn(t.scrollWidth, t.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = zn(t.scrollHeight, t.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -n.scrollLeft + oc(e), l = -n.scrollTop;
  return ln(o || t).direction === "rtl" && (s += zn(t.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function ac(e) {
  var r = ln(e), t = r.overflow, n = r.overflowX, o = r.overflowY;
  return /auto|scroll|overlay|hidden/.test(t + o + n);
}
function jh(e) {
  return ["html", "body", "#document"].indexOf(Wr(e)) >= 0 ? e.ownerDocument.body : rr(e) && ac(e) ? e : jh(Ns(e));
}
function Ia(e, r) {
  var t;
  r === void 0 && (r = []);
  var n = jh(e), o = n === ((t = e.ownerDocument) == null ? void 0 : t.body), a = Xt(n), i = o ? [a].concat(a.visualViewport || [], ac(n) ? n : []) : n, s = r.concat(i);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Ia(Ns(i)))
  );
}
function du(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function fx(e, r) {
  var t = Vo(e, !1, r === "fixed");
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function Qd(e, r, t) {
  return r === Vh ? du(cx(e, t)) : qn(r) ? fx(r, t) : du(dx(Rn(e)));
}
function px(e) {
  var r = Ia(Ns(e)), t = ["absolute", "fixed"].indexOf(ln(e).position) >= 0, n = t && rr(e) ? Ja(e) : e;
  return qn(n) ? r.filter(function(o) {
    return qn(o) && Hh(o, n) && Wr(o) !== "body";
  }) : [];
}
function hx(e, r, t, n) {
  var o = r === "clippingParents" ? px(e) : [].concat(r), a = [].concat(o, [t]), i = a[0], s = a.reduce(function(l, u) {
    var c = Qd(e, u, n);
    return l.top = zn(c.top, l.top), l.right = os(c.right, l.right), l.bottom = os(c.bottom, l.bottom), l.left = zn(c.left, l.left), l;
  }, Qd(e, i, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Zh(e) {
  var r = e.reference, t = e.element, n = e.placement, o = n ? Or(n) : null, a = n ? Go(n) : null, i = r.x + r.width / 2 - t.width / 2, s = r.y + r.height / 2 - t.height / 2, l;
  switch (o) {
    case Ft:
      l = {
        x: i,
        y: r.y - t.height
      };
      break;
    case ir:
      l = {
        x: i,
        y: r.y + r.height
      };
      break;
    case sr:
      l = {
        x: r.x + r.width,
        y: s
      };
      break;
    case Nt:
      l = {
        x: r.x - t.width,
        y: s
      };
      break;
    default:
      l = {
        x: r.x,
        y: r.y
      };
  }
  var u = o ? rc(o) : null;
  if (u != null) {
    var c = u === "y" ? "height" : "width";
    switch (a) {
      case Wo:
        l[u] = l[u] - (r[c] / 2 - t[c] / 2);
        break;
      case Aa:
        l[u] = l[u] + (r[c] / 2 - t[c] / 2);
        break;
    }
  }
  return l;
}
function Pa(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, o = n === void 0 ? e.placement : n, a = t.strategy, i = a === void 0 ? e.strategy : a, s = t.boundary, l = s === void 0 ? TS : s, u = t.rootBoundary, c = u === void 0 ? Vh : u, d = t.elementContext, f = d === void 0 ? ua : d, p = t.altBoundary, h = p === void 0 ? !1 : p, g = t.padding, m = g === void 0 ? 0 : g, v = $h(typeof m != "number" ? m : Xh(m, Ua)), y = f === ua ? FS : ua, C = e.rects.popper, I = e.elements[h ? y : f], b = hx(qn(I) ? I : I.contextElement || Rn(e.elements.popper), l, c, i), D = Vo(e.elements.reference), x = Zh({
    reference: D,
    element: C,
    placement: o
  }), _ = du(Object.assign({}, C, x)), E = f === ua ? _ : D, R = {
    top: b.top - E.top + v.top,
    bottom: E.bottom - b.bottom + v.bottom,
    left: b.left - E.left + v.left,
    right: E.right - b.right + v.right
  }, L = e.modifiersData.offset;
  if (f === ua && L) {
    var G = L[o];
    Object.keys(R).forEach(function(V) {
      var O = [sr, ir].indexOf(V) >= 0 ? 1 : -1, N = [Ft, ir].indexOf(V) >= 0 ? "y" : "x";
      R[V] += G[N] * O;
    });
  }
  return R;
}
function gx(e, r) {
  r === void 0 && (r = {});
  var t = r, n = t.placement, o = t.boundary, a = t.rootBoundary, i = t.padding, s = t.flipVariations, l = t.allowedAutoPlacements, u = l === void 0 ? Gh : l, c = Go(n), d = c ? s ? jd : jd.filter(function(h) {
    return Go(h) === c;
  }) : Ua, f = d.filter(function(h) {
    return u.indexOf(h) >= 0;
  });
  f.length === 0 && (f = d);
  var p = f.reduce(function(h, g) {
    return h[g] = Pa(e, {
      placement: g,
      boundary: o,
      rootBoundary: a,
      padding: i
    })[Or(g)], h;
  }, {});
  return Object.keys(p).sort(function(h, g) {
    return p[h] - p[g];
  });
}
function mx(e) {
  if (Or(e) === Ku)
    return [];
  var r = Pi(e);
  return [Jd(e), r, Jd(r)];
}
function vx(e) {
  var r = e.state, t = e.options, n = e.name;
  if (!r.modifiersData[n]._skip) {
    for (var o = t.mainAxis, a = o === void 0 ? !0 : o, i = t.altAxis, s = i === void 0 ? !0 : i, l = t.fallbackPlacements, u = t.padding, c = t.boundary, d = t.rootBoundary, f = t.altBoundary, p = t.flipVariations, h = p === void 0 ? !0 : p, g = t.allowedAutoPlacements, m = r.options.placement, v = Or(m), y = v === m, C = l || (y || !h ? [Pi(m)] : mx(m)), I = [m].concat(C).reduce(function(X, te) {
      return X.concat(Or(te) === Ku ? gx(r, {
        placement: te,
        boundary: c,
        rootBoundary: d,
        padding: u,
        flipVariations: h,
        allowedAutoPlacements: g
      }) : te);
    }, []), b = r.rects.reference, D = r.rects.popper, x = /* @__PURE__ */ new Map(), _ = !0, E = I[0], R = 0; R < I.length; R++) {
      var L = I[R], G = Or(L), V = Go(L) === Wo, O = [Ft, ir].indexOf(G) >= 0, N = O ? "width" : "height", P = Pa(r, {
        placement: L,
        boundary: c,
        rootBoundary: d,
        altBoundary: f,
        padding: u
      }), B = O ? V ? sr : Nt : V ? ir : Ft;
      b[N] > D[N] && (B = Pi(B));
      var H = Pi(B), re = [];
      if (a && re.push(P[G] <= 0), s && re.push(P[B] <= 0, P[H] <= 0), re.every(function(X) {
        return X;
      })) {
        E = L, _ = !1;
        break;
      }
      x.set(L, re);
    }
    if (_)
      for (var W = h ? 3 : 1, F = function(te) {
        var q = I.find(function(ue) {
          var ie = x.get(ue);
          if (ie)
            return ie.slice(0, te).every(function(be) {
              return be;
            });
        });
        if (q)
          return E = q, "break";
      }, $ = W; $ > 0; $--) {
        var Y = F($);
        if (Y === "break") break;
      }
    r.placement !== E && (r.modifiersData[n]._skip = !0, r.placement = E, r.reset = !0);
  }
}
const bx = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: vx,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function qd(e, r, t) {
  return t === void 0 && (t = {
    x: 0,
    y: 0
  }), {
    top: e.top - r.height - t.y,
    right: e.right - r.width + t.x,
    bottom: e.bottom - r.height + t.y,
    left: e.left - r.width - t.x
  };
}
function Kd(e) {
  return [Ft, sr, ir, Nt].some(function(r) {
    return e[r] >= 0;
  });
}
function yx(e) {
  var r = e.state, t = e.name, n = r.rects.reference, o = r.rects.popper, a = r.modifiersData.preventOverflow, i = Pa(r, {
    elementContext: "reference"
  }), s = Pa(r, {
    altBoundary: !0
  }), l = qd(i, n), u = qd(s, o, a), c = Kd(l), d = Kd(u);
  r.modifiersData[t] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: u,
    isReferenceHidden: c,
    hasPopperEscaped: d
  }, r.attributes.popper = Object.assign({}, r.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": d
  });
}
const wx = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: yx
};
function Cx(e, r, t) {
  var n = Or(e), o = [Nt, Ft].indexOf(n) >= 0 ? -1 : 1, a = typeof t == "function" ? t(Object.assign({}, r, {
    placement: e
  })) : t, i = a[0], s = a[1];
  return i = i || 0, s = (s || 0) * o, [Nt, sr].indexOf(n) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function Sx(e) {
  var r = e.state, t = e.options, n = e.name, o = t.offset, a = o === void 0 ? [0, 0] : o, i = Gh.reduce(function(c, d) {
    return c[d] = Cx(d, r.rects, a), c;
  }, {}), s = i[r.placement], l = s.x, u = s.y;
  r.modifiersData.popperOffsets != null && (r.modifiersData.popperOffsets.x += l, r.modifiersData.popperOffsets.y += u), r.modifiersData[n] = i;
}
const xx = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Sx
};
function Ix(e) {
  var r = e.state, t = e.name;
  r.modifiersData[t] = Zh({
    reference: r.rects.reference,
    element: r.rects.popper,
    placement: r.placement
  });
}
const Dx = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Ix,
  data: {}
};
function _x(e) {
  return e === "x" ? "y" : "x";
}
function kx(e) {
  var r = e.state, t = e.options, n = e.name, o = t.mainAxis, a = o === void 0 ? !0 : o, i = t.altAxis, s = i === void 0 ? !1 : i, l = t.boundary, u = t.rootBoundary, c = t.altBoundary, d = t.padding, f = t.tether, p = f === void 0 ? !0 : f, h = t.tetherOffset, g = h === void 0 ? 0 : h, m = Pa(r, {
    boundary: l,
    rootBoundary: u,
    padding: d,
    altBoundary: c
  }), v = Or(r.placement), y = Go(r.placement), C = !y, I = rc(v), b = _x(I), D = r.modifiersData.popperOffsets, x = r.rects.reference, _ = r.rects.popper, E = typeof g == "function" ? g(Object.assign({}, r.rects, {
    placement: r.placement
  })) : g, R = typeof E == "number" ? {
    mainAxis: E,
    altAxis: E
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, E), L = r.modifiersData.offset ? r.modifiersData.offset[r.placement] : null, G = {
    x: 0,
    y: 0
  };
  if (D) {
    if (a) {
      var V, O = I === "y" ? Ft : Nt, N = I === "y" ? ir : sr, P = I === "y" ? "height" : "width", B = D[I], H = B + m[O], re = B - m[N], W = p ? -_[P] / 2 : 0, F = y === Wo ? x[P] : _[P], $ = y === Wo ? -_[P] : -x[P], Y = r.elements.arrow, X = p && Y ? tc(Y) : {
        width: 0,
        height: 0
      }, te = r.modifiersData["arrow#persistent"] ? r.modifiersData["arrow#persistent"].padding : zh(), q = te[O], ue = te[N], ie = xa(0, x[P], X[P]), be = C ? x[P] / 2 - W - ie - q - R.mainAxis : F - ie - q - R.mainAxis, ge = C ? -x[P] / 2 + W + ie + ue + R.mainAxis : $ + ie + ue + R.mainAxis, Pe = r.elements.arrow && Ja(r.elements.arrow), Z = Pe ? I === "y" ? Pe.clientTop || 0 : Pe.clientLeft || 0 : 0, at = (V = L == null ? void 0 : L[I]) != null ? V : 0, xt = B + be - at - Z, Et = B + ge - at, zr = xa(p ? os(H, xt) : H, B, p ? zn(re, Et) : re);
      D[I] = zr, G[I] = zr - B;
    }
    if (s) {
      var Lt, Wt = I === "x" ? Ft : Nt, Mt = I === "x" ? ir : sr, Re = D[b], Ut = b === "y" ? "height" : "width", Bt = Re + m[Wt], Vt = Re - m[Mt], J = [Ft, Nt].indexOf(v) !== -1, fe = (Lt = L == null ? void 0 : L[b]) != null ? Lt : 0, Ze = J ? Bt : Re - x[Ut] - _[Ut] - fe + R.altAxis, it = J ? Re + x[Ut] + _[Ut] - fe - R.altAxis : Vt, ct = p && J ? QS(Ze, Re, it) : xa(p ? Ze : Bt, Re, p ? it : Vt);
      D[b] = ct, G[b] = ct - Re;
    }
    r.modifiersData[n] = G;
  }
}
const Ex = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: kx,
  requiresIfExists: ["offset"]
};
function Mx(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Ax(e) {
  return e === Xt(e) || !rr(e) ? nc(e) : Mx(e);
}
function Px(e) {
  var r = e.getBoundingClientRect(), t = Bo(r.width) / e.offsetWidth || 1, n = Bo(r.height) / e.offsetHeight || 1;
  return t !== 1 || n !== 1;
}
function Rx(e, r, t) {
  t === void 0 && (t = !1);
  var n = rr(r), o = rr(r) && Px(r), a = Rn(r), i = Vo(e, o, t), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !t) && ((Wr(r) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  ac(a)) && (s = Ax(r)), rr(r) ? (l = Vo(r, !0), l.x += r.clientLeft, l.y += r.clientTop) : a && (l.x = oc(a))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function Ox(e) {
  var r = /* @__PURE__ */ new Map(), t = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(a) {
    r.set(a.name, a);
  });
  function o(a) {
    t.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(s) {
      if (!t.has(s)) {
        var l = r.get(s);
        l && o(l);
      }
    }), n.push(a);
  }
  return e.forEach(function(a) {
    t.has(a.name) || o(a);
  }), n;
}
function Tx(e) {
  var r = Ox(e);
  return $S.reduce(function(t, n) {
    return t.concat(r.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function Fx(e) {
  var r;
  return function() {
    return r || (r = new Promise(function(t) {
      Promise.resolve().then(function() {
        r = void 0, t(e());
      });
    })), r;
  };
}
function Nx(e) {
  var r = e.reduce(function(t, n) {
    var o = t[n.name];
    return t[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, t;
  }, {});
  return Object.keys(r).map(function(t) {
    return r[t];
  });
}
var ef = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function tf() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return !r.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Lx(e) {
  e === void 0 && (e = {});
  var r = e, t = r.defaultModifiers, n = t === void 0 ? [] : t, o = r.defaultOptions, a = o === void 0 ? ef : o;
  return function(s, l, u) {
    u === void 0 && (u = a);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, ef, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: c,
      setOptions: function(v) {
        var y = typeof v == "function" ? v(c.options) : v;
        g(), c.options = Object.assign({}, a, c.options, y), c.scrollParents = {
          reference: qn(s) ? Ia(s) : s.contextElement ? Ia(s.contextElement) : [],
          popper: Ia(l)
        };
        var C = Tx(Nx([].concat(n, c.options.modifiers)));
        return c.orderedModifiers = C.filter(function(I) {
          return I.enabled;
        }), h(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var v = c.elements, y = v.reference, C = v.popper;
          if (tf(y, C)) {
            c.rects = {
              reference: Rx(y, Ja(C), c.options.strategy === "fixed"),
              popper: tc(C)
            }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function(R) {
              return c.modifiersData[R.name] = Object.assign({}, R.data);
            });
            for (var I = 0; I < c.orderedModifiers.length; I++) {
              if (c.reset === !0) {
                c.reset = !1, I = -1;
                continue;
              }
              var b = c.orderedModifiers[I], D = b.fn, x = b.options, _ = x === void 0 ? {} : x, E = b.name;
              typeof D == "function" && (c = D({
                state: c,
                options: _,
                name: E,
                instance: p
              }) || c);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Fx(function() {
        return new Promise(function(m) {
          p.forceUpdate(), m(c);
        });
      }),
      destroy: function() {
        g(), f = !0;
      }
    };
    if (!tf(s, l))
      return p;
    p.setOptions(u).then(function(m) {
      !f && u.onFirstUpdate && u.onFirstUpdate(m);
    });
    function h() {
      c.orderedModifiers.forEach(function(m) {
        var v = m.name, y = m.options, C = y === void 0 ? {} : y, I = m.effect;
        if (typeof I == "function") {
          var b = I({
            state: c,
            name: v,
            instance: p,
            options: C
          }), D = function() {
          };
          d.push(b || D);
        }
      });
    }
    function g() {
      d.forEach(function(m) {
        return m();
      }), d = [];
    }
    return p;
  };
}
var Wx = [sx, Dx, ax, ZS, xx, bx, Ex, tx, wx], Bx = /* @__PURE__ */ Lx({
  defaultModifiers: Wx
});
function Vx(e = {}) {
  const {
    enabled: r = !0,
    modifiers: t,
    placement: n = "bottom",
    strategy: o = "absolute",
    arrowPadding: a = 8,
    eventListeners: i = !0,
    offset: s,
    gutter: l = 8,
    flip: u = !0,
    boundary: c = "clippingParents",
    preventOverflow: d = !0,
    matchWidth: f,
    direction: p = "ltr"
  } = e, h = ye(null), g = ye(null), m = ye(null), v = OS(n, p), y = ye(() => {
  }), C = se(() => {
    var R;
    !r || !h.current || !g.current || ((R = y.current) == null || R.call(y), m.current = Bx(h.current, g.current, {
      placement: v,
      modifiers: [
        AS,
        kS,
        _S,
        {
          ...DS,
          enabled: !!f
        },
        {
          name: "eventListeners",
          ...IS(i)
        },
        {
          name: "arrow",
          options: { padding: a }
        },
        {
          name: "offset",
          options: {
            offset: s ?? [0, l]
          }
        },
        {
          name: "flip",
          enabled: !!u,
          options: { padding: 8 }
        },
        {
          name: "preventOverflow",
          enabled: !!d,
          options: { boundary: c }
        },
        // allow users override internal modifiers
        ...t ?? []
      ],
      strategy: o
    }), m.current.forceUpdate(), y.current = m.current.destroy);
  }, [
    v,
    r,
    t,
    f,
    i,
    a,
    s,
    l,
    u,
    d,
    c,
    o
  ]);
  Ye(() => () => {
    var R;
    !h.current && !g.current && ((R = m.current) == null || R.destroy(), m.current = null);
  }, []);
  const I = se(
    (R) => {
      h.current = R, C();
    },
    [C]
  ), b = se(
    (R = {}, L = null) => ({
      ...R,
      ref: Ma(I, L)
    }),
    [I]
  ), D = se(
    (R) => {
      g.current = R, C();
    },
    [C]
  ), x = se(
    (R = {}, L = null) => ({
      ...R,
      ref: Ma(D, L),
      style: {
        ...R.style,
        position: o,
        minWidth: f ? void 0 : "max-content",
        inset: "0 auto auto 0"
      }
    }),
    [o, D, f]
  ), _ = se((R = {}, L = null) => {
    const { size: G, shadowColor: V, bg: O, style: N, ...P } = R;
    return {
      ...P,
      ref: L,
      "data-popper-arrow": "",
      style: Gx(R)
    };
  }, []), E = se(
    (R = {}, L = null) => ({
      ...R,
      ref: L,
      "data-popper-arrow-inner": ""
    }),
    []
  );
  return {
    update() {
      var R;
      (R = m.current) == null || R.update();
    },
    forceUpdate() {
      var R;
      (R = m.current) == null || R.forceUpdate();
    },
    transformOrigin: zt.transformOrigin.varRef,
    referenceRef: I,
    popperRef: D,
    getPopperProps: x,
    getArrowProps: _,
    getArrowInnerProps: E,
    getReferenceProps: b
  };
}
function Gx(e) {
  const { size: r, shadowColor: t, bg: n, style: o } = e, a = { ...o, position: "absolute" };
  return r && (a["--popper-arrow-size"] = r), t && (a["--popper-arrow-shadow-color"] = t), n && (a["--popper-arrow-bg"] = n), a;
}
function Yx(e = {}) {
  const {
    onClose: r,
    onOpen: t,
    isOpen: n,
    id: o
  } = e, a = ns(t), i = ns(r), [s, l] = Se(e.defaultIsOpen || !1), u = n !== void 0 ? n : s, c = n !== void 0, d = Bu(), f = o ?? `disclosure-${d}`, p = se(() => {
    c || l(!1), i == null || i();
  }, [c, i]), h = se(() => {
    c || l(!0), a == null || a();
  }, [c, a]), g = se(() => {
    u ? p() : h();
  }, [u, h, p]);
  function m(y = {}) {
    return {
      ...y,
      "aria-expanded": u,
      "aria-controls": f,
      onClick(C) {
        var I;
        (I = y.onClick) == null || I.call(y, C), g();
      }
    };
  }
  function v(y = {}) {
    return {
      ...y,
      hidden: !u,
      id: f
    };
  }
  return {
    isOpen: u,
    onOpen: h,
    onClose: p,
    onToggle: g,
    isControlled: c,
    getButtonProps: m,
    getDisclosureProps: v
  };
}
function Hx(e) {
  const { ref: r, handler: t, enabled: n = !0 } = e, o = ns(t), i = ye({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }).current;
  Ye(() => {
    if (!n)
      return;
    const s = (d) => {
      xl(d, r) && (i.isPointerDown = !0);
    }, l = (d) => {
      if (i.ignoreEmulatedMouseEvents) {
        i.ignoreEmulatedMouseEvents = !1;
        return;
      }
      i.isPointerDown && t && xl(d, r) && (i.isPointerDown = !1, o(d));
    }, u = (d) => {
      i.ignoreEmulatedMouseEvents = !0, t && i.isPointerDown && xl(d, r) && (i.isPointerDown = !1, o(d));
    }, c = Uh(r.current);
    return c.addEventListener("mousedown", s, !0), c.addEventListener("mouseup", l, !0), c.addEventListener("touchstart", s, !0), c.addEventListener("touchend", u, !0), () => {
      c.removeEventListener("mousedown", s, !0), c.removeEventListener("mouseup", l, !0), c.removeEventListener("touchstart", s, !0), c.removeEventListener("touchend", u, !0);
    };
  }, [t, r, o, i, n]);
}
function xl(e, r) {
  var t;
  const n = e.target;
  return n && !Uh(n).contains(n) ? !1 : !((t = r.current) != null && t.contains(n));
}
function Uh(e) {
  var r;
  return (r = e == null ? void 0 : e.ownerDocument) != null ? r : document;
}
function zx(e) {
  const { isOpen: r, ref: t } = e, [n, o] = Se(r), [a, i] = Se(!1);
  return Ye(() => {
    a || (o(r), i(!0));
  }, [r, a, n]), bS(
    () => t.current,
    "animationend",
    () => {
      o(r);
    }
  ), {
    present: !(r ? !1 : !n),
    onComplete() {
      var l;
      const u = dS(t.current), c = new u.CustomEvent("animationend", { bubbles: !0 });
      (l = t.current) == null || l.dispatchEvent(c);
    }
  };
}
var [
  $x,
  qT,
  Xx
] = cS(), [jx] = ja({
  strict: !1,
  name: "MenuContext"
});
function Zx(e, ...r) {
  const t = Bu(), n = e || t;
  return Ve(() => r.map((o) => `${o}-${n}`), [n, r]);
}
function Ux(e) {
  var r;
  return (r = e == null ? void 0 : e.ownerDocument) != null ? r : document;
}
function Jx(e = {}) {
  const {
    id: r,
    closeOnSelect: t = !0,
    closeOnBlur: n = !0,
    initialFocusRef: o,
    autoSelect: a = !0,
    isLazy: i,
    isOpen: s,
    defaultIsOpen: l,
    onClose: u,
    onOpen: c,
    placement: d = "bottom-start",
    lazyBehavior: f = "unmount",
    direction: p,
    computePositionOnMount: h = !1,
    ...g
  } = e, m = ye(null), v = ye(null), y = Xx(), C = se(() => {
    requestAnimationFrame(() => {
      var Y;
      (Y = m.current) == null || Y.focus({ preventScroll: !1 });
    });
  }, []), I = se(() => {
    const Y = setTimeout(() => {
      var X;
      if (o)
        (X = o.current) == null || X.focus();
      else {
        const te = y.firstEnabled();
        te && V(te.index);
      }
    });
    H.current.add(Y);
  }, [y, o]), b = se(() => {
    const Y = setTimeout(() => {
      const X = y.lastEnabled();
      X && V(X.index);
    });
    H.current.add(Y);
  }, [y]), D = se(() => {
    c == null || c(), a ? I() : C();
  }, [a, I, C, c]), { isOpen: x, onOpen: _, onClose: E, onToggle: R } = Yx({
    isOpen: s,
    defaultIsOpen: l,
    onClose: u,
    onOpen: D
  });
  Hx({
    enabled: x && n,
    ref: m,
    handler: (Y) => {
      var X;
      (X = v.current) != null && X.contains(Y.target) || E();
    }
  });
  const L = Vx({
    ...g,
    enabled: x || h,
    placement: d,
    direction: p
  }), [G, V] = Se(-1);
  Bh(() => {
    x || V(-1);
  }, [x]), wS(m, {
    focusRef: v,
    visible: x
  });
  const O = zx({ isOpen: x, ref: m }), [N, P] = Zx(r, "menu-button", "menu-list"), B = se(() => {
    _(), C();
  }, [_, C]), H = ye(/* @__PURE__ */ new Set([]));
  Ye(() => {
    const Y = H.current;
    return () => {
      Y.forEach((X) => clearTimeout(X)), Y.clear();
    };
  }, []);
  const re = se(() => {
    _(), I();
  }, [I, _]), W = se(() => {
    _(), b();
  }, [_, b]), F = se(() => {
    var Y, X;
    const te = Ux(m.current), q = (Y = m.current) == null ? void 0 : Y.contains(te.activeElement);
    if (!(x && !q))
      return;
    const ie = (X = y.item(G)) == null ? void 0 : X.node;
    ie == null || ie.focus({ preventScroll: !0 });
  }, [x, G, y]), $ = ye(null);
  return {
    openAndFocusMenu: B,
    openAndFocusFirstItem: re,
    openAndFocusLastItem: W,
    onTransitionEnd: F,
    unstable__animationState: O,
    descendants: y,
    popper: L,
    buttonId: N,
    menuId: P,
    forceUpdate: L.forceUpdate,
    orientation: "vertical",
    isOpen: x,
    onToggle: R,
    onOpen: _,
    onClose: E,
    menuRef: m,
    buttonRef: v,
    focusedIndex: G,
    closeOnSelect: t,
    closeOnBlur: n,
    autoSelect: a,
    setFocusedIndex: V,
    isLazy: i,
    lazyBehavior: f,
    initialFocusRef: o,
    rafId: $
  };
}
var [Qx, qx] = ja({
  name: "MenuStylesContext",
  errorMessage: `useMenuStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Menu />" `
}), Jh = (e) => {
  const { children: r } = e, t = Lr("Menu", e), n = Os(e), { direction: o } = jo(), { descendants: a, ...i } = Jx({ ...n, direction: o }), s = Ve(() => i, [i]), { isOpen: l, onClose: u, forceUpdate: c } = s;
  return /* @__PURE__ */ S($x, { value: a, children: /* @__PURE__ */ S(jx, { value: s, children: /* @__PURE__ */ S(Qx, { value: t, children: yn(r, { isOpen: l, onClose: u, forceUpdate: c }) }) }) });
};
Jh.displayName = "Menu";
var Qh = (e) => {
  const { className: r, children: t, ...n } = e, o = qx(), a = bp.only(t), i = ib(a) ? Vu(a, {
    focusable: "false",
    "aria-hidden": !0,
    className: Qn("chakra-menu__icon", a.props.className)
  }) : null, s = Qn("chakra-menu__icon-wrapper", r);
  return /* @__PURE__ */ S(ar.span, { className: s, ...n, __css: o.icon, children: i });
};
Qh.displayName = "MenuIcon";
var Kx = ["allowCreateWhileLoading", "createOptionPosition", "formatCreateLabel", "isValidNewOption", "getNewOptionData", "onCreateOption", "options", "onChange"], rf = function() {
  var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", t = arguments.length > 1 ? arguments[1] : void 0, n = arguments.length > 2 ? arguments[2] : void 0, o = String(r).toLowerCase(), a = String(n.getOptionValue(t)).toLowerCase(), i = String(n.getOptionLabel(t)).toLowerCase();
  return a === o || i === o;
}, Il = {
  formatCreateLabel: function(r) {
    return 'Create "'.concat(r, '"');
  },
  isValidNewOption: function(r, t, n, o) {
    return !(!r || t.some(function(a) {
      return rf(r, a, o);
    }) || n.some(function(a) {
      return rf(r, a, o);
    }));
  },
  getNewOptionData: function(r, t) {
    return {
      label: t,
      value: r,
      __isNew__: !0
    };
  }
};
function qh(e) {
  var r = e.allowCreateWhileLoading, t = r === void 0 ? !1 : r, n = e.createOptionPosition, o = n === void 0 ? "last" : n, a = e.formatCreateLabel, i = a === void 0 ? Il.formatCreateLabel : a, s = e.isValidNewOption, l = s === void 0 ? Il.isValidNewOption : s, u = e.getNewOptionData, c = u === void 0 ? Il.getNewOptionData : u, d = e.onCreateOption, f = e.options, p = f === void 0 ? [] : f, h = e.onChange, g = br(e, Kx), m = g.getOptionValue, v = m === void 0 ? dh : m, y = g.getOptionLabel, C = y === void 0 ? ch : y, I = g.inputValue, b = g.isLoading, D = g.isMulti, x = g.value, _ = g.name, E = Ve(function() {
    return l(I, Qi(x), p, {
      getOptionValue: v,
      getOptionLabel: C
    }) ? c(I, i(I)) : void 0;
  }, [i, c, C, v, I, l, p, x]), R = Ve(function() {
    return (t || !b) && E ? o === "first" ? [E].concat(Do(p)) : [].concat(Do(p), [E]) : p;
  }, [t, o, b, E, p]), L = se(function(G, V) {
    if (V.action !== "select-option")
      return h(G, V);
    var O = Array.isArray(G) ? G : [G];
    if (O[O.length - 1] === E) {
      if (d) d(I);
      else {
        var N = c(I, I), P = {
          action: "create-option",
          name: _,
          option: N
        };
        h(va(D, [].concat(Do(Qi(x)), [N]), N), P);
      }
      return;
    }
    h(G, V);
  }, [c, I, D, _, E, d, h, x]);
  return ce(ce({}, g), {}, {
    options: R,
    onChange: L
  });
}
var eI = /* @__PURE__ */ ot(function(e, r) {
  var t = Ds(e), n = qh(t);
  return /* @__PURE__ */ U.createElement(Xa, pe({
    ref: r
  }, n));
}), tI = eI, rI = ["defaultOptions", "cacheOptions", "loadOptions", "options", "isLoading", "onInputChange", "filterOption"];
function Kh(e) {
  var r = e.defaultOptions, t = r === void 0 ? !1 : r, n = e.cacheOptions, o = n === void 0 ? !1 : n, a = e.loadOptions;
  e.options;
  var i = e.isLoading, s = i === void 0 ? !1 : i, l = e.onInputChange, u = e.filterOption, c = u === void 0 ? null : u, d = br(e, rI), f = d.inputValue, p = ye(void 0), h = ye(!1), g = Se(Array.isArray(t) ? t : void 0), m = yt(g, 2), v = m[0], y = m[1], C = Se(typeof f < "u" ? f : ""), I = yt(C, 2), b = I[0], D = I[1], x = Se(t === !0), _ = yt(x, 2), E = _[0], R = _[1], L = Se(void 0), G = yt(L, 2), V = G[0], O = G[1], N = Se([]), P = yt(N, 2), B = P[0], H = P[1], re = Se(!1), W = yt(re, 2), F = W[0], $ = W[1], Y = Se({}), X = yt(Y, 2), te = X[0], q = X[1], ue = Se(void 0), ie = yt(ue, 2), be = ie[0], ge = ie[1], Pe = Se(void 0), Z = yt(Pe, 2), at = Z[0], xt = Z[1];
  o !== at && (q({}), xt(o)), t !== be && (y(Array.isArray(t) ? t : void 0), ge(t)), Ye(function() {
    return h.current = !0, function() {
      h.current = !1;
    };
  }, []);
  var Et = se(function(Wt, Mt) {
    if (!a) return Mt();
    var Re = a(Wt, Mt);
    Re && typeof Re.then == "function" && Re.then(Mt, function() {
      return Mt();
    });
  }, [a]);
  Ye(function() {
    t === !0 && Et(b, function(Wt) {
      h.current && (y(Wt || []), R(!!p.current));
    });
  }, []);
  var zr = se(function(Wt, Mt) {
    var Re = ny(Wt, Mt, l);
    if (!Re) {
      p.current = void 0, D(""), O(""), H([]), R(!1), $(!1);
      return;
    }
    if (o && te[Re])
      D(Re), O(Re), H(te[Re]), R(!1), $(!1);
    else {
      var Ut = p.current = {};
      D(Re), R(!0), $(!V), Et(Re, function(Bt) {
        h && Ut === p.current && (p.current = void 0, R(!1), O(Re), H(Bt || []), $(!1), q(Bt ? ce(ce({}, te), {}, So({}, Re, Bt)) : te));
      });
    }
  }, [o, Et, V, te, l]), Lt = F ? [] : b && V ? B : v || [];
  return ce(ce({}, d), {}, {
    options: Lt,
    isLoading: E || s,
    onInputChange: zr,
    filterOption: c
  });
}
var nI = /* @__PURE__ */ ot(function(e, r) {
  var t = Kh(e), n = Ds(t);
  return /* @__PURE__ */ U.createElement(Xa, pe({
    ref: r
  }, n));
}), oI = nI, aI = /* @__PURE__ */ ot(function(e, r) {
  var t = Kh(e), n = Ds(t), o = qh(n);
  return /* @__PURE__ */ U.createElement(Xa, pe({
    ref: r
  }, o));
}), iI = aI, eg = (e) => {
  let { className: r, clearValue: t, cx: n, getStyles: o, getClassNames: a, getValue: i, hasValue: s, isMulti: l, isRtl: u, options: c, selectOption: d, selectProps: f, setValue: p, theme: h, ...g } = e;
  return { ...g };
}, sI = (e) => typeof e == "string" && ["sm", "md", "lg"].includes(e), lI = (e) => sI(e) ? e : e === "xs" ? "sm" : e === "xl" ? "lg" : "md", yr = (e) => {
  let r = jo(), t = lI(r.components.Input.defaultProps.size), n = e ?? t;
  return tS(typeof n == "string" ? [n] : n, { fallback: "md" }) || t;
}, uI = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, isDisabled: a, isRtl: i, hasValue: s, selectProps: { chakraStyles: l } } = e, u = { position: "relative", direction: i ? "rtl" : void 0, ...a ? { cursor: "not-allowed" } : {} }, c = l != null && l.container ? l.container(u, e) : u;
  return S(mt, { ...o, className: n({ "--is-disabled": a, "--is-rtl": i, "--has-value": s }, t), sx: c, children: r });
}, cI = (e) => {
  let { children: r, className: t, cx: n, isMulti: o, hasValue: a, innerProps: i, selectProps: { chakraStyles: s, size: l, variant: u, focusBorderColor: c, errorBorderColor: d, controlShouldRenderValue: f } } = e, p = yr(l), h = Lr("Input", { size: p, variant: u, focusBorderColor: c, errorBorderColor: d }), g = { display: o && a && f ? "flex" : "grid", alignItems: "center", flex: 1, paddingY: "2px", paddingX: h.field.px, flexWrap: "wrap", WebkitOverflowScrolling: "touch", position: "relative", overflow: "hidden" }, m = s != null && s.valueContainer ? s.valueContainer(g, e) : g;
  return S(mt, { ...i, className: n({ "value-container": !0, "value-container--is-multi": o, "value-container--has-value": a }, t), sx: m, children: r });
}, dI = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, selectProps: { chakraStyles: a } } = e, i = { display: "flex", alignItems: "center", alignSelf: "stretch", flexShrink: 0 }, s = a != null && a.indicatorsContainer ? a.indicatorsContainer(i, e) : i;
  return S(mt, { ...o, className: n({ indicators: !0 }, t), sx: s, children: r });
}, fI = (e) => {
  let { className: r, cx: t, children: n, innerRef: o, innerProps: a, isDisabled: i, isFocused: s, menuIsOpen: l, selectProps: { chakraStyles: u, size: c, variant: d, focusBorderColor: f, errorBorderColor: p, isInvalid: h, isReadOnly: g } } = e, m = yr(c), { field: { height: v, h: y, ...C } } = Lr("Input", { size: m, variant: d, focusBorderColor: f, errorBorderColor: p }), I = { ...C, position: "relative", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", padding: 0, overflow: "hidden", height: "auto", minH: v || y, ...i ? { pointerEvents: "none" } : {} }, b = u != null && u.control ? u.control(I, e) : I;
  return S(mt, { ref: o, className: t({ control: !0, "control--is-disabled": i, "control--is-focused": s, "control--menu-is-open": l }, r), sx: b, ...a, "data-focus": s ? !0 : void 0, "data-focus-visible": s ? !0 : void 0, "data-invalid": h ? !0 : void 0, "data-disabled": i ? !0 : void 0, "data-readonly": g ? !0 : void 0, children: n });
}, pI = (e) => {
  let { className: r, cx: t, selectProps: { chakraStyles: n, useBasicStyles: o, variant: a } } = e, i = { opacity: 1, ...o || a !== "outline" ? { display: "none" } : {} }, s = n != null && n.indicatorSeparator ? n.indicatorSeparator(i, e) : i;
  return S(Ah, { className: t({ "indicator-separator": !0 }, r), sx: s, orientation: "vertical" });
}, hI = (e) => S(Za, { role: "presentation", focusable: "false", "aria-hidden": "true", ...e, children: S("path", { fill: "currentColor", d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" }) }), gI = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, selectProps: { chakraStyles: a, useBasicStyles: i, size: s, focusBorderColor: l, errorBorderColor: u, variant: c } } = e, d = yr(s), f = Lr("Input", { size: d, variant: c, focusBorderColor: l, errorBorderColor: u }), p = { sm: "16px", md: "20px", lg: "24px" }[d], h = { ...f.addon, display: "flex", alignItems: "center", justifyContent: "center", height: "100%", borderRadius: 0, borderWidth: 0, fontSize: p, ...i && { background: "transparent", padding: 0, width: 6, marginRight: 2, marginLeft: 1, cursor: "inherit" } }, g = a != null && a.dropdownIndicator ? a.dropdownIndicator(h, e) : h, m = { height: "1em", width: "1em" }, v = a != null && a.downChevron ? a.downChevron(m, e) : m;
  return S(mt, { ...o, className: n({ indicator: !0, "dropdown-indicator": !0 }, t), sx: g, children: r || S(hI, { sx: v }) });
}, mI = (e) => S(Za, { focusable: "false", "aria-hidden": !0, ...e, children: S("path", { fill: "currentColor", d: "M.439,21.44a1.5,1.5,0,0,0,2.122,2.121L11.823,14.3a.25.25,0,0,1,.354,0l9.262,9.263a1.5,1.5,0,1,0,2.122-2.121L14.3,12.177a.25.25,0,0,1,0-.354l9.263-9.262A1.5,1.5,0,0,0,21.439.44L12.177,9.7a.25.25,0,0,1-.354,0L2.561.44A1.5,1.5,0,0,0,.439,2.561L9.7,11.823a.25.25,0,0,1,0,.354Z" }) }), vI = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, selectProps: { chakraStyles: a, size: i } } = e, s = yr(i), l = { ...Ts("CloseButton", { size: s }), marginX: 1, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, cursor: "pointer" }, u = a != null && a.clearIndicator ? a.clearIndicator(l, e) : l, c = { width: "1em", height: "1em" }, d = a != null && a.crossIcon ? a.crossIcon(c, e) : c;
  return S(mt, { role: "button", className: n({ indicator: !0, "clear-indicator": !0 }, t), sx: u, "aria-label": "Clear selected options", ...o, children: r || S(mI, { sx: d }) });
}, bI = (e) => {
  let { className: r, cx: t, innerProps: n, selectProps: { chakraStyles: o, size: a }, color: i, emptyColor: s, speed: l, thickness: u, spinnerSize: c } = e, d = yr(a), f = { sm: "xs", md: "sm", lg: "md" }[d], p = { marginRight: 3 }, h = o != null && o.loadingIndicator ? o.loadingIndicator(p, e) : p;
  return S(Rh, { className: t({ indicator: !0, "loading-indicator": !0 }, r), sx: h, ...n, size: c || f, color: i, emptyColor: s, speed: l, thickness: u });
}, yI = fI, wI = (e) => {
  let { className: r, cx: t, value: n, selectProps: { chakraStyles: o, isReadOnly: a } } = e, { innerRef: i, isDisabled: s, isHidden: l, inputClassName: u, ...c } = eg(e), d = { gridArea: "1 / 2", minW: "2px", border: 0, margin: 0, outline: 0, padding: 0 }, f = { flex: "1 1 auto", display: "inline-grid", gridArea: "1 / 1 / 2 / 3", gridTemplateColumns: "0 min-content", color: "inherit", marginX: "0.125rem", paddingY: "0.125rem", visibility: s ? "hidden" : "visible", transform: n ? "translateZ(0)" : "", _after: { content: 'attr(data-value) " "', visibility: "hidden", whiteSpace: "pre", padding: 0, ...d } }, p = o != null && o.inputContainer ? o.inputContainer(f, e) : f, h = { background: 0, opacity: l ? 0 : 1, width: "100%", ...d }, g = o != null && o.input ? o.input(h, e) : h;
  return S(mt, { className: t({ "input-container": !0 }, r), "data-value": n || "", sx: p, children: S(ar.input, { className: t({ input: !0 }, u), ref: i, sx: g, disabled: s, readOnly: a ? !0 : void 0, ...c }) });
}, CI = wI, SI = (e) => e ? { bottom: "top", top: "bottom" }[e] : "top", xI = (e) => {
  let { className: r, cx: t, children: n, innerProps: o, innerRef: a, placement: i, selectProps: { chakraStyles: s } } = e, l = { position: "absolute", [SI(i)]: "100%", marginY: "8px", width: "100%", zIndex: 1 }, u = s != null && s.menu ? s.menu(l, e) : l;
  return S(Jh, { children: S(mt, { ...o, ref: a, className: t({ menu: !0 }, r), sx: u, children: n }) });
}, II = xI, DI = (e) => {
  var r;
  let { className: t, cx: n, innerRef: o, children: a, maxHeight: i, isMulti: s, innerProps: l, selectProps: { chakraStyles: u, size: c, variant: d, focusBorderColor: f, errorBorderColor: p } } = e, h = Lr("Menu"), g = yr(c), m = Lr("Input", { size: g, variant: d, focusBorderColor: f, errorBorderColor: p }).field, v = { ...h.list, minW: "100%", maxHeight: `${i}px`, overflowY: "auto", "--input-border-radius": m == null ? void 0 : m["--input-border-radius"], borderRadius: (m == null ? void 0 : m.borderRadius) || ((r = h.list) == null ? void 0 : r.borderRadius), position: "relative", WebkitOverflowScrolling: "touch" }, y = u != null && u.menuList ? u.menuList(v, e) : v;
  return S(mt, { ...l, className: n({ "menu-list": !0, "menu-list--is-multi": s }, t), sx: y, ref: o, children: a });
}, _I = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, selectProps: { chakraStyles: a, size: i } } = e, s = yr(i), l = { color: "chakra-subtle-text", textAlign: "center", paddingY: { sm: "6px", md: "8px", lg: "10px" }[s], fontSize: s }, u = a != null && a.loadingMessage ? a.loadingMessage(l, e) : l;
  return S(mt, { ...o, className: n({ "menu-notice": !0, "menu-notice--loading": !0 }, t), sx: u, children: r });
}, kI = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, selectProps: { chakraStyles: a, size: i } } = e, s = yr(i), l = { color: "chakra-subtle-text", textAlign: "center", paddingY: { sm: "6px", md: "8px", lg: "10px" }[s], fontSize: s }, u = a != null && a.noOptionsMessage ? a.noOptionsMessage(l, e) : l;
  return S(mt, { ...o, className: n({ "menu-notice": !0, "menu-notice--no-options": !0 }, t), sx: u, children: r });
}, EI = (e) => {
  let { children: r, className: t, cx: n, theme: o, getStyles: a, Heading: i, headingProps: s, label: l, selectProps: u, innerProps: c, getClassNames: d } = e, { chakraStyles: f } = u, p = {}, h = f != null && f.group ? f.group(p, e) : p;
  return K(mt, { ...c, className: n({ group: !0 }, t), sx: h, children: [S(i, { ...s, selectProps: u, cx: n, theme: o, getStyles: a, getClassNames: d, children: l }), S(mt, { children: r })] });
}, MI = (e) => {
  let { cx: r, className: t, selectProps: { chakraStyles: n, size: o, hasStickyGroupHeaders: a } } = e, { data: i, ...s } = eg(e), l = Lr("Menu"), u = yr(o), c = { sm: "xs", md: "sm", lg: "md" }, d = { sm: "0.4rem 0.8rem", md: "0.5rem 1rem", lg: "0.6rem 1.2rem" }, f = { ...l.groupTitle, fontSize: c[u], padding: d[u], margin: 0, borderBottomWidth: a ? "1px" : 0, position: a ? "sticky" : "static", top: -2, bg: l.list.bg, zIndex: 1 }, p = n != null && n.groupHeading ? n.groupHeading(f, e) : f;
  return S(mt, { ...s, className: r({ "group-heading": !0 }, t), sx: p });
}, AI = (e) => S("svg", { viewBox: "0 0 14 14", width: "1em", height: "1em", ...e, children: S("polygon", { fill: "currentColor", points: "5.5 11.9993304 14 3.49933039 12.5 2 5.5 8.99933039 1.5 4.9968652 0 6.49933039" }) }), PI = (e) => {
  let { className: r, cx: t, innerRef: n, innerProps: o, children: a, isFocused: i, isDisabled: s, isSelected: l, selectProps: { chakraStyles: u, size: c, isMulti: d, hideSelectedOptions: f, selectedOptionStyle: p, selectedOptionColorScheme: h } } = e, g = Lr("Menu").item, m = yr(c), v = { sm: "0.6rem", md: "0.8rem", lg: "1rem" }, y = { sm: "0.3rem", md: "0.4rem", lg: "0.5rem" }, C = Pd(`${h}.500`, `${h}.300`), I = Pd("white", "black"), b = p === "check" && (!d || f === !1), D = p === "color", x = { ...g, cursor: "pointer", display: "flex", alignItems: "center", width: "100%", textAlign: "start", fontSize: m, paddingX: v[m], paddingY: y[m], ...D && { _selected: { bg: C, color: I, _active: { bg: C } } } }, _ = u != null && u.option ? u.option(x, e) : x;
  return K(mt, { ...o, className: t({ option: !0, "option--is-disabled": s, "option--is-focused": i, "option--is-selected": l }, r), sx: _, ref: n, "data-focus": i ? !0 : void 0, "aria-disabled": s ? !0 : void 0, "aria-selected": l, children: [b && S(Qh, { fontSize: "0.8em", marginEnd: "0.75rem", opacity: l ? 1 : 0, children: S(AI, {}) }), a] });
}, RI = (e) => typeof e == "object" && e !== null && "colorScheme" in e && typeof e.colorScheme == "string", OI = (e) => typeof e == "object" && e !== null && "variant" in e && typeof e.variant == "string", tg = (e) => typeof e == "object" && e !== null && "isFixed" in e && typeof e.isFixed == "boolean", TI = (e) => {
  let { children: r, className: t, components: n, cx: o, data: a, innerProps: i, isDisabled: s, isFocused: l, removeProps: u, selectProps: c, cropWithEllipsis: d } = e, { Container: f, Label: p, Remove: h } = n, { chakraStyles: g, colorScheme: m, tagVariant: v, size: y } = c, C = yr(y), I = "", b = "", D = !1;
  RI(a) && (I = a.colorScheme), OI(a) && (b = a.variant), tg(a) && (D = a.isFixed);
  let x = Lr("Tag", { size: C, colorScheme: I || m, variant: b || v || (D ? "solid" : "subtle") }), _ = { ...x.container, display: "flex", alignItems: "center", minWidth: 0, margin: "0.125rem" }, E = g != null && g.multiValue ? g.multiValue(_, e) : _, R = { ...x.label, overflow: "hidden", textOverflow: d || d === void 0 ? "ellipsis" : void 0, whiteSpace: "nowrap" }, L = g != null && g.multiValueLabel ? g.multiValueLabel(R, e) : R, G = { ...x.closeButton, display: "flex", alignItems: "center", justifyContent: "center" }, V = g != null && g.multiValueRemove ? g.multiValueRemove(G, e) : G;
  return K(f, { data: a, innerProps: { className: o({ "multi-value": !0, "multi-value--is-disabled": s }, t), ...i }, sx: E, selectProps: c, children: [S(p, { data: a, innerProps: { className: o({ "multi-value__label": !0 }, t) }, sx: L, selectProps: c, children: r }), S(h, { data: a, innerProps: { className: o({ "multi-value__remove": !0 }, t), "aria-label": `Remove ${r || "option"}`, ...u }, sx: V, selectProps: c, isFocused: l })] });
}, FI = (e) => {
  let { children: r, innerProps: t, sx: n } = e;
  return S(ar.span, { ...t, sx: n, children: r });
}, NI = (e) => {
  let { children: r, innerProps: t, sx: n } = e;
  return S(ar.span, { ...t, sx: n, children: r });
}, LI = (e) => S(Za, { verticalAlign: "inherit", viewBox: "0 0 512 512", ...e, children: S("path", { fill: "currentColor", d: "M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z" }) }), WI = (e) => {
  let { children: r, innerProps: t, isFocused: n, data: o, sx: a } = e;
  return tg(o) && o.isFixed ? null : S(mt, { ...t, role: "button", sx: a, "data-focus": n ? !0 : void 0, "data-focus-visible": n ? !0 : void 0, children: r || S(LI, {}) });
}, BI = TI, VI = (e) => {
  let { children: r, className: t, cx: n, innerProps: o, selectProps: { chakraStyles: a } } = e, i = { gridArea: "1 / 1 / 2 / 3", color: "chakra-placeholder-color", mx: "0.125rem", userSelect: "none" }, s = a != null && a.placeholder ? a.placeholder(i, e) : i;
  return S(mt, { ...o, className: n({ placeholder: !0 }, t), sx: s, children: r });
}, GI = VI, YI = (e) => {
  let { children: r, className: t, cx: n, isDisabled: o, innerProps: a, selectProps: { chakraStyles: i } } = e, s = { gridArea: "1 / 1 / 2 / 3", mx: "0.125rem", maxWidth: "100%", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }, l = i != null && i.singleValue ? i.singleValue(s, e) : s;
  return S(mt, { className: n({ "single-value": !0, "single-value--is-disabled": o }, t), sx: l, ...a, children: r });
}, HI = YI, zI = { ClearIndicator: vI, Control: yI, DropdownIndicator: gI, Group: EI, GroupHeading: MI, IndicatorSeparator: pI, IndicatorsContainer: dI, Input: CI, LoadingIndicator: bI, LoadingMessage: _I, Menu: II, MenuList: DI, MultiValue: BI, MultiValueContainer: FI, MultiValueLabel: NI, MultiValueRemove: WI, NoOptionsMessage: kI, Option: PI, Placeholder: GI, SelectContainer: uI, SingleValue: HI, ValueContainer: cI }, rg = zI, $I = ({ components: e = {}, theme: r, size: t, colorScheme: n = "gray", isDisabled: o, isInvalid: a, isReadOnly: i, required: s, isRequired: l, inputId: u, tagVariant: c, selectedOptionStyle: d = "color", selectedOptionColorScheme: f, selectedOptionColor: p, variant: h, focusBorderColor: g, errorBorderColor: m, chakraStyles: v = {}, onFocus: y, onBlur: C, menuIsOpen: I, ...b }) => {
  var D;
  let x = jo(), { variant: _ } = x.components.Input.defaultProps, E = j1({ id: u, isDisabled: o, isInvalid: a, isRequired: l, isReadOnly: i, onFocus: y, onBlur: C }), R = I ?? (E.readOnly ? !1 : void 0), L = d;
  ["color", "check"].includes(d) || (L = "color");
  let G = f || p || "blue";
  return typeof G != "string" && (G = "blue"), { components: { ...rg, ...e }, colorScheme: n, size: t, tagVariant: c, selectedOptionStyle: L, selectedOptionColorScheme: G, variant: h ?? _, chakraStyles: v, focusBorderColor: g, errorBorderColor: m, onFocus: E.onFocus, onBlur: E.onBlur, isDisabled: E.disabled, isInvalid: !!E["aria-invalid"], inputId: E.id, isReadOnly: E.readOnly, required: s ?? E.required, menuIsOpen: R, ...b, "aria-invalid": (D = b["aria-invalid"]) != null ? D : E["aria-invalid"] };
}, Ls = $I, XI = ot((e, r) => {
  let t = Ls(e);
  return S(yC, { ref: r, ...t });
}), jI = XI;
ot((e, r) => {
  let t = Ls(e);
  return S(tI, { ref: r, ...t });
});
var ZI = ot((e, r) => {
  let t = Ls(e);
  return S(oI, { ref: r, ...t });
}), UI = ZI;
ot((e, r) => {
  let t = Ls(e);
  return S(iI, { ref: r, ...t });
});
var JI = Fs({
  d: "M21,5H3C2.621,5,2.275,5.214,2.105,5.553C1.937,5.892,1.973,6.297,2.2,6.6l9,12 c0.188,0.252,0.485,0.4,0.8,0.4s0.611-0.148,0.8-0.4l9-12c0.228-0.303,0.264-0.708,0.095-1.047C21.725,5.214,21.379,5,21,5z",
  displayName: "TriangleDownIcon"
}), QI = Fs({
  d: "M12.8,5.4c-0.377-0.504-1.223-0.504-1.6,0l-9,12c-0.228,0.303-0.264,0.708-0.095,1.047 C2.275,18.786,2.621,19,3,19h18c0.379,0,0.725-0.214,0.895-0.553c0.169-0.339,0.133-0.744-0.095-1.047L12.8,5.4z",
  displayName: "TriangleUpIcon"
}), qI = Fs({
  d: "M12,0A12,12,0,1,0,24,12,12.013,12.013,0,0,0,12,0Zm.25,5a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,12.25,5ZM14.5,18.5h-4a1,1,0,0,1,0-2h.75a.25.25,0,0,0,.25-.25v-4.5a.25.25,0,0,0-.25-.25H10.5a1,1,0,0,1,0-2h1a2,2,0,0,1,2,2v4.75a.25.25,0,0,0,.25.25h.75a1,1,0,1,1,0,2Z"
}), KI = Fs({
  displayName: "ChevronDownIcon",
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
});
const ng = ({ label: e }) => /* @__PURE__ */ S(
  cb,
  {
    label: e,
    hasArrow: !0,
    placement: "top",
    bg: "gray.700",
    color: "white",
    fontSize: "sm",
    borderRadius: "md",
    p: 2,
    children: /* @__PURE__ */ S("span", { style: { display: "flex", alignItems: "center", cursor: "help" }, children: /* @__PURE__ */ S(
      qI,
      {
        w: 3,
        h: 3
      }
    ) })
  }
), og = {
  selectPlaceholder: "Selecciona",
  searchPlaceholder: "Buscar...",
  moreSelected: (e) => `+${e} más`,
  confirm: "Confirmar",
  cancel: "Cancelar",
  dropFile: "Arrastra tu archivo aqui",
  upload: "Subir",
  fieldDisabled: "Campo deshabilitado",
  dropFileOrClick: "Haz clic o arrastra el archivo aquí",
  dropFilesOrClick: "Haz clic o arrastra los archivos aquí",
  maxFileSize: (e) => `Máx ${e}MB`,
  fileTooLarge: (e) => `El archivo excede el tamaño máximo de ${e}MB`,
  validationError: "Error de validación",
  loadingProgress: (e) => `Cargando... ${e}%`,
  removeFile: "Eliminar archivo"
}, ag = Ya(og), eD = ({ texts: e, children: r }) => {
  const t = Ve(() => ({ ...og, ...e }), [e]);
  return /* @__PURE__ */ S(ag.Provider, { value: t, children: r });
}, Zo = () => $o(ag), KT = ({ name: e = "", id: r, label: t, placeholder: n, options: o = [], isDisabled: a = !1, helperText: i = "", value: s, isInvalid: l, onChange: u, onBlur: c, onFocus: d, isRequired: f, isMulti: p = !1, isClearable: h = !0, customWidth: g, isSearchable: m = !0, preventEnterSubmit: v = !1, labelTooltip: y }) => {
  const C = Zo(), I = A.useMemo(() => s == null ? null : p ? Array.isArray(s) && s.length ? s.map((b) => o.find((D) => D.value === b)) : [] : o.find((b) => b.value === s) ?? null, [s, o]);
  return /* @__PURE__ */ K(
    to,
    {
      width: g || ao,
      minH: nr.inputContainerHeight,
      id: r,
      isDisabled: a,
      isInvalid: l,
      children: [
        /* @__PURE__ */ S(
          ro,
          {
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            children: /* @__PURE__ */ K(
              Rt,
              {
                align: "center",
                gap: 1,
                children: [
                  /* @__PURE__ */ K("span", { children: [
                    t,
                    " ",
                    f ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
                  ] }),
                  y && /* @__PURE__ */ S(ng, { label: y })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ S(
          jI,
          {
            menuPortalTarget: typeof document < "u" ? document.body : void 0,
            styles: {
              menuPortal: (b) => ({ ...b, zIndex: 9999 })
            },
            chakraStyles: {
              container: (b) => ({
                ...b,
                maxH: "fit-content"
              }),
              group: (b) => ({
                ...b,
                maxH: "fit-content"
              }),
              inputContainer: (b) => ({
                ...b,
                maxH: "fit-content"
              }),
              input: (b) => ({
                ...b,
                maxH: "fit-content",
                fontSize: Xe.input
              }),
              control: (b) => ({
                ...b,
                maxH: "fit-content",
                minHeight: tr,
                height: p ? "fit-content" : tr,
                fontSize: Xe.input
              }),
              valueContainer: (b) => ({
                ...b,
                padding: "0 8px",
                fontSize: Xe.input
              }),
              singleValue: (b) => ({
                ...b,
                fontSize: Xe.input
              }),
              placeholder: (b) => ({
                ...b,
                fontSize: Xe.input
              }),
              option: (b, { isSelected: D, isFocused: x }) => ({
                ...b,
                fontSize: Xe.input,
                backgroundColor: D || x ? "#D3D7FF" : "transparent",
                color: "#1B1C1E",
                ":hover": {
                  backgroundColor: "#D3D7FF"
                }
              })
            },
            inputId: r,
            isSearchable: m,
            id: r,
            options: o.map((b) => ({
              value: b.value !== null ? b.value : "",
              label: b.label || ""
            })),
            value: I,
            isInvalid: l,
            name: e,
            isMulti: p,
            placeholder: n ?? C.selectPlaceholder,
            closeMenuOnSelect: !p,
            isDisabled: a,
            errorBorderColor: Yt.error.border,
            focusBorderColor: "#7A86FF",
            onFocus: d,
            onBlur: c,
            onKeyDown: v ? (b) => {
              b.key === "Enter" && b.preventDefault();
            } : void 0,
            onChange: (b) => {
              const D = p ? b.map(({ value: x }) => x) : b === null ? null : b.value;
              u && u(e, D);
            },
            isClearable: h
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: i })
      ]
    }
  );
}, eF = ({ name: e = "", id: r, label: t, placeholder: n, loadOptions: o, defaultOptions: a = !0, cacheOptions: i = !0, debounceMs: s = 300, isDisabled: l = !1, helperText: u = "", value: c, isInvalid: d, onChange: f, onBlur: p, onFocus: h, isRequired: g, isClearable: m = !0, isMulti: v = !1, customWidth: y, fixedOptions: C = [], initialOption: I = null, isSearchable: b = !0, maxVisibleTags: D = 2, initialOptions: x, preventEnterSubmit: _ = !1, labelTooltip: E }) => {
  const R = Zo(), L = ye(null), G = ye(!1), [V, O] = A.useState(null);
  A.useEffect(() => {
    O(v ? x ?? [] : I);
  }, [I, x]);
  const N = se(
    (F, $) => {
      L.current && clearTimeout(L.current), L.current = setTimeout(async () => {
        const Y = await o(F);
        $([...F ? [] : C, ...Y]);
      }, s);
    },
    [o, s, C]
  ), P = se(async () => {
    if (Array.isArray(a))
      return [...C, ...a];
    if (a === !0) {
      const F = await o("");
      return [...C, ...F];
    }
    return C;
  }, [a, C, o]), [B, H] = A.useState(Array.isArray(a) ? [...C, ...a] : C);
  A.useEffect(() => {
    P().then(H);
  }, [a]);
  const re = Ve(() => {
    if (!v || !Array.isArray(V) || V.length === 0)
      return B;
    const F = V.filter(($) => !B.some((Y) => Y.value === $.value));
    return F.length === 0 ? B : [...F, ...B];
  }, [v, V, B]);
  A.useEffect(() => {
    v || c == null && O(null);
  }, [c, v]), A.useEffect(() => {
    if (v) {
      if (G.current) {
        G.current = !1;
        return;
      }
      if (!c || Array.isArray(c) && c.length === 0) {
        O([]);
        return;
      }
      if (Array.isArray(c)) {
        const F = Array.isArray(V) ? V : [], $ = c.map((Y) => {
          const X = F.find((te) => te.value === Y);
          return X || (B.find((te) => te.value === Y) ?? null);
        }).filter((Y) => Y !== null);
        O($);
      }
    }
  }, [c, v, B]);
  const W = Ve(() => {
    if (v)
      return {
        MultiValue: ({ index: F, getValue: $, ...Y }) => {
          const te = $().length;
          return F >= D ? F === D ? /* @__PURE__ */ S(
            db,
            {
              size: "md",
              borderRadius: "md",
              variant: "solid",
              colorScheme: "blue",
              mx: 1,
              my: 0.5,
              children: /* @__PURE__ */ S(fb, { fontSize: Xe.input, children: R.moreSelected(te - D) })
            }
          ) : null : /* @__PURE__ */ S(
            rg.MultiValue,
            {
              ...Y,
              index: F,
              getValue: $
            }
          );
        }
      };
  }, [v, D, R]);
  return /* @__PURE__ */ K(
    to,
    {
      width: y || ao,
      minH: nr.inputContainerHeight,
      id: r,
      isDisabled: l,
      isInvalid: d,
      children: [
        /* @__PURE__ */ S(
          ro,
          {
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            children: /* @__PURE__ */ K(
              Rt,
              {
                align: "center",
                gap: 1,
                children: [
                  /* @__PURE__ */ K("span", { children: [
                    t,
                    " ",
                    g ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
                  ] }),
                  E && /* @__PURE__ */ S(ng, { label: E })
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ S(
          UI,
          {
            menuPortalTarget: typeof document < "u" ? document.body : void 0,
            styles: {
              menuPortal: (F) => ({ ...F, zIndex: 9999 })
            },
            components: W,
            chakraStyles: {
              container: (F) => ({
                ...F,
                maxH: "fit-content"
              }),
              inputContainer: (F) => ({
                ...F,
                maxH: "fit-content"
              }),
              input: (F) => ({
                ...F,
                maxH: "fit-content",
                fontSize: Xe.input
              }),
              control: (F) => ({
                ...F,
                minHeight: tr,
                height: tr,
                fontSize: Xe.input,
                overflow: "hidden"
              }),
              valueContainer: (F) => ({
                ...F,
                padding: "0 8px",
                fontSize: Xe.input,
                flexWrap: v ? "nowrap" : "wrap",
                overflow: "hidden",
                maxHeight: tr
              }),
              singleValue: (F) => ({
                ...F,
                fontSize: Xe.input
              }),
              placeholder: (F) => ({
                ...F,
                fontSize: Xe.input
              }),
              option: (F, { isSelected: $, isFocused: Y }) => ({
                ...F,
                fontSize: Xe.input,
                backgroundColor: $ || Y ? "#D3D7FF" : "transparent",
                color: "#1B1C1E",
                ":hover": {
                  backgroundColor: "#D3D7FF"
                }
              })
            },
            inputId: r,
            id: r,
            loadOptions: N,
            defaultOptions: re,
            cacheOptions: i,
            value: V,
            isMulti: v,
            closeMenuOnSelect: !v,
            hideSelectedOptions: !1,
            isInvalid: d,
            name: e,
            placeholder: n ?? R.searchPlaceholder,
            isDisabled: l,
            errorBorderColor: Yt.error.border,
            focusBorderColor: "#7A86FF",
            onFocus: h,
            onBlur: p,
            onKeyDown: _ ? (F) => {
              F.key === "Enter" && F.preventDefault();
            } : void 0,
            isSearchable: b,
            onChange: (F) => {
              if (O(F), v) {
                G.current = !0;
                const $ = F ? F.map((Y) => Y.value) : [];
                f && f(e, $);
              } else {
                const $ = F === null ? null : F.value;
                f && f(e, $);
              }
            },
            isClearable: m,
            noOptionsMessage: ({ inputValue: F }) => F ? "No se encontraron resultados" : "Escribe para buscar",
            loadingMessage: () => "Buscando..."
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: u })
      ]
    }
  );
};
function tD(e) {
  return lr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "line", attr: { x1: "18", y1: "6", x2: "6", y2: "18" }, child: [] }, { tag: "line", attr: { x1: "6", y1: "6", x2: "18", y2: "18" }, child: [] }] })(e);
}
function ig(e) {
  return lr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }, child: [] }, { tag: "polyline", attr: { points: "17 8 12 3 7 8" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "3", x2: "12", y2: "15" }, child: [] }] })(e);
}
function sg(e) {
  return lr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z" }, child: [] }, { tag: "polyline", attr: { points: "13 2 13 9 20 9" }, child: [] }] })(e);
}
function rD(e) {
  return lr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" }, child: [] }, { tag: "rect", attr: { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1" }, child: [] }] })(e);
}
function nD(e) {
  return lr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "polyline", attr: { points: "20 6 9 17 4 12" }, child: [] }] })(e);
}
function oD(e) {
  return lr({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "circle", attr: { cx: "12", cy: "12", r: "10" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "8", x2: "12", y2: "12" }, child: [] }, { tag: "line", attr: { x1: "12", y1: "16", x2: "12.01", y2: "16" }, child: [] }] })(e);
}
var fu = { exports: {} }, gi = { exports: {} }, Ne = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var nf;
function aD() {
  if (nf) return Ne;
  nf = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function C(b) {
    if (typeof b == "object" && b !== null) {
      var D = b.$$typeof;
      switch (D) {
        case r:
          switch (b = b.type, b) {
            case l:
            case u:
            case n:
            case a:
            case o:
            case d:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case c:
                case h:
                case p:
                case i:
                  return b;
                default:
                  return D;
              }
          }
        case t:
          return D;
      }
    }
  }
  function I(b) {
    return C(b) === u;
  }
  return Ne.AsyncMode = l, Ne.ConcurrentMode = u, Ne.ContextConsumer = s, Ne.ContextProvider = i, Ne.Element = r, Ne.ForwardRef = c, Ne.Fragment = n, Ne.Lazy = h, Ne.Memo = p, Ne.Portal = t, Ne.Profiler = a, Ne.StrictMode = o, Ne.Suspense = d, Ne.isAsyncMode = function(b) {
    return I(b) || C(b) === l;
  }, Ne.isConcurrentMode = I, Ne.isContextConsumer = function(b) {
    return C(b) === s;
  }, Ne.isContextProvider = function(b) {
    return C(b) === i;
  }, Ne.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === r;
  }, Ne.isForwardRef = function(b) {
    return C(b) === c;
  }, Ne.isFragment = function(b) {
    return C(b) === n;
  }, Ne.isLazy = function(b) {
    return C(b) === h;
  }, Ne.isMemo = function(b) {
    return C(b) === p;
  }, Ne.isPortal = function(b) {
    return C(b) === t;
  }, Ne.isProfiler = function(b) {
    return C(b) === a;
  }, Ne.isStrictMode = function(b) {
    return C(b) === o;
  }, Ne.isSuspense = function(b) {
    return C(b) === d;
  }, Ne.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === u || b === a || b === o || b === d || b === f || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === p || b.$$typeof === i || b.$$typeof === s || b.$$typeof === c || b.$$typeof === m || b.$$typeof === v || b.$$typeof === y || b.$$typeof === g);
  }, Ne.typeOf = C, Ne;
}
var Le = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var of;
function iD() {
  return of || (of = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, t = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, g = e ? Symbol.for("react.block") : 60121, m = e ? Symbol.for("react.fundamental") : 60117, v = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function C(Z) {
      return typeof Z == "string" || typeof Z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Z === n || Z === u || Z === a || Z === o || Z === d || Z === f || typeof Z == "object" && Z !== null && (Z.$$typeof === h || Z.$$typeof === p || Z.$$typeof === i || Z.$$typeof === s || Z.$$typeof === c || Z.$$typeof === m || Z.$$typeof === v || Z.$$typeof === y || Z.$$typeof === g);
    }
    function I(Z) {
      if (typeof Z == "object" && Z !== null) {
        var at = Z.$$typeof;
        switch (at) {
          case r:
            var xt = Z.type;
            switch (xt) {
              case l:
              case u:
              case n:
              case a:
              case o:
              case d:
                return xt;
              default:
                var Et = xt && xt.$$typeof;
                switch (Et) {
                  case s:
                  case c:
                  case h:
                  case p:
                  case i:
                    return Et;
                  default:
                    return at;
                }
            }
          case t:
            return at;
        }
      }
    }
    var b = l, D = u, x = s, _ = i, E = r, R = c, L = n, G = h, V = p, O = t, N = a, P = o, B = d, H = !1;
    function re(Z) {
      return H || (H = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(Z) || I(Z) === l;
    }
    function W(Z) {
      return I(Z) === u;
    }
    function F(Z) {
      return I(Z) === s;
    }
    function $(Z) {
      return I(Z) === i;
    }
    function Y(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === r;
    }
    function X(Z) {
      return I(Z) === c;
    }
    function te(Z) {
      return I(Z) === n;
    }
    function q(Z) {
      return I(Z) === h;
    }
    function ue(Z) {
      return I(Z) === p;
    }
    function ie(Z) {
      return I(Z) === t;
    }
    function be(Z) {
      return I(Z) === a;
    }
    function ge(Z) {
      return I(Z) === o;
    }
    function Pe(Z) {
      return I(Z) === d;
    }
    Le.AsyncMode = b, Le.ConcurrentMode = D, Le.ContextConsumer = x, Le.ContextProvider = _, Le.Element = E, Le.ForwardRef = R, Le.Fragment = L, Le.Lazy = G, Le.Memo = V, Le.Portal = O, Le.Profiler = N, Le.StrictMode = P, Le.Suspense = B, Le.isAsyncMode = re, Le.isConcurrentMode = W, Le.isContextConsumer = F, Le.isContextProvider = $, Le.isElement = Y, Le.isForwardRef = X, Le.isFragment = te, Le.isLazy = q, Le.isMemo = ue, Le.isPortal = ie, Le.isProfiler = be, Le.isStrictMode = ge, Le.isSuspense = Pe, Le.isValidElementType = C, Le.typeOf = I;
  }()), Le;
}
var af;
function lg() {
  return af || (af = 1, process.env.NODE_ENV === "production" ? gi.exports = aD() : gi.exports = iD()), gi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Dl, sf;
function sD() {
  if (sf) return Dl;
  sf = 1;
  var e = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function n(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(c) {
        return i[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Dl = o() ? Object.assign : function(a, i) {
    for (var s, l = n(a), u, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var d in s)
        r.call(s, d) && (l[d] = s[d]);
      if (e) {
        u = e(s);
        for (var f = 0; f < u.length; f++)
          t.call(s, u[f]) && (l[u[f]] = s[u[f]]);
      }
    }
    return l;
  }, Dl;
}
var _l, lf;
function ic() {
  if (lf) return _l;
  lf = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _l = e, _l;
}
var kl, uf;
function ug() {
  return uf || (uf = 1, kl = Function.call.bind(Object.prototype.hasOwnProperty)), kl;
}
var El, cf;
function lD() {
  if (cf) return El;
  cf = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var r = ic(), t = {}, n = ug();
    e = function(a) {
      var i = "Warning: " + a;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function o(a, i, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in a)
        if (n(a, c)) {
          var d;
          try {
            if (typeof a[c] != "function") {
              var f = Error(
                (l || "React class") + ": " + s + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = a[c](i, c, l, s, null, r);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + s + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, El = o, El;
}
var Ml, df;
function uD() {
  if (df) return Ml;
  df = 1;
  var e = lg(), r = sD(), t = ic(), n = ug(), o = lD(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return Ml = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(W) {
      var F = W && (u && W[u] || W[c]);
      if (typeof F == "function")
        return F;
    }
    var f = "<<anonymous>>", p = {
      array: v("array"),
      bigint: v("bigint"),
      bool: v("boolean"),
      func: v("function"),
      number: v("number"),
      object: v("object"),
      string: v("string"),
      symbol: v("symbol"),
      any: y(),
      arrayOf: C,
      element: I(),
      elementType: b(),
      instanceOf: D,
      node: R(),
      objectOf: _,
      oneOf: x,
      oneOfType: E,
      shape: G,
      exact: V
    };
    function h(W, F) {
      return W === F ? W !== 0 || 1 / W === 1 / F : W !== W && F !== F;
    }
    function g(W, F) {
      this.message = W, this.data = F && typeof F == "object" ? F : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function m(W) {
      if (process.env.NODE_ENV !== "production")
        var F = {}, $ = 0;
      function Y(te, q, ue, ie, be, ge, Pe) {
        if (ie = ie || f, ge = ge || ue, Pe !== t) {
          if (l) {
            var Z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Z.name = "Invariant Violation", Z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var at = ie + ":" + ue;
            !F[at] && // Avoid spamming the console because they are often not actionable except for lib authors
            $ < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + ge + "` prop on `" + ie + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), F[at] = !0, $++);
          }
        }
        return q[ue] == null ? te ? q[ue] === null ? new g("The " + be + " `" + ge + "` is marked as required " + ("in `" + ie + "`, but its value is `null`.")) : new g("The " + be + " `" + ge + "` is marked as required in " + ("`" + ie + "`, but its value is `undefined`.")) : null : W(q, ue, ie, be, ge);
      }
      var X = Y.bind(null, !1);
      return X.isRequired = Y.bind(null, !0), X;
    }
    function v(W) {
      function F($, Y, X, te, q, ue) {
        var ie = $[Y], be = P(ie);
        if (be !== W) {
          var ge = B(ie);
          return new g(
            "Invalid " + te + " `" + q + "` of type " + ("`" + ge + "` supplied to `" + X + "`, expected ") + ("`" + W + "`."),
            { expectedType: W }
          );
        }
        return null;
      }
      return m(F);
    }
    function y() {
      return m(i);
    }
    function C(W) {
      function F($, Y, X, te, q) {
        if (typeof W != "function")
          return new g("Property `" + q + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var ue = $[Y];
        if (!Array.isArray(ue)) {
          var ie = P(ue);
          return new g("Invalid " + te + " `" + q + "` of type " + ("`" + ie + "` supplied to `" + X + "`, expected an array."));
        }
        for (var be = 0; be < ue.length; be++) {
          var ge = W(ue, be, X, te, q + "[" + be + "]", t);
          if (ge instanceof Error)
            return ge;
        }
        return null;
      }
      return m(F);
    }
    function I() {
      function W(F, $, Y, X, te) {
        var q = F[$];
        if (!s(q)) {
          var ue = P(q);
          return new g("Invalid " + X + " `" + te + "` of type " + ("`" + ue + "` supplied to `" + Y + "`, expected a single ReactElement."));
        }
        return null;
      }
      return m(W);
    }
    function b() {
      function W(F, $, Y, X, te) {
        var q = F[$];
        if (!e.isValidElementType(q)) {
          var ue = P(q);
          return new g("Invalid " + X + " `" + te + "` of type " + ("`" + ue + "` supplied to `" + Y + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return m(W);
    }
    function D(W) {
      function F($, Y, X, te, q) {
        if (!($[Y] instanceof W)) {
          var ue = W.name || f, ie = re($[Y]);
          return new g("Invalid " + te + " `" + q + "` of type " + ("`" + ie + "` supplied to `" + X + "`, expected ") + ("instance of `" + ue + "`."));
        }
        return null;
      }
      return m(F);
    }
    function x(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), i;
      function F($, Y, X, te, q) {
        for (var ue = $[Y], ie = 0; ie < W.length; ie++)
          if (h(ue, W[ie]))
            return null;
        var be = JSON.stringify(W, function(Pe, Z) {
          var at = B(Z);
          return at === "symbol" ? String(Z) : Z;
        });
        return new g("Invalid " + te + " `" + q + "` of value `" + String(ue) + "` " + ("supplied to `" + X + "`, expected one of " + be + "."));
      }
      return m(F);
    }
    function _(W) {
      function F($, Y, X, te, q) {
        if (typeof W != "function")
          return new g("Property `" + q + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var ue = $[Y], ie = P(ue);
        if (ie !== "object")
          return new g("Invalid " + te + " `" + q + "` of type " + ("`" + ie + "` supplied to `" + X + "`, expected an object."));
        for (var be in ue)
          if (n(ue, be)) {
            var ge = W(ue, be, X, te, q + "." + be, t);
            if (ge instanceof Error)
              return ge;
          }
        return null;
      }
      return m(F);
    }
    function E(W) {
      if (!Array.isArray(W))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var F = 0; F < W.length; F++) {
        var $ = W[F];
        if (typeof $ != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + H($) + " at index " + F + "."
          ), i;
      }
      function Y(X, te, q, ue, ie) {
        for (var be = [], ge = 0; ge < W.length; ge++) {
          var Pe = W[ge], Z = Pe(X, te, q, ue, ie, t);
          if (Z == null)
            return null;
          Z.data && n(Z.data, "expectedType") && be.push(Z.data.expectedType);
        }
        var at = be.length > 0 ? ", expected one of type [" + be.join(", ") + "]" : "";
        return new g("Invalid " + ue + " `" + ie + "` supplied to " + ("`" + q + "`" + at + "."));
      }
      return m(Y);
    }
    function R() {
      function W(F, $, Y, X, te) {
        return O(F[$]) ? null : new g("Invalid " + X + " `" + te + "` supplied to " + ("`" + Y + "`, expected a ReactNode."));
      }
      return m(W);
    }
    function L(W, F, $, Y, X) {
      return new g(
        (W || "React class") + ": " + F + " type `" + $ + "." + Y + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function G(W) {
      function F($, Y, X, te, q) {
        var ue = $[Y], ie = P(ue);
        if (ie !== "object")
          return new g("Invalid " + te + " `" + q + "` of type `" + ie + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var be in W) {
          var ge = W[be];
          if (typeof ge != "function")
            return L(X, te, q, be, B(ge));
          var Pe = ge(ue, be, X, te, q + "." + be, t);
          if (Pe)
            return Pe;
        }
        return null;
      }
      return m(F);
    }
    function V(W) {
      function F($, Y, X, te, q) {
        var ue = $[Y], ie = P(ue);
        if (ie !== "object")
          return new g("Invalid " + te + " `" + q + "` of type `" + ie + "` " + ("supplied to `" + X + "`, expected `object`."));
        var be = r({}, $[Y], W);
        for (var ge in be) {
          var Pe = W[ge];
          if (n(W, ge) && typeof Pe != "function")
            return L(X, te, q, ge, B(Pe));
          if (!Pe)
            return new g(
              "Invalid " + te + " `" + q + "` key `" + ge + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify($[Y], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(W), null, "  ")
            );
          var Z = Pe(ue, ge, X, te, q + "." + ge, t);
          if (Z)
            return Z;
        }
        return null;
      }
      return m(F);
    }
    function O(W) {
      switch (typeof W) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !W;
        case "object":
          if (Array.isArray(W))
            return W.every(O);
          if (W === null || s(W))
            return !0;
          var F = d(W);
          if (F) {
            var $ = F.call(W), Y;
            if (F !== W.entries) {
              for (; !(Y = $.next()).done; )
                if (!O(Y.value))
                  return !1;
            } else
              for (; !(Y = $.next()).done; ) {
                var X = Y.value;
                if (X && !O(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function N(W, F) {
      return W === "symbol" ? !0 : F ? F["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && F instanceof Symbol : !1;
    }
    function P(W) {
      var F = typeof W;
      return Array.isArray(W) ? "array" : W instanceof RegExp ? "object" : N(F, W) ? "symbol" : F;
    }
    function B(W) {
      if (typeof W > "u" || W === null)
        return "" + W;
      var F = P(W);
      if (F === "object") {
        if (W instanceof Date)
          return "date";
        if (W instanceof RegExp)
          return "regexp";
      }
      return F;
    }
    function H(W) {
      var F = B(W);
      switch (F) {
        case "array":
        case "object":
          return "an " + F;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + F;
        default:
          return F;
      }
    }
    function re(W) {
      return !W.constructor || !W.constructor.name ? f : W.constructor.name;
    }
    return p.checkPropTypes = o, p.resetWarningCache = o.resetWarningCache, p.PropTypes = p, p;
  }, Ml;
}
var Al, ff;
function cD() {
  if (ff) return Al;
  ff = 1;
  var e = ic();
  function r() {
  }
  function t() {
  }
  return t.resetWarningCache = r, Al = function() {
    function n(i, s, l, u, c, d) {
      if (d !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    n.isRequired = n;
    function o() {
      return n;
    }
    var a = {
      array: n,
      bigint: n,
      bool: n,
      func: n,
      number: n,
      object: n,
      string: n,
      symbol: n,
      any: n,
      arrayOf: o,
      element: n,
      elementType: n,
      instanceOf: o,
      node: n,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: t,
      resetWarningCache: r
    };
    return a.PropTypes = a, a;
  }, Al;
}
if (process.env.NODE_ENV !== "production") {
  var dD = lg(), fD = !0;
  fu.exports = uD()(dD.isElement, fD);
} else
  fu.exports = cD()();
var pD = fu.exports;
const $e = /* @__PURE__ */ Uu(pD);
function Uo(e, r, t, n) {
  function o(a) {
    return a instanceof t ? a : new t(function(i) {
      i(a);
    });
  }
  return new (t || (t = Promise))(function(a, i) {
    function s(c) {
      try {
        u(n.next(c));
      } catch (d) {
        i(d);
      }
    }
    function l(c) {
      try {
        u(n.throw(c));
      } catch (d) {
        i(d);
      }
    }
    function u(c) {
      c.done ? a(c.value) : o(c.value).then(s, l);
    }
    u((n = n.apply(e, r || [])).next());
  });
}
function Jo(e, r) {
  var t = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, n, o, a, i = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return i.next = s(0), i.throw = s(1), i.return = s(2), typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(u) {
    return function(c) {
      return l([u, c]);
    };
  }
  function l(u) {
    if (n) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, u[0] && (t = 0)), t; ) try {
      if (n = 1, o && (a = u[0] & 2 ? o.return : u[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, u[1])).done) return a;
      switch (o = 0, a && (u = [u[0] & 2, a.value]), u[0]) {
        case 0:
        case 1:
          a = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (a = t.trys, !(a = a.length > 0 && a[a.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!a || u[1] > a[0] && u[1] < a[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < a[1]) {
            t.label = a[1], a = u;
            break;
          }
          if (a && t.label < a[2]) {
            t.label = a[2], t.ops.push(u);
            break;
          }
          a[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = r.call(e, t);
    } catch (c) {
      u = [6, c], o = 0;
    } finally {
      n = a = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function pf(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var n = t.call(e), o, a = [], i;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = n.next()).done; ) a.push(o.value);
  } catch (s) {
    i = { error: s };
  } finally {
    try {
      o && !o.done && (t = n.return) && t.call(n);
    } finally {
      if (i) throw i.error;
    }
  }
  return a;
}
function hf(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}
var hD = /* @__PURE__ */ new Map([
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
  ["aac", "audio/aac"],
  ["abw", "application/x-abiword"],
  ["arc", "application/x-freearc"],
  ["avif", "image/avif"],
  ["avi", "video/x-msvideo"],
  ["azw", "application/vnd.amazon.ebook"],
  ["bin", "application/octet-stream"],
  ["bmp", "image/bmp"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["cda", "application/x-cdf"],
  ["csh", "application/x-csh"],
  ["css", "text/css"],
  ["csv", "text/csv"],
  ["doc", "application/msword"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["eot", "application/vnd.ms-fontobject"],
  ["epub", "application/epub+zip"],
  ["gz", "application/gzip"],
  ["gif", "image/gif"],
  ["heic", "image/heic"],
  ["heif", "image/heif"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["ico", "image/vnd.microsoft.icon"],
  ["ics", "text/calendar"],
  ["jar", "application/java-archive"],
  ["jpeg", "image/jpeg"],
  ["jpg", "image/jpeg"],
  ["js", "text/javascript"],
  ["json", "application/json"],
  ["jsonld", "application/ld+json"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mjs", "text/javascript"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mpeg", "video/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["opus", "audio/opus"],
  ["otf", "font/otf"],
  ["png", "image/png"],
  ["pdf", "application/pdf"],
  ["php", "application/x-httpd-php"],
  ["ppt", "application/vnd.ms-powerpoint"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["rar", "application/vnd.rar"],
  ["rtf", "application/rtf"],
  ["sh", "application/x-sh"],
  ["svg", "image/svg+xml"],
  ["swf", "application/x-shockwave-flash"],
  ["tar", "application/x-tar"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["ts", "video/mp2t"],
  ["ttf", "font/ttf"],
  ["txt", "text/plain"],
  ["vsd", "application/vnd.visio"],
  ["wav", "audio/wav"],
  ["weba", "audio/webm"],
  ["webm", "video/webm"],
  ["webp", "image/webp"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["xhtml", "application/xhtml+xml"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xml", "application/xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["zip", "application/zip"],
  ["7z", "application/x-7z-compressed"],
  // Others
  ["mkv", "video/x-matroska"],
  ["mov", "video/quicktime"],
  ["msg", "application/vnd.ms-outlook"]
]);
function Qa(e, r) {
  var t = gD(e);
  if (typeof t.path != "string") {
    var n = e.webkitRelativePath;
    Object.defineProperty(t, "path", {
      value: typeof r == "string" ? r : typeof n == "string" && n.length > 0 ? n : e.name,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return t;
}
function gD(e) {
  var r = e.name, t = r && r.lastIndexOf(".") !== -1;
  if (t && !e.type) {
    var n = r.split(".").pop().toLowerCase(), o = hD.get(n);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
var mD = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  "Thumbs.db"
  // Windows
];
function vD(e) {
  return Uo(this, void 0, void 0, function() {
    return Jo(this, function(r) {
      return as(e) && bD(e.dataTransfer) ? [2, SD(e.dataTransfer, e.type)] : yD(e) ? [2, wD(e)] : Array.isArray(e) && e.every(function(t) {
        return "getFile" in t && typeof t.getFile == "function";
      }) ? [2, CD(e)] : [2, []];
    });
  });
}
function bD(e) {
  return as(e);
}
function yD(e) {
  return as(e) && as(e.target);
}
function as(e) {
  return typeof e == "object" && e !== null;
}
function wD(e) {
  return pu(e.target.files).map(function(r) {
    return Qa(r);
  });
}
function CD(e) {
  return Uo(this, void 0, void 0, function() {
    var r;
    return Jo(this, function(t) {
      switch (t.label) {
        case 0:
          return [4, Promise.all(e.map(function(n) {
            return n.getFile();
          }))];
        case 1:
          return r = t.sent(), [2, r.map(function(n) {
            return Qa(n);
          })];
      }
    });
  });
}
function SD(e, r) {
  return Uo(this, void 0, void 0, function() {
    var t, n;
    return Jo(this, function(o) {
      switch (o.label) {
        case 0:
          return e.items ? (t = pu(e.items).filter(function(a) {
            return a.kind === "file";
          }), r !== "drop" ? [2, t] : [4, Promise.all(t.map(xD))]) : [3, 2];
        case 1:
          return n = o.sent(), [2, gf(cg(n))];
        case 2:
          return [2, gf(pu(e.files).map(function(a) {
            return Qa(a);
          }))];
      }
    });
  });
}
function gf(e) {
  return e.filter(function(r) {
    return mD.indexOf(r.name) === -1;
  });
}
function pu(e) {
  if (e === null)
    return [];
  for (var r = [], t = 0; t < e.length; t++) {
    var n = e[t];
    r.push(n);
  }
  return r;
}
function xD(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return mf(e);
  var r = e.webkitGetAsEntry();
  return r && r.isDirectory ? dg(r) : mf(e);
}
function cg(e) {
  return e.reduce(function(r, t) {
    return hf(hf([], pf(r), !1), pf(Array.isArray(t) ? cg(t) : [t]), !1);
  }, []);
}
function mf(e) {
  var r = e.getAsFile();
  if (!r)
    return Promise.reject("".concat(e, " is not a File"));
  var t = Qa(r);
  return Promise.resolve(t);
}
function ID(e) {
  return Uo(this, void 0, void 0, function() {
    return Jo(this, function(r) {
      return [2, e.isDirectory ? dg(e) : DD(e)];
    });
  });
}
function dg(e) {
  var r = e.createReader();
  return new Promise(function(t, n) {
    var o = [];
    function a() {
      var i = this;
      r.readEntries(function(s) {
        return Uo(i, void 0, void 0, function() {
          var l, u, c;
          return Jo(this, function(d) {
            switch (d.label) {
              case 0:
                if (s.length) return [3, 5];
                d.label = 1;
              case 1:
                return d.trys.push([1, 3, , 4]), [4, Promise.all(o)];
              case 2:
                return l = d.sent(), t(l), [3, 4];
              case 3:
                return u = d.sent(), n(u), [3, 4];
              case 4:
                return [3, 6];
              case 5:
                c = Promise.all(s.map(ID)), o.push(c), a(), d.label = 6;
              case 6:
                return [
                  2
                  /*return*/
                ];
            }
          });
        });
      }, function(s) {
        n(s);
      });
    }
    a();
  });
}
function DD(e) {
  return Uo(this, void 0, void 0, function() {
    return Jo(this, function(r) {
      return [2, new Promise(function(t, n) {
        e.file(function(o) {
          var a = Qa(o, e.fullPath);
          t(a);
        }, function(o) {
          n(o);
        });
      })];
    });
  });
}
var _D = function(e, r) {
  if (e && r) {
    var t = Array.isArray(r) ? r : r.split(",");
    if (t.length === 0)
      return !0;
    var n = e.name || "", o = (e.type || "").toLowerCase(), a = o.replace(/\/.*$/, "");
    return t.some(function(i) {
      var s = i.trim().toLowerCase();
      return s.charAt(0) === "." ? n.toLowerCase().endsWith(s) : s.endsWith("/*") ? a === s.replace(/\/.*$/, "") : o === s;
    });
  }
  return !0;
};
function vf(e) {
  return MD(e) || ED(e) || pg(e) || kD();
}
function kD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ED(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function MD(e) {
  if (Array.isArray(e)) return hu(e);
}
function bf(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function yf(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? bf(Object(t), !0).forEach(function(n) {
      fg(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : bf(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function fg(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Ra(e, r) {
  return RD(e) || PD(e, r) || pg(e, r) || AD();
}
function AD() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function pg(e, r) {
  if (e) {
    if (typeof e == "string") return hu(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return hu(e, r);
  }
}
function hu(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function PD(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], o = !0, a = !1, i, s;
    try {
      for (t = t.call(e); !(o = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); o = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a) throw s;
      }
    }
    return n;
  }
}
function RD(e) {
  if (Array.isArray(e)) return e;
}
var OD = "file-invalid-type", TD = "file-too-large", FD = "file-too-small", ND = "too-many-files", LD = function(r) {
  r = Array.isArray(r) && r.length === 1 ? r[0] : r;
  var t = Array.isArray(r) ? "one of ".concat(r.join(", ")) : r;
  return {
    code: OD,
    message: "File type must be ".concat(t)
  };
}, wf = function(r) {
  return {
    code: TD,
    message: "File is larger than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, Cf = function(r) {
  return {
    code: FD,
    message: "File is smaller than ".concat(r, " ").concat(r === 1 ? "byte" : "bytes")
  };
}, WD = {
  code: ND,
  message: "Too many files"
};
function hg(e, r) {
  var t = e.type === "application/x-moz-file" || _D(e, r);
  return [t, t ? null : LD(r)];
}
function gg(e, r, t) {
  if (Wn(e.size))
    if (Wn(r) && Wn(t)) {
      if (e.size > t) return [!1, wf(t)];
      if (e.size < r) return [!1, Cf(r)];
    } else {
      if (Wn(r) && e.size < r) return [!1, Cf(r)];
      if (Wn(t) && e.size > t) return [!1, wf(t)];
    }
  return [!0, null];
}
function Wn(e) {
  return e != null;
}
function BD(e) {
  var r = e.files, t = e.accept, n = e.minSize, o = e.maxSize, a = e.multiple, i = e.maxFiles, s = e.validator;
  return !a && r.length > 1 || a && i >= 1 && r.length > i ? !1 : r.every(function(l) {
    var u = hg(l, t), c = Ra(u, 1), d = c[0], f = gg(l, n, o), p = Ra(f, 1), h = p[0], g = s ? s(l) : null;
    return d && h && !g;
  });
}
function is(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function mi(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(r) {
    return r === "Files" || r === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function Sf(e) {
  e.preventDefault();
}
function VD(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function GD(e) {
  return e.indexOf("Edge/") !== -1;
}
function YD() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return VD(e) || GD(e);
}
function Sr() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  return function(n) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), i = 1; i < o; i++)
      a[i - 1] = arguments[i];
    return r.some(function(s) {
      return !is(n) && s && s.apply(void 0, [n].concat(a)), is(n);
    });
  };
}
function HD() {
  return "showOpenFilePicker" in window;
}
function zD(e) {
  if (Wn(e)) {
    var r = Object.entries(e).filter(function(t) {
      var n = Ra(t, 2), o = n[0], a = n[1], i = !0;
      return mg(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), i = !1), (!Array.isArray(a) || !a.every(vg)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), i = !1), i;
    }).reduce(function(t, n) {
      var o = Ra(n, 2), a = o[0], i = o[1];
      return yf(yf({}, t), {}, fg({}, a, i));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: r
    }];
  }
  return e;
}
function $D(e) {
  if (Wn(e))
    return Object.entries(e).reduce(function(r, t) {
      var n = Ra(t, 2), o = n[0], a = n[1];
      return [].concat(vf(r), [o], vf(a));
    }, []).filter(function(r) {
      return mg(r) || vg(r);
    }).join(",");
}
function XD(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function jD(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function mg(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || /\w+\/[-+.\w]+/g.test(e);
}
function vg(e) {
  return /^.*\.[\w]+$/.test(e);
}
var ZD = ["children"], UD = ["open"], JD = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], QD = ["refKey", "onChange", "onClick"];
function qD(e) {
  return t_(e) || e_(e) || bg(e) || KD();
}
function KD() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function e_(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function t_(e) {
  if (Array.isArray(e)) return gu(e);
}
function Pl(e, r) {
  return o_(e) || n_(e, r) || bg(e, r) || r_();
}
function r_() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bg(e, r) {
  if (e) {
    if (typeof e == "string") return gu(e, r);
    var t = Object.prototype.toString.call(e).slice(8, -1);
    if (t === "Object" && e.constructor && (t = e.constructor.name), t === "Map" || t === "Set") return Array.from(e);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return gu(e, r);
  }
}
function gu(e, r) {
  (r == null || r > e.length) && (r = e.length);
  for (var t = 0, n = new Array(r); t < r; t++)
    n[t] = e[t];
  return n;
}
function n_(e, r) {
  var t = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (t != null) {
    var n = [], o = !0, a = !1, i, s;
    try {
      for (t = t.call(e); !(o = (i = t.next()).done) && (n.push(i.value), !(r && n.length === r)); o = !0)
        ;
    } catch (l) {
      a = !0, s = l;
    } finally {
      try {
        !o && t.return != null && t.return();
      } finally {
        if (a) throw s;
      }
    }
    return n;
  }
}
function o_(e) {
  if (Array.isArray(e)) return e;
}
function xf(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    r && (n = n.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, n);
  }
  return t;
}
function rt(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? xf(Object(t), !0).forEach(function(n) {
      mu(e, n, t[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : xf(Object(t)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n));
    });
  }
  return e;
}
function mu(e, r, t) {
  return r in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function ss(e, r) {
  if (e == null) return {};
  var t = a_(e, r), n, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      n = a[o], !(r.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (t[n] = e[n]);
  }
  return t;
}
function a_(e, r) {
  if (e == null) return {};
  var t = {}, n = Object.keys(e), o, a;
  for (a = 0; a < n.length; a++)
    o = n[a], !(r.indexOf(o) >= 0) && (t[o] = e[o]);
  return t;
}
var sc = /* @__PURE__ */ ot(function(e, r) {
  var t = e.children, n = ss(e, ZD), o = lc(n), a = o.open, i = ss(o, UD);
  return wp(r, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ A.createElement(Yi, null, t(rt(rt({}, i), {}, {
    open: a
  })));
});
sc.displayName = "Dropzone";
var yg = {
  disabled: !1,
  getFilesFromEvent: vD,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !0,
  autoFocus: !1
};
sc.defaultProps = yg;
sc.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: $e.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: $e.objectOf($e.arrayOf($e.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: $e.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: $e.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: $e.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: $e.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: $e.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: $e.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: $e.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: $e.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: $e.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: $e.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: $e.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: $e.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: $e.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: $e.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: $e.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: $e.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: $e.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: $e.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: $e.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: $e.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: $e.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: $e.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: $e.func
};
var vu = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function lc() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = rt(rt({}, yg), e), t = r.accept, n = r.disabled, o = r.getFilesFromEvent, a = r.maxSize, i = r.minSize, s = r.multiple, l = r.maxFiles, u = r.onDragEnter, c = r.onDragLeave, d = r.onDragOver, f = r.onDrop, p = r.onDropAccepted, h = r.onDropRejected, g = r.onFileDialogCancel, m = r.onFileDialogOpen, v = r.useFsAccessApi, y = r.autoFocus, C = r.preventDropOnDocument, I = r.noClick, b = r.noKeyboard, D = r.noDrag, x = r.noDragEventsBubbling, _ = r.onError, E = r.validator, R = Ve(function() {
    return $D(t);
  }, [t]), L = Ve(function() {
    return zD(t);
  }, [t]), G = Ve(function() {
    return typeof m == "function" ? m : If;
  }, [m]), V = Ve(function() {
    return typeof g == "function" ? g : If;
  }, [g]), O = ye(null), N = ye(null), P = yp(i_, vu), B = Pl(P, 2), H = B[0], re = B[1], W = H.isFocused, F = H.isFileDialogActive, $ = ye(typeof window < "u" && window.isSecureContext && v && HD()), Y = function() {
    !$.current && F && setTimeout(function() {
      if (N.current) {
        var fe = N.current.files;
        fe.length || (re({
          type: "closeDialog"
        }), V());
      }
    }, 300);
  };
  Ye(function() {
    return window.addEventListener("focus", Y, !1), function() {
      window.removeEventListener("focus", Y, !1);
    };
  }, [N, F, V, $]);
  var X = ye([]), te = function(fe) {
    O.current && O.current.contains(fe.target) || (fe.preventDefault(), X.current = []);
  };
  Ye(function() {
    return C && (document.addEventListener("dragover", Sf, !1), document.addEventListener("drop", te, !1)), function() {
      C && (document.removeEventListener("dragover", Sf), document.removeEventListener("drop", te));
    };
  }, [O, C]), Ye(function() {
    return !n && y && O.current && O.current.focus(), function() {
    };
  }, [O, y, n]);
  var q = se(function(J) {
    _ ? _(J) : console.error(J);
  }, [_]), ue = se(function(J) {
    J.preventDefault(), J.persist(), Re(J), X.current = [].concat(qD(X.current), [J.target]), mi(J) && Promise.resolve(o(J)).then(function(fe) {
      if (!(is(J) && !x)) {
        var Ze = fe.length, it = Ze > 0 && BD({
          files: fe,
          accept: R,
          minSize: i,
          maxSize: a,
          multiple: s,
          maxFiles: l,
          validator: E
        }), ct = Ze > 0 && !it;
        re({
          isDragAccept: it,
          isDragReject: ct,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), u && u(J);
      }
    }).catch(function(fe) {
      return q(fe);
    });
  }, [o, u, q, x, R, i, a, s, l, E]), ie = se(function(J) {
    J.preventDefault(), J.persist(), Re(J);
    var fe = mi(J);
    if (fe && J.dataTransfer)
      try {
        J.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return fe && d && d(J), !1;
  }, [d, x]), be = se(function(J) {
    J.preventDefault(), J.persist(), Re(J);
    var fe = X.current.filter(function(it) {
      return O.current && O.current.contains(it);
    }), Ze = fe.indexOf(J.target);
    Ze !== -1 && fe.splice(Ze, 1), X.current = fe, !(fe.length > 0) && (re({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), mi(J) && c && c(J));
  }, [O, c, x]), ge = se(function(J, fe) {
    var Ze = [], it = [];
    J.forEach(function(ct) {
      var hn = hg(ct, R), $r = Pl(hn, 2), uo = $r[0], co = $r[1], ta = gg(ct, i, a), fo = Pl(ta, 2), dr = fo[0], gn = fo[1], ra = E ? E(ct) : null;
      if (uo && dr && !ra)
        Ze.push(ct);
      else {
        var po = [co, gn];
        ra && (po = po.concat(ra)), it.push({
          file: ct,
          errors: po.filter(function(tl) {
            return tl;
          })
        });
      }
    }), (!s && Ze.length > 1 || s && l >= 1 && Ze.length > l) && (Ze.forEach(function(ct) {
      it.push({
        file: ct,
        errors: [WD]
      });
    }), Ze.splice(0)), re({
      acceptedFiles: Ze,
      fileRejections: it,
      type: "setFiles"
    }), f && f(Ze, it, fe), it.length > 0 && h && h(it, fe), Ze.length > 0 && p && p(Ze, fe);
  }, [re, s, R, i, a, l, f, p, h, E]), Pe = se(function(J) {
    J.preventDefault(), J.persist(), Re(J), X.current = [], mi(J) && Promise.resolve(o(J)).then(function(fe) {
      is(J) && !x || ge(fe, J);
    }).catch(function(fe) {
      return q(fe);
    }), re({
      type: "reset"
    });
  }, [o, ge, q, x]), Z = se(function() {
    if ($.current) {
      re({
        type: "openDialog"
      }), G();
      var J = {
        multiple: s,
        types: L
      };
      window.showOpenFilePicker(J).then(function(fe) {
        return o(fe);
      }).then(function(fe) {
        ge(fe, null), re({
          type: "closeDialog"
        });
      }).catch(function(fe) {
        XD(fe) ? (V(fe), re({
          type: "closeDialog"
        })) : jD(fe) ? ($.current = !1, N.current ? (N.current.value = null, N.current.click()) : q(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : q(fe);
      });
      return;
    }
    N.current && (re({
      type: "openDialog"
    }), G(), N.current.value = null, N.current.click());
  }, [re, G, V, v, ge, q, L, s]), at = se(function(J) {
    !O.current || !O.current.isEqualNode(J.target) || (J.key === " " || J.key === "Enter" || J.keyCode === 32 || J.keyCode === 13) && (J.preventDefault(), Z());
  }, [O, Z]), xt = se(function() {
    re({
      type: "focus"
    });
  }, []), Et = se(function() {
    re({
      type: "blur"
    });
  }, []), zr = se(function() {
    I || (YD() ? setTimeout(Z, 0) : Z());
  }, [I, Z]), Lt = function(fe) {
    return n ? null : fe;
  }, Wt = function(fe) {
    return b ? null : Lt(fe);
  }, Mt = function(fe) {
    return D ? null : Lt(fe);
  }, Re = function(fe) {
    x && fe.stopPropagation();
  }, Ut = Ve(function() {
    return function() {
      var J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fe = J.refKey, Ze = fe === void 0 ? "ref" : fe, it = J.role, ct = J.onKeyDown, hn = J.onFocus, $r = J.onBlur, uo = J.onClick, co = J.onDragEnter, ta = J.onDragOver, fo = J.onDragLeave, dr = J.onDrop, gn = ss(J, JD);
      return rt(rt(mu({
        onKeyDown: Wt(Sr(ct, at)),
        onFocus: Wt(Sr(hn, xt)),
        onBlur: Wt(Sr($r, Et)),
        onClick: Lt(Sr(uo, zr)),
        onDragEnter: Mt(Sr(co, ue)),
        onDragOver: Mt(Sr(ta, ie)),
        onDragLeave: Mt(Sr(fo, be)),
        onDrop: Mt(Sr(dr, Pe)),
        role: typeof it == "string" && it !== "" ? it : "presentation"
      }, Ze, O), !n && !b ? {
        tabIndex: 0
      } : {}), gn);
    };
  }, [O, at, xt, Et, zr, ue, ie, be, Pe, b, D, n]), Bt = se(function(J) {
    J.stopPropagation();
  }, []), Vt = Ve(function() {
    return function() {
      var J = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, fe = J.refKey, Ze = fe === void 0 ? "ref" : fe, it = J.onChange, ct = J.onClick, hn = ss(J, QD), $r = mu({
        accept: R,
        multiple: s,
        type: "file",
        style: {
          display: "none"
        },
        onChange: Lt(Sr(it, Pe)),
        onClick: Lt(Sr(ct, Bt)),
        tabIndex: -1
      }, Ze, N);
      return rt(rt({}, $r), hn);
    };
  }, [N, t, s, Pe, n]);
  return rt(rt({}, H), {}, {
    isFocused: W && !n,
    getRootProps: Ut,
    getInputProps: Vt,
    rootRef: O,
    inputRef: N,
    open: Lt(Z)
  });
}
function i_(e, r) {
  switch (r.type) {
    case "focus":
      return rt(rt({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return rt(rt({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return rt(rt({}, vu), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return rt(rt({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return rt(rt({}, e), {}, {
        isDragActive: r.isDragActive,
        isDragAccept: r.isDragAccept,
        isDragReject: r.isDragReject
      });
    case "setFiles":
      return rt(rt({}, e), {}, {
        acceptedFiles: r.acceptedFiles,
        fileRejections: r.fileRejections
      });
    case "reset":
      return rt({}, vu);
    default:
      return e;
  }
}
function If() {
}
const s_ = (e) => e ? Object.values(e).flat().map((t) => t.replace(".", "").toUpperCase()).join(", ") : "Todos los archivos", tF = A.memo(({ label: e, isRequired: r, isDisabled: t, accept: n, name: o, id: a, onChange: i, formValue: s, multiple: l, helperText: u, maxSizeMB: c = 10, fileCount: d }) => {
  const f = Zo(), [p, h] = A.useState(""), g = A.useCallback(
    (x) => {
      var _;
      h(l ? `${x.length} ${x.length === 1 ? "archivo" : "archivos"}` : ((_ = x[0]) == null ? void 0 : _.name) || ""), i && i(o, x);
    },
    [i, h, l, o]
  );
  A.useEffect(() => {
    s || h("");
  }, [s, h]), A.useEffect(() => {
    d !== void 0 && l && h(d === 0 ? "" : `${d} ${d === 1 ? "archivo" : "archivos"}`);
  }, [d, l]);
  const { getRootProps: m, getInputProps: v, isDragActive: y } = lc({
    onDrop: g,
    accept: n,
    disabled: t,
    multiple: l !== !1
  }), C = A.useMemo(() => t ? j.border : y ? j.tertiary[1] : j.border, [t, y]), I = A.useMemo(() => t ? j.neutro[1] : y ? j.tertiary[3] : "transparent", [t, y]), b = A.useMemo(() => s_(n), [n]), D = A.useMemo(
    () => t ? void 0 : {
      borderColor: j.tertiary[1],
      bg: j.tertiary[3]
    },
    [t]
  );
  return /* @__PURE__ */ K(
    je,
    {
      width: ao,
      maxH: "fit-content",
      mb: 2,
      children: [
        e && /* @__PURE__ */ K(
          gt,
          {
            width: "100%",
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            mb: 1,
            children: [
              e,
              " ",
              r ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ K(
          je,
          {
            ...m(),
            cursor: t ? "not-allowed" : "pointer",
            border: "2px dashed",
            borderColor: C,
            bg: I,
            rounded: Is.input,
            px: 3,
            py: 2,
            transition: "all 0.2s",
            _hover: D,
            children: [
              /* @__PURE__ */ S(
                "input",
                {
                  type: "file",
                  id: a,
                  name: o,
                  disabled: t,
                  ...v(),
                  style: { display: "none" }
                }
              ),
              p ? /* @__PURE__ */ K(
                Rt,
                {
                  align: "center",
                  gap: 2,
                  children: [
                    /* @__PURE__ */ S(
                      Bn,
                      {
                        as: sg,
                        color: j.neutralDark,
                        boxSize: "18px"
                      }
                    ),
                    /* @__PURE__ */ S(je, { flex: 1, children: /* @__PURE__ */ S(
                      gt,
                      {
                        fontSize: Xe.input,
                        fontWeight: 400,
                        noOfLines: 1,
                        title: p,
                        children: p
                      }
                    ) })
                  ]
                }
              ) : /* @__PURE__ */ K(
                Rt,
                {
                  direction: "row",
                  align: "center",
                  justify: "start",
                  gap: 3,
                  py: 1,
                  children: [
                    /* @__PURE__ */ S(
                      Bn,
                      {
                        as: ig,
                        boxSize: "20px",
                        color: t ? j.neutralDark : j.tertiary[1]
                      }
                    ),
                    /* @__PURE__ */ K(
                      je,
                      {
                        textAlign: "left",
                        flex: 1,
                        children: [
                          /* @__PURE__ */ S(
                            gt,
                            {
                              fontSize: Xe.input,
                              fontWeight: 400,
                              color: t ? j.neutralDark : j.text[2],
                              children: t ? f.fieldDisabled : f.dropFilesOrClick
                            }
                          ),
                          /* @__PURE__ */ K(
                            gt,
                            {
                              fontSize: "xs",
                              color: j.text[3],
                              children: [
                                b,
                                " • ",
                                f.maxFileSize(c)
                              ]
                            }
                          )
                        ]
                      }
                    )
                  ]
                }
              )
            ]
          }
        ),
        u && /* @__PURE__ */ S(
          gt,
          {
            fontSize: "xs",
            color: j.text[3],
            mt: 1,
            px: 1,
            children: u
          }
        )
      ]
    }
  );
});
var Qo = [["Afghanistan", "af", "93"], ["Albania", "al", "355"], ["Algeria", "dz", "213"], ["Andorra", "ad", "376"], ["Angola", "ao", "244"], ["Antigua and Barbuda", "ag", "1268"], ["Argentina", "ar", "54", "(..) ........", 0], ["Armenia", "am", "374", ".. ......"], ["Aruba", "aw", "297"], ["Australia", "au", "61", { default: ". .... ....", "/^4/": "... ... ...", "/^5(?!50)/": "... ... ...", "/^1(3|8)00/": ".... ... ...", "/^13/": ".. .. ..", "/^180/": "... ...." }, 0, []], ["Austria", "at", "43"], ["Azerbaijan", "az", "994", "(..) ... .. .."], ["Bahamas", "bs", "1242"], ["Bahrain", "bh", "973"], ["Bangladesh", "bd", "880"], ["Barbados", "bb", "1246"], ["Belarus", "by", "375", "(..) ... .. .."], ["Belgium", "be", "32", "... .. .. .."], ["Belize", "bz", "501"], ["Benin", "bj", "229"], ["Bhutan", "bt", "975"], ["Bolivia", "bo", "591"], ["Bosnia and Herzegovina", "ba", "387"], ["Botswana", "bw", "267"], ["Brazil", "br", "55", "(..) ........."], ["British Indian Ocean Territory", "io", "246"], ["Brunei", "bn", "673"], ["Bulgaria", "bg", "359"], ["Burkina Faso", "bf", "226"], ["Burundi", "bi", "257"], ["Cambodia", "kh", "855"], ["Cameroon", "cm", "237"], ["Canada", "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", "cv", "238"], ["Caribbean Netherlands", "bq", "599", "", 1], ["Cayman Islands", "ky", "1", "... ... ....", 4, ["345"]], ["Central African Republic", "cf", "236"], ["Chad", "td", "235"], ["Chile", "cl", "56"], ["China", "cn", "86", "... .... ...."], ["Colombia", "co", "57", "... ... ...."], ["Comoros", "km", "269"], ["Congo", "cd", "243"], ["Congo", "cg", "242"], ["Costa Rica", "cr", "506", "....-...."], ["Côte d'Ivoire", "ci", "225", ".. .. .. .. .."], ["Croatia", "hr", "385"], ["Cuba", "cu", "53"], ["Curaçao", "cw", "599", "", 0], ["Cyprus", "cy", "357", ".. ......"], ["Czech Republic", "cz", "420", "... ... ..."], ["Denmark", "dk", "45", ".. .. .. .."], ["Djibouti", "dj", "253"], ["Dominica", "dm", "1767"], ["Dominican Republic", "do", "1", "(...) ...-....", 2, ["809", "829", "849"]], ["Ecuador", "ec", "593"], ["Egypt", "eg", "20"], ["El Salvador", "sv", "503", "....-...."], ["Equatorial Guinea", "gq", "240"], ["Eritrea", "er", "291"], ["Estonia", "ee", "372", ".... ......"], ["Ethiopia", "et", "251"], ["Fiji", "fj", "679"], ["Finland", "fi", "358", ".. ... .. .."], ["France", "fr", "33", ". .. .. .. .."], ["French Guiana", "gf", "594"], ["French Polynesia", "pf", "689"], ["Gabon", "ga", "241"], ["Gambia", "gm", "220"], ["Georgia", "ge", "995"], ["Germany", "de", "49", "... ........."], ["Ghana", "gh", "233"], ["Greece", "gr", "30"], ["Greenland", "gl", "299", ".. .. .."], ["Grenada", "gd", "1473"], ["Guadeloupe", "gp", "590", "", 0], ["Guam", "gu", "1671"], ["Guatemala", "gt", "502", "....-...."], ["Guinea", "gn", "224"], ["Guinea-Bissau", "gw", "245"], ["Guyana", "gy", "592"], ["Haiti", "ht", "509", "....-...."], ["Honduras", "hn", "504"], ["Hong Kong", "hk", "852", ".... ...."], ["Hungary", "hu", "36"], ["Iceland", "is", "354", "... ...."], ["India", "in", "91", ".....-....."], ["Indonesia", "id", "62"], ["Iran", "ir", "98", "... ... ...."], ["Iraq", "iq", "964"], ["Ireland", "ie", "353", ".. ......."], ["Israel", "il", "972", "... ... ...."], ["Italy", "it", "39", "... .......", 0], ["Jamaica", "jm", "1876"], ["Japan", "jp", "81", ".. .... ...."], ["Jordan", "jo", "962"], ["Kazakhstan", "kz", "7", "... ...-..-..", 0], ["Kenya", "ke", "254"], ["Kiribati", "ki", "686"], ["Kosovo", "xk", "383"], ["Kuwait", "kw", "965"], ["Kyrgyzstan", "kg", "996", "... ... ..."], ["Laos", "la", "856"], ["Latvia", "lv", "371", ".. ... ..."], ["Lebanon", "lb", "961"], ["Lesotho", "ls", "266"], ["Liberia", "lr", "231"], ["Libya", "ly", "218"], ["Liechtenstein", "li", "423"], ["Lithuania", "lt", "370"], ["Luxembourg", "lu", "352"], ["Macau", "mo", "853"], ["Macedonia", "mk", "389"], ["Madagascar", "mg", "261"], ["Malawi", "mw", "265"], ["Malaysia", "my", "60", "..-....-...."], ["Maldives", "mv", "960"], ["Mali", "ml", "223"], ["Malta", "mt", "356"], ["Marshall Islands", "mh", "692"], ["Martinique", "mq", "596"], ["Mauritania", "mr", "222"], ["Mauritius", "mu", "230"], ["Mexico", "mx", "52", "... ... ....", 0], ["Micronesia", "fm", "691"], ["Moldova", "md", "373", "(..) ..-..-.."], ["Monaco", "mc", "377"], ["Mongolia", "mn", "976"], ["Montenegro", "me", "382"], ["Morocco", "ma", "212"], ["Mozambique", "mz", "258"], ["Myanmar", "mm", "95"], ["Namibia", "na", "264"], ["Nauru", "nr", "674"], ["Nepal", "np", "977"], ["Netherlands", "nl", "31", { "/^06/": "(.). .........", "/^6/": ". .........", "/^0(10|13|14|15|20|23|24|26|30|33|35|36|38|40|43|44|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|82|84|85|87|88|91)/": "(.).. ........", "/^(10|13|14|15|20|23|24|26|30|33|35|36|38|40|43|44|45|46|50|53|55|58|70|71|72|73|74|75|76|77|78|79|82|84|85|87|88|91)/": ".. ........", "/^0/": "(.)... .......", default: "... ......." }], ["New Caledonia", "nc", "687"], ["New Zealand", "nz", "64", "...-...-...."], ["Nicaragua", "ni", "505"], ["Niger", "ne", "227"], ["Nigeria", "ng", "234"], ["North Korea", "kp", "850"], ["Norway", "no", "47", "... .. ..."], ["Oman", "om", "968"], ["Pakistan", "pk", "92", "...-......."], ["Palau", "pw", "680"], ["Palestine", "ps", "970"], ["Panama", "pa", "507"], ["Papua New Guinea", "pg", "675"], ["Paraguay", "py", "595"], ["Peru", "pe", "51"], ["Philippines", "ph", "63", ".... ......."], ["Poland", "pl", "48", "...-...-..."], ["Portugal", "pt", "351"], ["Puerto Rico", "pr", "1", "(...) ...-....", 3, ["787", "939"]], ["Qatar", "qa", "974"], ["Réunion", "re", "262"], ["Romania", "ro", "40"], ["Russia", "ru", "7", "(...) ...-..-..", 1], ["Rwanda", "rw", "250"], ["Saint Kitts and Nevis", "kn", "1869"], ["Saint Lucia", "lc", "1758"], ["Saint Vincent and the Grenadines", "vc", "1784"], ["Samoa", "ws", "685"], ["San Marino", "sm", "378"], ["São Tomé and Príncipe", "st", "239"], ["Saudi Arabia", "sa", "966"], ["Senegal", "sn", "221"], ["Serbia", "rs", "381"], ["Seychelles", "sc", "248"], ["Sierra Leone", "sl", "232"], ["Singapore", "sg", "65", "....-...."], ["Slovakia", "sk", "421"], ["Slovenia", "si", "386"], ["Solomon Islands", "sb", "677"], ["Somalia", "so", "252"], ["South Africa", "za", "27"], ["South Korea", "kr", "82", "... .... ...."], ["South Sudan", "ss", "211"], ["Spain", "es", "34", "... ... ..."], ["Sri Lanka", "lk", "94"], ["Sudan", "sd", "249"], ["Suriname", "sr", "597"], ["Swaziland", "sz", "268"], ["Sweden", "se", "46", "... ... ..."], ["Switzerland", "ch", "41", ".. ... .. .."], ["Syria", "sy", "963"], ["Taiwan", "tw", "886"], ["Tajikistan", "tj", "992"], ["Tanzania", "tz", "255"], ["Thailand", "th", "66"], ["Timor-Leste", "tl", "670"], ["Togo", "tg", "228"], ["Tonga", "to", "676"], ["Trinidad and Tobago", "tt", "1868"], ["Tunisia", "tn", "216"], ["Turkey", "tr", "90", "... ... .. .."], ["Turkmenistan", "tm", "993"], ["Tuvalu", "tv", "688"], ["Uganda", "ug", "256"], ["Ukraine", "ua", "380", "(..) ... .. .."], ["United Arab Emirates", "ae", "971"], ["United Kingdom", "gb", "44", ".... ......"], ["United States", "us", "1", "(...) ...-....", 0], ["Uruguay", "uy", "598"], ["Uzbekistan", "uz", "998", ".. ... .. .."], ["Vanuatu", "vu", "678"], ["Vatican City", "va", "39", ".. .... ....", 1], ["Venezuela", "ve", "58"], ["Vietnam", "vn", "84"], ["Yemen", "ye", "967"], ["Zambia", "zm", "260"], ["Zimbabwe", "zw", "263"]], l_ = "react-international-phone-", wg = (...e) => e.filter((r) => !!r).join(" ").trim(), u_ = (...e) => wg(...e).split(" ").map((r) => `${l_}${r}`).join(" "), Dt = ({ addPrefix: e, rawClassNames: r }) => wg(u_(...e), ...r), c_ = ({ value: e, mask: r, maskSymbol: t, offset: n = 0, trimNonMaskCharsLeftover: o = !1 }) => {
  if (e.length < n) return e;
  let a = e.slice(0, n), i = e.slice(n), s = a, l = 0;
  for (let u of r.split("")) {
    if (l >= i.length) {
      if (!o && u !== t) {
        s += u;
        continue;
      }
      break;
    }
    u === t ? (s += i[l], l += 1) : s += u;
  }
  return s;
}, yo = (e) => e ? /^\d+$/.test(e) : !1, Ws = (e) => e.replace(/\D/g, ""), d_ = (e, r) => {
  let t = e.style.display;
  t !== "block" && (e.style.display = "block");
  let n = e.getBoundingClientRect(), o = r.getBoundingClientRect(), a = o.top - n.top, i = n.bottom - o.bottom;
  a >= 0 && i >= 0 || (Math.abs(a) < Math.abs(i) ? e.scrollTop += a : e.scrollTop -= i), e.style.display = t;
}, f_ = () => typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes("macintosh"), p_ = (e, r) => {
  let t = r.disableDialCodeAndPrefix ? !1 : r.forceDialCode, n = r.disableDialCodeAndPrefix ? !1 : r.insertDialCodeOnEmpty, o = e, a = (u) => r.trimNonDigitsEnd ? u.trim() : u;
  if (!o) return n && !o.length || t ? a(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`) : a(o);
  if (o = Ws(o), o === r.dialCode && !r.disableDialCodeAndPrefix) return a(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
  if (r.dialCode.startsWith(o) && !r.disableDialCodeAndPrefix) return a(t ? `${r.prefix}${r.dialCode}${r.charAfterDialCode}` : `${r.prefix}${o}`);
  if (!o.startsWith(r.dialCode) && !r.disableDialCodeAndPrefix) {
    if (t) return a(`${r.prefix}${r.dialCode}${r.charAfterDialCode}`);
    if (o.length < r.dialCode.length) return a(`${r.prefix}${o}`);
  }
  let i = () => {
    let u = r.dialCode.length, c = o.slice(0, u), d = o.slice(u);
    return { phoneLeftSide: c, phoneRightSide: d };
  }, { phoneLeftSide: s, phoneRightSide: l } = i();
  return s = `${r.prefix}${s}${r.charAfterDialCode}`, l = c_({ value: l, mask: r.mask, maskSymbol: r.maskChar, trimNonMaskCharsLeftover: r.trimNonDigitsEnd || r.disableDialCodeAndPrefix && l.length === 0 }), r.disableDialCodeAndPrefix && (s = ""), a(`${s}${l}`);
}, h_ = ({ phoneBeforeInput: e, phoneAfterInput: r, phoneAfterFormatted: t, cursorPositionAfterInput: n, leftOffset: o = 0, deletion: a }) => {
  if (n < o) return o;
  if (!e) return t.length;
  let i = null;
  for (let c = n - 1; c >= 0; c -= 1) if (yo(r[c])) {
    i = c;
    break;
  }
  if (i === null) {
    for (let c = 0; c < r.length; c += 1) if (yo(t[c])) return c;
    return r.length;
  }
  let s = 0;
  for (let c = 0; c < i; c += 1) yo(r[c]) && (s += 1);
  let l = 0, u = 0;
  for (let c = 0; c < t.length && (l += 1, yo(t[c]) && (u += 1), !(u >= s + 1)); c += 1) ;
  if (a !== "backward") for (; !yo(t[l]) && l < t.length; ) l += 1;
  return l;
}, Ri = ({ phone: e, prefix: r }) => e ? `${r}${Ws(e)}` : "";
function bu({ value: e, country: r, insertDialCodeOnEmpty: t, trimNonDigitsEnd: n, countries: o, prefix: a, charAfterDialCode: i, forceDialCode: s, disableDialCodeAndPrefix: l, defaultMask: u, countryGuessingEnabled: c, disableFormatting: d }) {
  let f = e;
  l && (f = f.startsWith(`${a}`) ? f : `${a}${r.dialCode}${f}`);
  let p = c ? x_({ phone: f, countries: o, currentCountryIso2: r == null ? void 0 : r.iso2 }) : void 0, h = (p == null ? void 0 : p.country) ?? r, g = p_(f, { prefix: a, mask: C_({ phone: f, country: h, defaultMask: u, disableFormatting: d }), maskChar: Cg, dialCode: h.dialCode, trimNonDigitsEnd: n, charAfterDialCode: i, forceDialCode: s, insertDialCodeOnEmpty: t, disableDialCodeAndPrefix: l }), m = c && !(p != null && p.fullDialCodeMatch) ? r : h;
  return { phone: Ri({ phone: l ? `${m.dialCode}${g}` : g, prefix: a }), inputValue: g, country: m };
}
var g_ = (e) => {
  if ((e == null ? void 0 : e.toLocaleLowerCase().includes("delete")) ?? !1) return e != null && e.toLocaleLowerCase().includes("forward") ? "forward" : "backward";
}, m_ = (e, { country: r, insertDialCodeOnEmpty: t, phoneBeforeInput: n, prefix: o, charAfterDialCode: a, forceDialCode: i, disableDialCodeAndPrefix: s, countryGuessingEnabled: l, defaultMask: u, disableFormatting: c, countries: d }) => {
  let f = e.nativeEvent, p = f.inputType, h = g_(p), g = !!(p != null && p.startsWith("insertFrom")), m = p === "insertText", v = (f == null ? void 0 : f.data) || void 0, y = e.target.value, C = e.target.selectionStart ?? 0;
  if (p != null && p.includes("history")) return { inputValue: n, phone: Ri({ phone: n, prefix: o }), cursorPosition: n.length, country: r };
  if (m && !yo(v) && y !== o) return { inputValue: n, phone: Ri({ phone: s ? `${r.dialCode}${n}` : n, prefix: o }), cursorPosition: C - ((v == null ? void 0 : v.length) ?? 0), country: r };
  if (i && !y.startsWith(`${o}${r.dialCode}`) && !g) {
    let _ = y ? n : `${o}${r.dialCode}${a}`;
    return { inputValue: _, phone: Ri({ phone: _, prefix: o }), cursorPosition: o.length + r.dialCode.length + a.length, country: r };
  }
  let { phone: I, inputValue: b, country: D } = bu({ value: y, country: r, trimNonDigitsEnd: h === "backward", insertDialCodeOnEmpty: t, countryGuessingEnabled: l, countries: d, prefix: o, charAfterDialCode: a, forceDialCode: i, disableDialCodeAndPrefix: s, disableFormatting: c, defaultMask: u }), x = h_({ cursorPositionAfterInput: C, phoneBeforeInput: n, phoneAfterInput: y, phoneAfterFormatted: b, leftOffset: i ? o.length + r.dialCode.length + a.length : 0, deletion: h });
  return { phone: I, inputValue: b, cursorPosition: x, country: D };
}, v_ = (e, r) => {
  let t = Object.keys(e), n = Object.keys(r);
  if (t.length !== n.length) return !1;
  for (let o of t) if (e[o] !== r[o]) return !1;
  return !0;
}, b_ = () => {
  let e = ye(), r = ye(Date.now());
  return { check: () => {
    let t = Date.now(), n = e.current ? t - r.current : void 0;
    return e.current = r.current, r.current = t, n;
  } };
}, y_ = { size: 20, overrideLastItemDebounceMS: -1 };
function w_(e, r) {
  let { size: t, overrideLastItemDebounceMS: n, onChange: o } = { ...y_, ...r }, [a, i] = Se(e), [s, l] = Se([a]), [u, c] = Se(0), d = b_();
  return [a, (f, p) => {
    if (typeof f == "object" && typeof a == "object" && v_(f, a) || f === a) return;
    let h = n > 0, g = d.check(), m = h && g !== void 0 ? g > n : !0;
    if ((p == null ? void 0 : p.overrideLastItem) !== void 0 ? p.overrideLastItem : !m) l((v) => [...v.slice(0, u), f]);
    else {
      let v = s.length >= t;
      l((y) => [...y.slice(v ? 1 : 0, u + 1), f]), v || c((y) => y + 1);
    }
    i(f), o == null || o(f);
  }, () => {
    if (u <= 0) return { success: !1 };
    let f = s[u - 1];
    return i(f), c((p) => p - 1), o == null || o(f), { success: !0, value: f };
  }, () => {
    if (u + 1 >= s.length) return { success: !1 };
    let f = s[u + 1];
    return i(f), c((p) => p + 1), o == null || o(f), { success: !0, value: f };
  }];
}
var Cg = ".", Qt = { defaultCountry: "us", value: "", prefix: "+", defaultMask: "............", charAfterDialCode: " ", historySaveDebounceMS: 200, disableCountryGuess: !1, disableDialCodePrefill: !1, forceDialCode: !1, disableDialCodeAndPrefix: !1, disableFormatting: !1, countries: Qo }, Sg = ({ defaultCountry: e = Qt.defaultCountry, value: r = Qt.value, countries: t = Qt.countries, prefix: n = Qt.prefix, defaultMask: o = Qt.defaultMask, charAfterDialCode: a = Qt.charAfterDialCode, historySaveDebounceMS: i = Qt.historySaveDebounceMS, disableCountryGuess: s = Qt.disableCountryGuess, disableDialCodePrefill: l = Qt.disableDialCodePrefill, forceDialCode: u = Qt.forceDialCode, disableDialCodeAndPrefix: c = Qt.disableDialCodeAndPrefix, disableFormatting: d = Qt.disableFormatting, onChange: f, inputRef: p }) => {
  let h = { countries: t, prefix: n, charAfterDialCode: a, forceDialCode: c ? !1 : u, disableDialCodeAndPrefix: c, defaultMask: o, countryGuessingEnabled: !s, disableFormatting: d }, g = ye(null), m = p || g, v = (O) => {
    Promise.resolve().then(() => {
      var N;
      typeof window > "u" || m.current !== (document == null ? void 0 : document.activeElement) || ((N = m.current) == null || N.setSelectionRange(O, O));
    });
  }, [{ phone: y, inputValue: C, country: I }, b, D, x] = w_(() => {
    let O = xo({ value: e, field: "iso2", countries: t });
    O || console.error(`[react-international-phone]: can not find a country with "${e}" iso2 code`);
    let N = O || xo({ value: "us", field: "iso2", countries: t }), { phone: P, inputValue: B, country: H } = bu({ value: r, country: N, insertDialCodeOnEmpty: !l, ...h });
    return v(B.length), { phone: P, inputValue: B, country: H.iso2 };
  }, { overrideLastItemDebounceMS: i, onChange: ({ inputValue: O, phone: N, country: P }) => {
    if (!f) return;
    let B = _(P);
    f({ phone: N, inputValue: O, country: B });
  } }), _ = se((O) => xo({ value: O, field: "iso2", countries: t }), [t]), E = Ve(() => _(I), [I, _]);
  Ye(() => {
    let O = m.current;
    if (!O) return;
    let N = (P) => {
      if (!P.key) return;
      let B = P.ctrlKey, H = P.metaKey, re = P.shiftKey;
      if (P.key.toLowerCase() === "z") {
        if (f_()) {
          if (!H) return;
        } else if (!B) return;
        re ? x() : D();
      }
    };
    return O.addEventListener("keydown", N), () => {
      O.removeEventListener("keydown", N);
    };
  }, [m, D, x]);
  let R = (O) => {
    O.preventDefault();
    let { phone: N, inputValue: P, country: B, cursorPosition: H } = m_(O, { country: E, phoneBeforeInput: C, insertDialCodeOnEmpty: !1, ...h });
    return b({ inputValue: P, phone: N, country: B.iso2 }), v(H), r;
  }, L = (O, N = { focusOnInput: !1 }) => {
    let P = xo({ value: O, field: "iso2", countries: t });
    if (!P) {
      console.error(`[react-international-phone]: can not find a country with "${O}" iso2 code`);
      return;
    }
    let B = c ? "" : `${n}${P.dialCode}${a}`;
    b({ inputValue: B, phone: `${n}${P.dialCode}`, country: P.iso2 }), N.focusOnInput && Promise.resolve().then(() => {
      var H;
      (H = m.current) == null || H.focus();
    });
  }, [G, V] = Se(!1);
  return Ye(() => {
    if (!G) {
      V(!0), r !== y && (f == null || f({ inputValue: C, phone: y, country: E }));
      return;
    }
    if (r === y) return;
    let { phone: O, inputValue: N, country: P } = bu({ value: r, country: E, insertDialCodeOnEmpty: !l, ...h });
    b({ phone: O, inputValue: N, country: P.iso2 });
  }, [r]), { phone: y, inputValue: C, country: E, setCountry: L, handlePhoneValueChange: R, inputRef: m };
}, C_ = ({ phone: e, country: r, defaultMask: t = "............", disableFormatting: n = !1 }) => {
  let o = r.format, a = (s) => n ? s.replace(new RegExp(`[^${Cg}]`, "g"), "") : s;
  if (!o) return a(t);
  if (typeof o == "string") return a(o);
  if (!o.default) return console.error(`[react-international-phone]: default mask for ${r.iso2} is not provided`), a(t);
  let i = Object.keys(o).find((s) => {
    if (s === "default") return !1;
    if (!(s.charAt(0) === "/" && s.charAt(s.length - 1) === "/")) return console.error(`[react-international-phone]: format regex "${s}" for ${r.iso2} is not valid`), !1;
    let l = new RegExp(s.substring(1, s.length - 1)), u = e.replace(r.dialCode, "");
    return l.test(Ws(u));
  });
  return a(i ? o[i] : o.default);
}, xr = (e) => {
  let [r, t, n, o, a, i] = e;
  return { name: r, iso2: t, dialCode: n, format: o, priority: a, areaCodes: i };
}, S_ = (e) => `Field "${e}" is not supported`, xo = ({ field: e, value: r, countries: t = Qo }) => {
  if (["priority"].includes(e)) throw new Error(S_(e));
  let n = t.find((o) => {
    let a = xr(o);
    return r === a[e];
  });
  if (n) return xr(n);
}, x_ = ({ phone: e, countries: r = Qo, currentCountryIso2: t }) => {
  var s;
  let n = { country: void 0, fullDialCodeMatch: !1 };
  if (!e) return n;
  let o = Ws(e);
  if (!o) return n;
  let a = n, i = ({ country: l, fullDialCodeMatch: u }) => {
    var f, p;
    let c = l.dialCode === ((f = a.country) == null ? void 0 : f.dialCode), d = (l.priority ?? 0) < (((p = a.country) == null ? void 0 : p.priority) ?? 0);
    (!c || d) && (a = { country: l, fullDialCodeMatch: u });
  };
  for (let l of r) {
    let u = xr(l), { dialCode: c, areaCodes: d } = u;
    if (o.startsWith(c)) {
      let f = a.country ? Number(c) >= Number(a.country.dialCode) : !0;
      if (d) {
        let p = o.substring(c.length);
        for (let h of d) if (p.startsWith(h)) return { country: u, fullDialCodeMatch: !0 };
      }
      (f || c === o || !a.fullDialCodeMatch) && i({ country: u, fullDialCodeMatch: !0 });
    }
    a.fullDialCodeMatch || o.length < c.length && c.startsWith(o) && (!a.country || Number(c) <= Number(a.country.dialCode)) && i({ country: u, fullDialCodeMatch: !1 });
  }
  if (t) {
    let l = xo({ value: t, field: "iso2", countries: r });
    if (!l) return a;
    let u = l ? ((c) => {
      if (!(c != null && c.areaCodes)) return !1;
      let d = o.substring(c.dialCode.length);
      return c.areaCodes.some((f) => f.startsWith(d));
    })(l) : !1;
    a && ((s = a.country) == null ? void 0 : s.dialCode) === l.dialCode && a.country !== l && a.fullDialCodeMatch && (!l.areaCodes || u) && (a = { country: l, fullDialCodeMatch: !0 });
  }
  return a;
}, I_ = (e, r) => {
  let t = parseInt(e, 16);
  return Number(t + r).toString(16);
}, D_ = "abcdefghijklmnopqrstuvwxyz", __ = "1f1e6", Df = D_.split("").reduce((e, r, t) => ({ ...e, [r]: I_(__, t) }), {}), k_ = (e) => [Df[e[0]], Df[e[1]]].join("-"), xg = ({ iso2: e, size: r, src: t, protocol: n = "https", disableLazyLoading: o, className: a, style: i, ...s }) => {
  if (!e) return A.createElement("img", { className: Dt({ addPrefix: ["flag-emoji"], rawClassNames: [a] }), width: r, height: r, ...s });
  let l = () => {
    if (t) return t;
    let u = k_(e);
    return `${n}://cdnjs.cloudflare.com/ajax/libs/twemoji/14.0.2/svg/${u}.svg`;
  };
  return A.createElement("img", { className: Dt({ addPrefix: ["flag-emoji"], rawClassNames: [a] }), src: l(), width: r, height: r, draggable: !1, "data-country": e, loading: o ? void 0 : "lazy", style: { width: r, height: r, ...i }, alt: "", ...s });
}, E_ = 1e3, M_ = ({ show: e, dialCodePrefix: r = "+", selectedCountry: t, countries: n = Qo, preferredCountries: o = [], flags: a, onSelect: i, onClose: s, ...l }) => {
  let u = ye(null), c = ye(), d = Ve(() => {
    if (!o || !o.length) return n;
    let D = [], x = [...n];
    for (let _ of o) {
      let E = x.findIndex((R) => xr(R).iso2 === _);
      if (E !== -1) {
        let R = x.splice(E, 1)[0];
        D.push(R);
      }
    }
    return D.concat(x);
  }, [n, o]), f = ye({ updatedAt: void 0, value: "" }), p = (D) => {
    let x = f.current.updatedAt && (/* @__PURE__ */ new Date()).getTime() - f.current.updatedAt.getTime() > E_;
    f.current = { value: x ? D : `${f.current.value}${D}`, updatedAt: /* @__PURE__ */ new Date() };
    let _ = d.findIndex((E) => xr(E).name.toLowerCase().startsWith(f.current.value));
    _ !== -1 && m(_);
  }, h = se((D) => d.findIndex((x) => xr(x).iso2 === D), [d]), [g, m] = Se(h(t)), v = () => {
    c.current !== t && m(h(t));
  }, y = se((D) => {
    m(h(D.iso2)), i == null || i(D);
  }, [i, h]), C = (D) => {
    let x = d.length - 1, _ = (E) => D === "prev" ? E - 1 : D === "next" ? E + 1 : D === "last" ? x : 0;
    m((E) => {
      let R = _(E);
      return R < 0 ? 0 : R > x ? x : R;
    });
  }, I = (D) => {
    if (D.stopPropagation(), D.key === "Enter") {
      D.preventDefault();
      let x = xr(d[g]);
      y(x);
      return;
    }
    if (D.key === "Escape") {
      s == null || s();
      return;
    }
    if (D.key === "ArrowUp") {
      D.preventDefault(), C("prev");
      return;
    }
    if (D.key === "ArrowDown") {
      D.preventDefault(), C("next");
      return;
    }
    if (D.key === "PageUp") {
      D.preventDefault(), C("first");
      return;
    }
    if (D.key === "PageDown") {
      D.preventDefault(), C("last");
      return;
    }
    D.key === " " && D.preventDefault(), D.key.length === 1 && !D.altKey && !D.ctrlKey && !D.metaKey && p(D.key.toLocaleLowerCase());
  }, b = se(() => {
    if (!u.current || g === void 0) return;
    let D = xr(d[g]).iso2;
    if (D === c.current) return;
    let x = u.current.querySelector(`[data-country="${D}"]`);
    x && (d_(u.current, x), c.current = D);
  }, [g, d]);
  return Ye(() => {
    b();
  }, [g, b]), Ye(() => {
    u.current && (e ? u.current.focus() : v());
  }, [e]), Ye(() => {
    v();
  }, [t]), A.createElement("ul", { ref: u, role: "listbox", className: Dt({ addPrefix: ["country-selector-dropdown"], rawClassNames: [l.className] }), style: { display: e ? "block" : "none", ...l.style }, onKeyDown: I, onBlur: s, tabIndex: -1, "aria-activedescendant": `react-international-phone__${xr(d[g]).iso2}-option` }, d.map((D, x) => {
    let _ = xr(D), E = _.iso2 === t, R = x === g, L = o.includes(_.iso2), G = x === o.length - 1, V = a == null ? void 0 : a.find((O) => O.iso2 === _.iso2);
    return A.createElement(A.Fragment, { key: _.iso2 }, A.createElement("li", { "data-country": _.iso2, role: "option", "aria-selected": E, "aria-label": `${_.name} ${r}${_.dialCode}`, id: `react-international-phone__${_.iso2}-option`, className: Dt({ addPrefix: ["country-selector-dropdown__list-item", L && "country-selector-dropdown__list-item--preferred", E && "country-selector-dropdown__list-item--selected", R && "country-selector-dropdown__list-item--focused"], rawClassNames: [l.listItemClassName] }), onClick: () => y(_), style: l.listItemStyle, title: _.name }, A.createElement(xg, { iso2: _.iso2, src: V == null ? void 0 : V.src, className: Dt({ addPrefix: ["country-selector-dropdown__list-item-flag-emoji"], rawClassNames: [l.listItemFlagClassName] }), style: l.listItemFlagStyle }), A.createElement("span", { className: Dt({ addPrefix: ["country-selector-dropdown__list-item-country-name"], rawClassNames: [l.listItemCountryNameClassName] }), style: l.listItemCountryNameStyle }, _.name), A.createElement("span", { className: Dt({ addPrefix: ["country-selector-dropdown__list-item-dial-code"], rawClassNames: [l.listItemDialCodeClassName] }), style: l.listItemDialCodeStyle }, r, _.dialCode)), G ? A.createElement("hr", { className: Dt({ addPrefix: ["country-selector-dropdown__preferred-list-divider"], rawClassNames: [l.preferredListDividerClassName] }), style: l.preferredListDividerStyle }) : null);
  }));
}, Ig = ({ selectedCountry: e, onSelect: r, disabled: t, hideDropdown: n, countries: o = Qo, preferredCountries: a = [], flags: i, renderButtonWrapper: s, ...l }) => {
  let [u, c] = Se(!1), d = Ve(() => {
    if (e) return xo({ value: e, field: "iso2", countries: o });
  }, [o, e]), f = ye(null), p = (g) => {
    g.key && ["ArrowUp", "ArrowDown"].includes(g.key) && (g.preventDefault(), c(!0));
  }, h = () => {
    var v;
    let g = { title: d == null ? void 0 : d.name, onClick: () => c((y) => !y), onMouseDown: (y) => y.preventDefault(), onKeyDown: p, disabled: n || t, role: "combobox", "aria-label": "Country selector", "aria-haspopup": "listbox", "aria-expanded": u }, m = A.createElement("div", { className: Dt({ addPrefix: ["country-selector-button__button-content"], rawClassNames: [l.buttonContentWrapperClassName] }), style: l.buttonContentWrapperStyle }, A.createElement(xg, { iso2: e, src: (v = i == null ? void 0 : i.find((y) => y.iso2 === e)) == null ? void 0 : v.src, className: Dt({ addPrefix: ["country-selector-button__flag-emoji", t && "country-selector-button__flag-emoji--disabled"], rawClassNames: [l.flagClassName] }), style: { visibility: e ? "visible" : "hidden", ...l.flagStyle } }), !n && A.createElement("div", { className: Dt({ addPrefix: ["country-selector-button__dropdown-arrow", t && "country-selector-button__dropdown-arrow--disabled", u && "country-selector-button__dropdown-arrow--active"], rawClassNames: [l.dropdownArrowClassName] }), style: l.dropdownArrowStyle }));
    return s ? s({ children: m, rootProps: g }) : A.createElement("button", { ...g, type: "button", className: Dt({ addPrefix: ["country-selector-button", u && "country-selector-button--active", t && "country-selector-button--disabled", n && "country-selector-button--hide-dropdown"], rawClassNames: [l.buttonClassName] }), "data-country": e, style: l.buttonStyle }, m);
  };
  return A.createElement("div", { className: Dt({ addPrefix: ["country-selector"], rawClassNames: [l.className] }), style: l.style, ref: f }, h(), A.createElement(M_, { show: u, countries: o, preferredCountries: a, flags: i, onSelect: (g) => {
    c(!1), r == null || r(g);
  }, selectedCountry: e, onClose: () => {
    c(!1);
  }, ...l.dropdownStyleProps }));
}, A_ = ({ dialCode: e, prefix: r, disabled: t, style: n, className: o }) => A.createElement("div", { className: Dt({ addPrefix: ["dial-code-preview", t && "dial-code-preview--disabled"], rawClassNames: [o] }), style: n }, `${r}${e}`);
ot(({ value: e, onChange: r, countries: t = Qo, preferredCountries: n = [], hideDropdown: o, showDisabledDialCodeAndPrefix: a, disableFocusAfterCountrySelect: i, flags: s, style: l, className: u, inputStyle: c, inputClassName: d, countrySelectorStyleProps: f, dialCodePreviewStyleProps: p, inputProps: h, placeholder: g, disabled: m, name: v, onFocus: y, onBlur: C, required: I, autoFocus: b, ...D }, x) => {
  let { phone: _, inputValue: E, inputRef: R, country: L, setCountry: G, handlePhoneValueChange: V } = Sg({ value: e, countries: t, ...D, onChange: (N) => {
    r == null || r(N.phone, { country: N.country, inputValue: N.inputValue });
  } }), O = D.disableDialCodeAndPrefix && a && (L == null ? void 0 : L.dialCode);
  return wp(x, () => R.current ? Object.assign(R.current, { setCountry: G, state: { phone: _, inputValue: E, country: L } }) : null, [R, G, _, E, L]), A.createElement("div", { ref: x, className: Dt({ addPrefix: ["input-container"], rawClassNames: [u] }), style: l }, A.createElement(Ig, { onSelect: (N) => G(N.iso2, { focusOnInput: !i }), flags: s, selectedCountry: L.iso2, countries: t, preferredCountries: n, disabled: m, hideDropdown: o, ...f }), O && A.createElement(A_, { dialCode: L.dialCode, prefix: D.prefix ?? "+", disabled: m, ...p }), A.createElement("input", { onChange: V, value: E, type: "tel", ref: R, className: Dt({ addPrefix: ["input", m && "input--disabled"], rawClassNames: [d] }), placeholder: g, disabled: m, style: c, name: v, onFocus: y, onBlur: C, autoFocus: b, required: I, ...h }));
});
const rF = ({ placeholder: e, addClass: r, name: t, helperText: n, label: o, id: a, isDisabled: i, onChange: s, isInvalid: l = !1, value: u, onFocus: c, onBlur: d, isReadOnly: f, isRequired: p }) => {
  const h = Sg({
    defaultCountry: "mx",
    value: u,
    onChange: (g) => {
      s(g.phone);
    }
  });
  return /* @__PURE__ */ K(
    to,
    {
      zIndex: "sticky",
      width: ao,
      minH: nr.inputContainerHeight,
      id: a,
      isDisabled: i,
      isInvalid: l,
      children: [
        /* @__PURE__ */ K(
          ro,
          {
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            children: [
              o,
              " ",
              p ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ S(
          no,
          {
            zIndex: "sticky",
            width: "100%",
            flexGrow: 1,
            children: /* @__PURE__ */ K(
              Rt,
              {
                w: "100%",
                alignItems: "center",
                position: "relative",
                zIndex: "sticky",
                children: [
                  /* @__PURE__ */ S(
                    Ig,
                    {
                      selectedCountry: h.country.iso2,
                      onSelect: (g) => h.setCountry(g.iso2),
                      renderButtonWrapper: ({ children: g, rootProps: m }) => /* @__PURE__ */ S(
                        Pt,
                        {
                          ...m,
                          variant: "outline",
                          px: "10px",
                          mr: "8px",
                          children: g
                        }
                      )
                    }
                  ),
                  /* @__PURE__ */ S(
                    Ha,
                    {
                      height: tr,
                      width: "100%",
                      flexGrow: 1,
                      name: t,
                      type: "tel",
                      color: "primary",
                      value: h.inputValue,
                      onChange: h.handlePhoneValueChange,
                      ref: h.inputRef,
                      errorBorderColor: Yt.error.border,
                      focusBorderColor: Yt.default.focus.border,
                      className: r,
                      isInvalid: l,
                      onBlur: d,
                      onFocus: c,
                      placeholder: e,
                      isReadOnly: f
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: n })
      ]
    }
  );
};
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Dg;
function Q() {
  return Dg.apply(null, arguments);
}
function P_(e) {
  Dg = e;
}
function gr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function $n(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function Me(e, r) {
  return Object.prototype.hasOwnProperty.call(e, r);
}
function uc(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var r;
  for (r in e)
    if (Me(e, r))
      return !1;
  return !0;
}
function Tt(e) {
  return e === void 0;
}
function un(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function qa(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function _g(e, r) {
  var t = [], n, o = e.length;
  for (n = 0; n < o; ++n)
    t.push(r(e[n], n));
  return t;
}
function wn(e, r) {
  for (var t in r)
    Me(r, t) && (e[t] = r[t]);
  return Me(r, "toString") && (e.toString = r.toString), Me(r, "valueOf") && (e.valueOf = r.valueOf), e;
}
function Yr(e, r, t, n) {
  return Ug(e, r, t, n, !0).utc();
}
function R_() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function we(e) {
  return e._pf == null && (e._pf = R_()), e._pf;
}
var yu;
Array.prototype.some ? yu = Array.prototype.some : yu = function(e) {
  var r = Object(this), t = r.length >>> 0, n;
  for (n = 0; n < t; n++)
    if (n in r && e.call(this, r[n], n, r))
      return !0;
  return !1;
};
function cc(e) {
  var r = null, t = !1, n = e._d && !isNaN(e._d.getTime());
  if (n && (r = we(e), t = yu.call(r.parsedDateParts, function(o) {
    return o != null;
  }), n = r.overflow < 0 && !r.empty && !r.invalidEra && !r.invalidMonth && !r.invalidWeekday && !r.weekdayMismatch && !r.nullInput && !r.invalidFormat && !r.userInvalidated && (!r.meridiem || r.meridiem && t), e._strict && (n = n && r.charsLeftOver === 0 && r.unusedTokens.length === 0 && r.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = n;
  else
    return n;
  return e._isValid;
}
function Bs(e) {
  var r = Yr(NaN);
  return e != null ? wn(we(r), e) : we(r).userInvalidated = !0, r;
}
var _f = Q.momentProperties = [], Rl = !1;
function dc(e, r) {
  var t, n, o, a = _f.length;
  if (Tt(r._isAMomentObject) || (e._isAMomentObject = r._isAMomentObject), Tt(r._i) || (e._i = r._i), Tt(r._f) || (e._f = r._f), Tt(r._l) || (e._l = r._l), Tt(r._strict) || (e._strict = r._strict), Tt(r._tzm) || (e._tzm = r._tzm), Tt(r._isUTC) || (e._isUTC = r._isUTC), Tt(r._offset) || (e._offset = r._offset), Tt(r._pf) || (e._pf = we(r)), Tt(r._locale) || (e._locale = r._locale), a > 0)
    for (t = 0; t < a; t++)
      n = _f[t], o = r[n], Tt(o) || (e[n] = o);
  return e;
}
function Ka(e) {
  dc(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Rl === !1 && (Rl = !0, Q.updateOffset(this), Rl = !1);
}
function mr(e) {
  return e instanceof Ka || e != null && e._isAMomentObject != null;
}
function kg(e) {
  Q.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function ur(e, r) {
  var t = !0;
  return wn(function() {
    if (Q.deprecationHandler != null && Q.deprecationHandler(null, e), t) {
      var n = [], o, a, i, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (i in arguments[0])
            Me(arguments[0], i) && (o += i + ": " + arguments[0][i] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        n.push(o);
      }
      kg(
        e + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), t = !1;
    }
    return r.apply(this, arguments);
  }, r);
}
var kf = {};
function Eg(e, r) {
  Q.deprecationHandler != null && Q.deprecationHandler(e, r), kf[e] || (kg(r), kf[e] = !0);
}
Q.suppressDeprecationWarnings = !1;
Q.deprecationHandler = null;
function Hr(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function O_(e) {
  var r, t;
  for (t in e)
    Me(e, t) && (r = e[t], Hr(r) ? this[t] = r : this["_" + t] = r);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function wu(e, r) {
  var t = wn({}, e), n;
  for (n in r)
    Me(r, n) && ($n(e[n]) && $n(r[n]) ? (t[n] = {}, wn(t[n], e[n]), wn(t[n], r[n])) : r[n] != null ? t[n] = r[n] : delete t[n]);
  for (n in e)
    Me(e, n) && !Me(r, n) && $n(e[n]) && (t[n] = wn({}, t[n]));
  return t;
}
function fc(e) {
  e != null && this.set(e);
}
var Cu;
Object.keys ? Cu = Object.keys : Cu = function(e) {
  var r, t = [];
  for (r in e)
    Me(e, r) && t.push(r);
  return t;
};
var T_ = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function F_(e, r, t) {
  var n = this._calendar[e] || this._calendar.sameElse;
  return Hr(n) ? n.call(r, t) : n;
}
function Br(e, r, t) {
  var n = "" + Math.abs(e), o = r - n.length, a = e >= 0;
  return (a ? t ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + n;
}
var pc = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, vi = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Ol = {}, ko = {};
function de(e, r, t, n) {
  var o = n;
  typeof n == "string" && (o = function() {
    return this[n]();
  }), e && (ko[e] = o), r && (ko[r[0]] = function() {
    return Br(o.apply(this, arguments), r[1], r[2]);
  }), t && (ko[t] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function N_(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function L_(e) {
  var r = e.match(pc), t, n;
  for (t = 0, n = r.length; t < n; t++)
    ko[r[t]] ? r[t] = ko[r[t]] : r[t] = N_(r[t]);
  return function(o) {
    var a = "", i;
    for (i = 0; i < n; i++)
      a += Hr(r[i]) ? r[i].call(o, e) : r[i];
    return a;
  };
}
function Oi(e, r) {
  return e.isValid() ? (r = Mg(r, e.localeData()), Ol[r] = Ol[r] || L_(r), Ol[r](e)) : e.localeData().invalidDate();
}
function Mg(e, r) {
  var t = 5;
  function n(o) {
    return r.longDateFormat(o) || o;
  }
  for (vi.lastIndex = 0; t >= 0 && vi.test(e); )
    e = e.replace(
      vi,
      n
    ), vi.lastIndex = 0, t -= 1;
  return e;
}
var W_ = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function B_(e) {
  var r = this._longDateFormat[e], t = this._longDateFormat[e.toUpperCase()];
  return r || !t ? r : (this._longDateFormat[e] = t.match(pc).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[e]);
}
var V_ = "Invalid date";
function G_() {
  return this._invalidDate;
}
var Y_ = "%d", H_ = /\d{1,2}/;
function z_(e) {
  return this._ordinal.replace("%d", e);
}
var $_ = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function X_(e, r, t, n) {
  var o = this._relativeTime[t];
  return Hr(o) ? o(e, r, t, n) : o.replace(/%d/i, e);
}
function j_(e, r) {
  var t = this._relativeTime[e > 0 ? "future" : "past"];
  return Hr(t) ? t(r) : t.replace(/%s/i, r);
}
var Ef = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function cr(e) {
  return typeof e == "string" ? Ef[e] || Ef[e.toLowerCase()] : void 0;
}
function hc(e) {
  var r = {}, t, n;
  for (n in e)
    Me(e, n) && (t = cr(n), t && (r[t] = e[n]));
  return r;
}
var Z_ = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function U_(e) {
  var r = [], t;
  for (t in e)
    Me(e, t) && r.push({ unit: t, priority: Z_[t] });
  return r.sort(function(n, o) {
    return n.priority - o.priority;
  }), r;
}
var Ag = /\d/, Zt = /\d\d/, Pg = /\d{3}/, gc = /\d{4}/, Vs = /[+-]?\d{6}/, qe = /\d\d?/, Rg = /\d\d\d\d?/, Og = /\d\d\d\d\d\d?/, Gs = /\d{1,3}/, mc = /\d{1,4}/, Ys = /[+-]?\d{1,6}/, qo = /\d+/, Hs = /[+-]?\d+/, J_ = /Z|[+-]\d\d:?\d\d/gi, zs = /Z|[+-]\d\d(?::?\d\d)?/gi, Q_ = /[+-]?\d+(\.\d{1,3})?/, ei = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, Ko = /^[1-9]\d?/, vc = /^([1-9]\d|\d)/, ls;
ls = {};
function ae(e, r, t) {
  ls[e] = Hr(r) ? r : function(n, o) {
    return n && t ? t : r;
  };
}
function q_(e, r) {
  return Me(ls, e) ? ls[e](r._strict, r._locale) : new RegExp(K_(e));
}
function K_(e) {
  return rn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(r, t, n, o, a) {
        return t || n || o || a;
      }
    )
  );
}
function rn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function er(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function xe(e) {
  var r = +e, t = 0;
  return r !== 0 && isFinite(r) && (t = er(r)), t;
}
var Su = {};
function He(e, r) {
  var t, n = r, o;
  for (typeof e == "string" && (e = [e]), un(r) && (n = function(a, i) {
    i[r] = xe(a);
  }), o = e.length, t = 0; t < o; t++)
    Su[e[t]] = n;
}
function ti(e, r) {
  He(e, function(t, n, o, a) {
    o._w = o._w || {}, r(t, o._w, o, a);
  });
}
function ek(e, r, t) {
  r != null && Me(Su, e) && Su[e](r, t._a, t, e);
}
function $s(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var kt = 0, Kr = 1, Er = 2, vt = 3, pr = 4, en = 5, Gn = 6, tk = 7, rk = 8;
de("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? Br(e, 4) : "+" + e;
});
de(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
de(0, ["YYYY", 4], 0, "year");
de(0, ["YYYYY", 5], 0, "year");
de(0, ["YYYYYY", 6, !0], 0, "year");
ae("Y", Hs);
ae("YY", qe, Zt);
ae("YYYY", mc, gc);
ae("YYYYY", Ys, Vs);
ae("YYYYYY", Ys, Vs);
He(["YYYYY", "YYYYYY"], kt);
He("YYYY", function(e, r) {
  r[kt] = e.length === 2 ? Q.parseTwoDigitYear(e) : xe(e);
});
He("YY", function(e, r) {
  r[kt] = Q.parseTwoDigitYear(e);
});
He("Y", function(e, r) {
  r[kt] = parseInt(e, 10);
});
function Da(e) {
  return $s(e) ? 366 : 365;
}
Q.parseTwoDigitYear = function(e) {
  return xe(e) + (xe(e) > 68 ? 1900 : 2e3);
};
var Tg = ea("FullYear", !0);
function nk() {
  return $s(this.year());
}
function ea(e, r) {
  return function(t) {
    return t != null ? (Fg(this, e, t), Q.updateOffset(this, r), this) : Oa(this, e);
  };
}
function Oa(e, r) {
  if (!e.isValid())
    return NaN;
  var t = e._d, n = e._isUTC;
  switch (r) {
    case "Milliseconds":
      return n ? t.getUTCMilliseconds() : t.getMilliseconds();
    case "Seconds":
      return n ? t.getUTCSeconds() : t.getSeconds();
    case "Minutes":
      return n ? t.getUTCMinutes() : t.getMinutes();
    case "Hours":
      return n ? t.getUTCHours() : t.getHours();
    case "Date":
      return n ? t.getUTCDate() : t.getDate();
    case "Day":
      return n ? t.getUTCDay() : t.getDay();
    case "Month":
      return n ? t.getUTCMonth() : t.getMonth();
    case "FullYear":
      return n ? t.getUTCFullYear() : t.getFullYear();
    default:
      return NaN;
  }
}
function Fg(e, r, t) {
  var n, o, a, i, s;
  if (!(!e.isValid() || isNaN(t))) {
    switch (n = e._d, o = e._isUTC, r) {
      case "Milliseconds":
        return void (o ? n.setUTCMilliseconds(t) : n.setMilliseconds(t));
      case "Seconds":
        return void (o ? n.setUTCSeconds(t) : n.setSeconds(t));
      case "Minutes":
        return void (o ? n.setUTCMinutes(t) : n.setMinutes(t));
      case "Hours":
        return void (o ? n.setUTCHours(t) : n.setHours(t));
      case "Date":
        return void (o ? n.setUTCDate(t) : n.setDate(t));
      case "FullYear":
        break;
      default:
        return;
    }
    a = t, i = e.month(), s = e.date(), s = s === 29 && i === 1 && !$s(a) ? 28 : s, o ? n.setUTCFullYear(a, i, s) : n.setFullYear(a, i, s);
  }
}
function ok(e) {
  return e = cr(e), Hr(this[e]) ? this[e]() : this;
}
function ak(e, r) {
  if (typeof e == "object") {
    e = hc(e);
    var t = U_(e), n, o = t.length;
    for (n = 0; n < o; n++)
      this[t[n].unit](e[t[n].unit]);
  } else if (e = cr(e), Hr(this[e]))
    return this[e](r);
  return this;
}
function ik(e, r) {
  return (e % r + r) % r;
}
var dt;
Array.prototype.indexOf ? dt = Array.prototype.indexOf : dt = function(e) {
  var r;
  for (r = 0; r < this.length; ++r)
    if (this[r] === e)
      return r;
  return -1;
};
function bc(e, r) {
  if (isNaN(e) || isNaN(r))
    return NaN;
  var t = ik(r, 12);
  return e += (r - t) / 12, t === 1 ? $s(e) ? 29 : 28 : 31 - t % 7 % 2;
}
de("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
de("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
de("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
ae("M", qe, Ko);
ae("MM", qe, Zt);
ae("MMM", function(e, r) {
  return r.monthsShortRegex(e);
});
ae("MMMM", function(e, r) {
  return r.monthsRegex(e);
});
He(["M", "MM"], function(e, r) {
  r[Kr] = xe(e) - 1;
});
He(["MMM", "MMMM"], function(e, r, t, n) {
  var o = t._locale.monthsParse(e, n, t._strict);
  o != null ? r[Kr] = o : we(t).invalidMonth = e;
});
var sk = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Ng = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Lg = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, lk = ei, uk = ei;
function ck(e, r) {
  return e ? gr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Lg).test(r) ? "format" : "standalone"][e.month()] : gr(this._months) ? this._months : this._months.standalone;
}
function dk(e, r) {
  return e ? gr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Lg.test(r) ? "format" : "standalone"][e.month()] : gr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function fk(e, r, t) {
  var n, o, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      a = Yr([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(a, "").toLocaleLowerCase();
  return t ? r === "MMM" ? (o = dt.call(this._shortMonthsParse, i), o !== -1 ? o : null) : (o = dt.call(this._longMonthsParse, i), o !== -1 ? o : null) : r === "MMM" ? (o = dt.call(this._shortMonthsParse, i), o !== -1 ? o : (o = dt.call(this._longMonthsParse, i), o !== -1 ? o : null)) : (o = dt.call(this._longMonthsParse, i), o !== -1 ? o : (o = dt.call(this._shortMonthsParse, i), o !== -1 ? o : null));
}
function pk(e, r, t) {
  var n, o, a;
  if (this._monthsParseExact)
    return fk.call(this, e, r, t);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (o = Yr([2e3, n]), t && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !t && !this._monthsParse[n] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[n] = new RegExp(a.replace(".", ""), "i")), t && r === "MMMM" && this._longMonthsParse[n].test(e))
      return n;
    if (t && r === "MMM" && this._shortMonthsParse[n].test(e))
      return n;
    if (!t && this._monthsParse[n].test(e))
      return n;
  }
}
function Wg(e, r) {
  if (!e.isValid())
    return e;
  if (typeof r == "string") {
    if (/^\d+$/.test(r))
      r = xe(r);
    else if (r = e.localeData().monthsParse(r), !un(r))
      return e;
  }
  var t = r, n = e.date();
  return n = n < 29 ? n : Math.min(n, bc(e.year(), t)), e._isUTC ? e._d.setUTCMonth(t, n) : e._d.setMonth(t, n), e;
}
function Bg(e) {
  return e != null ? (Wg(this, e), Q.updateOffset(this, !0), this) : Oa(this, "Month");
}
function hk() {
  return bc(this.year(), this.month());
}
function gk(e) {
  return this._monthsParseExact ? (Me(this, "_monthsRegex") || Vg.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (Me(this, "_monthsShortRegex") || (this._monthsShortRegex = lk), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function mk(e) {
  return this._monthsParseExact ? (Me(this, "_monthsRegex") || Vg.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (Me(this, "_monthsRegex") || (this._monthsRegex = uk), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Vg() {
  function e(l, u) {
    return u.length - l.length;
  }
  var r = [], t = [], n = [], o, a, i, s;
  for (o = 0; o < 12; o++)
    a = Yr([2e3, o]), i = rn(this.monthsShort(a, "")), s = rn(this.months(a, "")), r.push(i), t.push(s), n.push(s), n.push(i);
  r.sort(e), t.sort(e), n.sort(e), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function vk(e, r, t, n, o, a, i) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, r, t, n, o, a, i), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, r, t, n, o, a, i), s;
}
function Ta(e) {
  var r, t;
  return e < 100 && e >= 0 ? (t = Array.prototype.slice.call(arguments), t[0] = e + 400, r = new Date(Date.UTC.apply(null, t)), isFinite(r.getUTCFullYear()) && r.setUTCFullYear(e)) : r = new Date(Date.UTC.apply(null, arguments)), r;
}
function us(e, r, t) {
  var n = 7 + r - t, o = (7 + Ta(e, 0, n).getUTCDay() - r) % 7;
  return -o + n - 1;
}
function Gg(e, r, t, n, o) {
  var a = (7 + t - n) % 7, i = us(e, n, o), s = 1 + 7 * (r - 1) + a + i, l, u;
  return s <= 0 ? (l = e - 1, u = Da(l) + s) : s > Da(e) ? (l = e + 1, u = s - Da(e)) : (l = e, u = s), {
    year: l,
    dayOfYear: u
  };
}
function Fa(e, r, t) {
  var n = us(e.year(), r, t), o = Math.floor((e.dayOfYear() - n - 1) / 7) + 1, a, i;
  return o < 1 ? (i = e.year() - 1, a = o + nn(i, r, t)) : o > nn(e.year(), r, t) ? (a = o - nn(e.year(), r, t), i = e.year() + 1) : (i = e.year(), a = o), {
    week: a,
    year: i
  };
}
function nn(e, r, t) {
  var n = us(e, r, t), o = us(e + 1, r, t);
  return (Da(e) - n + o) / 7;
}
de("w", ["ww", 2], "wo", "week");
de("W", ["WW", 2], "Wo", "isoWeek");
ae("w", qe, Ko);
ae("ww", qe, Zt);
ae("W", qe, Ko);
ae("WW", qe, Zt);
ti(
  ["w", "ww", "W", "WW"],
  function(e, r, t, n) {
    r[n.substr(0, 1)] = xe(e);
  }
);
function bk(e) {
  return Fa(e, this._week.dow, this._week.doy).week;
}
var yk = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function wk() {
  return this._week.dow;
}
function Ck() {
  return this._week.doy;
}
function Sk(e) {
  var r = this.localeData().week(this);
  return e == null ? r : this.add((e - r) * 7, "d");
}
function xk(e) {
  var r = Fa(this, 1, 4).week;
  return e == null ? r : this.add((e - r) * 7, "d");
}
de("d", 0, "do", "day");
de("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
de("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
de("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
de("e", 0, 0, "weekday");
de("E", 0, 0, "isoWeekday");
ae("d", qe);
ae("e", qe);
ae("E", qe);
ae("dd", function(e, r) {
  return r.weekdaysMinRegex(e);
});
ae("ddd", function(e, r) {
  return r.weekdaysShortRegex(e);
});
ae("dddd", function(e, r) {
  return r.weekdaysRegex(e);
});
ti(["dd", "ddd", "dddd"], function(e, r, t, n) {
  var o = t._locale.weekdaysParse(e, n, t._strict);
  o != null ? r.d = o : we(t).invalidWeekday = e;
});
ti(["d", "e", "E"], function(e, r, t, n) {
  r[n] = xe(e);
});
function Ik(e, r) {
  return typeof e != "string" ? e : isNaN(e) ? (e = r.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Dk(e, r) {
  return typeof e == "string" ? r.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function yc(e, r) {
  return e.slice(r, 7).concat(e.slice(0, r));
}
var _k = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), Yg = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), kk = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), Ek = ei, Mk = ei, Ak = ei;
function Pk(e, r) {
  var t = gr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(r) ? "format" : "standalone"];
  return e === !0 ? yc(t, this._week.dow) : e ? t[e.day()] : t;
}
function Rk(e) {
  return e === !0 ? yc(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Ok(e) {
  return e === !0 ? yc(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function Tk(e, r, t) {
  var n, o, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      a = Yr([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(a, "").toLocaleLowerCase();
  return t ? r === "dddd" ? (o = dt.call(this._weekdaysParse, i), o !== -1 ? o : null) : r === "ddd" ? (o = dt.call(this._shortWeekdaysParse, i), o !== -1 ? o : null) : (o = dt.call(this._minWeekdaysParse, i), o !== -1 ? o : null) : r === "dddd" ? (o = dt.call(this._weekdaysParse, i), o !== -1 || (o = dt.call(this._shortWeekdaysParse, i), o !== -1) ? o : (o = dt.call(this._minWeekdaysParse, i), o !== -1 ? o : null)) : r === "ddd" ? (o = dt.call(this._shortWeekdaysParse, i), o !== -1 || (o = dt.call(this._weekdaysParse, i), o !== -1) ? o : (o = dt.call(this._minWeekdaysParse, i), o !== -1 ? o : null)) : (o = dt.call(this._minWeekdaysParse, i), o !== -1 || (o = dt.call(this._weekdaysParse, i), o !== -1) ? o : (o = dt.call(this._shortWeekdaysParse, i), o !== -1 ? o : null));
}
function Fk(e, r, t) {
  var n, o, a;
  if (this._weekdaysParseExact)
    return Tk.call(this, e, r, t);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (o = Yr([2e3, 1]).day(n), t && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[n] = new RegExp(a.replace(".", ""), "i")), t && r === "dddd" && this._fullWeekdaysParse[n].test(e))
      return n;
    if (t && r === "ddd" && this._shortWeekdaysParse[n].test(e))
      return n;
    if (t && r === "dd" && this._minWeekdaysParse[n].test(e))
      return n;
    if (!t && this._weekdaysParse[n].test(e))
      return n;
  }
}
function Nk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = Oa(this, "Day");
  return e != null ? (e = Ik(e, this.localeData()), this.add(e - r, "d")) : r;
}
function Lk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var r = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? r : this.add(e - r, "d");
}
function Wk(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var r = Dk(e, this.localeData());
    return this.day(this.day() % 7 ? r : r - 7);
  } else
    return this.day() || 7;
}
function Bk(e) {
  return this._weekdaysParseExact ? (Me(this, "_weekdaysRegex") || wc.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (Me(this, "_weekdaysRegex") || (this._weekdaysRegex = Ek), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Vk(e) {
  return this._weekdaysParseExact ? (Me(this, "_weekdaysRegex") || wc.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (Me(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Mk), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Gk(e) {
  return this._weekdaysParseExact ? (Me(this, "_weekdaysRegex") || wc.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (Me(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Ak), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function wc() {
  function e(c, d) {
    return d.length - c.length;
  }
  var r = [], t = [], n = [], o = [], a, i, s, l, u;
  for (a = 0; a < 7; a++)
    i = Yr([2e3, 1]).day(a), s = rn(this.weekdaysMin(i, "")), l = rn(this.weekdaysShort(i, "")), u = rn(this.weekdays(i, "")), r.push(s), t.push(l), n.push(u), o.push(s), o.push(l), o.push(u);
  r.sort(e), t.sort(e), n.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
function Cc() {
  return this.hours() % 12 || 12;
}
function Yk() {
  return this.hours() || 24;
}
de("H", ["HH", 2], 0, "hour");
de("h", ["hh", 2], 0, Cc);
de("k", ["kk", 2], 0, Yk);
de("hmm", 0, 0, function() {
  return "" + Cc.apply(this) + Br(this.minutes(), 2);
});
de("hmmss", 0, 0, function() {
  return "" + Cc.apply(this) + Br(this.minutes(), 2) + Br(this.seconds(), 2);
});
de("Hmm", 0, 0, function() {
  return "" + this.hours() + Br(this.minutes(), 2);
});
de("Hmmss", 0, 0, function() {
  return "" + this.hours() + Br(this.minutes(), 2) + Br(this.seconds(), 2);
});
function Hg(e, r) {
  de(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      r
    );
  });
}
Hg("a", !0);
Hg("A", !1);
function zg(e, r) {
  return r._meridiemParse;
}
ae("a", zg);
ae("A", zg);
ae("H", qe, vc);
ae("h", qe, Ko);
ae("k", qe, Ko);
ae("HH", qe, Zt);
ae("hh", qe, Zt);
ae("kk", qe, Zt);
ae("hmm", Rg);
ae("hmmss", Og);
ae("Hmm", Rg);
ae("Hmmss", Og);
He(["H", "HH"], vt);
He(["k", "kk"], function(e, r, t) {
  var n = xe(e);
  r[vt] = n === 24 ? 0 : n;
});
He(["a", "A"], function(e, r, t) {
  t._isPm = t._locale.isPM(e), t._meridiem = e;
});
He(["h", "hh"], function(e, r, t) {
  r[vt] = xe(e), we(t).bigHour = !0;
});
He("hmm", function(e, r, t) {
  var n = e.length - 2;
  r[vt] = xe(e.substr(0, n)), r[pr] = xe(e.substr(n)), we(t).bigHour = !0;
});
He("hmmss", function(e, r, t) {
  var n = e.length - 4, o = e.length - 2;
  r[vt] = xe(e.substr(0, n)), r[pr] = xe(e.substr(n, 2)), r[en] = xe(e.substr(o)), we(t).bigHour = !0;
});
He("Hmm", function(e, r, t) {
  var n = e.length - 2;
  r[vt] = xe(e.substr(0, n)), r[pr] = xe(e.substr(n));
});
He("Hmmss", function(e, r, t) {
  var n = e.length - 4, o = e.length - 2;
  r[vt] = xe(e.substr(0, n)), r[pr] = xe(e.substr(n, 2)), r[en] = xe(e.substr(o));
});
function Hk(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var zk = /[ap]\.?m?\.?/i, $k = ea("Hours", !0);
function Xk(e, r, t) {
  return e > 11 ? t ? "pm" : "PM" : t ? "am" : "AM";
}
var $g = {
  calendar: T_,
  longDateFormat: W_,
  invalidDate: V_,
  ordinal: Y_,
  dayOfMonthOrdinalParse: H_,
  relativeTime: $_,
  months: sk,
  monthsShort: Ng,
  week: yk,
  weekdays: _k,
  weekdaysMin: kk,
  weekdaysShort: Yg,
  meridiemParse: zk
}, tt = {}, ca = {}, Na;
function jk(e, r) {
  var t, n = Math.min(e.length, r.length);
  for (t = 0; t < n; t += 1)
    if (e[t] !== r[t])
      return t;
  return n;
}
function Mf(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Zk(e) {
  for (var r = 0, t, n, o, a; r < e.length; ) {
    for (a = Mf(e[r]).split("-"), t = a.length, n = Mf(e[r + 1]), n = n ? n.split("-") : null; t > 0; ) {
      if (o = Xs(a.slice(0, t).join("-")), o)
        return o;
      if (n && n.length >= t && jk(a, n) >= t - 1)
        break;
      t--;
    }
    r++;
  }
  return Na;
}
function Uk(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function Xs(e) {
  var r = null, t;
  if (tt[e] === void 0 && typeof module < "u" && module && module.exports && Uk(e))
    try {
      r = Na._abbr, t = require, t("./locale/" + e), In(r);
    } catch {
      tt[e] = null;
    }
  return tt[e];
}
function In(e, r) {
  var t;
  return e && (Tt(r) ? t = fn(e) : t = Sc(e, r), t ? Na = t : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Na._abbr;
}
function Sc(e, r) {
  if (r !== null) {
    var t, n = $g;
    if (r.abbr = e, tt[e] != null)
      Eg(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = tt[e]._config;
    else if (r.parentLocale != null)
      if (tt[r.parentLocale] != null)
        n = tt[r.parentLocale]._config;
      else if (t = Xs(r.parentLocale), t != null)
        n = t._config;
      else
        return ca[r.parentLocale] || (ca[r.parentLocale] = []), ca[r.parentLocale].push({
          name: e,
          config: r
        }), null;
    return tt[e] = new fc(wu(n, r)), ca[e] && ca[e].forEach(function(o) {
      Sc(o.name, o.config);
    }), In(e), tt[e];
  } else
    return delete tt[e], null;
}
function Jk(e, r) {
  if (r != null) {
    var t, n, o = $g;
    tt[e] != null && tt[e].parentLocale != null ? tt[e].set(wu(tt[e]._config, r)) : (n = Xs(e), n != null && (o = n._config), r = wu(o, r), n == null && (r.abbr = e), t = new fc(r), t.parentLocale = tt[e], tt[e] = t), In(e);
  } else
    tt[e] != null && (tt[e].parentLocale != null ? (tt[e] = tt[e].parentLocale, e === In() && In(e)) : tt[e] != null && delete tt[e]);
  return tt[e];
}
function fn(e) {
  var r;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Na;
  if (!gr(e)) {
    if (r = Xs(e), r)
      return r;
    e = [e];
  }
  return Zk(e);
}
function Qk() {
  return Cu(tt);
}
function xc(e) {
  var r, t = e._a;
  return t && we(e).overflow === -2 && (r = t[Kr] < 0 || t[Kr] > 11 ? Kr : t[Er] < 1 || t[Er] > bc(t[kt], t[Kr]) ? Er : t[vt] < 0 || t[vt] > 24 || t[vt] === 24 && (t[pr] !== 0 || t[en] !== 0 || t[Gn] !== 0) ? vt : t[pr] < 0 || t[pr] > 59 ? pr : t[en] < 0 || t[en] > 59 ? en : t[Gn] < 0 || t[Gn] > 999 ? Gn : -1, we(e)._overflowDayOfYear && (r < kt || r > Er) && (r = Er), we(e)._overflowWeeks && r === -1 && (r = tk), we(e)._overflowWeekday && r === -1 && (r = rk), we(e).overflow = r), e;
}
var qk = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, Kk = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, eE = /Z|[+-]\d\d(?::?\d\d)?/, bi = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], Tl = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], tE = /^\/?Date\((-?\d+)/i, rE = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, nE = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Xg(e) {
  var r, t, n = e._i, o = qk.exec(n) || Kk.exec(n), a, i, s, l, u = bi.length, c = Tl.length;
  if (o) {
    for (we(e).iso = !0, r = 0, t = u; r < t; r++)
      if (bi[r][1].exec(o[1])) {
        i = bi[r][0], a = bi[r][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (r = 0, t = c; r < t; r++)
        if (Tl[r][1].exec(o[3])) {
          s = (o[2] || " ") + Tl[r][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (eE.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (s || "") + (l || ""), Dc(e);
  } else
    e._isValid = !1;
}
function oE(e, r, t, n, o, a) {
  var i = [
    aE(e),
    Ng.indexOf(r),
    parseInt(t, 10),
    parseInt(n, 10),
    parseInt(o, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function aE(e) {
  var r = parseInt(e, 10);
  return r <= 49 ? 2e3 + r : r <= 999 ? 1900 + r : r;
}
function iE(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function sE(e, r, t) {
  if (e) {
    var n = Yg.indexOf(e), o = new Date(
      r[0],
      r[1],
      r[2]
    ).getDay();
    if (n !== o)
      return we(t).weekdayMismatch = !0, t._isValid = !1, !1;
  }
  return !0;
}
function lE(e, r, t) {
  if (e)
    return nE[e];
  if (r)
    return 0;
  var n = parseInt(t, 10), o = n % 100, a = (n - o) / 100;
  return a * 60 + o;
}
function jg(e) {
  var r = rE.exec(iE(e._i)), t;
  if (r) {
    if (t = oE(
      r[4],
      r[3],
      r[2],
      r[5],
      r[6],
      r[7]
    ), !sE(r[1], t, e))
      return;
    e._a = t, e._tzm = lE(r[8], r[9], r[10]), e._d = Ta.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), we(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function uE(e) {
  var r = tE.exec(e._i);
  if (r !== null) {
    e._d = /* @__PURE__ */ new Date(+r[1]);
    return;
  }
  if (Xg(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (jg(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : Q.createFromInputFallback(e);
}
Q.createFromInputFallback = ur(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function wo(e, r, t) {
  return e ?? r ?? t;
}
function cE(e) {
  var r = new Date(Q.now());
  return e._useUTC ? [
    r.getUTCFullYear(),
    r.getUTCMonth(),
    r.getUTCDate()
  ] : [r.getFullYear(), r.getMonth(), r.getDate()];
}
function Ic(e) {
  var r, t, n = [], o, a, i;
  if (!e._d) {
    for (o = cE(e), e._w && e._a[Er] == null && e._a[Kr] == null && dE(e), e._dayOfYear != null && (i = wo(e._a[kt], o[kt]), (e._dayOfYear > Da(i) || e._dayOfYear === 0) && (we(e)._overflowDayOfYear = !0), t = Ta(i, 0, e._dayOfYear), e._a[Kr] = t.getUTCMonth(), e._a[Er] = t.getUTCDate()), r = 0; r < 3 && e._a[r] == null; ++r)
      e._a[r] = n[r] = o[r];
    for (; r < 7; r++)
      e._a[r] = n[r] = e._a[r] == null ? r === 2 ? 1 : 0 : e._a[r];
    e._a[vt] === 24 && e._a[pr] === 0 && e._a[en] === 0 && e._a[Gn] === 0 && (e._nextDay = !0, e._a[vt] = 0), e._d = (e._useUTC ? Ta : vk).apply(
      null,
      n
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[vt] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (we(e).weekdayMismatch = !0);
  }
}
function dE(e) {
  var r, t, n, o, a, i, s, l, u;
  r = e._w, r.GG != null || r.W != null || r.E != null ? (a = 1, i = 4, t = wo(
    r.GG,
    e._a[kt],
    Fa(Qe(), 1, 4).year
  ), n = wo(r.W, 1), o = wo(r.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, u = Fa(Qe(), a, i), t = wo(r.gg, e._a[kt], u.year), n = wo(r.w, u.week), r.d != null ? (o = r.d, (o < 0 || o > 6) && (l = !0)) : r.e != null ? (o = r.e + a, (r.e < 0 || r.e > 6) && (l = !0)) : o = a), n < 1 || n > nn(t, a, i) ? we(e)._overflowWeeks = !0 : l != null ? we(e)._overflowWeekday = !0 : (s = Gg(t, n, o, a, i), e._a[kt] = s.year, e._dayOfYear = s.dayOfYear);
}
Q.ISO_8601 = function() {
};
Q.RFC_2822 = function() {
};
function Dc(e) {
  if (e._f === Q.ISO_8601) {
    Xg(e);
    return;
  }
  if (e._f === Q.RFC_2822) {
    jg(e);
    return;
  }
  e._a = [], we(e).empty = !0;
  var r = "" + e._i, t, n, o, a, i, s = r.length, l = 0, u, c;
  for (o = Mg(e._f, e._locale).match(pc) || [], c = o.length, t = 0; t < c; t++)
    a = o[t], n = (r.match(q_(a, e)) || [])[0], n && (i = r.substr(0, r.indexOf(n)), i.length > 0 && we(e).unusedInput.push(i), r = r.slice(
      r.indexOf(n) + n.length
    ), l += n.length), ko[a] ? (n ? we(e).empty = !1 : we(e).unusedTokens.push(a), ek(a, n, e)) : e._strict && !n && we(e).unusedTokens.push(a);
  we(e).charsLeftOver = s - l, r.length > 0 && we(e).unusedInput.push(r), e._a[vt] <= 12 && we(e).bigHour === !0 && e._a[vt] > 0 && (we(e).bigHour = void 0), we(e).parsedDateParts = e._a.slice(0), we(e).meridiem = e._meridiem, e._a[vt] = fE(
    e._locale,
    e._a[vt],
    e._meridiem
  ), u = we(e).era, u !== null && (e._a[kt] = e._locale.erasConvertYear(u, e._a[kt])), Ic(e), xc(e);
}
function fE(e, r, t) {
  var n;
  return t == null ? r : e.meridiemHour != null ? e.meridiemHour(r, t) : (e.isPM != null && (n = e.isPM(t), n && r < 12 && (r += 12), !n && r === 12 && (r = 0)), r);
}
function pE(e) {
  var r, t, n, o, a, i, s = !1, l = e._f.length;
  if (l === 0) {
    we(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, i = !1, r = dc({}, e), e._useUTC != null && (r._useUTC = e._useUTC), r._f = e._f[o], Dc(r), cc(r) && (i = !0), a += we(r).charsLeftOver, a += we(r).unusedTokens.length * 10, we(r).score = a, s ? a < n && (n = a, t = r) : (n == null || a < n || i) && (n = a, t = r, i && (s = !0));
  wn(e, t || r);
}
function hE(e) {
  if (!e._d) {
    var r = hc(e._i), t = r.day === void 0 ? r.date : r.day;
    e._a = _g(
      [r.year, r.month, t, r.hour, r.minute, r.second, r.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), Ic(e);
  }
}
function gE(e) {
  var r = new Ka(xc(Zg(e)));
  return r._nextDay && (r.add(1, "d"), r._nextDay = void 0), r;
}
function Zg(e) {
  var r = e._i, t = e._f;
  return e._locale = e._locale || fn(e._l), r === null || t === void 0 && r === "" ? Bs({ nullInput: !0 }) : (typeof r == "string" && (e._i = r = e._locale.preparse(r)), mr(r) ? new Ka(xc(r)) : (qa(r) ? e._d = r : gr(t) ? pE(e) : t ? Dc(e) : mE(e), cc(e) || (e._d = null), e));
}
function mE(e) {
  var r = e._i;
  Tt(r) ? e._d = new Date(Q.now()) : qa(r) ? e._d = new Date(r.valueOf()) : typeof r == "string" ? uE(e) : gr(r) ? (e._a = _g(r.slice(0), function(t) {
    return parseInt(t, 10);
  }), Ic(e)) : $n(r) ? hE(e) : un(r) ? e._d = new Date(r) : Q.createFromInputFallback(e);
}
function Ug(e, r, t, n, o) {
  var a = {};
  return (r === !0 || r === !1) && (n = r, r = void 0), (t === !0 || t === !1) && (n = t, t = void 0), ($n(e) && uc(e) || gr(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = t, a._i = e, a._f = r, a._strict = n, gE(a);
}
function Qe(e, r, t, n) {
  return Ug(e, r, t, n, !1);
}
var vE = ur(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Qe.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Bs();
  }
), bE = ur(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = Qe.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Bs();
  }
);
function Jg(e, r) {
  var t, n;
  if (r.length === 1 && gr(r[0]) && (r = r[0]), !r.length)
    return Qe();
  for (t = r[0], n = 1; n < r.length; ++n)
    (!r[n].isValid() || r[n][e](t)) && (t = r[n]);
  return t;
}
function yE() {
  var e = [].slice.call(arguments, 0);
  return Jg("isBefore", e);
}
function wE() {
  var e = [].slice.call(arguments, 0);
  return Jg("isAfter", e);
}
var CE = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, da = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function SE(e) {
  var r, t = !1, n, o = da.length;
  for (r in e)
    if (Me(e, r) && !(dt.call(da, r) !== -1 && (e[r] == null || !isNaN(e[r]))))
      return !1;
  for (n = 0; n < o; ++n)
    if (e[da[n]]) {
      if (t)
        return !1;
      parseFloat(e[da[n]]) !== xe(e[da[n]]) && (t = !0);
    }
  return !0;
}
function xE() {
  return this._isValid;
}
function IE() {
  return wr(NaN);
}
function js(e) {
  var r = hc(e), t = r.year || 0, n = r.quarter || 0, o = r.month || 0, a = r.week || r.isoWeek || 0, i = r.day || 0, s = r.hour || 0, l = r.minute || 0, u = r.second || 0, c = r.millisecond || 0;
  this._isValid = SE(r), this._milliseconds = +c + u * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +o + n * 3 + t * 12, this._data = {}, this._locale = fn(), this._bubble();
}
function Ti(e) {
  return e instanceof js;
}
function xu(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function DE(e, r, t) {
  var n = Math.min(e.length, r.length), o = Math.abs(e.length - r.length), a = 0, i;
  for (i = 0; i < n; i++)
    xe(e[i]) !== xe(r[i]) && a++;
  return a + o;
}
function Qg(e, r) {
  de(e, 0, 0, function() {
    var t = this.utcOffset(), n = "+";
    return t < 0 && (t = -t, n = "-"), n + Br(~~(t / 60), 2) + r + Br(~~t % 60, 2);
  });
}
Qg("Z", ":");
Qg("ZZ", "");
ae("Z", zs);
ae("ZZ", zs);
He(["Z", "ZZ"], function(e, r, t) {
  t._useUTC = !0, t._tzm = _c(zs, e);
});
var _E = /([\+\-]|\d\d)/gi;
function _c(e, r) {
  var t = (r || "").match(e), n, o, a;
  return t === null ? null : (n = t[t.length - 1] || [], o = (n + "").match(_E) || ["-", 0, 0], a = +(o[1] * 60) + xe(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function kc(e, r) {
  var t, n;
  return r._isUTC ? (t = r.clone(), n = (mr(e) || qa(e) ? e.valueOf() : Qe(e).valueOf()) - t.valueOf(), t._d.setTime(t._d.valueOf() + n), Q.updateOffset(t, !1), t) : Qe(e).local();
}
function Iu(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
Q.updateOffset = function() {
};
function kE(e, r, t) {
  var n = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = _c(zs, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !t && (e = e * 60);
    return !this._isUTC && r && (o = Iu(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), n !== e && (!r || this._changeInProgress ? em(
      this,
      wr(e - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, Q.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : Iu(this);
}
function EE(e, r) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, r), this) : -this.utcOffset();
}
function ME(e) {
  return this.utcOffset(0, e);
}
function AE(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Iu(this), "m")), this;
}
function PE() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = _c(J_, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function RE(e) {
  return this.isValid() ? (e = e ? Qe(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function OE() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function TE() {
  if (!Tt(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, r;
  return dc(e, this), e = Zg(e), e._a ? (r = e._isUTC ? Yr(e._a) : Qe(e._a), this._isDSTShifted = this.isValid() && DE(e._a, r.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function FE() {
  return this.isValid() ? !this._isUTC : !1;
}
function NE() {
  return this.isValid() ? this._isUTC : !1;
}
function qg() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var LE = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, WE = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function wr(e, r) {
  var t = e, n = null, o, a, i;
  return Ti(e) ? t = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : un(e) || !isNaN(+e) ? (t = {}, r ? t[r] = +e : t.milliseconds = +e) : (n = LE.exec(e)) ? (o = n[1] === "-" ? -1 : 1, t = {
    y: 0,
    d: xe(n[Er]) * o,
    h: xe(n[vt]) * o,
    m: xe(n[pr]) * o,
    s: xe(n[en]) * o,
    ms: xe(xu(n[Gn] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (n = WE.exec(e)) ? (o = n[1] === "-" ? -1 : 1, t = {
    y: Nn(n[2], o),
    M: Nn(n[3], o),
    w: Nn(n[4], o),
    d: Nn(n[5], o),
    h: Nn(n[6], o),
    m: Nn(n[7], o),
    s: Nn(n[8], o)
  }) : t == null ? t = {} : typeof t == "object" && ("from" in t || "to" in t) && (i = BE(
    Qe(t.from),
    Qe(t.to)
  ), t = {}, t.ms = i.milliseconds, t.M = i.months), a = new js(t), Ti(e) && Me(e, "_locale") && (a._locale = e._locale), Ti(e) && Me(e, "_isValid") && (a._isValid = e._isValid), a;
}
wr.fn = js.prototype;
wr.invalid = IE;
function Nn(e, r) {
  var t = e && parseFloat(e.replace(",", "."));
  return (isNaN(t) ? 0 : t) * r;
}
function Af(e, r) {
  var t = {};
  return t.months = r.month() - e.month() + (r.year() - e.year()) * 12, e.clone().add(t.months, "M").isAfter(r) && --t.months, t.milliseconds = +r - +e.clone().add(t.months, "M"), t;
}
function BE(e, r) {
  var t;
  return e.isValid() && r.isValid() ? (r = kc(r, e), e.isBefore(r) ? t = Af(e, r) : (t = Af(r, e), t.milliseconds = -t.milliseconds, t.months = -t.months), t) : { milliseconds: 0, months: 0 };
}
function Kg(e, r) {
  return function(t, n) {
    var o, a;
    return n !== null && !isNaN(+n) && (Eg(
      r,
      "moment()." + r + "(period, number) is deprecated. Please use moment()." + r + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = t, t = n, n = a), o = wr(t, n), em(this, o, e), this;
  };
}
function em(e, r, t, n) {
  var o = r._milliseconds, a = xu(r._days), i = xu(r._months);
  e.isValid() && (n = n ?? !0, i && Wg(e, Oa(e, "Month") + i * t), a && Fg(e, "Date", Oa(e, "Date") + a * t), o && e._d.setTime(e._d.valueOf() + o * t), n && Q.updateOffset(e, a || i));
}
var VE = Kg(1, "add"), GE = Kg(-1, "subtract");
function tm(e) {
  return typeof e == "string" || e instanceof String;
}
function YE(e) {
  return mr(e) || qa(e) || tm(e) || un(e) || zE(e) || HE(e) || e === null || e === void 0;
}
function HE(e) {
  var r = $n(e) && !uc(e), t = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, i = n.length;
  for (o = 0; o < i; o += 1)
    a = n[o], t = t || Me(e, a);
  return r && t;
}
function zE(e) {
  var r = gr(e), t = !1;
  return r && (t = e.filter(function(n) {
    return !un(n) && tm(e);
  }).length === 0), r && t;
}
function $E(e) {
  var r = $n(e) && !uc(e), t = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < n.length; o += 1)
    a = n[o], t = t || Me(e, a);
  return r && t;
}
function XE(e, r) {
  var t = e.diff(r, "days", !0);
  return t < -6 ? "sameElse" : t < -1 ? "lastWeek" : t < 0 ? "lastDay" : t < 1 ? "sameDay" : t < 2 ? "nextDay" : t < 7 ? "nextWeek" : "sameElse";
}
function jE(e, r) {
  arguments.length === 1 && (arguments[0] ? YE(arguments[0]) ? (e = arguments[0], r = void 0) : $E(arguments[0]) && (r = arguments[0], e = void 0) : (e = void 0, r = void 0));
  var t = e || Qe(), n = kc(t, this).startOf("day"), o = Q.calendarFormat(this, n) || "sameElse", a = r && (Hr(r[o]) ? r[o].call(this, t) : r[o]);
  return this.format(
    a || this.localeData().calendar(o, this, Qe(t))
  );
}
function ZE() {
  return new Ka(this);
}
function UE(e, r) {
  var t = mr(e) ? e : Qe(e);
  return this.isValid() && t.isValid() ? (r = cr(r) || "millisecond", r === "millisecond" ? this.valueOf() > t.valueOf() : t.valueOf() < this.clone().startOf(r).valueOf()) : !1;
}
function JE(e, r) {
  var t = mr(e) ? e : Qe(e);
  return this.isValid() && t.isValid() ? (r = cr(r) || "millisecond", r === "millisecond" ? this.valueOf() < t.valueOf() : this.clone().endOf(r).valueOf() < t.valueOf()) : !1;
}
function QE(e, r, t, n) {
  var o = mr(e) ? e : Qe(e), a = mr(r) ? r : Qe(r);
  return this.isValid() && o.isValid() && a.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(o, t) : !this.isBefore(o, t)) && (n[1] === ")" ? this.isBefore(a, t) : !this.isAfter(a, t))) : !1;
}
function qE(e, r) {
  var t = mr(e) ? e : Qe(e), n;
  return this.isValid() && t.isValid() ? (r = cr(r) || "millisecond", r === "millisecond" ? this.valueOf() === t.valueOf() : (n = t.valueOf(), this.clone().startOf(r).valueOf() <= n && n <= this.clone().endOf(r).valueOf())) : !1;
}
function KE(e, r) {
  return this.isSame(e, r) || this.isAfter(e, r);
}
function eM(e, r) {
  return this.isSame(e, r) || this.isBefore(e, r);
}
function tM(e, r, t) {
  var n, o, a;
  if (!this.isValid())
    return NaN;
  if (n = kc(e, this), !n.isValid())
    return NaN;
  switch (o = (n.utcOffset() - this.utcOffset()) * 6e4, r = cr(r), r) {
    case "year":
      a = Fi(this, n) / 12;
      break;
    case "month":
      a = Fi(this, n);
      break;
    case "quarter":
      a = Fi(this, n) / 3;
      break;
    case "second":
      a = (this - n) / 1e3;
      break;
    case "minute":
      a = (this - n) / 6e4;
      break;
    case "hour":
      a = (this - n) / 36e5;
      break;
    case "day":
      a = (this - n - o) / 864e5;
      break;
    case "week":
      a = (this - n - o) / 6048e5;
      break;
    default:
      a = this - n;
  }
  return t ? a : er(a);
}
function Fi(e, r) {
  if (e.date() < r.date())
    return -Fi(r, e);
  var t = (r.year() - e.year()) * 12 + (r.month() - e.month()), n = e.clone().add(t, "months"), o, a;
  return r - n < 0 ? (o = e.clone().add(t - 1, "months"), a = (r - n) / (n - o)) : (o = e.clone().add(t + 1, "months"), a = (r - n) / (o - n)), -(t + a) || 0;
}
Q.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
Q.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function rM() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function nM(e) {
  if (!this.isValid())
    return null;
  var r = e !== !0, t = r ? this.clone().utc() : this;
  return t.year() < 0 || t.year() > 9999 ? Oi(
    t,
    r ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : Hr(Date.prototype.toISOString) ? r ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", Oi(t, "Z")) : Oi(
    t,
    r ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function oM() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", r = "", t, n, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", r = "Z"), t = "[" + e + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = r + '[")]', this.format(t + n + o + a);
}
function aM(e) {
  e || (e = this.isUtc() ? Q.defaultFormatUtc : Q.defaultFormat);
  var r = Oi(this, e);
  return this.localeData().postformat(r);
}
function iM(e, r) {
  return this.isValid() && (mr(e) && e.isValid() || Qe(e).isValid()) ? wr({ to: this, from: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function sM(e) {
  return this.from(Qe(), e);
}
function lM(e, r) {
  return this.isValid() && (mr(e) && e.isValid() || Qe(e).isValid()) ? wr({ from: this, to: e }).locale(this.locale()).humanize(!r) : this.localeData().invalidDate();
}
function uM(e) {
  return this.to(Qe(), e);
}
function rm(e) {
  var r;
  return e === void 0 ? this._locale._abbr : (r = fn(e), r != null && (this._locale = r), this);
}
var nm = ur(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function om() {
  return this._locale;
}
var cs = 1e3, Eo = 60 * cs, ds = 60 * Eo, am = (365 * 400 + 97) * 24 * ds;
function Mo(e, r) {
  return (e % r + r) % r;
}
function im(e, r, t) {
  return e < 100 && e >= 0 ? new Date(e + 400, r, t) - am : new Date(e, r, t).valueOf();
}
function sm(e, r, t) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, r, t) - am : Date.UTC(e, r, t);
}
function cM(e) {
  var r, t;
  if (e = cr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? sm : im, e) {
    case "year":
      r = t(this.year(), 0, 1);
      break;
    case "quarter":
      r = t(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      r = t(this.year(), this.month(), 1);
      break;
    case "week":
      r = t(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      r = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      r = t(this.year(), this.month(), this.date());
      break;
    case "hour":
      r = this._d.valueOf(), r -= Mo(
        r + (this._isUTC ? 0 : this.utcOffset() * Eo),
        ds
      );
      break;
    case "minute":
      r = this._d.valueOf(), r -= Mo(r, Eo);
      break;
    case "second":
      r = this._d.valueOf(), r -= Mo(r, cs);
      break;
  }
  return this._d.setTime(r), Q.updateOffset(this, !0), this;
}
function dM(e) {
  var r, t;
  if (e = cr(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (t = this._isUTC ? sm : im, e) {
    case "year":
      r = t(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      r = t(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      r = t(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      r = t(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      r = t(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      r = t(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      r = this._d.valueOf(), r += ds - Mo(
        r + (this._isUTC ? 0 : this.utcOffset() * Eo),
        ds
      ) - 1;
      break;
    case "minute":
      r = this._d.valueOf(), r += Eo - Mo(r, Eo) - 1;
      break;
    case "second":
      r = this._d.valueOf(), r += cs - Mo(r, cs) - 1;
      break;
  }
  return this._d.setTime(r), Q.updateOffset(this, !0), this;
}
function fM() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function pM() {
  return Math.floor(this.valueOf() / 1e3);
}
function hM() {
  return new Date(this.valueOf());
}
function gM() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function mM() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function vM() {
  return this.isValid() ? this.toISOString() : null;
}
function bM() {
  return cc(this);
}
function yM() {
  return wn({}, we(this));
}
function wM() {
  return we(this).overflow;
}
function CM() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
de("N", 0, 0, "eraAbbr");
de("NN", 0, 0, "eraAbbr");
de("NNN", 0, 0, "eraAbbr");
de("NNNN", 0, 0, "eraName");
de("NNNNN", 0, 0, "eraNarrow");
de("y", ["y", 1], "yo", "eraYear");
de("y", ["yy", 2], 0, "eraYear");
de("y", ["yyy", 3], 0, "eraYear");
de("y", ["yyyy", 4], 0, "eraYear");
ae("N", Ec);
ae("NN", Ec);
ae("NNN", Ec);
ae("NNNN", RM);
ae("NNNNN", OM);
He(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, r, t, n) {
    var o = t._locale.erasParse(e, n, t._strict);
    o ? we(t).era = o : we(t).invalidEra = e;
  }
);
ae("y", qo);
ae("yy", qo);
ae("yyy", qo);
ae("yyyy", qo);
ae("yo", TM);
He(["y", "yy", "yyy", "yyyy"], kt);
He(["yo"], function(e, r, t, n) {
  var o;
  t._locale._eraYearOrdinalRegex && (o = e.match(t._locale._eraYearOrdinalRegex)), t._locale.eraYearOrdinalParse ? r[kt] = t._locale.eraYearOrdinalParse(e, o) : r[kt] = parseInt(e, 10);
});
function SM(e, r) {
  var t, n, o, a = this._eras || fn("en")._eras;
  for (t = 0, n = a.length; t < n; ++t) {
    switch (typeof a[t].since) {
      case "string":
        o = Q(a[t].since).startOf("day"), a[t].since = o.valueOf();
        break;
    }
    switch (typeof a[t].until) {
      case "undefined":
        a[t].until = 1 / 0;
        break;
      case "string":
        o = Q(a[t].until).startOf("day").valueOf(), a[t].until = o.valueOf();
        break;
    }
  }
  return a;
}
function xM(e, r, t) {
  var n, o, a = this.eras(), i, s, l;
  for (e = e.toUpperCase(), n = 0, o = a.length; n < o; ++n)
    if (i = a[n].name.toUpperCase(), s = a[n].abbr.toUpperCase(), l = a[n].narrow.toUpperCase(), t)
      switch (r) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[n];
          break;
        case "NNNN":
          if (i === e)
            return a[n];
          break;
        case "NNNNN":
          if (l === e)
            return a[n];
          break;
      }
    else if ([i, s, l].indexOf(e) >= 0)
      return a[n];
}
function IM(e, r) {
  var t = e.since <= e.until ? 1 : -1;
  return r === void 0 ? Q(e.since).year() : Q(e.since).year() + (r - e.offset) * t;
}
function DM() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].name;
  return "";
}
function _M() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].narrow;
  return "";
}
function kM() {
  var e, r, t, n = this.localeData().eras();
  for (e = 0, r = n.length; e < r; ++e)
    if (t = this.clone().startOf("day").valueOf(), n[e].since <= t && t <= n[e].until || n[e].until <= t && t <= n[e].since)
      return n[e].abbr;
  return "";
}
function EM() {
  var e, r, t, n, o = this.localeData().eras();
  for (e = 0, r = o.length; e < r; ++e)
    if (t = o[e].since <= o[e].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return (this.year() - Q(o[e].since).year()) * t + o[e].offset;
  return this.year();
}
function MM(e) {
  return Me(this, "_erasNameRegex") || Mc.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function AM(e) {
  return Me(this, "_erasAbbrRegex") || Mc.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function PM(e) {
  return Me(this, "_erasNarrowRegex") || Mc.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Ec(e, r) {
  return r.erasAbbrRegex(e);
}
function RM(e, r) {
  return r.erasNameRegex(e);
}
function OM(e, r) {
  return r.erasNarrowRegex(e);
}
function TM(e, r) {
  return r._eraYearOrdinalRegex || qo;
}
function Mc() {
  var e = [], r = [], t = [], n = [], o, a, i, s, l, u = this.eras();
  for (o = 0, a = u.length; o < a; ++o)
    i = rn(u[o].name), s = rn(u[o].abbr), l = rn(u[o].narrow), r.push(i), e.push(s), t.push(l), n.push(i), n.push(s), n.push(l);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + r.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
de(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
de(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function Zs(e, r) {
  de(0, [e, e.length], 0, r);
}
Zs("gggg", "weekYear");
Zs("ggggg", "weekYear");
Zs("GGGG", "isoWeekYear");
Zs("GGGGG", "isoWeekYear");
ae("G", Hs);
ae("g", Hs);
ae("GG", qe, Zt);
ae("gg", qe, Zt);
ae("GGGG", mc, gc);
ae("gggg", mc, gc);
ae("GGGGG", Ys, Vs);
ae("ggggg", Ys, Vs);
ti(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, r, t, n) {
    r[n.substr(0, 2)] = xe(e);
  }
);
ti(["gg", "GG"], function(e, r, t, n) {
  r[n] = Q.parseTwoDigitYear(e);
});
function FM(e) {
  return lm.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function NM(e) {
  return lm.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function LM() {
  return nn(this.year(), 1, 4);
}
function WM() {
  return nn(this.isoWeekYear(), 1, 4);
}
function BM() {
  var e = this.localeData()._week;
  return nn(this.year(), e.dow, e.doy);
}
function VM() {
  var e = this.localeData()._week;
  return nn(this.weekYear(), e.dow, e.doy);
}
function lm(e, r, t, n, o) {
  var a;
  return e == null ? Fa(this, n, o).year : (a = nn(e, n, o), r > a && (r = a), GM.call(this, e, r, t, n, o));
}
function GM(e, r, t, n, o) {
  var a = Gg(e, r, t, n, o), i = Ta(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
de("Q", 0, "Qo", "quarter");
ae("Q", Ag);
He("Q", function(e, r) {
  r[Kr] = (xe(e) - 1) * 3;
});
function YM(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
de("D", ["DD", 2], "Do", "date");
ae("D", qe, Ko);
ae("DD", qe, Zt);
ae("Do", function(e, r) {
  return e ? r._dayOfMonthOrdinalParse || r._ordinalParse : r._dayOfMonthOrdinalParseLenient;
});
He(["D", "DD"], Er);
He("Do", function(e, r) {
  r[Er] = xe(e.match(qe)[0]);
});
var um = ea("Date", !0);
de("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
ae("DDD", Gs);
ae("DDDD", Pg);
He(["DDD", "DDDD"], function(e, r, t) {
  t._dayOfYear = xe(e);
});
function HM(e) {
  var r = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? r : this.add(e - r, "d");
}
de("m", ["mm", 2], 0, "minute");
ae("m", qe, vc);
ae("mm", qe, Zt);
He(["m", "mm"], pr);
var zM = ea("Minutes", !1);
de("s", ["ss", 2], 0, "second");
ae("s", qe, vc);
ae("ss", qe, Zt);
He(["s", "ss"], en);
var $M = ea("Seconds", !1);
de("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
de(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
de(0, ["SSS", 3], 0, "millisecond");
de(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
de(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
de(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
de(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
de(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
de(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
ae("S", Gs, Ag);
ae("SS", Gs, Zt);
ae("SSS", Gs, Pg);
var Cn, cm;
for (Cn = "SSSS"; Cn.length <= 9; Cn += "S")
  ae(Cn, qo);
function XM(e, r) {
  r[Gn] = xe(("0." + e) * 1e3);
}
for (Cn = "S"; Cn.length <= 9; Cn += "S")
  He(Cn, XM);
cm = ea("Milliseconds", !1);
de("z", 0, 0, "zoneAbbr");
de("zz", 0, 0, "zoneName");
function jM() {
  return this._isUTC ? "UTC" : "";
}
function ZM() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var z = Ka.prototype;
z.add = VE;
z.calendar = jE;
z.clone = ZE;
z.diff = tM;
z.endOf = dM;
z.format = aM;
z.from = iM;
z.fromNow = sM;
z.to = lM;
z.toNow = uM;
z.get = ok;
z.invalidAt = wM;
z.isAfter = UE;
z.isBefore = JE;
z.isBetween = QE;
z.isSame = qE;
z.isSameOrAfter = KE;
z.isSameOrBefore = eM;
z.isValid = bM;
z.lang = nm;
z.locale = rm;
z.localeData = om;
z.max = bE;
z.min = vE;
z.parsingFlags = yM;
z.set = ak;
z.startOf = cM;
z.subtract = GE;
z.toArray = gM;
z.toObject = mM;
z.toDate = hM;
z.toISOString = nM;
z.inspect = oM;
typeof Symbol < "u" && Symbol.for != null && (z[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
z.toJSON = vM;
z.toString = rM;
z.unix = pM;
z.valueOf = fM;
z.creationData = CM;
z.eraName = DM;
z.eraNarrow = _M;
z.eraAbbr = kM;
z.eraYear = EM;
z.year = Tg;
z.isLeapYear = nk;
z.weekYear = FM;
z.isoWeekYear = NM;
z.quarter = z.quarters = YM;
z.month = Bg;
z.daysInMonth = hk;
z.week = z.weeks = Sk;
z.isoWeek = z.isoWeeks = xk;
z.weeksInYear = BM;
z.weeksInWeekYear = VM;
z.isoWeeksInYear = LM;
z.isoWeeksInISOWeekYear = WM;
z.date = um;
z.day = z.days = Nk;
z.weekday = Lk;
z.isoWeekday = Wk;
z.dayOfYear = HM;
z.hour = z.hours = $k;
z.minute = z.minutes = zM;
z.second = z.seconds = $M;
z.millisecond = z.milliseconds = cm;
z.utcOffset = kE;
z.utc = ME;
z.local = AE;
z.parseZone = PE;
z.hasAlignedHourOffset = RE;
z.isDST = OE;
z.isLocal = FE;
z.isUtcOffset = NE;
z.isUtc = qg;
z.isUTC = qg;
z.zoneAbbr = jM;
z.zoneName = ZM;
z.dates = ur(
  "dates accessor is deprecated. Use date instead.",
  um
);
z.months = ur(
  "months accessor is deprecated. Use month instead",
  Bg
);
z.years = ur(
  "years accessor is deprecated. Use year instead",
  Tg
);
z.zone = ur(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  EE
);
z.isDSTShifted = ur(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  TE
);
function UM(e) {
  return Qe(e * 1e3);
}
function JM() {
  return Qe.apply(null, arguments).parseZone();
}
function dm(e) {
  return e;
}
var Ae = fc.prototype;
Ae.calendar = F_;
Ae.longDateFormat = B_;
Ae.invalidDate = G_;
Ae.ordinal = z_;
Ae.preparse = dm;
Ae.postformat = dm;
Ae.relativeTime = X_;
Ae.pastFuture = j_;
Ae.set = O_;
Ae.eras = SM;
Ae.erasParse = xM;
Ae.erasConvertYear = IM;
Ae.erasAbbrRegex = AM;
Ae.erasNameRegex = MM;
Ae.erasNarrowRegex = PM;
Ae.months = ck;
Ae.monthsShort = dk;
Ae.monthsParse = pk;
Ae.monthsRegex = mk;
Ae.monthsShortRegex = gk;
Ae.week = bk;
Ae.firstDayOfYear = Ck;
Ae.firstDayOfWeek = wk;
Ae.weekdays = Pk;
Ae.weekdaysMin = Ok;
Ae.weekdaysShort = Rk;
Ae.weekdaysParse = Fk;
Ae.weekdaysRegex = Bk;
Ae.weekdaysShortRegex = Vk;
Ae.weekdaysMinRegex = Gk;
Ae.isPM = Hk;
Ae.meridiem = Xk;
function fs(e, r, t, n) {
  var o = fn(), a = Yr().set(n, r);
  return o[t](a, e);
}
function fm(e, r, t) {
  if (un(e) && (r = e, e = void 0), e = e || "", r != null)
    return fs(e, r, t, "month");
  var n, o = [];
  for (n = 0; n < 12; n++)
    o[n] = fs(e, n, t, "month");
  return o;
}
function Ac(e, r, t, n) {
  typeof e == "boolean" ? (un(r) && (t = r, r = void 0), r = r || "") : (r = e, t = r, e = !1, un(r) && (t = r, r = void 0), r = r || "");
  var o = fn(), a = e ? o._week.dow : 0, i, s = [];
  if (t != null)
    return fs(r, (t + a) % 7, n, "day");
  for (i = 0; i < 7; i++)
    s[i] = fs(r, (i + a) % 7, n, "day");
  return s;
}
function QM(e, r) {
  return fm(e, r, "months");
}
function qM(e, r) {
  return fm(e, r, "monthsShort");
}
function KM(e, r, t) {
  return Ac(e, r, t, "weekdays");
}
function eA(e, r, t) {
  return Ac(e, r, t, "weekdaysShort");
}
function tA(e, r, t) {
  return Ac(e, r, t, "weekdaysMin");
}
In("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var r = e % 10, t = xe(e % 100 / 10) === 1 ? "th" : r === 1 ? "st" : r === 2 ? "nd" : r === 3 ? "rd" : "th";
    return e + t;
  }
});
Q.lang = ur(
  "moment.lang is deprecated. Use moment.locale instead.",
  In
);
Q.langData = ur(
  "moment.langData is deprecated. Use moment.localeData instead.",
  fn
);
var Zr = Math.abs;
function rA() {
  var e = this._data;
  return this._milliseconds = Zr(this._milliseconds), this._days = Zr(this._days), this._months = Zr(this._months), e.milliseconds = Zr(e.milliseconds), e.seconds = Zr(e.seconds), e.minutes = Zr(e.minutes), e.hours = Zr(e.hours), e.months = Zr(e.months), e.years = Zr(e.years), this;
}
function pm(e, r, t, n) {
  var o = wr(r, t);
  return e._milliseconds += n * o._milliseconds, e._days += n * o._days, e._months += n * o._months, e._bubble();
}
function nA(e, r) {
  return pm(this, e, r, 1);
}
function oA(e, r) {
  return pm(this, e, r, -1);
}
function Pf(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function aA() {
  var e = this._milliseconds, r = this._days, t = this._months, n = this._data, o, a, i, s, l;
  return e >= 0 && r >= 0 && t >= 0 || e <= 0 && r <= 0 && t <= 0 || (e += Pf(Du(t) + r) * 864e5, r = 0, t = 0), n.milliseconds = e % 1e3, o = er(e / 1e3), n.seconds = o % 60, a = er(o / 60), n.minutes = a % 60, i = er(a / 60), n.hours = i % 24, r += er(i / 24), l = er(hm(r)), t += l, r -= Pf(Du(l)), s = er(t / 12), t %= 12, n.days = r, n.months = t, n.years = s, this;
}
function hm(e) {
  return e * 4800 / 146097;
}
function Du(e) {
  return e * 146097 / 4800;
}
function iA(e) {
  if (!this.isValid())
    return NaN;
  var r, t, n = this._milliseconds;
  if (e = cr(e), e === "month" || e === "quarter" || e === "year")
    switch (r = this._days + n / 864e5, t = this._months + hm(r), e) {
      case "month":
        return t;
      case "quarter":
        return t / 3;
      case "year":
        return t / 12;
    }
  else
    switch (r = this._days + Math.round(Du(this._months)), e) {
      case "week":
        return r / 7 + n / 6048e5;
      case "day":
        return r + n / 864e5;
      case "hour":
        return r * 24 + n / 36e5;
      case "minute":
        return r * 1440 + n / 6e4;
      case "second":
        return r * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(r * 864e5) + n;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function pn(e) {
  return function() {
    return this.as(e);
  };
}
var gm = pn("ms"), sA = pn("s"), lA = pn("m"), uA = pn("h"), cA = pn("d"), dA = pn("w"), fA = pn("M"), pA = pn("Q"), hA = pn("y"), gA = gm;
function mA() {
  return wr(this);
}
function vA(e) {
  return e = cr(e), this.isValid() ? this[e + "s"]() : NaN;
}
function so(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var bA = so("milliseconds"), yA = so("seconds"), wA = so("minutes"), CA = so("hours"), SA = so("days"), xA = so("months"), IA = so("years");
function DA() {
  return er(this.days() / 7);
}
var Ur = Math.round, Io = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function _A(e, r, t, n, o) {
  return o.relativeTime(r || 1, !!t, e, n);
}
function kA(e, r, t, n) {
  var o = wr(e).abs(), a = Ur(o.as("s")), i = Ur(o.as("m")), s = Ur(o.as("h")), l = Ur(o.as("d")), u = Ur(o.as("M")), c = Ur(o.as("w")), d = Ur(o.as("y")), f = a <= t.ss && ["s", a] || a < t.s && ["ss", a] || i <= 1 && ["m"] || i < t.m && ["mm", i] || s <= 1 && ["h"] || s < t.h && ["hh", s] || l <= 1 && ["d"] || l < t.d && ["dd", l];
  return t.w != null && (f = f || c <= 1 && ["w"] || c < t.w && ["ww", c]), f = f || u <= 1 && ["M"] || u < t.M && ["MM", u] || d <= 1 && ["y"] || ["yy", d], f[2] = r, f[3] = +e > 0, f[4] = n, _A.apply(null, f);
}
function EA(e) {
  return e === void 0 ? Ur : typeof e == "function" ? (Ur = e, !0) : !1;
}
function MA(e, r) {
  return Io[e] === void 0 ? !1 : r === void 0 ? Io[e] : (Io[e] = r, e === "s" && (Io.ss = r - 1), !0);
}
function AA(e, r) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var t = !1, n = Io, o, a;
  return typeof e == "object" && (r = e, e = !1), typeof e == "boolean" && (t = e), typeof r == "object" && (n = Object.assign({}, Io, r), r.s != null && r.ss == null && (n.ss = r.s - 1)), o = this.localeData(), a = kA(this, !t, n, o), t && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var Fl = Math.abs;
function vo(e) {
  return (e > 0) - (e < 0) || +e;
}
function Us() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Fl(this._milliseconds) / 1e3, r = Fl(this._days), t = Fl(this._months), n, o, a, i, s = this.asSeconds(), l, u, c, d;
  return s ? (n = er(e / 60), o = er(n / 60), e %= 60, n %= 60, a = er(t / 12), t %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", u = vo(this._months) !== vo(s) ? "-" : "", c = vo(this._days) !== vo(s) ? "-" : "", d = vo(this._milliseconds) !== vo(s) ? "-" : "", l + "P" + (a ? u + a + "Y" : "") + (t ? u + t + "M" : "") + (r ? c + r + "D" : "") + (o || n || e ? "T" : "") + (o ? d + o + "H" : "") + (n ? d + n + "M" : "") + (e ? d + i + "S" : "")) : "P0D";
}
var ke = js.prototype;
ke.isValid = xE;
ke.abs = rA;
ke.add = nA;
ke.subtract = oA;
ke.as = iA;
ke.asMilliseconds = gm;
ke.asSeconds = sA;
ke.asMinutes = lA;
ke.asHours = uA;
ke.asDays = cA;
ke.asWeeks = dA;
ke.asMonths = fA;
ke.asQuarters = pA;
ke.asYears = hA;
ke.valueOf = gA;
ke._bubble = aA;
ke.clone = mA;
ke.get = vA;
ke.milliseconds = bA;
ke.seconds = yA;
ke.minutes = wA;
ke.hours = CA;
ke.days = SA;
ke.weeks = DA;
ke.months = xA;
ke.years = IA;
ke.humanize = AA;
ke.toISOString = Us;
ke.toString = Us;
ke.toJSON = Us;
ke.locale = rm;
ke.localeData = om;
ke.toIsoString = ur(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  Us
);
ke.lang = nm;
de("X", 0, 0, "unix");
de("x", 0, 0, "valueOf");
ae("x", Hs);
ae("X", Q_);
He("X", function(e, r, t) {
  t._d = new Date(parseFloat(e) * 1e3);
});
He("x", function(e, r, t) {
  t._d = new Date(xe(e));
});
//! moment.js
Q.version = "2.30.1";
P_(Qe);
Q.fn = z;
Q.min = yE;
Q.max = wE;
Q.now = CE;
Q.utc = Yr;
Q.unix = UM;
Q.months = QM;
Q.isDate = qa;
Q.locale = In;
Q.invalid = Bs;
Q.duration = wr;
Q.isMoment = mr;
Q.weekdays = KM;
Q.parseZone = JM;
Q.localeData = fn;
Q.isDuration = Ti;
Q.monthsShort = qM;
Q.weekdaysMin = tA;
Q.defineLocale = Sc;
Q.updateLocale = Jk;
Q.locales = Qk;
Q.weekdaysShort = eA;
Q.normalizeUnits = cr;
Q.relativeTimeRounding = EA;
Q.relativeTimeThreshold = MA;
Q.calendarFormat = XE;
Q.prototype = z;
Q.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
function mm(e) {
  var r, t, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (r = 0; r < o; r++) e[r] && (t = mm(e[r])) && (n && (n += " "), n += t);
  } else for (t in e) e[t] && (n && (n += " "), n += t);
  return n;
}
function wt() {
  for (var e, r, t = 0, n = "", o = arguments.length; t < o; t++) (e = arguments[t]) && (r = mm(e)) && (n && (n += " "), n += r);
  return n;
}
function oe(e) {
  const r = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && r === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || r === "[object Number]" || typeof e == "string" || r === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Be(e, r) {
  return e instanceof Date ? new e.constructor(r) : new Date(r);
}
function On(e, r) {
  const t = oe(e);
  return isNaN(r) ? Be(e, NaN) : (r && t.setDate(t.getDate() + r), t);
}
function Pc(e, r) {
  const t = +oe(e);
  return Be(e, t + r);
}
const vm = 6048e5, PA = 864e5, Js = 6e4, Qs = 36e5, RA = 1e3;
function OA(e, r) {
  return Pc(e, r * Qs);
}
function _u(e, r) {
  return Pc(e, r * Js);
}
function vr(e, r) {
  const t = oe(e);
  if (isNaN(r)) return Be(e, NaN);
  if (!r)
    return t;
  const n = t.getDate(), o = Be(e, t.getTime());
  o.setMonth(t.getMonth() + r + 1, 0);
  const a = o.getDate();
  return n >= a ? o : (t.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    n
  ), t);
}
function Rc(e, r) {
  const t = r * 3;
  return vr(e, t);
}
function TA(e, r) {
  return Pc(e, r * 1e3);
}
function ps(e, r) {
  const t = r * 7;
  return On(e, t);
}
function on(e, r) {
  return vr(e, r * 12);
}
function Kn(e) {
  const r = oe(e);
  return r.setHours(0, 0, 0, 0), r;
}
function hs(e) {
  const r = oe(e), t = new Date(
    Date.UTC(
      r.getFullYear(),
      r.getMonth(),
      r.getDate(),
      r.getHours(),
      r.getMinutes(),
      r.getSeconds(),
      r.getMilliseconds()
    )
  );
  return t.setUTCFullYear(r.getFullYear()), +e - +t;
}
function La(e, r) {
  const t = Kn(e), n = Kn(r), o = +t - hs(t), a = +n - hs(n);
  return Math.round((o - a) / PA);
}
function gs(e, r) {
  const t = oe(e), n = oe(r), o = t.getFullYear() - n.getFullYear(), a = t.getMonth() - n.getMonth();
  return o * 12 + a;
}
function Xn(e) {
  const r = oe(e);
  return Math.trunc(r.getMonth() / 3) + 1;
}
function ms(e, r) {
  const t = oe(e), n = oe(r), o = t.getFullYear() - n.getFullYear(), a = Xn(t) - Xn(n);
  return o * 4 + a;
}
function vs(e, r) {
  const t = oe(e), n = oe(r);
  return t.getFullYear() - n.getFullYear();
}
function bm(e) {
  const r = oe(e);
  return r.setHours(23, 59, 59, 999), r;
}
function FA(e) {
  const r = oe(e), t = r.getMonth();
  return r.setFullYear(r.getFullYear(), t + 1, 0), r.setHours(23, 59, 59, 999), r;
}
let NA = {};
function lo() {
  return NA;
}
function LA(e, r) {
  var s, l;
  const t = lo(), n = t.weekStartsOn ?? ((l = (s = t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? 0, o = oe(e), a = o.getDay(), i = (a < n ? -7 : 0) + 6 - (a - n);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function ym(e) {
  const r = oe(e), t = r.getFullYear();
  return r.setFullYear(t + 1, 0, 0), r.setHours(23, 59, 59, 999), r;
}
const WA = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, BA = (e, r, t) => {
  let n;
  const o = WA[e];
  return typeof o == "string" ? n = o : r === 1 ? n = o.one : n = o.other.replace("{{count}}", r.toString()), t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "in " + n : n + " ago" : n;
};
function Nl(e) {
  return (r = {}) => {
    const t = r.width ? String(r.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const VA = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, GA = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, YA = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, HA = {
  date: Nl({
    formats: VA,
    defaultWidth: "full"
  }),
  time: Nl({
    formats: GA,
    defaultWidth: "full"
  }),
  dateTime: Nl({
    formats: YA,
    defaultWidth: "full"
  })
}, zA = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, $A = (e, r, t, n) => zA[e];
function fa(e) {
  return (r, t) => {
    const n = t != null && t.context ? String(t.context) : "standalone";
    let o;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = t != null && t.width ? String(t.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = t != null && t.width ? String(t.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(r) : r;
    return o[a];
  };
}
const XA = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, jA = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ZA = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, UA = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, JA = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, QA = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, qA = (e, r) => {
  const t = Number(e), n = t % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, KA = {
  ordinalNumber: qA,
  era: fa({
    values: XA,
    defaultWidth: "wide"
  }),
  quarter: fa({
    values: jA,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: fa({
    values: ZA,
    defaultWidth: "wide"
  }),
  day: fa({
    values: UA,
    defaultWidth: "wide"
  }),
  dayPeriod: fa({
    values: JA,
    defaultWidth: "wide",
    formattingValues: QA,
    defaultFormattingWidth: "wide"
  })
};
function pa(e) {
  return (r, t = {}) => {
    const n = t.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = r.match(o);
    if (!a)
      return null;
    const i = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? tP(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      eP(s, (d) => d.test(i))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(u)
    ) : u;
    const c = r.slice(i.length);
    return { value: u, rest: c };
  };
}
function eP(e, r) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && r(e[t]))
      return t;
}
function tP(e, r) {
  for (let t = 0; t < e.length; t++)
    if (r(e[t]))
      return t;
}
function rP(e) {
  return (r, t = {}) => {
    const n = r.match(e.matchPattern);
    if (!n) return null;
    const o = n[0], a = r.match(e.parsePattern);
    if (!a) return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = t.valueCallback ? t.valueCallback(i) : i;
    const s = r.slice(o.length);
    return { value: i, rest: s };
  };
}
const nP = /^(\d+)(th|st|nd|rd)?/i, oP = /\d+/i, aP = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, iP = {
  any: [/^b/i, /^(a|c)/i]
}, sP = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, lP = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, uP = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, cP = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, dP = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, fP = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, pP = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, hP = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, gP = {
  ordinalNumber: rP({
    matchPattern: nP,
    parsePattern: oP,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: pa({
    matchPatterns: aP,
    defaultMatchWidth: "wide",
    parsePatterns: iP,
    defaultParseWidth: "any"
  }),
  quarter: pa({
    matchPatterns: sP,
    defaultMatchWidth: "wide",
    parsePatterns: lP,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: pa({
    matchPatterns: uP,
    defaultMatchWidth: "wide",
    parsePatterns: cP,
    defaultParseWidth: "any"
  }),
  day: pa({
    matchPatterns: dP,
    defaultMatchWidth: "wide",
    parsePatterns: fP,
    defaultParseWidth: "any"
  }),
  dayPeriod: pa({
    matchPatterns: pP,
    defaultMatchWidth: "any",
    parsePatterns: hP,
    defaultParseWidth: "any"
  })
}, wm = {
  code: "en-US",
  formatDistance: BA,
  formatLong: HA,
  formatRelative: $A,
  localize: KA,
  match: gP,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function qs(e) {
  const r = oe(e), t = Be(e, 0);
  return t.setFullYear(r.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function mP(e) {
  const r = oe(e);
  return La(r, qs(r)) + 1;
}
function cn(e, r) {
  var s, l, u, c;
  const t = lo(), n = (r == null ? void 0 : r.weekStartsOn) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? t.weekStartsOn ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = oe(e), a = o.getDay(), i = (a < n ? 7 : 0) + a - n;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function Yo(e) {
  return cn(e, { weekStartsOn: 1 });
}
function Cm(e) {
  const r = oe(e), t = r.getFullYear(), n = Be(e, 0);
  n.setFullYear(t + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = Yo(n), a = Be(e, 0);
  a.setFullYear(t, 0, 4), a.setHours(0, 0, 0, 0);
  const i = Yo(a);
  return r.getTime() >= o.getTime() ? t + 1 : r.getTime() >= i.getTime() ? t : t - 1;
}
function vP(e) {
  const r = Cm(e), t = Be(e, 0);
  return t.setFullYear(r, 0, 4), t.setHours(0, 0, 0, 0), Yo(t);
}
function Oc(e) {
  const r = oe(e), t = +Yo(r) - +vP(r);
  return Math.round(t / vm) + 1;
}
function Tc(e, r) {
  var c, d, f, p;
  const t = oe(e), n = t.getFullYear(), o = lo(), a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((d = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((p = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = Be(e, 0);
  i.setFullYear(n + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = cn(i, r), l = Be(e, 0);
  l.setFullYear(n, 0, a), l.setHours(0, 0, 0, 0);
  const u = cn(l, r);
  return t.getTime() >= s.getTime() ? n + 1 : t.getTime() >= u.getTime() ? n : n - 1;
}
function bP(e, r) {
  var s, l, u, c;
  const t = lo(), n = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((l = (s = r == null ? void 0 : r.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? t.firstWeekContainsDate ?? ((c = (u = t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, o = Tc(e, r), a = Be(e, 0);
  return a.setFullYear(o, 0, n), a.setHours(0, 0, 0, 0), cn(a, r);
}
function Sm(e, r) {
  const t = oe(e), n = +cn(t, r) - +bP(t, r);
  return Math.round(n / vm) + 1;
}
function We(e, r) {
  const t = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(r, "0");
  return t + n;
}
const bn = {
  // Year
  y(e, r) {
    const t = e.getFullYear(), n = t > 0 ? t : 1 - t;
    return We(r === "yy" ? n % 100 : n, r.length);
  },
  // Month
  M(e, r) {
    const t = e.getMonth();
    return r === "M" ? String(t + 1) : We(t + 1, 2);
  },
  // Day of the month
  d(e, r) {
    return We(e.getDate(), r.length);
  },
  // AM or PM
  a(e, r) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, r) {
    return We(e.getHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H(e, r) {
    return We(e.getHours(), r.length);
  },
  // Minute
  m(e, r) {
    return We(e.getMinutes(), r.length);
  },
  // Second
  s(e, r) {
    return We(e.getSeconds(), r.length);
  },
  // Fraction of second
  S(e, r) {
    const t = r.length, n = e.getMilliseconds(), o = Math.trunc(
      n * Math.pow(10, t - 3)
    );
    return We(o, r.length);
  }
}, bo = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Rf = {
  // Era
  G: function(e, r, t) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(n, { width: "abbreviated" });
      case "GGGGG":
        return t.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, r, t) {
    if (r === "yo") {
      const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
      return t.ordinalNumber(o, { unit: "year" });
    }
    return bn.y(e, r);
  },
  // Local week-numbering year
  Y: function(e, r, t, n) {
    const o = Tc(e, n), a = o > 0 ? o : 1 - o;
    if (r === "YY") {
      const i = a % 100;
      return We(i, 2);
    }
    return r === "Yo" ? t.ordinalNumber(a, { unit: "year" }) : We(a, r.length);
  },
  // ISO week-numbering year
  R: function(e, r) {
    const t = Cm(e);
    return We(t, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, r) {
    const t = e.getFullYear();
    return We(t, r.length);
  },
  // Quarter
  Q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(n);
      case "QQ":
        return We(n, 2);
      case "Qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return t.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, r, t) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(n);
      case "qq":
        return We(n, 2);
      case "qo":
        return t.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return t.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "M":
      case "MM":
        return bn.M(e, r);
      case "Mo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return t.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, r, t) {
    const n = e.getMonth();
    switch (r) {
      case "L":
        return String(n + 1);
      case "LL":
        return We(n + 1, 2);
      case "Lo":
        return t.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return t.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, r, t, n) {
    const o = Sm(e, n);
    return r === "wo" ? t.ordinalNumber(o, { unit: "week" }) : We(o, r.length);
  },
  // ISO week of year
  I: function(e, r, t) {
    const n = Oc(e);
    return r === "Io" ? t.ordinalNumber(n, { unit: "week" }) : We(n, r.length);
  },
  // Day of the month
  d: function(e, r, t) {
    return r === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : bn.d(e, r);
  },
  // Day of year
  D: function(e, r, t) {
    const n = mP(e);
    return r === "Do" ? t.ordinalNumber(n, { unit: "dayOfYear" }) : We(n, r.length);
  },
  // Day of week
  E: function(e, r, t) {
    const n = e.getDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, r, t, n) {
    const o = e.getDay(), a = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(a);
      case "ee":
        return We(a, 2);
      case "eo":
        return t.ordinalNumber(a, { unit: "day" });
      case "eee":
        return t.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, r, t, n) {
    const o = e.getDay(), a = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(a);
      case "cc":
        return We(a, r.length);
      case "co":
        return t.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return t.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, r, t) {
    const n = e.getDay(), o = n === 0 ? 7 : n;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return We(o, r.length);
      case "io":
        return t.ordinalNumber(o, { unit: "day" });
      case "iii":
        return t.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, r, t) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n === 12 ? o = bo.noon : n === 0 ? o = bo.midnight : o = n / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, r, t) {
    const n = e.getHours();
    let o;
    switch (n >= 17 ? o = bo.evening : n >= 12 ? o = bo.afternoon : n >= 4 ? o = bo.morning : o = bo.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, r, t) {
    if (r === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), t.ordinalNumber(n, { unit: "hour" });
    }
    return bn.h(e, r);
  },
  // Hour [0-23]
  H: function(e, r, t) {
    return r === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : bn.H(e, r);
  },
  // Hour [0-11]
  K: function(e, r, t) {
    const n = e.getHours() % 12;
    return r === "Ko" ? t.ordinalNumber(n, { unit: "hour" }) : We(n, r.length);
  },
  // Hour [1-24]
  k: function(e, r, t) {
    let n = e.getHours();
    return n === 0 && (n = 24), r === "ko" ? t.ordinalNumber(n, { unit: "hour" }) : We(n, r.length);
  },
  // Minute
  m: function(e, r, t) {
    return r === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : bn.m(e, r);
  },
  // Second
  s: function(e, r, t) {
    return r === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : bn.s(e, r);
  },
  // Fraction of second
  S: function(e, r) {
    return bn.S(e, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, r, t) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (r) {
      case "X":
        return Tf(n);
      case "XXXX":
      case "XX":
        return Ln(n);
      case "XXXXX":
      case "XXX":
      default:
        return Ln(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "x":
        return Tf(n);
      case "xxxx":
      case "xx":
        return Ln(n);
      case "xxxxx":
      case "xxx":
      default:
        return Ln(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Of(n, ":");
      case "OOOO":
      default:
        return "GMT" + Ln(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, r, t) {
    const n = e.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Of(n, ":");
      case "zzzz":
      default:
        return "GMT" + Ln(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, r, t) {
    const n = Math.trunc(e.getTime() / 1e3);
    return We(n, r.length);
  },
  // Milliseconds timestamp
  T: function(e, r, t) {
    const n = e.getTime();
    return We(n, r.length);
  }
};
function Of(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = Math.trunc(n / 60), a = n % 60;
  return a === 0 ? t + String(o) : t + String(o) + r + We(a, 2);
}
function Tf(e, r) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + We(Math.abs(e) / 60, 2) : Ln(e, r);
}
function Ln(e, r = "") {
  const t = e > 0 ? "-" : "+", n = Math.abs(e), o = We(Math.trunc(n / 60), 2), a = We(n % 60, 2);
  return t + o + r + a;
}
const Ff = (e, r) => {
  switch (e) {
    case "P":
      return r.date({ width: "short" });
    case "PP":
      return r.date({ width: "medium" });
    case "PPP":
      return r.date({ width: "long" });
    case "PPPP":
    default:
      return r.date({ width: "full" });
  }
}, xm = (e, r) => {
  switch (e) {
    case "p":
      return r.time({ width: "short" });
    case "pp":
      return r.time({ width: "medium" });
    case "ppp":
      return r.time({ width: "long" });
    case "pppp":
    default:
      return r.time({ width: "full" });
  }
}, yP = (e, r) => {
  const t = e.match(/(P+)(p+)?/) || [], n = t[1], o = t[2];
  if (!o)
    return Ff(e, r);
  let a;
  switch (n) {
    case "P":
      a = r.dateTime({ width: "short" });
      break;
    case "PP":
      a = r.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = r.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = r.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Ff(n, r)).replace("{{time}}", xm(o, r));
}, bs = {
  p: xm,
  P: yP
}, wP = /^D+$/, CP = /^Y+$/, SP = ["D", "DD", "YY", "YYYY"];
function Im(e) {
  return wP.test(e);
}
function Dm(e) {
  return CP.test(e);
}
function ku(e, r, t) {
  const n = xP(e, r, t);
  if (console.warn(n), SP.includes(e)) throw new RangeError(n);
}
function xP(e, r, t) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${r}\`) for formatting ${n} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
function an(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function ys(e) {
  if (!an(e) && typeof e != "number")
    return !1;
  const r = oe(e);
  return !isNaN(Number(r));
}
const IP = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, DP = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _P = /^'([^]*?)'?$/, kP = /''/g, EP = /[a-zA-Z]/;
function Nf(e, r, t) {
  var c, d, f, p, h, g, m, v;
  const n = lo(), o = (t == null ? void 0 : t.locale) ?? n.locale ?? wm, a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((p = (f = n.locale) == null ? void 0 : f.options) == null ? void 0 : p.firstWeekContainsDate) ?? 1, i = (t == null ? void 0 : t.weekStartsOn) ?? ((g = (h = t == null ? void 0 : t.locale) == null ? void 0 : h.options) == null ? void 0 : g.weekStartsOn) ?? n.weekStartsOn ?? ((v = (m = n.locale) == null ? void 0 : m.options) == null ? void 0 : v.weekStartsOn) ?? 0, s = oe(e);
  if (!ys(s))
    throw new RangeError("Invalid time value");
  let l = r.match(DP).map((y) => {
    const C = y[0];
    if (C === "p" || C === "P") {
      const I = bs[C];
      return I(y, o.formatLong);
    }
    return y;
  }).join("").match(IP).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const C = y[0];
    if (C === "'")
      return { isToken: !1, value: MP(y) };
    if (Rf[C])
      return { isToken: !0, value: y };
    if (C.match(EP))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + C + "`"
      );
    return { isToken: !1, value: y };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((y) => {
    if (!y.isToken) return y.value;
    const C = y.value;
    (!(t != null && t.useAdditionalWeekYearTokens) && Dm(C) || !(t != null && t.useAdditionalDayOfYearTokens) && Im(C)) && ku(C, r, String(e));
    const I = Rf[C[0]];
    return I(s, C, o.localize, u);
  }).join("");
}
function MP(e) {
  const r = e.match(_P);
  return r ? r[1].replace(kP, "'") : e;
}
function Lf(e) {
  return oe(e).getDate();
}
function AP(e) {
  return oe(e).getDay();
}
function Tr(e) {
  return oe(e).getHours();
}
function Fr(e) {
  return oe(e).getMinutes();
}
function Ot(e) {
  return oe(e).getMonth();
}
function sn(e) {
  return oe(e).getSeconds();
}
function Eu(e) {
  return oe(e).getTime();
}
function Ce(e) {
  return oe(e).getFullYear();
}
function Mn(e, r) {
  const t = oe(e), n = oe(r);
  return t.getTime() > n.getTime();
}
function eo(e, r) {
  const t = oe(e), n = oe(r);
  return +t < +n;
}
function PP(e, r) {
  const t = oe(e), n = oe(r);
  return +t == +n;
}
function RP(e, r) {
  const t = Kn(e), n = Kn(r);
  return +t == +n;
}
function OP(e, r) {
  const t = oe(e), n = oe(r);
  return t.getFullYear() === n.getFullYear() && t.getMonth() === n.getMonth();
}
function Mu(e) {
  const r = oe(e), t = r.getMonth(), n = t - t % 3;
  return r.setMonth(n, 1), r.setHours(0, 0, 0, 0), r;
}
function TP(e, r) {
  const t = Mu(e), n = Mu(r);
  return +t == +n;
}
function FP(e, r) {
  const t = oe(e), n = oe(r);
  return t.getFullYear() === n.getFullYear();
}
function Wa(e, r) {
  const t = +oe(e), [n, o] = [
    +oe(r.start),
    +oe(r.end)
  ].sort((a, i) => a - i);
  return t >= n && t <= o;
}
function Wf(e) {
  let r;
  return e.forEach(function(t) {
    const n = oe(t);
    (r === void 0 || r < n || isNaN(Number(n))) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function Bf(e) {
  let r;
  return e.forEach((t) => {
    const n = oe(t);
    (!r || r > n || isNaN(+n)) && (r = n);
  }), r || /* @__PURE__ */ new Date(NaN);
}
function NP() {
  return Object.assign({}, lo());
}
function LP(e, r) {
  const t = r instanceof Date ? Be(r, 0) : new r(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const WP = 10;
class _m {
  constructor() {
    ne(this, "subPriority", 0);
  }
  validate(r, t) {
    return !0;
  }
}
class BP extends _m {
  constructor(r, t, n, o, a) {
    super(), this.value = r, this.validateValue = t, this.setValue = n, this.priority = o, a && (this.subPriority = a);
  }
  validate(r, t) {
    return this.validateValue(r, this.value, t);
  }
  set(r, t, n) {
    return this.setValue(r, t, this.value, n);
  }
}
class VP extends _m {
  constructor() {
    super(...arguments);
    ne(this, "priority", WP);
    ne(this, "subPriority", -1);
  }
  set(t, n) {
    return n.timestampIsSet ? t : Be(t, LP(t, Date));
  }
}
class Fe {
  run(r, t, n, o) {
    const a = this.parse(r, t, n, o);
    return a ? {
      setter: new BP(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(r, t, n) {
    return !0;
  }
}
class GP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 140);
    ne(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
      case "GGGGG":
        return o.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return o.era(t, { width: "wide" }) || o.era(t, { width: "abbreviated" }) || o.era(t, { width: "narrow" });
    }
  }
  set(t, n, o) {
    return n.era = o, t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const ft = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Mr = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function pt(e, r) {
  return e && {
    value: r(e.value),
    rest: e.rest
  };
}
function nt(e, r) {
  const t = r.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: r.slice(t[0].length)
  } : null;
}
function Ar(e, r) {
  const t = r.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: r.slice(1)
    };
  const n = t[1] === "+" ? 1 : -1, o = t[2] ? parseInt(t[2], 10) : 0, a = t[3] ? parseInt(t[3], 10) : 0, i = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: n * (o * Qs + a * Js + i * RA),
    rest: r.slice(t[0].length)
  };
}
function km(e) {
  return nt(ft.anyDigitsSigned, e);
}
function ut(e, r) {
  switch (e) {
    case 1:
      return nt(ft.singleDigit, r);
    case 2:
      return nt(ft.twoDigits, r);
    case 3:
      return nt(ft.threeDigits, r);
    case 4:
      return nt(ft.fourDigits, r);
    default:
      return nt(new RegExp("^\\d{1," + e + "}"), r);
  }
}
function ws(e, r) {
  switch (e) {
    case 1:
      return nt(ft.singleDigitSigned, r);
    case 2:
      return nt(ft.twoDigitsSigned, r);
    case 3:
      return nt(ft.threeDigitsSigned, r);
    case 4:
      return nt(ft.fourDigitsSigned, r);
    default:
      return nt(new RegExp("^-?\\d{1," + e + "}"), r);
  }
}
function Fc(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Em(e, r) {
  const t = r > 0, n = t ? r : 1 - r;
  let o;
  if (n <= 50)
    o = e || 100;
  else {
    const a = n + 50, i = Math.trunc(a / 100) * 100, s = e >= a % 100;
    o = e + i - (s ? 100 : 0);
  }
  return t ? o : 1 - o;
}
function Mm(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class YP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, o) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: n === "yy"
    });
    switch (n) {
      case "y":
        return pt(ut(4, t), a);
      case "yo":
        return pt(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          a
        );
      default:
        return pt(ut(n.length, t), a);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, o) {
    const a = t.getFullYear();
    if (o.isTwoDigitYear) {
      const s = Em(
        o.year,
        a
      );
      return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const i = !("era" in n) || n.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class HP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const a = (i) => ({
      year: i,
      isTwoDigitYear: n === "YY"
    });
    switch (n) {
      case "Y":
        return pt(ut(4, t), a);
      case "Yo":
        return pt(
          o.ordinalNumber(t, {
            unit: "year"
          }),
          a
        );
      default:
        return pt(ut(n.length, t), a);
    }
  }
  validate(t, n) {
    return n.isTwoDigitYear || n.year > 0;
  }
  set(t, n, o, a) {
    const i = Tc(t, a);
    if (o.isTwoDigitYear) {
      const l = Em(
        o.year,
        i
      );
      return t.setFullYear(
        l,
        0,
        a.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), cn(t, a);
    }
    const s = !("era" in n) || n.era === 1 ? o.year : 1 - o.year;
    return t.setFullYear(s, 0, a.firstWeekContainsDate), t.setHours(0, 0, 0, 0), cn(t, a);
  }
}
class zP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n) {
    return ws(n === "R" ? 4 : n.length, t);
  }
  set(t, n, o) {
    const a = Be(t, 0);
    return a.setFullYear(o, 0, 4), a.setHours(0, 0, 0, 0), Yo(a);
  }
}
class $P extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 130);
    ne(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, n) {
    return ws(n === "u" ? 4 : n.length, t);
  }
  set(t, n, o) {
    return t.setFullYear(o, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class XP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 120);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "Q":
      case "QQ":
        return ut(n.length, t);
      case "Qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class jP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 120);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "q":
      case "qq":
        return ut(n.length, t);
      case "qo":
        return o.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return o.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || o.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 4;
  }
  set(t, n, o) {
    return t.setMonth((o - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ZP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    ne(this, "priority", 110);
  }
  parse(t, n, o) {
    const a = (i) => i - 1;
    switch (n) {
      case "M":
        return pt(
          nt(ft.month, t),
          a
        );
      case "MM":
        return pt(ut(2, t), a);
      case "Mo":
        return pt(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          a
        );
      case "MMM":
        return o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return o.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return o.month(t, { width: "wide", context: "formatting" }) || o.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class UP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 110);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const a = (i) => i - 1;
    switch (n) {
      case "L":
        return pt(
          nt(ft.month, t),
          a
        );
      case "LL":
        return pt(ut(2, t), a);
      case "Lo":
        return pt(
          o.ordinalNumber(t, {
            unit: "month"
          }),
          a
        );
      case "LLL":
        return o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return o.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return o.month(t, { width: "wide", context: "standalone" }) || o.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.setMonth(o, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function JP(e, r, t) {
  const n = oe(e), o = Sm(n, t) - r;
  return n.setDate(n.getDate() - o * 7), n;
}
class QP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 100);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "w":
        return nt(ft.week, t);
      case "wo":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, o, a) {
    return cn(JP(t, o, a), a);
  }
}
function qP(e, r) {
  const t = oe(e), n = Oc(t) - r;
  return t.setDate(t.getDate() - n * 7), t;
}
class KP extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 100);
    ne(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "I":
        return nt(ft.week, t);
      case "Io":
        return o.ordinalNumber(t, { unit: "week" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 53;
  }
  set(t, n, o) {
    return Yo(qP(t, o));
  }
}
const eR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], tR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class rR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "subPriority", 1);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "d":
        return nt(ft.date, t);
      case "do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    const o = t.getFullYear(), a = Mm(o), i = t.getMonth();
    return a ? n >= 1 && n <= tR[i] : n >= 1 && n <= eR[i];
  }
  set(t, n, o) {
    return t.setDate(o), t.setHours(0, 0, 0, 0), t;
  }
}
class nR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "subpriority", 1);
    ne(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    switch (n) {
      case "D":
      case "DD":
        return nt(ft.dayOfYear, t);
      case "Do":
        return o.ordinalNumber(t, { unit: "date" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    const o = t.getFullYear();
    return Mm(o) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
  }
  set(t, n, o) {
    return t.setMonth(0, o), t.setHours(0, 0, 0, 0), t;
  }
}
function Nc(e, r, t) {
  var d, f, p, h;
  const n = lo(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((h = (p = n.locale) == null ? void 0 : p.options) == null ? void 0 : h.weekStartsOn) ?? 0, a = oe(e), i = a.getDay(), l = (r % 7 + 7) % 7, u = 7 - o, c = r < 0 || r > 6 ? r - (i + u) % 7 : (l + u) % 7 - (i + u) % 7;
  return On(a, c);
}
class oR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, a) {
    return t = Nc(t, o, a), t.setHours(0, 0, 0, 0), t;
  }
}
class aR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o, a) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "e":
      case "ee":
        return pt(ut(n.length, t), i);
      case "eo":
        return pt(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "eee":
        return o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return o.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return o.day(t, { width: "wide", context: "formatting" }) || o.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.day(t, { width: "short", context: "formatting" }) || o.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, a) {
    return t = Nc(t, o, a), t.setHours(0, 0, 0, 0), t;
  }
}
class iR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, n, o, a) {
    const i = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (n) {
      case "c":
      case "cc":
        return pt(ut(n.length, t), i);
      case "co":
        return pt(
          o.ordinalNumber(t, {
            unit: "day"
          }),
          i
        );
      case "ccc":
        return o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return o.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return o.day(t, { width: "wide", context: "standalone" }) || o.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || o.day(t, { width: "short", context: "standalone" }) || o.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 6;
  }
  set(t, n, o, a) {
    return t = Nc(t, o, a), t.setHours(0, 0, 0, 0), t;
  }
}
function sR(e) {
  let t = oe(e).getDay();
  return t === 0 && (t = 7), t;
}
function lR(e, r) {
  const t = oe(e), n = sR(t), o = r - n;
  return On(t, o);
}
class uR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 90);
    ne(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, n, o) {
    const a = (i) => i === 0 ? 7 : i;
    switch (n) {
      case "i":
      case "ii":
        return ut(n.length, t);
      case "io":
        return o.ordinalNumber(t, { unit: "day" });
      case "iii":
        return pt(
          o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiii":
        return pt(
          o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiiiii":
        return pt(
          o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      case "iiii":
      default:
        return pt(
          o.day(t, {
            width: "wide",
            context: "formatting"
          }) || o.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || o.day(t, {
            width: "short",
            context: "formatting"
          }) || o.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 7;
  }
  set(t, n, o) {
    return t = lR(t, o), t.setHours(0, 0, 0, 0), t;
  }
}
class cR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 80);
    ne(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "a":
      case "aa":
      case "aaa":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(Fc(o), 0, 0, 0), t;
  }
}
class dR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 80);
    ne(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "b":
      case "bb":
      case "bbb":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(Fc(o), 0, 0, 0), t;
  }
}
class fR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 80);
    ne(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "B":
      case "BB":
      case "BBB":
        return o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return o.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || o.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, n, o) {
    return t.setHours(Fc(o), 0, 0, 0), t;
  }
}
class pR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "h":
        return nt(ft.hour12h, t);
      case "ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 12;
  }
  set(t, n, o) {
    const a = t.getHours() >= 12;
    return a && o < 12 ? t.setHours(o + 12, 0, 0, 0) : !a && o === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class hR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "H":
        return nt(ft.hour23h, t);
      case "Ho":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 23;
  }
  set(t, n, o) {
    return t.setHours(o, 0, 0, 0), t;
  }
}
class gR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "K":
        return nt(ft.hour11h, t);
      case "Ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 11;
  }
  set(t, n, o) {
    return t.getHours() >= 12 && o < 12 ? t.setHours(o + 12, 0, 0, 0) : t.setHours(o, 0, 0, 0), t;
  }
}
class mR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 70);
    ne(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "k":
        return nt(ft.hour24h, t);
      case "ko":
        return o.ordinalNumber(t, { unit: "hour" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 1 && n <= 24;
  }
  set(t, n, o) {
    const a = o <= 24 ? o % 24 : o;
    return t.setHours(a, 0, 0, 0), t;
  }
}
class vR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 60);
    ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "m":
        return nt(ft.minute, t);
      case "mo":
        return o.ordinalNumber(t, { unit: "minute" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, o) {
    return t.setMinutes(o, 0, 0), t;
  }
}
class bR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 50);
    ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n, o) {
    switch (n) {
      case "s":
        return nt(ft.second, t);
      case "so":
        return o.ordinalNumber(t, { unit: "second" });
      default:
        return ut(n.length, t);
    }
  }
  validate(t, n) {
    return n >= 0 && n <= 59;
  }
  set(t, n, o) {
    return t.setSeconds(o, 0), t;
  }
}
class yR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 30);
    ne(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, n) {
    const o = (a) => Math.trunc(a * Math.pow(10, -n.length + 3));
    return pt(ut(n.length, t), o);
  }
  set(t, n, o) {
    return t.setMilliseconds(o), t;
  }
}
class wR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 10);
    ne(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, n) {
    switch (n) {
      case "X":
        return Ar(
          Mr.basicOptionalMinutes,
          t
        );
      case "XX":
        return Ar(Mr.basic, t);
      case "XXXX":
        return Ar(
          Mr.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return Ar(
          Mr.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return Ar(Mr.extended, t);
    }
  }
  set(t, n, o) {
    return n.timestampIsSet ? t : Be(
      t,
      t.getTime() - hs(t) - o
    );
  }
}
class CR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 10);
    ne(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, n) {
    switch (n) {
      case "x":
        return Ar(
          Mr.basicOptionalMinutes,
          t
        );
      case "xx":
        return Ar(Mr.basic, t);
      case "xxxx":
        return Ar(
          Mr.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return Ar(
          Mr.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return Ar(Mr.extended, t);
    }
  }
  set(t, n, o) {
    return n.timestampIsSet ? t : Be(
      t,
      t.getTime() - hs(t) - o
    );
  }
}
class SR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 40);
    ne(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return km(t);
  }
  set(t, n, o) {
    return [Be(t, o * 1e3), { timestampIsSet: !0 }];
  }
}
class xR extends Fe {
  constructor() {
    super(...arguments);
    ne(this, "priority", 20);
    ne(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return km(t);
  }
  set(t, n, o) {
    return [Be(t, o), { timestampIsSet: !0 }];
  }
}
const IR = {
  G: new GP(),
  y: new YP(),
  Y: new HP(),
  R: new zP(),
  u: new $P(),
  Q: new XP(),
  q: new jP(),
  M: new ZP(),
  L: new UP(),
  w: new QP(),
  I: new KP(),
  d: new rR(),
  D: new nR(),
  E: new oR(),
  e: new aR(),
  c: new iR(),
  i: new uR(),
  a: new cR(),
  b: new dR(),
  B: new fR(),
  h: new pR(),
  H: new hR(),
  K: new gR(),
  k: new mR(),
  m: new vR(),
  s: new bR(),
  S: new yR(),
  X: new wR(),
  x: new CR(),
  t: new SR(),
  T: new xR()
}, DR = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _R = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, kR = /^'([^]*?)'?$/, ER = /''/g, MR = /\S/, AR = /[a-zA-Z]/;
function Ll(e, r, t, n) {
  var g, m, v, y, C, I, b, D;
  const o = NP(), a = (n == null ? void 0 : n.locale) ?? o.locale ?? wm, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((m = (g = n == null ? void 0 : n.locale) == null ? void 0 : g.options) == null ? void 0 : m.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((y = (v = o.locale) == null ? void 0 : v.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((I = (C = n == null ? void 0 : n.locale) == null ? void 0 : C.options) == null ? void 0 : I.weekStartsOn) ?? o.weekStartsOn ?? ((D = (b = o.locale) == null ? void 0 : b.options) == null ? void 0 : D.weekStartsOn) ?? 0;
  if (r === "")
    return e === "" ? oe(t) : Be(t, NaN);
  const l = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: a
  }, u = [new VP()], c = r.match(_R).map((x) => {
    const _ = x[0];
    if (_ in bs) {
      const E = bs[_];
      return E(x, a.formatLong);
    }
    return x;
  }).join("").match(DR), d = [];
  for (let x of c) {
    !(n != null && n.useAdditionalWeekYearTokens) && Dm(x) && ku(x, r, e), !(n != null && n.useAdditionalDayOfYearTokens) && Im(x) && ku(x, r, e);
    const _ = x[0], E = IR[_];
    if (E) {
      const { incompatibleTokens: R } = E;
      if (Array.isArray(R)) {
        const G = d.find(
          (V) => R.includes(V.token) || V.token === _
        );
        if (G)
          throw new RangeError(
            `The format string mustn't contain \`${G.fullToken}\` and \`${x}\` at the same time`
          );
      } else if (E.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${x}\` and any other token at the same time`
        );
      d.push({ token: _, fullToken: x });
      const L = E.run(
        e,
        x,
        a.match,
        l
      );
      if (!L)
        return Be(t, NaN);
      u.push(L.setter), e = L.rest;
    } else {
      if (_.match(AR))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (x === "''" ? x = "'" : _ === "'" && (x = PR(x)), e.indexOf(x) === 0)
        e = e.slice(x.length);
      else
        return Be(t, NaN);
    }
  }
  if (e.length > 0 && MR.test(e))
    return Be(t, NaN);
  const f = u.map((x) => x.priority).sort((x, _) => _ - x).filter((x, _, E) => E.indexOf(x) === _).map(
    (x) => u.filter((_) => _.priority === x).sort((_, E) => E.subPriority - _.subPriority)
  ).map((x) => x[0]);
  let p = oe(t);
  if (isNaN(p.getTime()))
    return Be(t, NaN);
  const h = {};
  for (const x of f) {
    if (!x.validate(p, l))
      return Be(t, NaN);
    const _ = x.set(p, h, l);
    Array.isArray(_) ? (p = _[0], Object.assign(h, _[1])) : p = _;
  }
  return Be(t, p);
}
function PR(e) {
  return e.match(kR)[1].replace(ER, "'");
}
function RR(e, r) {
  const n = NR(e);
  let o;
  if (n.date) {
    const l = LR(n.date, 2);
    o = WR(l.restDateString, l.year);
  }
  if (!o || isNaN(o.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const a = o.getTime();
  let i = 0, s;
  if (n.time && (i = BR(n.time), isNaN(i)))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (s = VR(n.timezone), isNaN(s))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(a + i), u = /* @__PURE__ */ new Date(0);
    return u.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), u.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), u;
  }
  return new Date(a + i + s);
}
const yi = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, OR = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, TR = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, FR = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function NR(e) {
  const r = {}, t = e.split(yi.dateTimeDelimiter);
  let n;
  if (t.length > 2)
    return r;
  if (/:/.test(t[0]) ? n = t[0] : (r.date = t[0], n = t[1], yi.timeZoneDelimiter.test(r.date) && (r.date = e.split(yi.timeZoneDelimiter)[0], n = e.substr(
    r.date.length,
    e.length
  ))), n) {
    const o = yi.timezone.exec(n);
    o ? (r.time = n.replace(o[1], ""), r.timezone = o[1]) : r.time = n;
  }
  return r;
}
function LR(e, r) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + r) + "})|(\\d{2}|[+-]\\d{" + (2 + r) + "})$)"
  ), n = e.match(t);
  if (!n) return { year: NaN, restDateString: "" };
  const o = n[1] ? parseInt(n[1]) : null, a = n[2] ? parseInt(n[2]) : null;
  return {
    year: a === null ? o : a * 100,
    restDateString: e.slice((n[1] || n[2]).length)
  };
}
function WR(e, r) {
  if (r === null) return /* @__PURE__ */ new Date(NaN);
  const t = e.match(OR);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const n = !!t[4], o = ha(t[1]), a = ha(t[2]) - 1, i = ha(t[3]), s = ha(t[4]), l = ha(t[5]) - 1;
  if (n)
    return $R(r, s, l) ? GR(r, s, l) : /* @__PURE__ */ new Date(NaN);
  {
    const u = /* @__PURE__ */ new Date(0);
    return !HR(r, a, i) || !zR(r, o) ? /* @__PURE__ */ new Date(NaN) : (u.setUTCFullYear(r, a, Math.max(o, i)), u);
  }
}
function ha(e) {
  return e ? parseInt(e) : 1;
}
function BR(e) {
  const r = e.match(TR);
  if (!r) return NaN;
  const t = Wl(r[1]), n = Wl(r[2]), o = Wl(r[3]);
  return XR(t, n, o) ? t * Qs + n * Js + o * 1e3 : NaN;
}
function Wl(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function VR(e) {
  if (e === "Z") return 0;
  const r = e.match(FR);
  if (!r) return 0;
  const t = r[1] === "+" ? -1 : 1, n = parseInt(r[2]), o = r[3] && parseInt(r[3]) || 0;
  return jR(n, o) ? t * (n * Qs + o * Js) : NaN;
}
function GR(e, r, t) {
  const n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(e, 0, 4);
  const o = n.getUTCDay() || 7, a = (r - 1) * 7 + t + 1 - o;
  return n.setUTCDate(n.getUTCDate() + a), n;
}
const YR = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Am(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function HR(e, r, t) {
  return r >= 0 && r <= 11 && t >= 1 && t <= (YR[r] || (Am(e) ? 29 : 28));
}
function zR(e, r) {
  return r >= 1 && r <= (Am(e) ? 366 : 365);
}
function $R(e, r, t) {
  return r >= 1 && r <= 53 && t >= 0 && t <= 6;
}
function XR(e, r, t) {
  return e === 24 ? r === 0 && t === 0 : t >= 0 && t < 60 && r >= 0 && r < 60 && e >= 0 && e < 25;
}
function jR(e, r) {
  return r >= 0 && r <= 59;
}
function ZR(e) {
  const r = oe(e), t = r.getFullYear(), n = r.getMonth(), o = Be(e, 0);
  return o.setFullYear(t, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function Ht(e, r) {
  const t = oe(e), n = t.getFullYear(), o = t.getDate(), a = Be(e, 0);
  a.setFullYear(n, r, 15), a.setHours(0, 0, 0, 0);
  const i = ZR(a);
  return t.setMonth(r, Math.min(o, i)), t;
}
function UR(e, r) {
  let t = oe(e);
  return isNaN(+t) ? Be(e, NaN) : (r.year != null && t.setFullYear(r.year), r.month != null && (t = Ht(t, r.month)), r.date != null && t.setDate(r.date), r.hours != null && t.setHours(r.hours), r.minutes != null && t.setMinutes(r.minutes), r.seconds != null && t.setSeconds(r.seconds), r.milliseconds != null && t.setMilliseconds(r.milliseconds), t);
}
function Ni(e, r) {
  const t = oe(e);
  return t.setHours(r), t;
}
function Li(e, r) {
  const t = oe(e);
  return t.setMinutes(r), t;
}
function Co(e, r) {
  const t = oe(e), n = Math.trunc(t.getMonth() / 3) + 1, o = r - n;
  return Ht(t, t.getMonth() + o * 3);
}
function Wi(e, r) {
  const t = oe(e);
  return t.setSeconds(r), t;
}
function Ir(e, r) {
  const t = oe(e);
  return isNaN(+t) ? Be(e, NaN) : (t.setFullYear(r), t);
}
function Pm(e) {
  const r = oe(e);
  return r.setDate(1), r.setHours(0, 0, 0, 0), r;
}
function JR(e, r) {
  return On(e, -1);
}
function Ho(e, r) {
  return vr(e, -r);
}
function Rm(e, r) {
  return Rc(e, -1);
}
function Vf(e, r) {
  return ps(e, -1);
}
function zo(e, r) {
  return on(e, -r);
}
var QR = typeof document < "u", qR = function() {
}, Bi = QR ? Ga : qR;
function Cs(e, r) {
  if (e === r)
    return !0;
  if (typeof e != typeof r)
    return !1;
  if (typeof e == "function" && e.toString() === r.toString())
    return !0;
  let t, n, o;
  if (e && r && typeof e == "object") {
    if (Array.isArray(e)) {
      if (t = e.length, t !== r.length) return !1;
      for (n = t; n-- !== 0; )
        if (!Cs(e[n], r[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), t = o.length, t !== Object.keys(r).length)
      return !1;
    for (n = t; n-- !== 0; )
      if (!{}.hasOwnProperty.call(r, o[n]))
        return !1;
    for (n = t; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !Cs(e[a], r[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
}
function Om(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Gf(e, r) {
  const t = Om(e);
  return Math.round(r * t) / t;
}
function Bl(e) {
  const r = U.useRef(e);
  return Bi(() => {
    r.current = e;
  }), r;
}
function KR(e) {
  e === void 0 && (e = {});
  const {
    placement: r = "bottom",
    strategy: t = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, d] = U.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: r,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = U.useState(n);
  Cs(f, n) || p(n);
  const [h, g] = U.useState(null), [m, v] = U.useState(null), y = U.useCallback((H) => {
    H !== D.current && (D.current = H, g(H));
  }, []), C = U.useCallback((H) => {
    H !== x.current && (x.current = H, v(H));
  }, []), I = a || h, b = i || m, D = U.useRef(null), x = U.useRef(null), _ = U.useRef(c), E = l != null, R = Bl(l), L = Bl(o), G = Bl(u), V = U.useCallback(() => {
    if (!D.current || !x.current)
      return;
    const H = {
      placement: r,
      strategy: t,
      middleware: f
    };
    L.current && (H.platform = L.current), K0(D.current, x.current, H).then((re) => {
      const W = {
        ...re,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: G.current !== !1
      };
      O.current && !Cs(_.current, W) && (_.current = W, Ob.flushSync(() => {
        d(W);
      }));
    });
  }, [f, r, t, L, G]);
  Bi(() => {
    u === !1 && _.current.isPositioned && (_.current.isPositioned = !1, d((H) => ({
      ...H,
      isPositioned: !1
    })));
  }, [u]);
  const O = U.useRef(!1);
  Bi(() => (O.current = !0, () => {
    O.current = !1;
  }), []), Bi(() => {
    if (I && (D.current = I), b && (x.current = b), I && b) {
      if (R.current)
        return R.current(I, b, V);
      V();
    }
  }, [I, b, V, R, E]);
  const N = U.useMemo(() => ({
    reference: D,
    floating: x,
    setReference: y,
    setFloating: C
  }), [y, C]), P = U.useMemo(() => ({
    reference: I,
    floating: b
  }), [I, b]), B = U.useMemo(() => {
    const H = {
      position: t,
      left: 0,
      top: 0
    };
    if (!P.floating)
      return H;
    const re = Gf(P.floating, c.x), W = Gf(P.floating, c.y);
    return s ? {
      ...H,
      transform: "translate(" + re + "px, " + W + "px)",
      ...Om(P.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: re,
      top: W
    };
  }, [t, s, P.floating, c.x, c.y]);
  return U.useMemo(() => ({
    ...c,
    update: V,
    refs: N,
    elements: P,
    floatingStyles: B
  }), [c, V, N, P, B]);
}
const eO = (e) => {
  function r(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const {
        element: n,
        padding: o
      } = typeof e == "function" ? e(t) : e;
      return n && r(n) ? n.current != null ? hd({
        element: n.current,
        padding: o
      }).fn(t) : {} : n ? hd({
        element: n,
        padding: o
      }).fn(t) : {};
    }
  };
}, tO = (e, r) => ({
  ...Q0(e),
  options: [e, r]
}), rO = (e, r) => ({
  ...q0(e),
  options: [e, r]
}), nO = (e, r) => ({
  ...eO(e),
  options: [e, r]
}), Tm = {
  ...U
}, oO = Tm.useInsertionEffect, aO = oO || ((e) => e());
function iO(e) {
  const r = U.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return aO(() => {
    r.current = e;
  }), U.useCallback(function() {
    for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++)
      n[o] = arguments[o];
    return r.current == null ? void 0 : r.current(...n);
  }, []);
}
var Ss = typeof document < "u" ? Ga : Ye;
function Au() {
  return Au = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Au.apply(this, arguments);
}
let Yf = !1, sO = 0;
const Hf = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + sO++
);
function lO() {
  const [e, r] = U.useState(() => Yf ? Hf() : void 0);
  return Ss(() => {
    e == null && r(Hf());
  }, []), U.useEffect(() => {
    Yf = !0;
  }, []), e;
}
const uO = Tm.useId, Fm = uO || lO;
let Ba;
process.env.NODE_ENV !== "production" && (Ba = /* @__PURE__ */ new Set());
function cO() {
  for (var e, r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  const o = "Floating UI: " + t.join(" ");
  if (!((e = Ba) != null && e.has(o))) {
    var a;
    (a = Ba) == null || a.add(o), console.warn(o);
  }
}
function dO() {
  for (var e, r = arguments.length, t = new Array(r), n = 0; n < r; n++)
    t[n] = arguments[n];
  const o = "Floating UI: " + t.join(" ");
  if (!((e = Ba) != null && e.has(o))) {
    var a;
    (a = Ba) == null || a.add(o), console.error(o);
  }
}
const fO = /* @__PURE__ */ U.forwardRef(function(r, t) {
  const {
    context: {
      placement: n,
      elements: {
        floating: o
      },
      middlewareData: {
        arrow: a,
        shift: i
      }
    },
    width: s = 14,
    height: l = 7,
    tipRadius: u = 0,
    strokeWidth: c = 0,
    staticOffset: d,
    stroke: f,
    d: p,
    style: {
      transform: h,
      ...g
    } = {},
    ...m
  } = r;
  process.env.NODE_ENV !== "production" && (t || cO("The `ref` prop is required for `FloatingArrow`."));
  const v = Fm(), [y, C] = U.useState(!1);
  if (Ss(() => {
    if (!o) return;
    or(o).direction === "rtl" && C(!0);
  }, [o]), !o)
    return null;
  const [I, b] = n.split("-"), D = I === "top" || I === "bottom";
  let x = d;
  (D && i != null && i.x || !D && i != null && i.y) && (x = null);
  const _ = c * 2, E = _ / 2, R = s / 2 * (u / -8 + 1), L = l / 2 * u / 4, G = !!p, V = x && b === "end" ? "bottom" : "top";
  let O = x && b === "end" ? "right" : "left";
  x && y && (O = b === "end" ? "left" : "right");
  const N = (a == null ? void 0 : a.x) != null ? x || a.x : "", P = (a == null ? void 0 : a.y) != null ? x || a.y : "", B = p || "M0,0" + (" H" + s) + (" L" + (s - R) + "," + (l - L)) + (" Q" + s / 2 + "," + l + " " + R + "," + (l - L)) + " Z", H = {
    top: G ? "rotate(180deg)" : "",
    left: G ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: G ? "" : "rotate(180deg)",
    right: G ? "rotate(-90deg)" : "rotate(90deg)"
  }[I];
  return /* @__PURE__ */ U.createElement("svg", Au({}, m, {
    "aria-hidden": !0,
    ref: t,
    width: G ? s : s + _,
    height: s,
    viewBox: "0 0 " + s + " " + (l > s ? l : s),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [O]: N,
      [V]: P,
      [I]: D || G ? "100%" : "calc(100% - " + _ / 2 + "px)",
      transform: [H, h].filter((re) => !!re).join(" "),
      ...g
    }
  }), _ > 0 && /* @__PURE__ */ U.createElement("path", {
    clipPath: "url(#" + v + ")",
    fill: "none",
    stroke: f,
    strokeWidth: _ + (p ? 0 : 1),
    d: B
  }), /* @__PURE__ */ U.createElement("path", {
    stroke: _ && !p ? m.fill : "none",
    d: B
  }), /* @__PURE__ */ U.createElement("clipPath", {
    id: v
  }, /* @__PURE__ */ U.createElement("rect", {
    x: -E,
    y: E * (G ? -1 : 1),
    width: s + _,
    height: s
  })));
});
function pO() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(r, t) {
      var n;
      (n = e.get(r)) == null || n.forEach((o) => o(t));
    },
    on(r, t) {
      e.set(r, [...e.get(r) || [], t]);
    },
    off(r, t) {
      var n;
      e.set(r, ((n = e.get(r)) == null ? void 0 : n.filter((o) => o !== t)) || []);
    }
  };
}
const hO = /* @__PURE__ */ U.createContext(null), gO = /* @__PURE__ */ U.createContext(null), mO = () => {
  var e;
  return ((e = U.useContext(hO)) == null ? void 0 : e.id) || null;
}, vO = () => U.useContext(gO);
function bO(e) {
  const {
    open: r = !1,
    onOpenChange: t,
    elements: n
  } = e, o = Fm(), a = U.useRef({}), [i] = U.useState(() => pO()), s = mO() != null;
  if (process.env.NODE_ENV !== "production") {
    const p = n.reference;
    p && !_t(p) && dO("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, u] = U.useState(n.reference), c = iO((p, h, g) => {
    a.current.openEvent = p ? h : void 0, i.emit("openchange", {
      open: p,
      event: h,
      reason: g,
      nested: s
    }), t == null || t(p, h, g);
  }), d = U.useMemo(() => ({
    setPositionReference: u
  }), []), f = U.useMemo(() => ({
    reference: l || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [l, n.reference, n.floating]);
  return U.useMemo(() => ({
    dataRef: a,
    open: r,
    onOpenChange: c,
    elements: f,
    events: i,
    floatingId: o,
    refs: d
  }), [r, c, f, i, o, d]);
}
function yO(e) {
  e === void 0 && (e = {});
  const {
    nodeId: r
  } = e, t = bO({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || t, o = n.elements, [a, i] = U.useState(null), [s, l] = U.useState(null), c = (o == null ? void 0 : o.domReference) || a, d = U.useRef(null), f = vO();
  Ss(() => {
    c && (d.current = c);
  }, [c]);
  const p = KR({
    ...e,
    elements: {
      ...o,
      ...s && {
        reference: s
      }
    }
  }), h = U.useCallback((C) => {
    const I = _t(C) ? {
      getBoundingClientRect: () => C.getBoundingClientRect(),
      contextElement: C
    } : C;
    l(I), p.refs.setReference(I);
  }, [p.refs]), g = U.useCallback((C) => {
    (_t(C) || C === null) && (d.current = C, i(C)), (_t(p.refs.reference.current) || p.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    C !== null && !_t(C)) && p.refs.setReference(C);
  }, [p.refs]), m = U.useMemo(() => ({
    ...p.refs,
    setReference: g,
    setPositionReference: h,
    domReference: d
  }), [p.refs, g, h]), v = U.useMemo(() => ({
    ...p.elements,
    domReference: c
  }), [p.elements, c]), y = U.useMemo(() => ({
    ...p,
    ...n,
    refs: m,
    elements: v,
    nodeId: r
  }), [p, m, v, r, n]);
  return Ss(() => {
    n.dataRef.current.floatingContext = y;
    const C = f == null ? void 0 : f.nodesRef.current.find((I) => I.id === r);
    C && (C.context = y);
  }), U.useMemo(() => ({
    ...p,
    context: y,
    refs: m,
    elements: v
  }), [p, m, v, y]);
}
/*!
  react-datepicker v7.4.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var Pu = function(r, t) {
  return Pu = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(n, o) {
    n.__proto__ = o;
  } || function(n, o) {
    for (var a in o) Object.prototype.hasOwnProperty.call(o, a) && (n[a] = o[a]);
  }, Pu(r, t);
};
function Ct(e, r) {
  if (typeof r != "function" && r !== null) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  Pu(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
var Ee = function() {
  return Ee = Object.assign || function(t) {
    for (var n, o = 1, a = arguments.length; o < a; o++) {
      n = arguments[o];
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Ee.apply(this, arguments);
};
function Pr(e, r, t) {
  if (t || arguments.length === 2) for (var n = 0, o = r.length, a; n < o; n++)
    (a || !(n in r)) && (a || (a = Array.prototype.slice.call(r, 0, n)), a[n] = r[n]);
  return e.concat(a || Array.prototype.slice.call(r));
}
var wO = function(e) {
  var r = e.showTimeSelectOnly, t = r === void 0 ? !1 : r, n = e.showTime, o = n === void 0 ? !1 : n, a = e.className, i = e.children, s = t ? "Choose Time" : "Choose Date".concat(o ? " and Time" : "");
  return A.createElement("div", { className: a, role: "dialog", "aria-label": s, "aria-modal": "true" }, i);
}, CO = function(e, r) {
  var t = ye(null), n = ye(e);
  n.current = e;
  var o = se(function(a) {
    var i;
    t.current && !t.current.contains(a.target) && (r && a.target instanceof HTMLElement && a.target.classList.contains(r) || (i = n.current) === null || i === void 0 || i.call(n, a));
  }, [r]);
  return Ye(function() {
    return document.addEventListener("mousedown", o), function() {
      document.removeEventListener("mousedown", o);
    };
  }, [o]), t;
}, Ks = function(e) {
  var r = e.children, t = e.onClickOutside, n = e.className, o = e.containerRef, a = e.style, i = e.ignoreClass, s = CO(t, i);
  return A.createElement("div", { className: n, style: a, ref: function(l) {
    s.current = l, o && (o.current = l);
  } }, r);
}, ee;
(function(e) {
  e.ArrowUp = "ArrowUp", e.ArrowDown = "ArrowDown", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Home = "Home", e.End = "End", e.Enter = "Enter", e.Space = " ", e.Tab = "Tab", e.Escape = "Escape", e.Backspace = "Backspace", e.X = "x";
})(ee || (ee = {}));
function Nm() {
  var e = typeof window < "u" ? window : globalThis;
  return e;
}
var ri = 12, SO = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function Ge(e) {
  if (e == null)
    return /* @__PURE__ */ new Date();
  var r = typeof e == "string" ? RR(e) : oe(e);
  return Qr(r) ? r : /* @__PURE__ */ new Date();
}
function Vl(e, r, t, n, o) {
  var a, i = null, s = jn(t) || jn(_a()), l = !0;
  if (Array.isArray(r))
    return r.forEach(function(c) {
      var d = Ll(e, c, /* @__PURE__ */ new Date(), {
        locale: s,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      n && (l = Qr(d, o) && e === Je(d, c, t)), Qr(d, o) && l && (i = d);
    }), i;
  if (i = Ll(e, r, /* @__PURE__ */ new Date(), {
    locale: s,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), n)
    l = Qr(i) && e === Je(i, r, t);
  else if (!Qr(i)) {
    var u = ((a = r.match(SO)) !== null && a !== void 0 ? a : []).map(function(c) {
      var d = c[0];
      if (d === "p" || d === "P") {
        var f = bs[d];
        return s ? f(c, s.formatLong) : d;
      }
      return c;
    }).join("");
    e.length > 0 && (i = Ll(e, u.slice(0, e.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), Qr(i) || (i = new Date(e));
  }
  return Qr(i) && l ? i : null;
}
function Qr(e, r) {
  return ys(e) && !eo(e, r ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function Je(e, r, t) {
  if (t === "en")
    return Nf(e, r, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var n = t ? jn(t) : void 0;
  return t && !n && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !n && _a() && jn(_a()) && (n = jn(_a())), Nf(e, r, {
    locale: n,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function Kt(e, r) {
  var t = r.dateFormat, n = r.locale, o = Array.isArray(t) && t.length > 0 ? t[0] : t;
  return e && Je(e, o, n) || "";
}
function xO(e, r, t) {
  if (!e)
    return "";
  var n = Kt(e, t), o = r ? Kt(r, t) : "";
  return "".concat(n, " - ").concat(o);
}
function IO(e, r) {
  if (!(e != null && e.length))
    return "";
  var t = e[0] ? Kt(e[0], r) : "";
  if (e.length === 1)
    return t;
  if (e.length === 2 && e[1]) {
    var n = Kt(e[1], r);
    return "".concat(t, ", ").concat(n);
  }
  var o = e.length - 1;
  return "".concat(t, " (+").concat(o, ")");
}
function Gl(e, r) {
  var t = r.hour, n = t === void 0 ? 0 : t, o = r.minute, a = o === void 0 ? 0 : o, i = r.second, s = i === void 0 ? 0 : i;
  return Ni(Li(Wi(e, s), a), n);
}
function DO(e) {
  return Oc(e);
}
function _O(e, r) {
  return Je(e, "ddd", r);
}
function Vi(e) {
  return Kn(e);
}
function Dn(e, r, t) {
  var n = jn(r || _a());
  return cn(e, {
    locale: n,
    weekStartsOn: t
  });
}
function _n(e) {
  return Pm(e);
}
function ba(e) {
  return qs(e);
}
function zf(e) {
  return Mu(e);
}
function $f() {
  return Kn(Ge());
}
function Xf(e) {
  return bm(e);
}
function kO(e) {
  return LA(e);
}
function _r(e, r) {
  return e && r ? FP(e, r) : !e && !r;
}
function At(e, r) {
  return e && r ? OP(e, r) : !e && !r;
}
function xs(e, r) {
  return e && r ? TP(e, r) : !e && !r;
}
function _e(e, r) {
  return e && r ? RP(e, r) : !e && !r;
}
function Yn(e, r) {
  return e && r ? PP(e, r) : !e && !r;
}
function ya(e, r, t) {
  var n, o = Kn(r), a = bm(t);
  try {
    n = Wa(e, { start: o, end: a });
  } catch {
    n = !1;
  }
  return n;
}
function _a() {
  var e = Nm();
  return e.__localeId__;
}
function jn(e) {
  if (typeof e == "string") {
    var r = Nm();
    return r.__localeData__ ? r.__localeData__[e] : void 0;
  } else
    return e;
}
function EO(e, r, t) {
  return r(Je(e, "EEEE", t));
}
function MO(e, r) {
  return Je(e, "EEEEEE", r);
}
function AO(e, r) {
  return Je(e, "EEE", r);
}
function Lc(e, r) {
  return Je(Ht(Ge(), e), "LLLL", r);
}
function Lm(e, r) {
  return Je(Ht(Ge(), e), "LLL", r);
}
function PO(e, r) {
  return Je(Co(Ge(), e), "QQQ", r);
}
function kr(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.maxDate, a = t.excludeDates, i = t.excludeDateIntervals, s = t.includeDates, l = t.includeDateIntervals, u = t.filterDate;
  return ni(e, { minDate: n, maxDate: o }) || a && a.some(function(c) {
    return c instanceof Date ? _e(e, c) : _e(e, c.date);
  }) || i && i.some(function(c) {
    var d = c.start, f = c.end;
    return Wa(e, { start: d, end: f });
  }) || s && !s.some(function(c) {
    return _e(e, c);
  }) || l && !l.some(function(c) {
    var d = c.start, f = c.end;
    return Wa(e, { start: d, end: f });
  }) || u && !u(Ge(e)) || !1;
}
function Wc(e, r) {
  var t = r === void 0 ? {} : r, n = t.excludeDates, o = t.excludeDateIntervals;
  return o && o.length > 0 ? o.some(function(a) {
    var i = a.start, s = a.end;
    return Wa(e, { start: i, end: s });
  }) : n && n.some(function(a) {
    var i;
    return a instanceof Date ? _e(e, a) : _e(e, (i = a.date) !== null && i !== void 0 ? i : /* @__PURE__ */ new Date());
  }) || !1;
}
function Wm(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.maxDate, a = t.excludeDates, i = t.includeDates, s = t.filterDate;
  return ni(e, {
    minDate: n ? Pm(n) : void 0,
    maxDate: o ? FA(o) : void 0
  }) || (a == null ? void 0 : a.some(function(l) {
    return At(e, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return At(e, l);
  }) || s && !s(Ge(e)) || !1;
}
function wi(e, r, t, n) {
  var o = Ce(e), a = Ot(e), i = Ce(r), s = Ot(r), l = Ce(n);
  return o === i && o === l ? a <= t && t <= s : o < i ? l === o && a <= t || l === i && s >= t || l < i && l > o : !1;
}
function RO(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.maxDate, a = t.excludeDates, i = t.includeDates;
  return ni(e, { minDate: n, maxDate: o }) || a && a.some(function(s) {
    return At(s instanceof Date ? s : s.date, e);
  }) || i && !i.some(function(s) {
    return At(s, e);
  }) || !1;
}
function Ci(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.maxDate, a = t.excludeDates, i = t.includeDates, s = t.filterDate;
  return ni(e, { minDate: n, maxDate: o }) || (a == null ? void 0 : a.some(function(l) {
    return xs(e, l instanceof Date ? l : l.date);
  })) || i && !i.some(function(l) {
    return xs(e, l);
  }) || s && !s(Ge(e)) || !1;
}
function Si(e, r, t) {
  if (!r || !t || !ys(r) || !ys(t))
    return !1;
  var n = Ce(r), o = Ce(t);
  return n <= e && o >= e;
}
function Gi(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.maxDate, a = t.excludeDates, i = t.includeDates, s = t.filterDate, l = new Date(e, 0, 1);
  return ni(l, {
    minDate: n ? qs(n) : void 0,
    maxDate: o ? ym(o) : void 0
  }) || (a == null ? void 0 : a.some(function(u) {
    return _r(l, u instanceof Date ? u : u.date);
  })) || i && !i.some(function(u) {
    return _r(l, u);
  }) || s && !s(Ge(l)) || !1;
}
function xi(e, r, t, n) {
  var o = Ce(e), a = Xn(e), i = Ce(r), s = Xn(r), l = Ce(n);
  return o === i && o === l ? a <= t && t <= s : o < i ? l === o && a <= t || l === i && s >= t || l < i && l > o : !1;
}
function ni(e, r) {
  var t, n = r === void 0 ? {} : r, o = n.minDate, a = n.maxDate;
  return (t = o && La(e, o) < 0 || a && La(e, a) > 0) !== null && t !== void 0 ? t : !1;
}
function jf(e, r) {
  return r.some(function(t) {
    return Tr(t) === Tr(e) && Fr(t) === Fr(e) && sn(t) === sn(e);
  });
}
function Zf(e, r) {
  var t = r === void 0 ? {} : r, n = t.excludeTimes, o = t.includeTimes, a = t.filterTime;
  return n && jf(e, n) || o && !jf(e, o) || a && !a(e) || !1;
}
function Uf(e, r) {
  var t = r.minTime, n = r.maxTime;
  if (!t || !n)
    throw new Error("Both minTime and maxTime props required");
  var o = Ge();
  o = Ni(o, Tr(e)), o = Li(o, Fr(e)), o = Wi(o, sn(e));
  var a = Ge();
  a = Ni(a, Tr(t)), a = Li(a, Fr(t)), a = Wi(a, sn(t));
  var i = Ge();
  i = Ni(i, Tr(n)), i = Li(i, Fr(n)), i = Wi(i, sn(n));
  var s;
  try {
    s = !Wa(o, { start: a, end: i });
  } catch {
    s = !1;
  }
  return s;
}
function Jf(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.includeDates, a = Ho(e, 1);
  return n && gs(n, a) > 0 || o && o.every(function(i) {
    return gs(i, a) > 0;
  }) || !1;
}
function Qf(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, o = t.includeDates, a = vr(e, 1);
  return n && gs(a, n) > 0 || o && o.every(function(i) {
    return gs(a, i) > 0;
  }) || !1;
}
function OO(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.includeDates, a = qs(e), i = Rm(a);
  return n && ms(n, i) > 0 || o && o.every(function(s) {
    return ms(s, i) > 0;
  }) || !1;
}
function TO(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, o = t.includeDates, a = ym(e), i = Rc(a, 1);
  return n && ms(i, n) > 0 || o && o.every(function(s) {
    return ms(i, s) > 0;
  }) || !1;
}
function qf(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.includeDates, a = zo(e, 1);
  return n && vs(n, a) > 0 || o && o.every(function(i) {
    return vs(i, a) > 0;
  }) || !1;
}
function FO(e, r) {
  var t = r === void 0 ? {} : r, n = t.minDate, o = t.yearItemNumber, a = o === void 0 ? ri : o, i = ba(zo(e, a)), s = Sn(i, a).endPeriod, l = n && Ce(n);
  return l && l > s || !1;
}
function Kf(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, o = t.includeDates, a = on(e, 1);
  return n && vs(a, n) > 0 || o && o.every(function(i) {
    return vs(a, i) > 0;
  }) || !1;
}
function NO(e, r) {
  var t = r === void 0 ? {} : r, n = t.maxDate, o = t.yearItemNumber, a = o === void 0 ? ri : o, i = on(e, a), s = Sn(i, a).startPeriod, l = n && Ce(n);
  return l && l < s || !1;
}
function Bm(e) {
  var r = e.minDate, t = e.includeDates;
  if (t && r) {
    var n = t.filter(function(o) {
      return La(o, r) >= 0;
    });
    return Bf(n);
  } else return t ? Bf(t) : r;
}
function Vm(e) {
  var r = e.maxDate, t = e.includeDates;
  if (t && r) {
    var n = t.filter(function(o) {
      return La(o, r) <= 0;
    });
    return Wf(n);
  } else return t ? Wf(t) : r;
}
function ep(e, r) {
  var t;
  e === void 0 && (e = []), r === void 0 && (r = "react-datepicker__day--highlighted");
  for (var n = /* @__PURE__ */ new Map(), o = 0, a = e.length; o < a; o++) {
    var i = e[o];
    if (an(i)) {
      var s = Je(i, "MM.dd.yyyy"), l = n.get(s) || [];
      l.includes(r) || (l.push(r), n.set(s, l));
    } else if (typeof i == "object") {
      var u = Object.keys(i), c = (t = u[0]) !== null && t !== void 0 ? t : "", d = i[c];
      if (typeof c == "string" && Array.isArray(d))
        for (var f = 0, p = d.length; f < p; f++) {
          var h = d[f];
          if (h) {
            var s = Je(h, "MM.dd.yyyy"), l = n.get(s) || [];
            l.includes(c) || (l.push(c), n.set(s, l));
          }
        }
    }
  }
  return n;
}
function LO(e, r) {
  return e.length !== r.length ? !1 : e.every(function(t, n) {
    return t === r[n];
  });
}
function WO(e, r) {
  e === void 0 && (e = []), r === void 0 && (r = "react-datepicker__day--holidays");
  var t = /* @__PURE__ */ new Map();
  return e.forEach(function(n) {
    var o = n.date, a = n.holidayName;
    if (an(o)) {
      var i = Je(o, "MM.dd.yyyy"), s = t.get(i) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in s && s.className === r && LO(s.holidayNames, [a]))) {
        s.className = r;
        var l = s.holidayNames;
        s.holidayNames = l ? Pr(Pr([], l, !0), [a], !1) : [a], t.set(i, s);
      }
    }
  }), t;
}
function BO(e, r, t, n, o) {
  for (var a = o.length, i = [], s = 0; s < a; s++) {
    var l = e, u = o[s];
    u && (l = OA(l, Tr(u)), l = _u(l, Fr(u)), l = TA(l, sn(u)));
    var c = _u(e, (t + 1) * n);
    Mn(l, r) && eo(l, c) && u != null && i.push(u);
  }
  return i;
}
function tp(e) {
  return e < 10 ? "0".concat(e) : "".concat(e);
}
function Sn(e, r) {
  r === void 0 && (r = ri);
  var t = Math.ceil(Ce(e) / r) * r, n = t - (r - 1);
  return { startPeriod: n, endPeriod: t };
}
function VO(e) {
  var r = new Date(e.getFullYear(), e.getMonth(), e.getDate()), t = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
  return Math.round((+t - +r) / 36e5);
}
function rp(e) {
  var r = e.getSeconds(), t = e.getMilliseconds();
  return oe(e.getTime() - r * 1e3 - t);
}
function GO(e, r) {
  return rp(e).getTime() === rp(r).getTime();
}
function np(e) {
  if (!an(e))
    throw new Error("Invalid date");
  var r = new Date(e);
  return r.setHours(0, 0, 0, 0), r;
}
function op(e, r) {
  if (!an(e) || !an(r))
    throw new Error("Invalid date received");
  var t = np(e), n = np(r);
  return eo(t, n);
}
function Gm(e) {
  return e.key === ee.Space;
}
var YO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.inputRef = A.createRef(), n.onTimeChange = function(o) {
        var a, i;
        n.setState({ time: o });
        var s = n.props.date, l = s instanceof Date && !isNaN(+s), u = l ? s : /* @__PURE__ */ new Date();
        if (o != null && o.includes(":")) {
          var c = o.split(":"), d = c[0], f = c[1];
          u.setHours(Number(d)), u.setMinutes(Number(f));
        }
        (i = (a = n.props).onChange) === null || i === void 0 || i.call(a, u);
      }, n.renderTimeInput = function() {
        var o = n.state.time, a = n.props, i = a.date, s = a.timeString, l = a.customTimeInput;
        return l ? Vu(l, {
          date: i,
          value: o,
          onChange: n.onTimeChange
        }) : A.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: n.inputRef, onClick: function() {
          var u;
          (u = n.inputRef.current) === null || u === void 0 || u.focus();
        }, required: !0, value: o, onChange: function(u) {
          n.onTimeChange(u.target.value || s);
        } });
      }, n.state = {
        time: n.props.timeString
      }, n;
    }
    return r.getDerivedStateFromProps = function(t, n) {
      return t.timeString !== n.time ? {
        time: t.timeString
      } : null;
    }, r.prototype.render = function() {
      return A.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        A.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        A.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          A.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, r;
  }(bt)
), HO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.dayEl = kn(), t.handleClick = function(n) {
        !t.isDisabled() && t.props.onClick && t.props.onClick(n);
      }, t.handleMouseEnter = function(n) {
        !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(n);
      }, t.handleOnKeyDown = function(n) {
        var o, a, i = n.key;
        i === ee.Space && (n.preventDefault(), n.key = ee.Enter), (a = (o = t.props).handleOnKeyDown) === null || a === void 0 || a.call(o, n);
      }, t.isSameDay = function(n) {
        return _e(t.props.day, n);
      }, t.isKeyboardSelected = function() {
        var n;
        if (t.props.disabledKeyboardNavigation)
          return !1;
        var o = t.props.selectsMultiple ? (n = t.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(i) {
          return t.isSameDayOrWeek(i);
        }) : t.isSameDayOrWeek(t.props.selected), a = t.props.preSelection && t.isDisabled(t.props.preSelection);
        return !o && t.isSameDayOrWeek(t.props.preSelection) && !a;
      }, t.isDisabled = function(n) {
        return n === void 0 && (n = t.props.day), kr(n, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function() {
        return Wc(t.props.day, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.isStartOfWeek = function() {
        return _e(t.props.day, Dn(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameWeek = function(n) {
        return t.props.showWeekPicker && _e(n, Dn(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameDayOrWeek = function(n) {
        return t.isSameDay(n) || t.isSameWeek(n);
      }, t.getHighLightedClass = function() {
        var n = t.props, o = n.day, a = n.highlightDates;
        if (!a)
          return !1;
        var i = Je(o, "MM.dd.yyyy");
        return a.get(i);
      }, t.getHolidaysClass = function() {
        var n, o = t.props, a = o.day, i = o.holidays;
        if (!i)
          return [void 0];
        var s = Je(a, "MM.dd.yyyy");
        return i.has(s) ? [(n = i.get(s)) === null || n === void 0 ? void 0 : n.className] : [void 0];
      }, t.isInRange = function() {
        var n = t.props, o = n.day, a = n.startDate, i = n.endDate;
        return !a || !i ? !1 : ya(o, a, i);
      }, t.isInSelectingRange = function() {
        var n, o = t.props, a = o.day, i = o.selectsStart, s = o.selectsEnd, l = o.selectsRange, u = o.selectsDisabledDaysInRange, c = o.startDate, d = o.endDate, f = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return !(i || s || l) || !f || !u && t.isDisabled() ? !1 : i && d && (eo(f, d) || Yn(f, d)) ? ya(a, f, d) : s && c && (Mn(f, c) || Yn(f, c)) || l && c && !d && (Mn(f, c) || Yn(f, c)) ? ya(a, c, f) : !1;
      }, t.isSelectingRangeStart = function() {
        var n;
        if (!t.isInSelectingRange())
          return !1;
        var o = t.props, a = o.day, i = o.startDate, s = o.selectsStart, l = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return s ? _e(a, l) : _e(a, i);
      }, t.isSelectingRangeEnd = function() {
        var n;
        if (!t.isInSelectingRange())
          return !1;
        var o = t.props, a = o.day, i = o.endDate, s = o.selectsEnd, l = o.selectsRange, u = (n = t.props.selectingDate) !== null && n !== void 0 ? n : t.props.preSelection;
        return s || l ? _e(a, u) : _e(a, i);
      }, t.isRangeStart = function() {
        var n = t.props, o = n.day, a = n.startDate, i = n.endDate;
        return !a || !i ? !1 : _e(a, o);
      }, t.isRangeEnd = function() {
        var n = t.props, o = n.day, a = n.startDate, i = n.endDate;
        return !a || !i ? !1 : _e(i, o);
      }, t.isWeekend = function() {
        var n = AP(t.props.day);
        return n === 0 || n === 6;
      }, t.isAfterMonth = function() {
        return t.props.month !== void 0 && (t.props.month + 1) % 12 === Ot(t.props.day);
      }, t.isBeforeMonth = function() {
        return t.props.month !== void 0 && (Ot(t.props.day) + 1) % 12 === t.props.month;
      }, t.isCurrentDay = function() {
        return t.isSameDay(Ge());
      }, t.isSelected = function() {
        var n;
        return t.props.selectsMultiple ? (n = t.props.selectedDates) === null || n === void 0 ? void 0 : n.some(function(o) {
          return t.isSameDayOrWeek(o);
        }) : t.isSameDayOrWeek(t.props.selected);
      }, t.getClassNames = function(n) {
        var o = t.props.dayClassName ? t.props.dayClassName(n) : void 0;
        return wt("react-datepicker__day", o, "react-datepicker__day--" + _O(t.props.day), {
          "react-datepicker__day--disabled": t.isDisabled(),
          "react-datepicker__day--excluded": t.isExcluded(),
          "react-datepicker__day--selected": t.isSelected(),
          "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
          "react-datepicker__day--range-start": t.isRangeStart(),
          "react-datepicker__day--range-end": t.isRangeEnd(),
          "react-datepicker__day--in-range": t.isInRange(),
          "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
          "react-datepicker__day--today": t.isCurrentDay(),
          "react-datepicker__day--weekend": t.isWeekend(),
          "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
        }, t.getHighLightedClass(), t.getHolidaysClass());
      }, t.getAriaLabel = function() {
        var n = t.props, o = n.day, a = n.ariaLabelPrefixWhenEnabled, i = a === void 0 ? "Choose" : a, s = n.ariaLabelPrefixWhenDisabled, l = s === void 0 ? "Not available" : s, u = t.isDisabled() || t.isExcluded() ? l : i;
        return "".concat(u, " ").concat(Je(o, "PPPP", t.props.locale));
      }, t.getTitle = function() {
        var n = t.props, o = n.day, a = n.holidays, i = a === void 0 ? /* @__PURE__ */ new Map() : a, s = n.excludeDates, l = Je(o, "MM.dd.yyyy"), u = [];
        return i.has(l) && u.push.apply(u, i.get(l).holidayNames), t.isExcluded() && u.push(s == null ? void 0 : s.filter(function(c) {
          return c instanceof Date ? _e(c, o) : _e(c == null ? void 0 : c.date, o);
        }).map(function(c) {
          if (!(c instanceof Date))
            return c == null ? void 0 : c.message;
        })), u.join(", ");
      }, t.getTabIndex = function() {
        var n = t.props.selected, o = t.props.preSelection, a = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(n) && _e(o, n)) ? 0 : -1;
        return a;
      }, t.handleFocusDay = function() {
        var n;
        t.shouldFocusDay() && ((n = t.dayEl.current) === null || n === void 0 || n.focus({ preventScroll: !0 }));
      }, t.renderDayContents = function() {
        return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(Lf(t.props.day), t.props.day) : Lf(t.props.day);
      }, t.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          A.createElement(
            "div",
            { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter, onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() },
            t.renderDayContents(),
            t.getTitle() !== "" && A.createElement("span", { className: "overlay" }, t.getTitle())
          )
        );
      }, t;
    }
    return r.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, r.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, r.prototype.shouldFocusDay = function() {
      var t = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (t = !0), this.props.inline && !this.props.shouldFocusDayInline && (t = !1), this.isDayActiveElement() && (t = !0), this.isDuplicateDay() && (t = !1)), t;
    }, r.prototype.isDayActiveElement = function() {
      var t, n, o;
      return ((n = (t = this.props.containerRef) === null || t === void 0 ? void 0 : t.current) === null || n === void 0 ? void 0 : n.contains(document.activeElement)) && ((o = document.activeElement) === null || o === void 0 ? void 0 : o.classList.contains("react-datepicker__day"));
    }, r.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, r;
  }(bt)
), zO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.weekNumberEl = kn(), t.handleClick = function(n) {
        t.props.onClick && t.props.onClick(n);
      }, t.handleOnKeyDown = function(n) {
        var o, a, i = n.key;
        i === ee.Space && (n.preventDefault(), n.key = ee.Enter), (a = (o = t.props).handleOnKeyDown) === null || a === void 0 || a.call(o, n);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !_e(t.props.date, t.props.selected) && _e(t.props.date, t.props.preSelection);
      }, t.getTabIndex = function() {
        return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || _e(t.props.date, t.props.selected) && _e(t.props.preSelection, t.props.selected)) ? 0 : -1;
      }, t.handleFocusWeekNumber = function(n) {
        var o = !1;
        t.getTabIndex() === 0 && !(n != null && n.isInputFocused) && _e(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (o = !0), t.props.inline && !t.props.shouldFocusDayInline && (o = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (o = !0)), o && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, r.prototype.componentDidUpdate = function(t) {
      this.handleFocusWeekNumber(t);
    }, r.prototype.render = function() {
      var t = this.props, n = t.weekNumber, o = t.ariaLabelPrefix, a = o === void 0 ? r.defaultProps.ariaLabelPrefix : o, i = t.onClick, s = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!i,
        "react-datepicker__week-number--selected": !!i && _e(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return A.createElement("div", { ref: this.weekNumberEl, className: wt(s), "aria-label": "".concat(a, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, n);
    }, r;
  }(bt)
), $O = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.isDisabled = function(n) {
        return kr(n, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.handleDayClick = function(n, o) {
        t.props.onDayClick && t.props.onDayClick(n, o);
      }, t.handleDayMouseEnter = function(n) {
        t.props.onDayMouseEnter && t.props.onDayMouseEnter(n);
      }, t.handleWeekClick = function(n, o, a) {
        for (var i, s, l, u = new Date(n), c = 0; c < 7; c++) {
          var d = new Date(n);
          d.setDate(d.getDate() + c);
          var f = !t.isDisabled(d);
          if (f) {
            u = d;
            break;
          }
        }
        typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(u, o, a), t.props.showWeekPicker && t.handleDayClick(u, a), ((i = t.props.shouldCloseOnSelect) !== null && i !== void 0 ? i : r.defaultProps.shouldCloseOnSelect) && ((l = (s = t.props).setOpen) === null || l === void 0 || l.call(s, !1));
      }, t.formatWeekNumber = function(n) {
        return t.props.formatWeekNumber ? t.props.formatWeekNumber(n) : DO(n);
      }, t.renderDays = function() {
        var n = t.startOfWeek(), o = [], a = t.formatWeekNumber(n);
        if (t.props.showWeekNumber) {
          var i = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, n, a) : void 0;
          o.push(A.createElement(zO, Ee({ key: "W" }, r.defaultProps, t.props, { weekNumber: a, date: n, onClick: i })));
        }
        return o.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = On(n, s);
          return A.createElement(HO, Ee({}, r.defaultProps, t.props, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: t.handleDayClick.bind(t, l), onMouseEnter: t.handleDayMouseEnter.bind(t, l) }));
        }));
      }, t.startOfWeek = function() {
        return Dn(t.props.day, t.props.locale, t.props.calendarStartDay);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !_e(t.startOfWeek(), t.props.selected) && _e(t.startOfWeek(), t.props.preSelection);
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": _e(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return A.createElement("div", { className: wt(t) }, this.renderDays());
    }, r;
  }(bt)
), ga, XO = 6, Ao = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, Yl = (ga = {}, ga[Ao.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, ga[Ao.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, ga[Ao.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, ga), Ii = 1;
function ap(e, r) {
  return e ? Ao.FOUR_COLUMNS : r ? Ao.TWO_COLUMNS : Ao.THREE_COLUMNS;
}
var jO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.MONTH_REFS = Pr([], Array(12), !0).map(function() {
        return kn();
      }), t.QUARTER_REFS = Pr([], Array(4), !0).map(function() {
        return kn();
      }), t.isDisabled = function(n) {
        return kr(n, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function(n) {
        return Wc(n, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.handleDayClick = function(n, o) {
        var a, i;
        (i = (a = t.props).onDayClick) === null || i === void 0 || i.call(a, n, o, t.props.orderInDisplay);
      }, t.handleDayMouseEnter = function(n) {
        var o, a;
        (a = (o = t.props).onDayMouseEnter) === null || a === void 0 || a.call(o, n);
      }, t.handleMouseLeave = function() {
        var n, o;
        (o = (n = t.props).onMouseLeave) === null || o === void 0 || o.call(n);
      }, t.isRangeStartMonth = function(n) {
        var o = t.props, a = o.day, i = o.startDate, s = o.endDate;
        return !i || !s ? !1 : At(Ht(a, n), i);
      }, t.isRangeStartQuarter = function(n) {
        var o = t.props, a = o.day, i = o.startDate, s = o.endDate;
        return !i || !s ? !1 : xs(Co(a, n), i);
      }, t.isRangeEndMonth = function(n) {
        var o = t.props, a = o.day, i = o.startDate, s = o.endDate;
        return !i || !s ? !1 : At(Ht(a, n), s);
      }, t.isRangeEndQuarter = function(n) {
        var o = t.props, a = o.day, i = o.startDate, s = o.endDate;
        return !i || !s ? !1 : xs(Co(a, n), s);
      }, t.isInSelectingRangeMonth = function(n) {
        var o, a = t.props, i = a.day, s = a.selectsStart, l = a.selectsEnd, u = a.selectsRange, c = a.startDate, d = a.endDate, f = (o = t.props.selectingDate) !== null && o !== void 0 ? o : t.props.preSelection;
        return !(s || l || u) || !f ? !1 : s && d ? wi(f, d, n, i) : l && c || u && c && !d ? wi(c, f, n, i) : !1;
      }, t.isSelectingMonthRangeStart = function(n) {
        var o;
        if (!t.isInSelectingRangeMonth(n))
          return !1;
        var a = t.props, i = a.day, s = a.startDate, l = a.selectsStart, u = Ht(i, n), c = (o = t.props.selectingDate) !== null && o !== void 0 ? o : t.props.preSelection;
        return l ? At(u, c) : At(u, s);
      }, t.isSelectingMonthRangeEnd = function(n) {
        var o;
        if (!t.isInSelectingRangeMonth(n))
          return !1;
        var a = t.props, i = a.day, s = a.endDate, l = a.selectsEnd, u = a.selectsRange, c = Ht(i, n), d = (o = t.props.selectingDate) !== null && o !== void 0 ? o : t.props.preSelection;
        return l || u ? At(c, d) : At(c, s);
      }, t.isInSelectingRangeQuarter = function(n) {
        var o, a = t.props, i = a.day, s = a.selectsStart, l = a.selectsEnd, u = a.selectsRange, c = a.startDate, d = a.endDate, f = (o = t.props.selectingDate) !== null && o !== void 0 ? o : t.props.preSelection;
        return !(s || l || u) || !f ? !1 : s && d ? xi(f, d, n, i) : l && c || u && c && !d ? xi(c, f, n, i) : !1;
      }, t.isWeekInMonth = function(n) {
        var o = t.props.day, a = On(n, 6);
        return At(n, o) || At(a, o);
      }, t.isCurrentMonth = function(n, o) {
        return Ce(n) === Ce(Ge()) && o === Ot(Ge());
      }, t.isCurrentQuarter = function(n, o) {
        return Ce(n) === Ce(Ge()) && o === Xn(Ge());
      }, t.isSelectedMonth = function(n, o, a) {
        return Ot(a) === o && Ce(n) === Ce(a);
      }, t.isSelectMonthInList = function(n, o, a) {
        return a.some(function(i) {
          return t.isSelectedMonth(n, o, i);
        });
      }, t.isSelectedQuarter = function(n, o, a) {
        return Xn(n) === o && Ce(n) === Ce(a);
      }, t.renderWeeks = function() {
        for (var n = [], o = t.props.fixedHeight, a = 0, i = !1, s = Dn(_n(t.props.day), t.props.locale, t.props.calendarStartDay), l = function(h) {
          return t.props.showWeekPicker ? Dn(h, t.props.locale, t.props.calendarStartDay) : t.props.preSelection;
        }, u = function(h) {
          return t.props.showWeekPicker ? Dn(h, t.props.locale, t.props.calendarStartDay) : t.props.selected;
        }, c = t.props.selected ? u(t.props.selected) : void 0, d = t.props.preSelection ? l(t.props.preSelection) : void 0; n.push(A.createElement($O, Ee({}, t.props, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, key: a, day: s, month: Ot(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, selected: c, preSelection: d, showWeekNumber: t.props.showWeekNumbers }))), !i; ) {
          a++, s = ps(s, 1);
          var f = o && a >= XO, p = !o && !t.isWeekInMonth(s);
          if (f || p)
            if (t.props.peekNextMonth)
              i = !0;
            else
              break;
        }
        return n;
      }, t.onMonthClick = function(n, o) {
        var a = t.isMonthDisabledForLabelDate(o), i = a.isDisabled, s = a.labelDate;
        i || t.handleDayClick(_n(s), n);
      }, t.onMonthMouseEnter = function(n) {
        var o = t.isMonthDisabledForLabelDate(n), a = o.isDisabled, i = o.labelDate;
        a || t.handleDayMouseEnter(_n(i));
      }, t.handleMonthNavigation = function(n, o) {
        var a, i, s, l;
        (i = (a = t.props).setPreSelection) === null || i === void 0 || i.call(a, o), (l = (s = t.MONTH_REFS[n]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus();
      }, t.handleKeyboardNavigation = function(n, o, a) {
        var i, s = t.props, l = s.selected, u = s.preSelection, c = s.setPreSelection, d = s.minDate, f = s.maxDate, p = s.showFourColumnMonthYearPicker, h = s.showTwoColumnMonthYearPicker;
        if (u) {
          var g = ap(p, h), m = t.getVerticalOffset(g), v = (i = Yl[g]) === null || i === void 0 ? void 0 : i.grid, y = function(x, _, E) {
            var R, L, G = _, V = E;
            switch (x) {
              case ee.ArrowRight:
                G = vr(_, Ii), V = E === 11 ? 0 : E + Ii;
                break;
              case ee.ArrowLeft:
                G = Ho(_, Ii), V = E === 0 ? 11 : E - Ii;
                break;
              case ee.ArrowUp:
                G = Ho(_, m), V = !((R = v == null ? void 0 : v[0]) === null || R === void 0) && R.includes(E) ? E + 12 - m : E - m;
                break;
              case ee.ArrowDown:
                G = vr(_, m), V = !((L = v == null ? void 0 : v[v.length - 1]) === null || L === void 0) && L.includes(E) ? E - 12 + m : E + m;
                break;
            }
            return { newCalculatedDate: G, newCalculatedMonth: V };
          }, C = function(x, _, E) {
            for (var R = 40, L = x, G = !1, V = 0, O = y(L, _, E), N = O.newCalculatedDate, P = O.newCalculatedMonth; !G; ) {
              if (V >= R) {
                N = _, P = E;
                break;
              }
              if (d && N < d) {
                L = ee.ArrowRight;
                var B = y(L, N, P);
                N = B.newCalculatedDate, P = B.newCalculatedMonth;
              }
              if (f && N > f) {
                L = ee.ArrowLeft;
                var B = y(L, N, P);
                N = B.newCalculatedDate, P = B.newCalculatedMonth;
              }
              if (RO(N, t.props)) {
                var B = y(L, N, P);
                N = B.newCalculatedDate, P = B.newCalculatedMonth;
              } else
                G = !0;
              V++;
            }
            return { newCalculatedDate: N, newCalculatedMonth: P };
          };
          if (o === ee.Enter) {
            t.isMonthDisabled(a) || (t.onMonthClick(n, a), c == null || c(l));
            return;
          }
          var I = C(o, u, a), b = I.newCalculatedDate, D = I.newCalculatedMonth;
          switch (o) {
            case ee.ArrowRight:
            case ee.ArrowLeft:
            case ee.ArrowUp:
            case ee.ArrowDown:
              t.handleMonthNavigation(D, b);
              break;
          }
        }
      }, t.getVerticalOffset = function(n) {
        var o, a;
        return (a = (o = Yl[n]) === null || o === void 0 ? void 0 : o.verticalNavigationOffset) !== null && a !== void 0 ? a : 0;
      }, t.onMonthKeyDown = function(n, o) {
        var a = t.props, i = a.disabledKeyboardNavigation, s = a.handleOnMonthKeyDown, l = n.key;
        l !== ee.Tab && n.preventDefault(), i || t.handleKeyboardNavigation(n, l, o), s && s(n);
      }, t.onQuarterClick = function(n, o) {
        var a = Co(t.props.day, o);
        Ci(a, t.props) || t.handleDayClick(zf(a), n);
      }, t.onQuarterMouseEnter = function(n) {
        var o = Co(t.props.day, n);
        Ci(o, t.props) || t.handleDayMouseEnter(zf(o));
      }, t.handleQuarterNavigation = function(n, o) {
        var a, i, s, l;
        t.isDisabled(o) || t.isExcluded(o) || ((i = (a = t.props).setPreSelection) === null || i === void 0 || i.call(a, o), (l = (s = t.QUARTER_REFS[n - 1]) === null || s === void 0 ? void 0 : s.current) === null || l === void 0 || l.focus());
      }, t.onQuarterKeyDown = function(n, o) {
        var a, i, s = n.key;
        if (!t.props.disabledKeyboardNavigation)
          switch (s) {
            case ee.Enter:
              t.onQuarterClick(n, o), (i = (a = t.props).setPreSelection) === null || i === void 0 || i.call(a, t.props.selected);
              break;
            case ee.ArrowRight:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(o === 4 ? 1 : o + 1, Rc(t.props.preSelection, 1));
              break;
            case ee.ArrowLeft:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(o === 1 ? 4 : o - 1, Rm(t.props.preSelection));
              break;
          }
      }, t.isMonthDisabledForLabelDate = function(n) {
        var o, a = t.props, i = a.day, s = a.minDate, l = a.maxDate, u = a.excludeDates, c = a.includeDates, d = Ht(i, n);
        return {
          isDisabled: (o = (s || l || u || c) && Wm(d, t.props)) !== null && o !== void 0 ? o : !1,
          labelDate: d
        };
      }, t.isMonthDisabled = function(n) {
        var o = t.isMonthDisabledForLabelDate(n).isDisabled;
        return o;
      }, t.getMonthClassNames = function(n) {
        var o = t.props, a = o.day, i = o.startDate, s = o.endDate, l = o.preSelection, u = o.monthClassName, c = u ? u(Ht(a, n)) : void 0, d = t.getSelection();
        return wt("react-datepicker__month-text", "react-datepicker__month-".concat(n), c, {
          "react-datepicker__month-text--disabled": t.isMonthDisabled(n),
          "react-datepicker__month-text--selected": d ? t.isSelectMonthInList(a, n, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && l && t.isSelectedMonth(a, n, l) && !t.isMonthDisabled(n),
          "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(n),
          "react-datepicker__month-text--in-range": i && s ? wi(i, s, n, a) : void 0,
          "react-datepicker__month-text--range-start": t.isRangeStartMonth(n),
          "react-datepicker__month-text--range-end": t.isRangeEndMonth(n),
          "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(n),
          "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(n),
          "react-datepicker__month-text--today": t.isCurrentMonth(a, n)
        });
      }, t.getTabIndex = function(n) {
        if (t.props.preSelection == null)
          return "-1";
        var o = Ot(t.props.preSelection), a = t.isMonthDisabledForLabelDate(o).isDisabled, i = n === o && !(a || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, t.getQuarterTabIndex = function(n) {
        if (t.props.preSelection == null)
          return "-1";
        var o = Xn(t.props.preSelection), a = Ci(t.props.day, t.props), i = n === o && !(a || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return i;
      }, t.getAriaLabel = function(n) {
        var o = t.props, a = o.chooseDayAriaLabelPrefix, i = a === void 0 ? "Choose" : a, s = o.disabledDayAriaLabelPrefix, l = s === void 0 ? "Not available" : s, u = o.day, c = o.locale, d = Ht(u, n), f = t.isDisabled(d) || t.isExcluded(d) ? l : i;
        return "".concat(f, " ").concat(Je(d, "MMMM yyyy", c));
      }, t.getQuarterClassNames = function(n) {
        var o = t.props, a = o.day, i = o.startDate, s = o.endDate, l = o.selected, u = o.minDate, c = o.maxDate, d = o.excludeDates, f = o.includeDates, p = o.filterDate, h = o.preSelection, g = o.disabledKeyboardNavigation, m = (u || c || d || f || p) && Ci(Co(a, n), t.props);
        return wt("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(n), {
          "react-datepicker__quarter-text--disabled": m,
          "react-datepicker__quarter-text--selected": l ? t.isSelectedQuarter(a, n, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !g && h && t.isSelectedQuarter(a, n, h) && !m,
          "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(n),
          "react-datepicker__quarter-text--in-range": i && s ? xi(i, s, n, a) : void 0,
          "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(n),
          "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(n)
        });
      }, t.getMonthContent = function(n) {
        var o = t.props, a = o.showFullMonthYearPicker, i = o.renderMonthContent, s = o.locale, l = o.day, u = Lm(n, s), c = Lc(n, s);
        return i ? i(n, u, c, l) : a ? c : u;
      }, t.getQuarterContent = function(n) {
        var o, a = t.props, i = a.renderQuarterContent, s = a.locale, l = PO(n, s);
        return (o = i == null ? void 0 : i(n, l)) !== null && o !== void 0 ? o : l;
      }, t.renderMonths = function() {
        var n, o = t.props, a = o.showTwoColumnMonthYearPicker, i = o.showFourColumnMonthYearPicker, s = o.day, l = o.selected, u = (n = Yl[ap(i, a)]) === null || n === void 0 ? void 0 : n.grid;
        return u == null ? void 0 : u.map(function(c, d) {
          return A.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, c.map(function(f, p) {
            return A.createElement("div", { ref: t.MONTH_REFS[f], key: p, onClick: function(h) {
              t.onMonthClick(h, f);
            }, onKeyDown: function(h) {
              Gm(h) && (h.preventDefault(), h.key = ee.Enter), t.onMonthKeyDown(h, f);
            }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(f);
            }, onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(f);
            } : void 0, tabIndex: Number(t.getTabIndex(f)), className: t.getMonthClassNames(f), "aria-disabled": t.isMonthDisabled(f), role: "option", "aria-label": t.getAriaLabel(f), "aria-current": t.isCurrentMonth(s, f) ? "date" : void 0, "aria-selected": l ? t.isSelectedMonth(s, f, l) : void 0 }, t.getMonthContent(f));
          }));
        });
      }, t.renderQuarters = function() {
        var n = t.props, o = n.day, a = n.selected, i = [1, 2, 3, 4];
        return A.createElement("div", { className: "react-datepicker__quarter-wrapper" }, i.map(function(s, l) {
          return A.createElement("div", { key: l, ref: t.QUARTER_REFS[l], role: "option", onClick: function(u) {
            t.onQuarterClick(u, s);
          }, onKeyDown: function(u) {
            t.onQuarterKeyDown(u, s);
          }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(s);
          }, onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(s);
          } : void 0, className: t.getQuarterClassNames(s), "aria-selected": a ? t.isSelectedQuarter(o, s, a) : void 0, tabIndex: Number(t.getQuarterTabIndex(s)), "aria-current": t.isCurrentQuarter(o, s) ? "date" : void 0 }, t.getQuarterContent(s));
        }));
      }, t.getClassNames = function() {
        var n = t.props, o = n.selectingDate, a = n.selectsStart, i = n.selectsEnd, s = n.showMonthYearPicker, l = n.showQuarterYearPicker, u = n.showWeekPicker;
        return wt("react-datepicker__month", {
          "react-datepicker__month--selecting-range": o && (a || i)
        }, { "react-datepicker__monthPicker": s }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": u });
      }, t;
    }
    return r.prototype.getSelection = function() {
      var t = this.props, n = t.selected, o = t.selectedDates, a = t.selectsMultiple;
      if (a)
        return o;
      if (n)
        return [n];
    }, r.prototype.render = function() {
      var t = this.props, n = t.showMonthYearPicker, o = t.showQuarterYearPicker, a = t.day, i = t.ariaLabelPrefix, s = i === void 0 ? "Month " : i, l = s ? s.trim() + " " : "";
      return A.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(Je(a, "MMMM, yyyy", this.props.locale)), role: "listbox" }, n ? this.renderMonths() : o ? this.renderQuarters() : this.renderWeeks());
    }, r;
  }(bt)
), ZO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.isSelectedMonth = function(n) {
        return t.props.month === n;
      }, t.renderOptions = function() {
        return t.props.monthNames.map(function(n, o) {
          return A.createElement(
            "div",
            { className: t.isSelectedMonth(o) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: n, onClick: t.onChange.bind(t, o), "aria-selected": t.isSelectedMonth(o) ? "true" : void 0 },
            t.isSelectedMonth(o) ? A.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            n
          );
        });
      }, t.onChange = function(n) {
        return t.props.onChange(n);
      }, t.handleClickOutside = function() {
        return t.props.onCancel();
      }, t;
    }
    return r.prototype.render = function() {
      return A.createElement(Ks, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(bt)
), UO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function(n) {
        return n.map(function(o, a) {
          return A.createElement("option", { key: o, value: a }, o);
        });
      }, t.renderSelectMode = function(n) {
        return A.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(o) {
          return t.onChange(parseInt(o.target.value));
        } }, t.renderSelectOptions(n));
      }, t.renderReadView = function(n, o) {
        return A.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown },
          A.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          A.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, o[t.props.month])
        );
      }, t.renderDropdown = function(n) {
        return A.createElement(ZO, Ee({ key: "dropdown" }, t.props, { monthNames: n, onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function(n) {
        var o = t.state.dropdownVisible, a = [t.renderReadView(!o, n)];
        return o && a.unshift(t.renderDropdown(n)), a;
      }, t.onChange = function(n) {
        t.toggleDropdown(), n !== t.props.month && t.props.onChange(n);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return r.prototype.render = function() {
      var t = this, n = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(a) {
        return Lm(a, t.props.locale);
      } : function(a) {
        return Lc(a, t.props.locale);
      }), o;
      switch (this.props.dropdownMode) {
        case "scroll":
          o = this.renderScrollMode(n);
          break;
        case "select":
          o = this.renderSelectMode(n);
          break;
      }
      return A.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, o);
    }, r;
  }(bt)
);
function JO(e, r) {
  for (var t = [], n = _n(e), o = _n(r); !Mn(n, o); )
    t.push(Ge(n)), n = vr(n, 1);
  return t;
}
var QO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.renderOptions = function() {
        return n.state.monthYearsList.map(function(o) {
          var a = Eu(o), i = _r(n.props.date, o) && At(n.props.date, o);
          return A.createElement(
            "div",
            { className: i ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: a, onClick: n.onChange.bind(n, a), "aria-selected": i ? "true" : void 0 },
            i ? A.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            Je(o, n.props.dateFormat, n.props.locale)
          );
        });
      }, n.onChange = function(o) {
        return n.props.onChange(o);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.state = {
        monthYearsList: JO(n.props.minDate, n.props.maxDate)
      }, n;
    }
    return r.prototype.render = function() {
      var t = wt({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return A.createElement(Ks, { className: t, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(bt)
), qO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var n = _n(t.props.minDate), o = _n(t.props.maxDate), a = []; !Mn(n, o); ) {
          var i = Eu(n);
          a.push(A.createElement("option", { key: i, value: i }, Je(n, t.props.dateFormat, t.props.locale))), n = vr(n, 1);
        }
        return a;
      }, t.onSelectChange = function(n) {
        t.onChange(parseInt(n.target.value));
      }, t.renderSelectMode = function() {
        return A.createElement("select", { value: Eu(_n(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(n) {
        var o = Je(t.props.date, t.props.dateFormat, t.props.locale);
        return A.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: t.toggleDropdown },
          A.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          A.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, o)
        );
      }, t.renderDropdown = function() {
        return A.createElement(QO, Ee({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var n = t.state.dropdownVisible, o = [t.renderReadView(!n)];
        return n && o.unshift(t.renderDropdown()), o;
      }, t.onChange = function(n) {
        t.toggleDropdown();
        var o = Ge(n);
        _r(t.props.date, o) && At(t.props.date, o) || t.props.onChange(o);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return r.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return A.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, r;
  }(bt)
), KO = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        height: null
      }, t.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var n, o, a;
          t.list && (t.list.scrollTop = (a = t.centerLi && r.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - ((o = (n = t.header) === null || n === void 0 ? void 0 : n.clientHeight) !== null && o !== void 0 ? o : 0) : t.list.clientHeight, t.centerLi)) !== null && a !== void 0 ? a : 0);
        });
      }, t.handleClick = function(n) {
        var o, a;
        (t.props.minTime || t.props.maxTime) && Uf(n, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Zf(n, t.props) || (a = (o = t.props).onChange) === null || a === void 0 || a.call(o, n);
      }, t.isSelectedTime = function(n) {
        return t.props.selected && GO(t.props.selected, n);
      }, t.isDisabledTime = function(n) {
        return (t.props.minTime || t.props.maxTime) && Uf(n, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Zf(n, t.props);
      }, t.liClasses = function(n) {
        var o, a = [
          "react-datepicker__time-list-item",
          t.props.timeClassName ? t.props.timeClassName(n) : void 0
        ];
        return t.isSelectedTime(n) && a.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(n) && a.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (Tr(n) * 3600 + Fr(n) * 60 + sn(n)) % (((o = t.props.intervals) !== null && o !== void 0 ? o : r.defaultProps.intervals) * 60) !== 0 && a.push("react-datepicker__time-list-item--injected"), a.join(" ");
      }, t.handleOnKeyDown = function(n, o) {
        var a, i;
        n.key === ee.Space && (n.preventDefault(), n.key = ee.Enter), (n.key === ee.ArrowUp || n.key === ee.ArrowLeft) && n.target instanceof HTMLElement && n.target.previousSibling && (n.preventDefault(), n.target.previousSibling instanceof HTMLElement && n.target.previousSibling.focus()), (n.key === ee.ArrowDown || n.key === ee.ArrowRight) && n.target instanceof HTMLElement && n.target.nextSibling && (n.preventDefault(), n.target.nextSibling instanceof HTMLElement && n.target.nextSibling.focus()), n.key === ee.Enter && t.handleClick(o), (i = (a = t.props).handleOnKeyDown) === null || i === void 0 || i.call(a, n);
      }, t.renderTimes = function() {
        for (var n, o = [], a = t.props.format ? t.props.format : "p", i = (n = t.props.intervals) !== null && n !== void 0 ? n : r.defaultProps.intervals, s = t.props.selected || t.props.openToDate || Ge(), l = Vi(s), u = t.props.injectTimes && t.props.injectTimes.sort(function(m, v) {
          return m.getTime() - v.getTime();
        }), c = 60 * VO(s), d = c / i, f = 0; f < d; f++) {
          var p = _u(l, f * i);
          if (o.push(p), u) {
            var h = BO(l, p, f, i, u);
            o = o.concat(h);
          }
        }
        var g = o.reduce(function(m, v) {
          return v.getTime() <= s.getTime() ? v : m;
        }, o[0]);
        return o.map(function(m) {
          return A.createElement("li", { key: m.valueOf(), onClick: t.handleClick.bind(t, m), className: t.liClasses(m), ref: function(v) {
            m === g && (t.centerLi = v);
          }, onKeyDown: function(v) {
            t.handleOnKeyDown(v, m);
          }, tabIndex: m === g ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(m) ? "true" : void 0, "aria-disabled": t.isDisabledTime(m) ? "true" : void 0 }, Je(m, a, t.props.locale));
        });
      }, t.renderTimeCaption = function() {
        return t.props.showTimeCaption === !1 ? A.createElement(A.Fragment, null) : A.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(t.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(n) {
            t.header = n;
          } },
          A.createElement("div", { className: "react-datepicker-time__header" }, t.props.timeCaption)
        );
      }, t;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, r.prototype.render = function() {
      var t = this, n, o = this.state.height;
      return A.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((n = this.props.todayButton) !== null && n !== void 0 ? n : r.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        A.createElement(
          "div",
          { className: "react-datepicker__time" },
          A.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            A.createElement("ul", { className: "react-datepicker__time-list", ref: function(a) {
              t.list = a;
            }, style: o ? { height: o } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, r.calcCenterPosition = function(t, n) {
      return n.offsetTop - (t / 2 - n.clientHeight / 2);
    }, r;
  }(bt)
), ip = 3, e2 = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.YEAR_REFS = Pr([], Array(n.props.yearItemNumber), !0).map(function() {
        return kn();
      }), n.isDisabled = function(o) {
        return kr(o, {
          minDate: n.props.minDate,
          maxDate: n.props.maxDate,
          excludeDates: n.props.excludeDates,
          includeDates: n.props.includeDates,
          filterDate: n.props.filterDate
        });
      }, n.isExcluded = function(o) {
        return Wc(o, {
          excludeDates: n.props.excludeDates
        });
      }, n.selectingDate = function() {
        var o;
        return (o = n.props.selectingDate) !== null && o !== void 0 ? o : n.props.preSelection;
      }, n.updateFocusOnPaginate = function(o) {
        var a = function() {
          var i, s;
          (s = (i = n.YEAR_REFS[o]) === null || i === void 0 ? void 0 : i.current) === null || s === void 0 || s.focus();
        };
        window.requestAnimationFrame(a);
      }, n.handleYearClick = function(o, a) {
        n.props.onDayClick && n.props.onDayClick(o, a);
      }, n.handleYearNavigation = function(o, a) {
        var i, s, l, u, c = n.props, d = c.date, f = c.yearItemNumber;
        if (!(d === void 0 || f === void 0)) {
          var p = Sn(d, f).startPeriod;
          n.isDisabled(a) || n.isExcluded(a) || ((s = (i = n.props).setPreSelection) === null || s === void 0 || s.call(i, a), o - p < 0 ? n.updateFocusOnPaginate(f - (p - o)) : o - p >= f ? n.updateFocusOnPaginate(Math.abs(f - (o - p))) : (u = (l = n.YEAR_REFS[o - p]) === null || l === void 0 ? void 0 : l.current) === null || u === void 0 || u.focus());
        }
      }, n.isSameDay = function(o, a) {
        return _e(o, a);
      }, n.isCurrentYear = function(o) {
        return o === Ce(Ge());
      }, n.isRangeStart = function(o) {
        return n.props.startDate && n.props.endDate && _r(Ir(Ge(), o), n.props.startDate);
      }, n.isRangeEnd = function(o) {
        return n.props.startDate && n.props.endDate && _r(Ir(Ge(), o), n.props.endDate);
      }, n.isInRange = function(o) {
        return Si(o, n.props.startDate, n.props.endDate);
      }, n.isInSelectingRange = function(o) {
        var a = n.props, i = a.selectsStart, s = a.selectsEnd, l = a.selectsRange, u = a.startDate, c = a.endDate;
        return !(i || s || l) || !n.selectingDate() ? !1 : i && c ? Si(o, n.selectingDate(), c) : s && u || l && u && !c ? Si(o, u, n.selectingDate()) : !1;
      }, n.isSelectingRangeStart = function(o) {
        var a;
        if (!n.isInSelectingRange(o))
          return !1;
        var i = n.props, s = i.startDate, l = i.selectsStart, u = Ir(Ge(), o);
        return l ? _r(u, (a = n.selectingDate()) !== null && a !== void 0 ? a : null) : _r(u, s ?? null);
      }, n.isSelectingRangeEnd = function(o) {
        var a;
        if (!n.isInSelectingRange(o))
          return !1;
        var i = n.props, s = i.endDate, l = i.selectsEnd, u = i.selectsRange, c = Ir(Ge(), o);
        return l || u ? _r(c, (a = n.selectingDate()) !== null && a !== void 0 ? a : null) : _r(c, s ?? null);
      }, n.isKeyboardSelected = function(o) {
        if (!(n.props.date === void 0 || n.props.selected == null || n.props.preSelection == null)) {
          var a = n.props, i = a.minDate, s = a.maxDate, l = a.excludeDates, u = a.includeDates, c = a.filterDate, d = ba(Ir(n.props.date, o)), f = (i || s || l || u || c) && Gi(o, n.props);
          return !n.props.disabledKeyboardNavigation && !n.props.inline && !_e(d, ba(n.props.selected)) && _e(d, ba(n.props.preSelection)) && !f;
        }
      }, n.onYearClick = function(o, a) {
        var i = n.props.date;
        i !== void 0 && n.handleYearClick(ba(Ir(i, a)), o);
      }, n.onYearKeyDown = function(o, a) {
        var i, s, l = o.key, u = n.props, c = u.date, d = u.yearItemNumber, f = u.handleOnKeyDown;
        if (l !== ee.Tab && o.preventDefault(), !n.props.disabledKeyboardNavigation)
          switch (l) {
            case ee.Enter:
              if (n.props.selected == null)
                break;
              n.onYearClick(o, a), (s = (i = n.props).setPreSelection) === null || s === void 0 || s.call(i, n.props.selected);
              break;
            case ee.ArrowRight:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(a + 1, on(n.props.preSelection, 1));
              break;
            case ee.ArrowLeft:
              if (n.props.preSelection == null)
                break;
              n.handleYearNavigation(a - 1, zo(n.props.preSelection, 1));
              break;
            case ee.ArrowUp: {
              if (c === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var p = Sn(c, d).startPeriod, h = ip, g = a - h;
              if (g < p) {
                var m = d % h;
                a >= p && a < p + m ? h = m : h += m, g = a - h;
              }
              n.handleYearNavigation(g, zo(n.props.preSelection, h));
              break;
            }
            case ee.ArrowDown: {
              if (c === void 0 || d === void 0 || n.props.preSelection == null)
                break;
              var v = Sn(c, d).endPeriod, h = ip, g = a + h;
              if (g > v) {
                var m = d % h;
                a <= v && a > v - m ? h = m : h += m, g = a + h;
              }
              n.handleYearNavigation(g, on(n.props.preSelection, h));
              break;
            }
          }
        f && f(o);
      }, n.getYearClassNames = function(o) {
        var a = n.props, i = a.date, s = a.minDate, l = a.maxDate, u = a.selected, c = a.excludeDates, d = a.includeDates, f = a.filterDate, p = a.yearClassName;
        return wt("react-datepicker__year-text", "react-datepicker__year-".concat(o), i ? p == null ? void 0 : p(Ir(i, o)) : void 0, {
          "react-datepicker__year-text--selected": u ? o === Ce(u) : void 0,
          "react-datepicker__year-text--disabled": (s || l || c || d || f) && Gi(o, n.props),
          "react-datepicker__year-text--keyboard-selected": n.isKeyboardSelected(o),
          "react-datepicker__year-text--range-start": n.isRangeStart(o),
          "react-datepicker__year-text--range-end": n.isRangeEnd(o),
          "react-datepicker__year-text--in-range": n.isInRange(o),
          "react-datepicker__year-text--in-selecting-range": n.isInSelectingRange(o),
          "react-datepicker__year-text--selecting-range-start": n.isSelectingRangeStart(o),
          "react-datepicker__year-text--selecting-range-end": n.isSelectingRangeEnd(o),
          "react-datepicker__year-text--today": n.isCurrentYear(o)
        });
      }, n.getYearTabIndex = function(o) {
        if (n.props.disabledKeyboardNavigation || n.props.preSelection == null)
          return "-1";
        var a = Ce(n.props.preSelection), i = Gi(o, n.props);
        return o === a && !i ? "0" : "-1";
      }, n.getYearContainerClassNames = function() {
        var o = n.props, a = o.selectingDate, i = o.selectsStart, s = o.selectsEnd, l = o.selectsRange;
        return wt("react-datepicker__year", {
          "react-datepicker__year--selecting-range": a && (i || s || l)
        });
      }, n.getYearContent = function(o) {
        return n.props.renderYearContent ? n.props.renderYearContent(o) : o;
      }, n;
    }
    return r.prototype.render = function() {
      var t = this, n = [], o = this.props, a = o.date, i = o.yearItemNumber, s = o.onYearMouseEnter, l = o.onYearMouseLeave;
      if (a === void 0)
        return null;
      for (var u = Sn(a, i), c = u.startPeriod, d = u.endPeriod, f = function(g) {
        n.push(A.createElement("div", { ref: p.YEAR_REFS[g - c], onClick: function(m) {
          t.onYearClick(m, g);
        }, onKeyDown: function(m) {
          Gm(m) && (m.preventDefault(), m.key = ee.Enter), t.onYearKeyDown(m, g);
        }, tabIndex: Number(p.getYearTabIndex(g)), className: p.getYearClassNames(g), onMouseEnter: p.props.usePointerEvent ? void 0 : function(m) {
          return s(m, g);
        }, onPointerEnter: p.props.usePointerEvent ? function(m) {
          return s(m, g);
        } : void 0, onMouseLeave: p.props.usePointerEvent ? void 0 : function(m) {
          return l(m, g);
        }, onPointerLeave: p.props.usePointerEvent ? function(m) {
          return l(m, g);
        } : void 0, key: g, "aria-current": p.isCurrentYear(g) ? "date" : void 0 }, p.getYearContent(g)));
      }, p = this, h = c; h <= d; h++)
        f(h);
      return A.createElement(
        "div",
        { className: this.getYearContainerClassNames() },
        A.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, n)
      );
    }, r;
  }(bt)
);
function t2(e, r, t, n) {
  for (var o = [], a = 0; a < 2 * r + 1; a++) {
    var i = e + r - a, s = !0;
    t && (s = Ce(t) <= i), n && s && (s = Ce(n) >= i), s && o.push(i);
  }
  return o;
}
var r2 = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      n.renderOptions = function() {
        var s = n.props.year, l = n.state.yearsList.map(function(d) {
          return A.createElement(
            "div",
            { className: s === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: n.onChange.bind(n, d), "aria-selected": s === d ? "true" : void 0 },
            s === d ? A.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), u = n.props.minDate ? Ce(n.props.minDate) : null, c = n.props.maxDate ? Ce(n.props.maxDate) : null;
        return (!c || !n.state.yearsList.find(function(d) {
          return d === c;
        })) && l.unshift(A.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: n.incrementYears },
          A.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!u || !n.state.yearsList.find(function(d) {
          return d === u;
        })) && l.push(A.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: n.decrementYears },
          A.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, n.onChange = function(s) {
        n.props.onChange(s);
      }, n.handleClickOutside = function() {
        n.props.onCancel();
      }, n.shiftYears = function(s) {
        var l = n.state.yearsList.map(function(u) {
          return u + s;
        });
        n.setState({
          yearsList: l
        });
      }, n.incrementYears = function() {
        return n.shiftYears(1);
      }, n.decrementYears = function() {
        return n.shiftYears(-1);
      };
      var o = t.yearDropdownItemNumber, a = t.scrollableYearDropdown, i = o || (a ? 10 : 5);
      return n.state = {
        yearsList: t2(n.props.year, i, n.props.minDate, n.props.maxDate)
      }, n.dropdownRef = kn(), n;
    }
    return r.prototype.componentDidMount = function() {
      var t = this.dropdownRef.current;
      if (t) {
        var n = t.children ? Array.from(t.children) : null, o = n ? n.find(function(a) {
          return a.ariaSelected;
        }) : null;
        t.scrollTop = o && o instanceof HTMLElement ? o.offsetTop + (o.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
      }
    }, r.prototype.render = function() {
      var t = wt({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return A.createElement(Ks, { className: t, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, r;
  }(bt)
), n2 = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      var t = e !== null && e.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var n = t.props.minDate ? Ce(t.props.minDate) : 1900, o = t.props.maxDate ? Ce(t.props.maxDate) : 2100, a = [], i = n; i <= o; i++)
          a.push(A.createElement("option", { key: i, value: i }, i));
        return a;
      }, t.onSelectChange = function(n) {
        t.onChange(parseInt(n.target.value));
      }, t.renderSelectMode = function() {
        return A.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(n) {
        return A.createElement(
          "div",
          { key: "read", style: { visibility: n ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(o) {
            return t.toggleDropdown(o);
          } },
          A.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          A.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year)
        );
      }, t.renderDropdown = function() {
        return A.createElement(r2, Ee({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var n = t.state.dropdownVisible, o = [t.renderReadView(!n)];
        return n && o.unshift(t.renderDropdown()), o;
      }, t.onChange = function(n) {
        t.toggleDropdown(), n !== t.props.year && t.props.onChange(n);
      }, t.toggleDropdown = function(n) {
        t.setState({
          dropdownVisible: !t.state.dropdownVisible
        }, function() {
          t.props.adjustDateOnChange && t.handleYearChange(t.props.date, n);
        });
      }, t.handleYearChange = function(n, o) {
        var a;
        (a = t.onSelect) === null || a === void 0 || a.call(t, n, o), t.setOpen();
      }, t.onSelect = function(n, o) {
        var a, i;
        (i = (a = t.props).onSelect) === null || i === void 0 || i.call(a, n, o);
      }, t.setOpen = function() {
        var n, o;
        (o = (n = t.props).setOpen) === null || o === void 0 || o.call(n, !0);
      }, t;
    }
    return r.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return A.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, r;
  }(bt)
), o2 = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], a2 = function(e) {
  var r = (e.className || "").split(/\s+/);
  return o2.some(function(t) {
    return r.indexOf(t) >= 0;
  });
}, i2 = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.monthContainer = void 0, n.handleClickOutside = function(o) {
        n.props.onClickOutside(o);
      }, n.setClickOutsideRef = function() {
        return n.containerRef.current;
      }, n.handleDropdownFocus = function(o) {
        var a, i;
        a2(o.target) && ((i = (a = n.props).onDropdownFocus) === null || i === void 0 || i.call(a, o));
      }, n.getDateInView = function() {
        var o = n.props, a = o.preSelection, i = o.selected, s = o.openToDate, l = Bm(n.props), u = Vm(n.props), c = Ge(), d = s || i || a;
        return d || (l && eo(c, l) ? l : u && Mn(c, u) ? u : c);
      }, n.increaseMonth = function() {
        n.setState(function(o) {
          var a = o.date;
          return {
            date: vr(a, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.decreaseMonth = function() {
        n.setState(function(o) {
          var a = o.date;
          return {
            date: Ho(a, 1)
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.handleDayClick = function(o, a, i) {
        n.props.onSelect(o, a, i), n.props.setPreSelection && n.props.setPreSelection(o);
      }, n.handleDayMouseEnter = function(o) {
        n.setState({ selectingDate: o }), n.props.onDayMouseEnter && n.props.onDayMouseEnter(o);
      }, n.handleMonthMouseLeave = function() {
        n.setState({ selectingDate: void 0 }), n.props.onMonthMouseLeave && n.props.onMonthMouseLeave();
      }, n.handleYearMouseEnter = function(o, a) {
        n.setState({ selectingDate: Ir(Ge(), a) }), n.props.onYearMouseEnter && n.props.onYearMouseEnter(o, a);
      }, n.handleYearMouseLeave = function(o, a) {
        n.props.onYearMouseLeave && n.props.onYearMouseLeave(o, a);
      }, n.handleYearChange = function(o) {
        var a, i, s, l;
        (i = (a = n.props).onYearChange) === null || i === void 0 || i.call(a, o), n.setState({ isRenderAriaLiveMessage: !0 }), n.props.adjustDateOnChange && (n.props.onSelect(o), (l = (s = n.props).setOpen) === null || l === void 0 || l.call(s, !0)), n.props.setPreSelection && n.props.setPreSelection(o);
      }, n.handleMonthChange = function(o) {
        var a, i;
        n.handleCustomMonthChange(o), n.props.adjustDateOnChange && (n.props.onSelect(o), (i = (a = n.props).setOpen) === null || i === void 0 || i.call(a, !0)), n.props.setPreSelection && n.props.setPreSelection(o);
      }, n.handleCustomMonthChange = function(o) {
        var a, i;
        (i = (a = n.props).onMonthChange) === null || i === void 0 || i.call(a, o), n.setState({ isRenderAriaLiveMessage: !0 });
      }, n.handleMonthYearChange = function(o) {
        n.handleYearChange(o), n.handleMonthChange(o);
      }, n.changeYear = function(o) {
        n.setState(function(a) {
          var i = a.date;
          return {
            date: Ir(i, Number(o))
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.changeMonth = function(o) {
        n.setState(function(a) {
          var i = a.date;
          return {
            date: Ht(i, Number(o))
          };
        }, function() {
          return n.handleMonthChange(n.state.date);
        });
      }, n.changeMonthYear = function(o) {
        n.setState(function(a) {
          var i = a.date;
          return {
            date: Ir(Ht(i, Ot(o)), Ce(o))
          };
        }, function() {
          return n.handleMonthYearChange(n.state.date);
        });
      }, n.header = function(o) {
        o === void 0 && (o = n.state.date);
        var a = Dn(o, n.props.locale, n.props.calendarStartDay), i = [];
        return n.props.showWeekNumbers && i.push(A.createElement("div", { key: "W", className: "react-datepicker__day-name" }, n.props.weekLabel || "#")), i.concat([0, 1, 2, 3, 4, 5, 6].map(function(s) {
          var l = On(a, s), u = n.formatWeekday(l, n.props.locale), c = n.props.weekDayClassName ? n.props.weekDayClassName(l) : void 0;
          return A.createElement("div", { key: s, "aria-label": Je(l, "EEEE", n.props.locale), className: wt("react-datepicker__day-name", c) }, u);
        }));
      }, n.formatWeekday = function(o, a) {
        return n.props.formatWeekDay ? EO(o, n.props.formatWeekDay, a) : n.props.useWeekdaysShort ? AO(o, a) : MO(o, a);
      }, n.decreaseYear = function() {
        n.setState(function(o) {
          var a, i = o.date;
          return {
            date: zo(i, n.props.showYearPicker ? (a = n.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.clearSelectingDate = function() {
        n.setState({ selectingDate: void 0 });
      }, n.renderPreviousButton = function() {
        var o;
        if (!n.props.renderCustomHeader) {
          var a;
          switch (!0) {
            case n.props.showMonthYearPicker:
              a = qf(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              a = FO(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              a = OO(n.state.date, n.props);
              break;
            default:
              a = Jf(n.state.date, n.props);
              break;
          }
          if (!(!((o = n.props.forceShowMonthNavigation) !== null && o !== void 0 ? o : r.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && a || n.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], l = n.decreaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.decreaseYear), a && n.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--previous--disabled"), l = void 0);
            var u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.previousMonthButtonLabel, f = d === void 0 ? r.defaultProps.previousMonthButtonLabel : d, p = c.previousYearButtonLabel, h = p === void 0 ? r.defaultProps.previousYearButtonLabel : p, g = n.props, m = g.previousMonthAriaLabel, v = m === void 0 ? typeof f == "string" ? f : "Previous Month" : m, y = g.previousYearAriaLabel, C = y === void 0 ? typeof h == "string" ? h : "Previous Year" : y;
            return A.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": u ? C : v },
              A.createElement("span", { className: i.join(" ") }, u ? h : f)
            );
          }
        }
      }, n.increaseYear = function() {
        n.setState(function(o) {
          var a, i = o.date;
          return {
            date: on(i, n.props.showYearPicker ? (a = n.props.yearItemNumber) !== null && a !== void 0 ? a : r.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return n.handleYearChange(n.state.date);
        });
      }, n.renderNextButton = function() {
        var o;
        if (!n.props.renderCustomHeader) {
          var a;
          switch (!0) {
            case n.props.showMonthYearPicker:
              a = Kf(n.state.date, n.props);
              break;
            case n.props.showYearPicker:
              a = NO(n.state.date, n.props);
              break;
            case n.props.showQuarterYearPicker:
              a = TO(n.state.date, n.props);
              break;
            default:
              a = Qf(n.state.date, n.props);
              break;
          }
          if (!(!((o = n.props.forceShowMonthNavigation) !== null && o !== void 0 ? o : r.defaultProps.forceShowMonthNavigation) && !n.props.showDisabledMonthNavigation && a || n.props.showTimeSelectOnly)) {
            var i = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            n.props.showTimeSelect && i.push("react-datepicker__navigation--next--with-time"), n.props.todayButton && i.push("react-datepicker__navigation--next--with-today-button");
            var l = n.increaseMonth;
            (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker) && (l = n.increaseYear), a && n.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker, c = n.props, d = c.nextMonthButtonLabel, f = d === void 0 ? r.defaultProps.nextMonthButtonLabel : d, p = c.nextYearButtonLabel, h = p === void 0 ? r.defaultProps.nextYearButtonLabel : p, g = n.props, m = g.nextMonthAriaLabel, v = m === void 0 ? typeof f == "string" ? f : "Next Month" : m, y = g.nextYearAriaLabel, C = y === void 0 ? typeof h == "string" ? h : "Next Year" : y;
            return A.createElement(
              "button",
              { type: "button", className: i.join(" "), onClick: l, onKeyDown: n.props.handleOnKeyDown, "aria-label": u ? C : v },
              A.createElement("span", { className: s.join(" ") }, u ? h : f)
            );
          }
        }
      }, n.renderCurrentMonth = function(o) {
        o === void 0 && (o = n.state.date);
        var a = ["react-datepicker__current-month"];
        return n.props.showYearDropdown && a.push("react-datepicker__current-month--hasYearDropdown"), n.props.showMonthDropdown && a.push("react-datepicker__current-month--hasMonthDropdown"), n.props.showMonthYearDropdown && a.push("react-datepicker__current-month--hasMonthYearDropdown"), A.createElement("h2", { className: a.join(" ") }, Je(o, n.props.dateFormat, n.props.locale));
      }, n.renderYearDropdown = function(o) {
        if (o === void 0 && (o = !1), !(!n.props.showYearDropdown || o))
          return A.createElement(n2, Ee({}, r.defaultProps, n.props, { date: n.state.date, onChange: n.changeYear, year: Ce(n.state.date) }));
      }, n.renderMonthDropdown = function(o) {
        if (o === void 0 && (o = !1), !(!n.props.showMonthDropdown || o))
          return A.createElement(UO, Ee({}, r.defaultProps, n.props, { month: Ot(n.state.date), onChange: n.changeMonth }));
      }, n.renderMonthYearDropdown = function(o) {
        if (o === void 0 && (o = !1), !(!n.props.showMonthYearDropdown || o))
          return A.createElement(qO, Ee({}, r.defaultProps, n.props, { date: n.state.date, onChange: n.changeMonthYear }));
      }, n.handleTodayButtonClick = function(o) {
        n.props.onSelect($f(), o), n.props.setPreSelection && n.props.setPreSelection($f());
      }, n.renderTodayButton = function() {
        if (!(!n.props.todayButton || n.props.showTimeSelectOnly))
          return A.createElement("div", { className: "react-datepicker__today-button", onClick: n.handleTodayButtonClick }, n.props.todayButton);
      }, n.renderDefaultHeader = function(o) {
        var a = o.monthDate, i = o.i;
        return A.createElement(
          "div",
          { className: "react-datepicker__header ".concat(n.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          n.renderCurrentMonth(a),
          A.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode), onFocus: n.handleDropdownFocus },
            n.renderMonthDropdown(i !== 0),
            n.renderMonthYearDropdown(i !== 0),
            n.renderYearDropdown(i !== 0)
          ),
          A.createElement("div", { className: "react-datepicker__day-names" }, n.header(a))
        );
      }, n.renderCustomHeader = function(o) {
        var a, i, s = o.monthDate, l = o.i;
        if (n.props.showTimeSelect && !n.state.monthContainer || n.props.showTimeSelectOnly)
          return null;
        var u = Jf(n.state.date, n.props), c = Qf(n.state.date, n.props), d = qf(n.state.date, n.props), f = Kf(n.state.date, n.props), p = !n.props.showMonthYearPicker && !n.props.showQuarterYearPicker && !n.props.showYearPicker;
        return A.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: n.props.onDropdownFocus },
          (i = (a = n.props).renderCustomHeader) === null || i === void 0 ? void 0 : i.call(a, Ee(Ee({}, n.state), { customHeaderCount: l, monthDate: s, changeMonth: n.changeMonth, changeYear: n.changeYear, decreaseMonth: n.decreaseMonth, increaseMonth: n.increaseMonth, decreaseYear: n.decreaseYear, increaseYear: n.increaseYear, prevMonthButtonDisabled: u, nextMonthButtonDisabled: c, prevYearButtonDisabled: d, nextYearButtonDisabled: f })),
          p && A.createElement("div", { className: "react-datepicker__day-names" }, n.header(s))
        );
      }, n.renderYearHeader = function(o) {
        var a = o.monthDate, i = n.props, s = i.showYearPicker, l = i.yearItemNumber, u = l === void 0 ? r.defaultProps.yearItemNumber : l, c = Sn(a, u), d = c.startPeriod, f = c.endPeriod;
        return A.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, s ? "".concat(d, " - ").concat(f) : Ce(a));
      }, n.renderHeader = function(o) {
        var a = o.monthDate, i = o.i, s = i === void 0 ? 0 : i, l = { monthDate: a, i: s };
        switch (!0) {
          case n.props.renderCustomHeader !== void 0:
            return n.renderCustomHeader(l);
          case (n.props.showMonthYearPicker || n.props.showQuarterYearPicker || n.props.showYearPicker):
            return n.renderYearHeader(l);
          default:
            return n.renderDefaultHeader(l);
        }
      }, n.renderMonths = function() {
        var o, a;
        if (!(n.props.showTimeSelectOnly || n.props.showYearPicker)) {
          for (var i = [], s = (o = n.props.monthsShown) !== null && o !== void 0 ? o : r.defaultProps.monthsShown, l = n.props.showPreviousMonths ? s - 1 : 0, u = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? on(n.state.date, l) : Ho(n.state.date, l), c = (a = n.props.monthSelectedIn) !== null && a !== void 0 ? a : l, d = 0; d < s; ++d) {
            var f = d - c + l, p = n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? on(u, f) : vr(u, f), h = "month-".concat(d), g = d < s - 1, m = d > 0;
            i.push(A.createElement(
              "div",
              { key: h, ref: function(v) {
                n.monthContainer = v ?? void 0;
              }, className: "react-datepicker__month-container" },
              n.renderHeader({ monthDate: p, i: d }),
              A.createElement(jO, Ee({}, r.defaultProps, n.props, { ariaLabelPrefix: n.props.monthAriaLabelPrefix, day: p, onDayClick: n.handleDayClick, handleOnKeyDown: n.props.handleOnDayKeyDown, handleOnMonthKeyDown: n.props.handleOnKeyDown, onDayMouseEnter: n.handleDayMouseEnter, onMouseLeave: n.handleMonthMouseLeave, orderInDisplay: d, selectingDate: n.state.selectingDate, monthShowsDuplicateDaysEnd: g, monthShowsDuplicateDaysStart: m }))
            ));
          }
          return i;
        }
      }, n.renderYears = function() {
        if (!n.props.showTimeSelectOnly && n.props.showYearPicker)
          return A.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            n.renderHeader({ monthDate: n.state.date }),
            A.createElement(e2, Ee({}, r.defaultProps, n.props, { selectingDate: n.state.selectingDate, date: n.state.date, onDayClick: n.handleDayClick, clearSelectingDate: n.clearSelectingDate, onYearMouseEnter: n.handleYearMouseEnter, onYearMouseLeave: n.handleYearMouseLeave }))
          );
      }, n.renderTimeSection = function() {
        if (n.props.showTimeSelect && (n.state.monthContainer || n.props.showTimeSelectOnly))
          return A.createElement(KO, Ee({}, r.defaultProps, n.props, { onChange: n.props.onTimeChange, format: n.props.timeFormat, intervals: n.props.timeIntervals, monthRef: n.state.monthContainer }));
      }, n.renderInputTimeSection = function() {
        var o = n.props.selected ? new Date(n.props.selected) : void 0, a = o && Qr(o) && !!n.props.selected, i = a ? "".concat(tp(o.getHours()), ":").concat(tp(o.getMinutes())) : "";
        if (n.props.showTimeInput)
          return A.createElement(YO, Ee({}, r.defaultProps, n.props, { date: o, timeString: i, onChange: n.props.onTimeChange }));
      }, n.renderAriaLiveRegion = function() {
        var o, a = Sn(n.state.date, (o = n.props.yearItemNumber) !== null && o !== void 0 ? o : r.defaultProps.yearItemNumber), i = a.startPeriod, s = a.endPeriod, l;
        return n.props.showYearPicker ? l = "".concat(i, " - ").concat(s) : n.props.showMonthYearPicker || n.props.showQuarterYearPicker ? l = Ce(n.state.date) : l = "".concat(Lc(Ot(n.state.date), n.props.locale), " ").concat(Ce(n.state.date)), A.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, n.state.isRenderAriaLiveMessage && l);
      }, n.renderChildren = function() {
        if (n.props.children)
          return A.createElement("div", { className: "react-datepicker__children-container" }, n.props.children);
      }, n.containerRef = kn(), n.state = {
        date: n.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, n;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: ri
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      var t = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        t.setState({ monthContainer: t.monthContainer });
      }());
    }, r.prototype.componentDidUpdate = function(t) {
      var n = this;
      if (this.props.preSelection && (!_e(this.props.preSelection, t.preSelection) || this.props.monthSelectedIn !== t.monthSelectedIn)) {
        var o = !At(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return o && n.handleCustomMonthChange(n.state.date);
        });
      } else this.props.openToDate && !_e(this.props.openToDate, t.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, r.prototype.render = function() {
      var t = this.props.container || wO;
      return A.createElement(
        Ks,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        A.createElement(
          t,
          { className: wt("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, r;
  }(bt)
), s2 = function(e) {
  var r = e.icon, t = e.className, n = t === void 0 ? "" : t, o = e.onClick, a = "react-datepicker__calendar-icon";
  return typeof r == "string" ? A.createElement("i", { className: "".concat(a, " ").concat(r, " ").concat(n), "aria-hidden": "true", onClick: o }) : A.isValidElement(r) ? A.cloneElement(r, {
    className: "".concat(r.props.className || "", " ").concat(a, " ").concat(n),
    onClick: function(i) {
      typeof r.props.onClick == "function" && r.props.onClick(i), typeof o == "function" && o(i);
    }
  }) : A.createElement(
    "svg",
    { className: "".concat(a, " ").concat(n), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: o },
    A.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, Ym = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.portalRoot = null, n.el = document.createElement("div"), n;
    }
    return r.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, r.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, r.prototype.render = function() {
      return Tb.createPortal(this.props.children, this.el);
    }, r;
  }(bt)
), l2 = "[tabindex], a, button, input, select, textarea", u2 = function(e) {
  return (e instanceof HTMLAnchorElement || !e.disabled) && e.tabIndex !== -1;
}, Hm = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.getTabChildren = function() {
        var o;
        return Array.prototype.slice.call((o = n.tabLoopRef.current) === null || o === void 0 ? void 0 : o.querySelectorAll(l2), 1, -1).filter(u2);
      }, n.handleFocusStart = function() {
        var o = n.getTabChildren();
        o && o.length > 1 && o[o.length - 1].focus();
      }, n.handleFocusEnd = function() {
        var o = n.getTabChildren();
        o && o.length > 1 && o[0].focus();
      }, n.tabLoopRef = kn(), n;
    }
    return r.prototype.render = function() {
      var t;
      return ((t = this.props.enableTabLoop) !== null && t !== void 0 ? t : r.defaultProps.enableTabLoop) ? A.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        A.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        A.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, r.defaultProps = {
      enableTabLoop: !0
    }, r;
  }(bt)
);
function c2(e) {
  var r = function(t) {
    var n, o = typeof t.hidePopper == "boolean" ? t.hidePopper : !0, a = ye(null), i = yO(Ee({ open: !o, whileElementsMounted: Up, placement: t.popperPlacement, middleware: Pr([
      rO({ padding: 15 }),
      tO(10),
      nO({ element: a })
    ], (n = t.popperModifiers) !== null && n !== void 0 ? n : [], !0) }, t.popperProps)), s = Ee(Ee({}, t), { hidePopper: o, popperProps: Ee(Ee({}, i), { arrowRef: a }) });
    return A.createElement(e, Ee({}, s));
  };
  return r;
}
var d2 = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.render = function() {
      var t = this.props, n = t.className, o = t.wrapperClassName, a = t.hidePopper, i = a === void 0 ? r.defaultProps.hidePopper : a, s = t.popperComponent, l = t.targetComponent, u = t.enableTabLoop, c = t.popperOnKeyDown, d = t.portalId, f = t.portalHost, p = t.popperProps, h = t.showArrow, g = void 0;
      if (!i) {
        var m = wt("react-datepicker-popper", n);
        g = A.createElement(
          Hm,
          { enableTabLoop: u },
          A.createElement(
            "div",
            { ref: p.refs.setFloating, style: p.floatingStyles, className: m, "data-placement": p.placement, onKeyDown: c },
            s,
            h && A.createElement(fO, { ref: p.arrowRef, context: p.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (g = sb(this.props.popperContainer, {}, g)), d && !i && (g = A.createElement(Ym, { portalId: d, portalHost: f }, g));
      var v = wt("react-datepicker-wrapper", o);
      return A.createElement(
        A.Fragment,
        null,
        A.createElement("div", { ref: p.refs.setReference, className: v }, l),
        g
      );
    }, r;
  }(bt)
), f2 = c2(d2), sp = "react-datepicker-ignore-onclickoutside";
function p2(e, r) {
  return e && r ? Ot(e) !== Ot(r) || Ce(e) !== Ce(r) : e !== r;
}
var Hl = "Date input not valid.", zm = (
  /** @class */
  function(e) {
    Ct(r, e);
    function r(t) {
      var n = e.call(this, t) || this;
      return n.calendar = null, n.input = null, n.getPreSelection = function() {
        return n.props.openToDate ? n.props.openToDate : n.props.selectsEnd && n.props.startDate ? n.props.startDate : n.props.selectsStart && n.props.endDate ? n.props.endDate : Ge();
      }, n.modifyHolidays = function() {
        var o;
        return (o = n.props.holidays) === null || o === void 0 ? void 0 : o.reduce(function(a, i) {
          var s = new Date(i.date);
          return Qr(s) ? Pr(Pr([], a, !0), [Ee(Ee({}, i), { date: s })], !1) : a;
        }, []);
      }, n.calcInitialState = function() {
        var o, a = n.getPreSelection(), i = Bm(n.props), s = Vm(n.props), l = i && eo(a, Vi(i)) ? i : s && Mn(a, Xf(s)) ? s : a;
        return {
          open: n.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (o = n.props.selectsRange ? n.props.startDate : n.props.selected) !== null && o !== void 0 ? o : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: ep(n.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, n.resetHiddenStatus = function() {
        n.setState(Ee(Ee({}, n.state), { wasHidden: !1 }));
      }, n.setHiddenStatus = function() {
        n.setState(Ee(Ee({}, n.state), { wasHidden: !0 }));
      }, n.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && n.setHiddenStatus();
      }, n.clearPreventFocusTimeout = function() {
        n.preventFocusTimeout && clearTimeout(n.preventFocusTimeout);
      }, n.setFocus = function() {
        n.input && n.input.focus && n.input.focus({ preventScroll: !0 });
      }, n.setBlur = function() {
        n.input && n.input.blur && n.input.blur(), n.cancelFocusInput();
      }, n.setOpen = function(o, a) {
        a === void 0 && (a = !1), n.setState({
          open: o,
          preSelection: o && n.state.open ? n.state.preSelection : n.calcInitialState().preSelection,
          lastPreSelectChange: zl
        }, function() {
          o || n.setState(function(i) {
            return {
              focused: a ? i.focused : !1
            };
          }, function() {
            !a && n.setBlur(), n.setState({ inputValue: null });
          });
        });
      }, n.inputOk = function() {
        return an(n.state.preSelection);
      }, n.isCalendarOpen = function() {
        return n.props.open === void 0 ? n.state.open && !n.props.disabled && !n.props.readOnly : n.props.open;
      }, n.handleFocus = function(o) {
        var a, i, s = n.state.wasHidden, l = s ? n.state.open : !0;
        s && n.resetHiddenStatus(), !n.state.preventFocus && l && ((i = (a = n.props).onFocus) === null || i === void 0 || i.call(a, o), !n.props.preventOpenOnFocus && !n.props.readOnly && n.setOpen(!0)), n.setState({ focused: !0 });
      }, n.sendFocusBackToInput = function() {
        n.preventFocusTimeout && n.clearPreventFocusTimeout(), n.setState({ preventFocus: !0 }, function() {
          n.preventFocusTimeout = setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        });
      }, n.cancelFocusInput = function() {
        clearTimeout(n.inputFocusTimeout), n.inputFocusTimeout = void 0;
      }, n.deferFocusInput = function() {
        n.cancelFocusInput(), n.inputFocusTimeout = setTimeout(function() {
          return n.setFocus();
        }, 1);
      }, n.handleDropdownFocus = function() {
        n.cancelFocusInput();
      }, n.handleBlur = function(o) {
        var a, i;
        (!n.state.open || n.props.withPortal || n.props.showTimeInput) && ((i = (a = n.props).onBlur) === null || i === void 0 || i.call(a, o)), n.setState({ focused: !1 });
      }, n.handleCalendarClickOutside = function(o) {
        var a, i;
        n.props.inline || n.setOpen(!1), (i = (a = n.props).onClickOutside) === null || i === void 0 || i.call(a, o), n.props.withPortal && o.preventDefault();
      }, n.handleChange = function() {
        for (var o, a, i = [], s = 0; s < arguments.length; s++)
          i[s] = arguments[s];
        var l = i[0];
        if (!(n.props.onChangeRaw && (n.props.onChangeRaw.apply(n, i), !l || typeof l.isDefaultPrevented != "function" || l.isDefaultPrevented()))) {
          n.setState({
            inputValue: (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : null,
            lastPreSelectChange: h2
          });
          var u = n.props, c = u.dateFormat, d = c === void 0 ? r.defaultProps.dateFormat : c, f = u.strictParsing, p = f === void 0 ? r.defaultProps.strictParsing : f, h = u.selectsRange, g = u.startDate, m = u.endDate, v = (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : "";
          if (h) {
            var y = v.split("-", 2).map(function(R) {
              return R.trim();
            }), C = y[0], I = y[1], b = Vl(C ?? "", d, n.props.locale, p), D = Vl(I ?? "", d, n.props.locale, p), x = (g == null ? void 0 : g.getTime()) !== (b == null ? void 0 : b.getTime()), _ = (m == null ? void 0 : m.getTime()) !== (D == null ? void 0 : D.getTime());
            if (!x && !_ || b && kr(b, n.props) || D && kr(D, n.props))
              return;
            (a = (o = n.props).onChange) === null || a === void 0 || a.call(o, [b, D], l);
          } else {
            var E = Vl(v, d, n.props.locale, p, n.props.minDate);
            n.props.showTimeSelectOnly && n.props.selected && E && !_e(E, n.props.selected) && (E = UR(n.props.selected, {
              hours: Tr(E),
              minutes: Fr(E),
              seconds: sn(E)
            })), (E || !v) && n.setSelected(E, l, !0);
          }
        }
      }, n.handleSelect = function(o, a, i) {
        if (n.props.shouldCloseOnSelect && !n.props.showTimeSelect && n.sendFocusBackToInput(), n.props.onChangeRaw && n.props.onChangeRaw(a), n.setSelected(o, a, !1, i), n.props.showDateSelect && n.setState({ isRenderAriaLiveMessage: !0 }), !n.props.shouldCloseOnSelect || n.props.showTimeSelect)
          n.setPreSelection(o);
        else if (!n.props.inline) {
          n.props.selectsRange || n.setOpen(!1);
          var s = n.props, l = s.startDate, u = s.endDate;
          l && !u && (n.props.swapRange || !op(o, l)) && n.setOpen(!1);
        }
      }, n.setSelected = function(o, a, i, s) {
        var l, u, c = o;
        if (n.props.showYearPicker) {
          if (c !== null && Gi(Ce(c), n.props))
            return;
        } else if (n.props.showMonthYearPicker) {
          if (c !== null && Wm(c, n.props))
            return;
        } else if (c !== null && kr(c, n.props))
          return;
        var d = n.props, f = d.onChange, p = d.selectsRange, h = d.startDate, g = d.endDate, m = d.selectsMultiple, v = d.selectedDates, y = d.minTime, C = d.swapRange;
        if (!Yn(n.props.selected, c) || n.props.allowSameDay || p || m)
          if (c !== null && (n.props.selected && (!i || !n.props.showTimeSelect && !n.props.showTimeSelectOnly && !n.props.showTimeInput) && (c = Gl(c, {
            hour: Tr(n.props.selected),
            minute: Fr(n.props.selected),
            second: sn(n.props.selected)
          })), !i && (n.props.showTimeSelect || n.props.showTimeSelectOnly) && y && (c = Gl(c, {
            hour: y.getHours(),
            minute: y.getMinutes(),
            second: y.getSeconds()
          })), n.props.inline || n.setState({
            preSelection: c
          }), n.props.focusSelectedMonth || n.setState({ monthSelectedIn: s })), p) {
            var I = !h && !g, b = h && !g, D = h && g;
            I ? f == null || f([c, null], a) : b && (c === null ? f == null || f([null, null], a) : op(c, h) ? C ? f == null || f([c, h], a) : f == null || f([c, null], a) : f == null || f([h, c], a)), D && (f == null || f([c, null], a));
          } else if (m) {
            if (c !== null)
              if (!(v != null && v.length))
                f == null || f([c], a);
              else {
                var x = v.some(function(E) {
                  return _e(E, c);
                });
                if (x) {
                  var _ = v.filter(function(E) {
                    return !_e(E, c);
                  });
                  f == null || f(_, a);
                } else
                  f == null || f(Pr(Pr([], v, !0), [c], !1), a);
              }
          } else
            f == null || f(c, a);
        i || ((u = (l = n.props).onSelect) === null || u === void 0 || u.call(l, c, a), n.setState({ inputValue: null }));
      }, n.setPreSelection = function(o) {
        var a = an(n.props.minDate), i = an(n.props.maxDate), s = !0;
        if (o) {
          var l = Vi(o);
          if (a && i)
            s = ya(o, n.props.minDate, n.props.maxDate);
          else if (a) {
            var u = Vi(n.props.minDate);
            s = Mn(o, u) || Yn(l, u);
          } else if (i) {
            var c = Xf(n.props.maxDate);
            s = eo(o, c) || Yn(l, c);
          }
        }
        s && n.setState({
          preSelection: o
        });
      }, n.toggleCalendar = function() {
        n.setOpen(!n.state.open);
      }, n.handleTimeChange = function(o) {
        var a, i;
        if (!(n.props.selectsRange || n.props.selectsMultiple)) {
          var s = n.props.selected ? n.props.selected : n.getPreSelection(), l = n.props.selected ? o : Gl(s, {
            hour: Tr(o),
            minute: Fr(o)
          });
          n.setState({
            preSelection: l
          }), (i = (a = n.props).onChange) === null || i === void 0 || i.call(a, l), n.props.shouldCloseOnSelect && !n.props.showTimeInput && (n.sendFocusBackToInput(), n.setOpen(!1)), n.props.showTimeInput && n.setOpen(!0), (n.props.showTimeSelectOnly || n.props.showTimeSelect) && n.setState({ isRenderAriaLiveMessage: !0 }), n.setState({ inputValue: null });
        }
      }, n.onInputClick = function() {
        var o, a;
        !n.props.disabled && !n.props.readOnly && n.setOpen(!0), (a = (o = n.props).onInputClick) === null || a === void 0 || a.call(o);
      }, n.onInputKeyDown = function(o) {
        var a, i, s, l, u, c;
        (i = (a = n.props).onKeyDown) === null || i === void 0 || i.call(a, o);
        var d = o.key;
        if (!n.state.open && !n.props.inline && !n.props.preventOpenOnFocus) {
          (d === ee.ArrowDown || d === ee.ArrowUp || d === ee.Enter) && ((s = n.onInputClick) === null || s === void 0 || s.call(n));
          return;
        }
        if (n.state.open) {
          if (d === ee.ArrowDown || d === ee.ArrowUp) {
            o.preventDefault();
            var f = n.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : n.props.showWeekPicker && n.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : n.props.showFullMonthYearPicker || n.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', p = ((l = n.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && n.calendar.containerRef.current.querySelector(f);
            p instanceof HTMLElement && p.focus({ preventScroll: !0 });
            return;
          }
          var h = Ge(n.state.preSelection);
          d === ee.Enter ? (o.preventDefault(), n.inputOk() && n.state.lastPreSelectChange === zl ? (n.handleSelect(h, o), !n.props.shouldCloseOnSelect && n.setPreSelection(h)) : n.setOpen(!1)) : d === ee.Escape ? (o.preventDefault(), n.sendFocusBackToInput(), n.setOpen(!1)) : d === ee.Tab && n.setOpen(!1), n.inputOk() || (c = (u = n.props).onInputError) === null || c === void 0 || c.call(u, { code: 1, msg: Hl });
        }
      }, n.onPortalKeyDown = function(o) {
        var a = o.key;
        a === ee.Escape && (o.preventDefault(), n.setState({
          preventFocus: !0
        }, function() {
          n.setOpen(!1), setTimeout(function() {
            n.setFocus(), n.setState({ preventFocus: !1 });
          });
        }));
      }, n.onDayKeyDown = function(o) {
        var a, i, s, l, u, c, d = n.props, f = d.minDate, p = d.maxDate, h = d.disabledKeyboardNavigation, g = d.showWeekPicker, m = d.shouldCloseOnSelect, v = d.locale, y = d.calendarStartDay, C = d.adjustDateOnChange, I = d.inline;
        if ((i = (a = n.props).onKeyDown) === null || i === void 0 || i.call(a, o), !h) {
          var b = o.key, D = o.shiftKey, x = Ge(n.state.preSelection), _ = function(N, P) {
            var B = P;
            switch (N) {
              case ee.ArrowRight:
                B = g ? ps(P, 1) : On(P, 1);
                break;
              case ee.ArrowLeft:
                B = g ? Vf(P) : JR(P);
                break;
              case ee.ArrowUp:
                B = Vf(P);
                break;
              case ee.ArrowDown:
                B = ps(P, 1);
                break;
              case ee.PageUp:
                B = D ? zo(P, 1) : Ho(P, 1);
                break;
              case ee.PageDown:
                B = D ? on(P, 1) : vr(P, 1);
                break;
              case ee.Home:
                B = Dn(P, v, y);
                break;
              case ee.End:
                B = kO(P);
                break;
            }
            return B;
          }, E = function(N, P) {
            for (var B = 40, H = N, re = !1, W = 0, F = _(N, P); !re; ) {
              if (W >= B) {
                F = P;
                break;
              }
              f && F < f && (H = ee.ArrowRight, F = kr(f, n.props) ? _(H, F) : f), p && F > p && (H = ee.ArrowLeft, F = kr(p, n.props) ? _(H, F) : p), kr(F, n.props) ? ((H === ee.PageUp || H === ee.Home) && (H = ee.ArrowRight), (H === ee.PageDown || H === ee.End) && (H = ee.ArrowLeft), F = _(H, F)) : re = !0, W++;
            }
            return F;
          };
          if (b === ee.Enter) {
            o.preventDefault(), n.handleSelect(x, o), !m && n.setPreSelection(x);
            return;
          } else if (b === ee.Escape) {
            o.preventDefault(), n.setOpen(!1), n.inputOk() || (l = (s = n.props).onInputError) === null || l === void 0 || l.call(s, { code: 1, msg: Hl });
            return;
          }
          var R = null;
          switch (b) {
            case ee.ArrowLeft:
            case ee.ArrowRight:
            case ee.ArrowUp:
            case ee.ArrowDown:
            case ee.PageUp:
            case ee.PageDown:
            case ee.Home:
            case ee.End:
              R = E(b, x);
              break;
          }
          if (!R) {
            (c = (u = n.props).onInputError) === null || c === void 0 || c.call(u, { code: 1, msg: Hl });
            return;
          }
          if (o.preventDefault(), n.setState({ lastPreSelectChange: zl }), C && n.setSelected(R), n.setPreSelection(R), I) {
            var L = Ot(x), G = Ot(R), V = Ce(x), O = Ce(R);
            L !== G || V !== O ? n.setState({ shouldFocusDayInline: !0 }) : n.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, n.onPopperKeyDown = function(o) {
        var a = o.key;
        a === ee.Escape && (o.preventDefault(), n.sendFocusBackToInput());
      }, n.onClearClick = function(o) {
        o && o.preventDefault && o.preventDefault(), n.sendFocusBackToInput();
        var a = n.props, i = a.selectsRange, s = a.onChange;
        i ? s == null || s([null, null], o) : s == null || s(null, o), n.setState({ inputValue: null });
      }, n.clear = function() {
        n.onClearClick();
      }, n.onScroll = function(o) {
        typeof n.props.closeOnScroll == "boolean" && n.props.closeOnScroll ? (o.target === document || o.target === document.documentElement || o.target === document.body) && n.setOpen(!1) : typeof n.props.closeOnScroll == "function" && n.props.closeOnScroll(o) && n.setOpen(!1);
      }, n.renderCalendar = function() {
        var o, a;
        return !n.props.inline && !n.isCalendarOpen() ? null : A.createElement(i2, Ee({ showMonthYearDropdown: void 0, ref: function(i) {
          n.calendar = i;
        } }, n.props, n.state, { setOpen: n.setOpen, dateFormat: (o = n.props.dateFormatCalendar) !== null && o !== void 0 ? o : r.defaultProps.dateFormatCalendar, onSelect: n.handleSelect, onClickOutside: n.handleCalendarClickOutside, holidays: WO(n.modifyHolidays()), outsideClickIgnoreClass: sp, onDropdownFocus: n.handleDropdownFocus, onTimeChange: n.handleTimeChange, className: n.props.calendarClassName, container: n.props.calendarContainer, handleOnKeyDown: n.props.onKeyDown, handleOnDayKeyDown: n.onDayKeyDown, setPreSelection: n.setPreSelection, dropdownMode: (a = n.props.dropdownMode) !== null && a !== void 0 ? a : r.defaultProps.dropdownMode }), n.props.children);
      }, n.renderAriaLiveRegion = function() {
        var o = n.props, a = o.dateFormat, i = a === void 0 ? r.defaultProps.dateFormat : a, s = o.locale, l = n.props.showTimeInput || n.props.showTimeSelect, u = l ? "PPPPp" : "PPPP", c;
        return n.props.selectsRange ? c = "Selected start date: ".concat(Kt(n.props.startDate, {
          dateFormat: u,
          locale: s
        }), ". ").concat(n.props.endDate ? "End date: " + Kt(n.props.endDate, {
          dateFormat: u,
          locale: s
        }) : "") : n.props.showTimeSelectOnly ? c = "Selected time: ".concat(Kt(n.props.selected, { dateFormat: i, locale: s })) : n.props.showYearPicker ? c = "Selected year: ".concat(Kt(n.props.selected, { dateFormat: "yyyy", locale: s })) : n.props.showMonthYearPicker ? c = "Selected month: ".concat(Kt(n.props.selected, { dateFormat: "MMMM yyyy", locale: s })) : n.props.showQuarterYearPicker ? c = "Selected quarter: ".concat(Kt(n.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: s
        })) : c = "Selected date: ".concat(Kt(n.props.selected, {
          dateFormat: u,
          locale: s
        })), A.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, c);
      }, n.renderDateInput = function() {
        var o, a, i, s = wt(n.props.className, (o = {}, o[sp] = n.state.open, o)), l = n.props.customInput || A.createElement("input", { type: "text" }), u = n.props.customInputRef || "ref", c = n.props, d = c.dateFormat, f = d === void 0 ? r.defaultProps.dateFormat : d, p = c.locale, h = typeof n.props.value == "string" ? n.props.value : typeof n.state.inputValue == "string" ? n.state.inputValue : n.props.selectsRange ? xO(n.props.startDate, n.props.endDate, {
          dateFormat: f,
          locale: p
        }) : n.props.selectsMultiple ? IO((i = n.props.selectedDates) !== null && i !== void 0 ? i : [], {
          dateFormat: f,
          locale: p
        }) : Kt(n.props.selected, {
          dateFormat: f,
          locale: p
        });
        return Vu(l, (a = {}, a[u] = function(g) {
          n.input = g;
        }, a.value = h, a.onBlur = n.handleBlur, a.onChange = n.handleChange, a.onClick = n.onInputClick, a.onFocus = n.handleFocus, a.onKeyDown = n.onInputKeyDown, a.id = n.props.id, a.name = n.props.name, a.form = n.props.form, a.autoFocus = n.props.autoFocus, a.placeholder = n.props.placeholderText, a.disabled = n.props.disabled, a.autoComplete = n.props.autoComplete, a.className = wt(l.props.className, s), a.title = n.props.title, a.readOnly = n.props.readOnly, a.required = n.props.required, a.tabIndex = n.props.tabIndex, a["aria-describedby"] = n.props.ariaDescribedBy, a["aria-invalid"] = n.props.ariaInvalid, a["aria-labelledby"] = n.props.ariaLabelledBy, a["aria-required"] = n.props.ariaRequired, a));
      }, n.renderClearButton = function() {
        var o = n.props, a = o.isClearable, i = o.disabled, s = o.selected, l = o.startDate, u = o.endDate, c = o.clearButtonTitle, d = o.clearButtonClassName, f = d === void 0 ? "" : d, p = o.ariaLabelClose, h = p === void 0 ? "Close" : p, g = o.selectedDates;
        return a && (s != null || l != null || u != null || g != null && g.length) ? A.createElement("button", { type: "button", className: wt("react-datepicker__close-icon", f, { "react-datepicker__close-icon--disabled": i }), disabled: i, "aria-label": h, onClick: n.onClearClick, title: c, tabIndex: -1 }) : null;
      }, n.state = n.calcInitialState(), n.preventFocusTimeout = void 0, n;
    }
    return Object.defineProperty(r, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: ri,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.componentDidUpdate = function(t, n) {
      var o, a, i, s;
      t.inline && p2(t.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: ep(this.props.highlightDates)
      }), !n.focused && !Yn(t.selected, this.props.selected) && this.setState({ inputValue: null }), n.open !== this.state.open && (n.open === !1 && this.state.open === !0 && ((a = (o = this.props).onCalendarOpen) === null || a === void 0 || a.call(o)), n.open === !0 && this.state.open === !1 && ((s = (i = this.props).onCalendarClose) === null || s === void 0 || s.call(i)));
    }, r.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, r.prototype.renderInputContainer = function() {
      var t = this.props, n = t.showIcon, o = t.icon, a = t.calendarIconClassname, i = t.calendarIconClassName, s = t.toggleCalendarOnIconClick, l = this.state.open;
      return a && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), A.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(n ? " react-datepicker__view-calendar-icon" : "") },
        n && A.createElement(s2, Ee({ icon: o, className: wt(i, !i && a, l && "react-datepicker-ignore-onclickoutside") }, s ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, r.prototype.render = function() {
      var t = this.renderCalendar();
      if (this.props.inline)
        return t;
      if (this.props.withPortal) {
        var n = this.state.open ? A.createElement(
          Hm,
          { enableTabLoop: this.props.enableTabLoop },
          A.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)
        ) : null;
        return this.state.open && this.props.portalId && (n = A.createElement(Ym, Ee({ portalId: this.props.portalId }, this.props), n)), A.createElement(
          "div",
          null,
          this.renderInputContainer(),
          n
        );
      }
      return A.createElement(f2, Ee({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: t, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, r;
  }(bt)
), h2 = "input", zl = "navigate";
function Va(e) {
  return lr({ attr: { viewBox: "0 0 512 512" }, child: [{ tag: "path", attr: { fill: "none", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "48", d: "m112 268 144 144 144-144M256 392V100" }, child: [] }] })(e);
}
const lp = Symbol.for("constructDateFrom");
function g2(e, r) {
  return typeof e == "function" ? e(r) : e && typeof e == "object" && lp in e ? e[lp](r) : e instanceof Date ? new e.constructor(r) : new Date(r);
}
function $m(e, r) {
  return g2(e, e);
}
function Xm(e, r) {
  return $m(e).getMonth();
}
function jm(e, r) {
  return $m(e).getFullYear();
}
const ht = {
  /** Styles for navigation arrow buttons (prev/next month) */
  navigationButton: {
    size: "xs",
    variant: "ghost"
  },
  /** Styles for dropdown buttons (month/year selectors) */
  dropdownButton: {
    size: "xs",
    fontSize: "xs",
    variant: "ghost"
  },
  /** Styles for dropdown menu lists */
  menuList: {
    maxH: "200px",
    overflowY: "scroll",
    zIndex: 9999
  },
  /** Styles for menu items */
  menuItem: {
    fontSize: "sm"
  },
  /** Container styles for the custom header */
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "8px 12px",
    gap: "8px"
  },
  /** Inner container for dropdown buttons */
  dropdownContainer: {
    display: "flex",
    alignItems: "center",
    gap: "4px"
  }
};
Q.locale("es");
const m2 = (e) => {
  let r = (/* @__PURE__ */ new Date()).getFullYear(), t = [];
  for (e = e || 1935; e <= r; )
    t.push(e++);
  return t;
}, up = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], v2 = {
  Monday: "L",
  Tuesday: "M",
  Wednesday: "X",
  Thursday: "J",
  Friday: "V",
  Saturday: "S",
  Sunday: "D"
}, b2 = m2(1930).reverse(), Zm = "zumma-date-picker-portal", y2 = A.forwardRef((e, r) => {
  const { isClearable: t, size: n, ...o } = e;
  return /* @__PURE__ */ K(no, { children: [
    /* @__PURE__ */ S(
      Ha,
      {
        cursor: "pointer",
        width: "100%",
        height: "34px",
        fontSize: "0.85rem",
        focusBorderColor: "#7A86FF",
        ref: r,
        ...o
      }
    ),
    e.value && t ? null : /* @__PURE__ */ S(
      Sp,
      {
        cursor: "pointer",
        height: "34px",
        onClick: e.onFocus,
        children: /* @__PURE__ */ S(Np, { color: "#707070" })
      }
    )
  ] });
}), nF = A.memo(({ helperText: e, label: r, id: t, isDisabled: n, onChange: o, isInvalid: a = !1, value: i, onBlur: s, isRequired: l, minDate: u, maxDate: c = /* @__PURE__ */ new Date(), isClearable: d = !1, customWidth: f, onInvalidDate: p, normalizeToFullDay: h = !1 }) => {
  const g = A.useRef(null), m = A.useCallback(
    (v) => {
      if (!h || !v) return v;
      const [y, C] = v, I = [y, C];
      if (y) {
        const b = Q(y).startOf("day").toDate();
        I[0] = b;
      }
      if (C) {
        const b = Q(C).endOf("day").toDate();
        I[1] = b;
      }
      return I;
    },
    [h]
  );
  return /* @__PURE__ */ K(
    to,
    {
      width: f || "260px",
      minH: "70px",
      id: t,
      isDisabled: n,
      isInvalid: a,
      children: [
        /* @__PURE__ */ K(
          ro,
          {
            opacity: 0.5,
            fontSize: "0.8rem",
            fontWeight: 500,
            padding: "0 12px 4px 0",
            children: [
              r,
              " ",
              l ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ S(
          no,
          {
            width: "100%",
            flexGrow: 1,
            children: /* @__PURE__ */ S(
              zm,
              {
                strictParsing: !0,
                customInput: /* @__PURE__ */ S(
                  y2,
                  {
                    ref: g,
                    isClearable: d
                  }
                ),
                selectsRange: !0,
                dateFormat: "dd/MM/yyyy",
                startDate: (i == null ? void 0 : i[0]) || void 0,
                endDate: (i == null ? void 0 : i[1]) || void 0,
                minDate: u ?? void 0,
                maxDate: c ?? void 0,
                isClearable: d,
                showPopperArrow: !1,
                disabled: n,
                fixedHeight: !0,
                portalId: Zm,
                popperPlacement: "bottom-start",
                popperProps: {
                  strategy: "fixed"
                },
                popperClassName: "date-picker-popper",
                clearButtonClassName: "date-field__light-clear-button",
                showYearDropdown: !0,
                dateFormatCalendar: "MMMM",
                yearDropdownItemNumber: 90,
                scrollableYearDropdown: !0,
                onChangeRaw: () => {
                },
                onBlur: (v) => {
                  var y;
                  try {
                    const C = (y = v == null ? void 0 : v.target) == null ? void 0 : y.value;
                    if (!C || C.trim() === "") {
                      s && s(v);
                      return;
                    }
                    const I = (D) => {
                      const _ = D.trim().replace(/[\s\-\/]+/g, "/").split("/");
                      if (_.length !== 3) return null;
                      const [E, R, L] = _;
                      if (!E || !R || !L || isNaN(Number(E)) || isNaN(Number(R)) || isNaN(Number(L))) return null;
                      const G = `${R}/${E}/${L}`;
                      return Q(G).isValid() ? Q(G).toDate() : null;
                    }, b = C.split(" - ");
                    if (b.length > 1) {
                      const D = I(b[0]), x = I(b[1]);
                      if (!D || !x) {
                        p == null || p(), s && s(v);
                        return;
                      }
                      o(m([D, x]));
                    } else if (b[0] && b[0].trim() !== "") {
                      const D = I(b[0]);
                      if (!D) {
                        p == null || p(), s && s(v);
                        return;
                      }
                      o(m([D, null]));
                    }
                  } catch {
                    p == null || p();
                  }
                  s && s(v);
                },
                onChange: (v) => {
                  o && o(m(v));
                },
                formatWeekDay: (v) => v2[v],
                renderCustomHeader: ({ date: v, changeYear: y, changeMonth: C, decreaseMonth: I, increaseMonth: b, prevMonthButtonDisabled: D, nextMonthButtonDisabled: x }) => /* @__PURE__ */ K("div", { style: ht.container, children: [
                  /* @__PURE__ */ S(
                    Zn,
                    {
                      "aria-label": "previous month",
                      icon: /* @__PURE__ */ S(Fp, { size: 12 }),
                      ...ht.navigationButton,
                      onClick: (_) => {
                        _.preventDefault(), I();
                      },
                      isDisabled: D
                    }
                  ),
                  /* @__PURE__ */ K("div", { style: ht.dropdownContainer, children: [
                    /* @__PURE__ */ K(Po, { children: [
                      /* @__PURE__ */ S(
                        Ro,
                        {
                          as: Pt,
                          ...ht.dropdownButton,
                          rightIcon: /* @__PURE__ */ S(Va, { size: 10 }),
                          children: jm(v)
                        }
                      ),
                      /* @__PURE__ */ S(Oo, { ...ht.menuList, children: b2.map((_) => /* @__PURE__ */ S(
                        To,
                        {
                          ...ht.menuItem,
                          onClick: () => y(_),
                          children: _
                        },
                        _
                      )) })
                    ] }),
                    /* @__PURE__ */ K(Po, { children: [
                      /* @__PURE__ */ S(
                        Ro,
                        {
                          as: Pt,
                          ...ht.dropdownButton,
                          rightIcon: /* @__PURE__ */ S(Va, { size: 10 }),
                          children: up[Xm(v)]
                        }
                      ),
                      /* @__PURE__ */ S(Oo, { ...ht.menuList, children: up.map((_, E) => /* @__PURE__ */ S(
                        To,
                        {
                          ...ht.menuItem,
                          onClick: () => C(E),
                          children: _
                        },
                        _
                      )) })
                    ] })
                  ] }),
                  /* @__PURE__ */ S(
                    Zn,
                    {
                      "aria-label": "next month",
                      icon: /* @__PURE__ */ S(Tp, { size: 12 }),
                      ...ht.navigationButton,
                      onClick: (_) => {
                        _.preventDefault(), b();
                      },
                      isDisabled: x
                    }
                  )
                ] })
              }
            )
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: e })
      ]
    }
  );
});
Q.locale("es");
const w2 = (e) => {
  let r = (/* @__PURE__ */ new Date()).getFullYear(), t = [];
  for (e = e || 1935; e <= r; )
    t.push(e++);
  return t;
}, cp = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"], C2 = {
  Monday: "L",
  Tuesday: "M",
  Wednesday: "X",
  Thursday: "J",
  Friday: "V",
  Saturday: "S",
  Sunday: "D"
}, S2 = w2(1930).reverse(), x2 = A.forwardRef((e, r) => {
  const { isClearable: t, size: n, ...o } = e;
  return /* @__PURE__ */ K(no, { children: [
    /* @__PURE__ */ S(
      Ha,
      {
        cursor: "pointer",
        width: "100%",
        height: "34px",
        fontSize: "0.85rem",
        focusBorderColor: "#7A86FF",
        ref: r,
        ...o
      }
    ),
    e.value && t ? null : /* @__PURE__ */ S(
      Sp,
      {
        cursor: "pointer",
        height: "34px",
        onClick: e.onFocus,
        children: /* @__PURE__ */ S(Np, { color: "#707070" })
      }
    )
  ] });
}), dp = A.memo(({ helperText: e, label: r, id: t, isDisabled: n, onChange: o, isInvalid: a = !1, value: i, isRequired: s, minDate: l, maxDate: u = /* @__PURE__ */ new Date(), isClearable: c = !1, customWidth: d }) => {
  const f = A.useRef(null);
  return /* @__PURE__ */ K(
    to,
    {
      width: d || "260px",
      minH: "70px",
      id: t,
      isDisabled: n,
      isInvalid: a,
      children: [
        /* @__PURE__ */ K(
          ro,
          {
            opacity: 0.5,
            fontSize: "0.8rem",
            fontWeight: 500,
            padding: "0 12px 4px 0",
            children: [
              r,
              " ",
              s ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ S(
          no,
          {
            width: "100%",
            flexGrow: 1,
            children: /* @__PURE__ */ S(
              zm,
              {
                strictParsing: !0,
                customInput: /* @__PURE__ */ S(
                  x2,
                  {
                    ref: f,
                    isClearable: c
                  }
                ),
                dateFormat: "dd/MM/yyyy",
                selected: i,
                minDate: l ?? void 0,
                maxDate: u ?? void 0,
                isClearable: c,
                showPopperArrow: !1,
                disabled: n,
                fixedHeight: !0,
                portalId: Zm,
                clearButtonClassName: "date-field__light-clear-button",
                showYearDropdown: !0,
                dateFormatCalendar: "MMMM",
                yearDropdownItemNumber: 90,
                scrollableYearDropdown: !0,
                popperProps: {
                  strategy: "fixed"
                },
                popperClassName: "date-picker-popper",
                onChange: (p) => {
                  o && o(p);
                },
                formatWeekDay: (p) => C2[p],
                renderCustomHeader: ({ date: p, changeYear: h, changeMonth: g, decreaseMonth: m, increaseMonth: v, prevMonthButtonDisabled: y, nextMonthButtonDisabled: C }) => /* @__PURE__ */ K("div", { style: ht.container, children: [
                  /* @__PURE__ */ S(
                    Zn,
                    {
                      "aria-label": "previous month",
                      icon: /* @__PURE__ */ S(Fp, { size: 12 }),
                      ...ht.navigationButton,
                      onClick: (I) => {
                        I.preventDefault(), m();
                      },
                      isDisabled: y
                    }
                  ),
                  /* @__PURE__ */ K("div", { style: ht.dropdownContainer, children: [
                    /* @__PURE__ */ K(Po, { children: [
                      /* @__PURE__ */ S(
                        Ro,
                        {
                          as: Pt,
                          ...ht.dropdownButton,
                          rightIcon: /* @__PURE__ */ S(Va, { size: 10 }),
                          children: jm(p)
                        }
                      ),
                      /* @__PURE__ */ S(Oo, { ...ht.menuList, children: S2.map((I) => /* @__PURE__ */ S(
                        To,
                        {
                          ...ht.menuItem,
                          onClick: () => h(I),
                          children: I
                        },
                        I
                      )) })
                    ] }),
                    /* @__PURE__ */ K(Po, { children: [
                      /* @__PURE__ */ S(
                        Ro,
                        {
                          as: Pt,
                          ...ht.dropdownButton,
                          rightIcon: /* @__PURE__ */ S(Va, { size: 10 }),
                          children: cp[Xm(p)]
                        }
                      ),
                      /* @__PURE__ */ S(Oo, { ...ht.menuList, children: cp.map((I, b) => /* @__PURE__ */ S(
                        To,
                        {
                          ...ht.menuItem,
                          onClick: () => g(b),
                          children: I
                        },
                        I
                      )) })
                    ] })
                  ] }),
                  /* @__PURE__ */ S(
                    Zn,
                    {
                      "aria-label": "next month",
                      icon: /* @__PURE__ */ S(Tp, { size: 12 }),
                      ...ht.navigationButton,
                      onClick: (I) => {
                        I.preventDefault(), v();
                      },
                      isDisabled: C
                    }
                  )
                ] })
              }
            )
          }
        ),
        /* @__PURE__ */ S(oo, { height: 2, children: e })
      ]
    }
  );
}), oF = ({ value: e, onChange: r, fromLabel: t = "Desde", toLabel: n = "Hasta", isDisabled: o = !1, isRequired: a = !1, minWidth: i = "160px", gap: s = "12px", maxDate: l, allowFutureDates: u = !1, isClearable: c = !1 }) => {
  const d = Ve(() => e.from || void 0, [e.from]), f = Ve(() => e.to || void 0, [e.to]), p = Ve(() => l || (u ? null : /* @__PURE__ */ new Date()), [l, u]), h = se(
    (y) => {
      if (y && e.to && y > e.to) {
        r({
          from: y,
          to: y
        });
        return;
      }
      r({
        ...e,
        from: y || null
      });
    },
    [e, r]
  ), g = se(
    (y) => {
      if (y && e.from && y < e.from) {
        r({
          from: y,
          to: y
        });
        return;
      }
      r({
        ...e,
        to: y || null
      });
    },
    [e, r]
  ), m = Ve(() => e.to ? p && e.to > p ? p : e.to : p, [e.to, p]), v = Ve(() => e.from, [e.from]);
  return /* @__PURE__ */ K(
    Rt,
    {
      gap: s,
      align: "flex-end",
      w: { base: "full", md: "auto" },
      flexWrap: { base: "wrap", md: "nowrap" },
      children: [
        /* @__PURE__ */ S(
          je,
          {
            minW: typeof i == "object" ? i : { base: "0", md: i },
            flex: { base: "1 1 100%", md: "0 0 auto" },
            maxW: "100%",
            children: /* @__PURE__ */ S(
              dp,
              {
                label: t,
                value: d,
                onChange: h,
                maxDate: m,
                isDisabled: o,
                isRequired: a,
                isClearable: c,
                customWidth: typeof i == "string" ? "100%" : i
              }
            )
          }
        ),
        /* @__PURE__ */ S(
          je,
          {
            minW: typeof i == "object" ? i : { base: "0", md: i },
            flex: { base: "1 1 100%", md: "0 0 auto" },
            maxW: "100%",
            children: /* @__PURE__ */ S(
              dp,
              {
                label: n,
                value: f,
                onChange: g,
                minDate: v,
                maxDate: p,
                isDisabled: o,
                isRequired: a,
                isClearable: c,
                customWidth: typeof i == "string" ? "100%" : i
              }
            )
          }
        )
      ]
    }
  );
}, fp = (e) => {
  if (e === 0) return "0 Bytes";
  const r = 1024, t = ["Bytes", "KB", "MB", "GB"], n = Math.floor(Math.log(e) / Math.log(r));
  return Math.round(e / Math.pow(r, n) * 100) / 100 + " " + t[n];
}, I2 = (e) => e ? Object.values(e).flat().join(",") : "*", pp = (e) => e ? Object.values(e).flat().map((t) => t.replace(".", "").toUpperCase()).join(", ") : "Todos los archivos", aF = A.memo(({ id: e, name: r, label: t, isRequired: n, isDisabled: o, accept: a, value: i, onChange: s, helperText: l, maxSizeMB: u = 10 }) => {
  const c = pb(), d = Zo(), f = A.useRef(null), [p, h] = A.useState({
    file: null,
    fileName: "",
    fileSize: 0,
    status: "idle",
    error: null,
    progress: 0
  }), [g, m] = A.useState(!1);
  A.useEffect(() => {
    !i && p.fileName ? h({
      file: null,
      fileName: "",
      fileSize: 0,
      status: "idle",
      error: null,
      progress: 0
    }) : i && !p.file && typeof i == "string" && h({
      file: null,
      fileName: "Archivo existente",
      fileSize: 0,
      status: "success",
      error: null,
      progress: 100
    });
  }, [i]);
  const v = async (O) => new Promise((N, P) => {
    const B = new FileReader();
    B.onloadstart = () => {
      h((H) => ({ ...H, status: "loading", progress: 0 }));
    }, B.onprogress = (H) => {
      if (H.lengthComputable) {
        const re = Math.round(H.loaded / H.total * 100);
        h((W) => ({ ...W, progress: re }));
      }
    }, B.onload = () => {
      try {
        const re = B.result.split(",")[1];
        N(re);
      } catch {
        P(new Error("Error al procesar el archivo"));
      }
    }, B.onerror = () => {
      P(new Error("Error al leer el archivo"));
    }, B.readAsDataURL(O);
  }), y = (O) => {
    var P;
    const N = u * 1024 * 1024;
    if (O.size > N)
      return {
        valid: !1,
        error: d.fileTooLarge(u)
      };
    if (a) {
      const B = Object.values(a).flat(), H = "." + ((P = O.name.split(".").pop()) == null ? void 0 : P.toLowerCase());
      if (!B.includes(H))
        return {
          valid: !1,
          error: `Tipo de archivo no permitido. Se aceptan: ${pp(a)}`
        };
    }
    return { valid: !0 };
  }, C = async (O) => {
    try {
      const N = y(O);
      if (!N.valid) {
        h({
          file: null,
          fileName: O.name,
          fileSize: O.size,
          status: "error",
          error: N.error || d.validationError,
          progress: 0
        }), c({
          title: "Error al seleccionar archivo",
          description: N.error,
          status: "error",
          duration: 5e3,
          isClosable: !0
        });
        return;
      }
      h({
        file: O,
        fileName: O.name,
        fileSize: O.size,
        status: "loading",
        error: null,
        progress: 0
      });
      const P = await v(O);
      h((B) => ({
        ...B,
        status: "success",
        progress: 100
      })), s(r, P), c({
        title: "Archivo cargado exitosamente",
        description: `${O.name} (${fp(O.size)})`,
        status: "success",
        duration: 3e3,
        isClosable: !0
      });
    } catch (N) {
      const P = N instanceof Error ? N.message : "Error desconocido al cargar el archivo";
      h((B) => ({
        ...B,
        status: "error",
        error: P,
        progress: 0
      })), c({
        title: "Error al cargar archivo",
        description: P,
        status: "error",
        duration: 5e3,
        isClosable: !0
      }), s(r, null);
    }
  }, I = (O) => {
    const N = O.target.files;
    N && N.length > 0 && C(N[0]);
  }, b = () => {
    h({
      file: null,
      fileName: "",
      fileSize: 0,
      status: "idle",
      error: null,
      progress: 0
    }), s(r, null), f.current && (f.current.value = "");
  }, D = (O) => {
    O.preventDefault(), O.stopPropagation(), o || m(!0);
  }, x = (O) => {
    O.preventDefault(), O.stopPropagation(), m(!1);
  }, _ = (O) => {
    O.preventDefault(), O.stopPropagation();
  }, E = (O) => {
    if (O.preventDefault(), O.stopPropagation(), m(!1), o) return;
    const N = O.dataTransfer.files;
    N && N.length > 0 && C(N[0]);
  }, R = () => {
    !o && f.current && f.current.click();
  }, L = () => {
    switch (p.status) {
      case "loading":
        return null;
      case "success":
        return /* @__PURE__ */ S(
          Bn,
          {
            as: nD,
            color: "green.500",
            boxSize: "18px"
          }
        );
      case "error":
        return /* @__PURE__ */ S(
          Bn,
          {
            as: oD,
            color: "red.500",
            boxSize: "18px"
          }
        );
      default:
        return /* @__PURE__ */ S(
          Bn,
          {
            as: sg,
            color: j.neutralDark,
            boxSize: "18px",
            opacity: 0.6
          }
        );
    }
  }, G = () => o ? j.border : g ? j.primary[2] : p.status === "error" ? "red.400" : p.status === "success" ? "green.400" : j.border, V = () => o ? "gray.50" : g ? "blue.50" : "transparent";
  return /* @__PURE__ */ K(
    je,
    {
      width: ao,
      maxH: "fit-content",
      mb: 2,
      children: [
        t && /* @__PURE__ */ K(
          gt,
          {
            width: "100%",
            opacity: 0.5,
            fontSize: Xe.label,
            fontWeight: io.label,
            padding: nr.labelPadding,
            mb: 1,
            children: [
              t,
              " ",
              n ? /* @__PURE__ */ S("span", { style: { color: dn }, children: "*" }) : ""
            ]
          }
        ),
        /* @__PURE__ */ S(
          "input",
          {
            ref: f,
            type: "file",
            id: e,
            name: r,
            disabled: o,
            accept: I2(a),
            onChange: I,
            style: { display: "none" }
          }
        ),
        /* @__PURE__ */ S(
          je,
          {
            onDragEnter: D,
            onDragLeave: x,
            onDragOver: _,
            onDrop: E,
            onClick: R,
            cursor: o ? "not-allowed" : "pointer",
            border: "2px dashed",
            borderColor: G(),
            bg: V(),
            rounded: Is.input,
            px: 3,
            py: 2,
            transition: "all 0.2s",
            _hover: o ? void 0 : {
              borderColor: j.primary[2],
              bg: "blue.50"
            },
            children: p.fileName ? /* @__PURE__ */ K(
              Rt,
              {
                direction: "column",
                gap: 1,
                children: [
                  /* @__PURE__ */ K(
                    Rt,
                    {
                      justify: "space-between",
                      align: "center",
                      children: [
                        /* @__PURE__ */ K(
                          Rt,
                          {
                            align: "center",
                            gap: 2,
                            flex: 1,
                            minW: 0,
                            children: [
                              L(),
                              /* @__PURE__ */ K(
                                je,
                                {
                                  flex: 1,
                                  minW: 0,
                                  children: [
                                    /* @__PURE__ */ S(
                                      gt,
                                      {
                                        fontSize: Xe.input,
                                        fontWeight: 400,
                                        noOfLines: 1,
                                        title: p.fileName,
                                        children: p.fileName
                                      }
                                    ),
                                    p.fileSize > 0 && /* @__PURE__ */ S(
                                      gt,
                                      {
                                        fontSize: "xs",
                                        color: "gray.500",
                                        children: fp(p.fileSize)
                                      }
                                    )
                                  ]
                                }
                              )
                            ]
                          }
                        ),
                        !o && p.status !== "loading" && /* @__PURE__ */ S(
                          Zn,
                          {
                            "aria-label": d.removeFile,
                            icon: /* @__PURE__ */ S(tD, {}),
                            size: "xs",
                            variant: "ghost",
                            colorScheme: "red",
                            onClick: (O) => {
                              O.stopPropagation(), b();
                            }
                          }
                        )
                      ]
                    }
                  ),
                  p.status === "loading" && /* @__PURE__ */ K(je, { children: [
                    /* @__PURE__ */ S(
                      hb,
                      {
                        value: p.progress,
                        size: "sm",
                        colorScheme: "blue",
                        rounded: "full"
                      }
                    ),
                    /* @__PURE__ */ S(
                      gt,
                      {
                        fontSize: "xs",
                        color: "gray.500",
                        mt: 1,
                        children: d.loadingProgress(p.progress)
                      }
                    )
                  ] }),
                  p.status === "error" && p.error && /* @__PURE__ */ S(
                    gt,
                    {
                      fontSize: "xs",
                      color: "red.500",
                      children: p.error
                    }
                  )
                ]
              }
            ) : /* @__PURE__ */ K(
              Rt,
              {
                direction: "row",
                align: "center",
                justify: "start",
                gap: 3,
                py: 1,
                children: [
                  /* @__PURE__ */ S(
                    Bn,
                    {
                      as: ig,
                      boxSize: "20px",
                      color: o ? "gray.400" : j.primary[2]
                    }
                  ),
                  /* @__PURE__ */ K(
                    je,
                    {
                      textAlign: "left",
                      flex: 1,
                      children: [
                        /* @__PURE__ */ S(
                          gt,
                          {
                            fontSize: Xe.input,
                            fontWeight: 400,
                            color: o ? "gray.400" : "gray.700",
                            children: o ? d.fieldDisabled : d.dropFileOrClick
                          }
                        ),
                        /* @__PURE__ */ K(
                          gt,
                          {
                            fontSize: "xs",
                            color: "gray.500",
                            children: [
                              pp(a),
                              " • ",
                              d.maxFileSize(u)
                            ]
                          }
                        )
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        l && /* @__PURE__ */ S(
          gt,
          {
            fontSize: "xs",
            color: "gray.500",
            mt: 1,
            px: 1,
            children: l
          }
        )
      ]
    }
  );
});
function D2(e) {
  return lr({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm4 18H6V4h7v5h5v11zM8 15.01l1.41 1.41L11 14.84V19h2v-4.16l1.59 1.59L16 15.01 12.01 11z" }, child: [] }] })(e);
}
const wa = Vr(({ children: e, ...r }) => /* @__PURE__ */ S(gt, { ...r, children: e }));
wa.displayName = "Text";
const iF = A.memo(({ onSubmit: e, accept: r, error: t = null, label: n, hint: o, submitLabel: a, cancelLabel: i, submitVariant: s = "tertiary", cancelVariant: l = "default", isLoading: u = !1 }) => {
  const c = Zo(), [d, f] = Se(null), p = se((y) => {
    y.length > 0 && f(y[0]);
  }, []), { getRootProps: h, getInputProps: g, isDragActive: m } = lc({
    onDrop: p,
    accept: r,
    maxFiles: 1,
    multiple: !1,
    disabled: u
  }), v = se(() => {
    d && e(d);
  }, [d, e]);
  return /* @__PURE__ */ K(je, { children: [
    /* @__PURE__ */ K(
      je,
      {
        ...h(),
        border: "2px dashed",
        borderColor: m ? j.tertiary[1] : j.tertiary[3],
        borderRadius: Is.input,
        p: "2rem",
        textAlign: "center",
        cursor: u ? "not-allowed" : "pointer",
        opacity: u ? 0.6 : 1,
        bg: m ? j.tertiary[3] : "transparent",
        transition: "all 0.2s",
        _hover: { borderColor: j.tertiary[1], bg: j.tertiary[3] },
        children: [
          /* @__PURE__ */ S("input", { ...g() }),
          /* @__PURE__ */ S(
            Bn,
            {
              as: D2,
              boxSize: 10,
              color: j.tertiary[2],
              mb: "0.5rem"
            }
          ),
          d ? /* @__PURE__ */ S(wa, { fontWeight: 500, children: d.name }) : m ? /* @__PURE__ */ S(wa, { children: "Suelta el archivo aqui..." }) : /* @__PURE__ */ K(Wu, { children: [
            /* @__PURE__ */ S(wa, { fontWeight: 500, children: n ?? c.dropFile }),
            o && /* @__PURE__ */ S(
              wa,
              {
                fontSize: "sm",
                color: j.text[3],
                mt: "0.25rem",
                children: o
              }
            )
          ] })
        ]
      }
    ),
    t && /* @__PURE__ */ K(
      gb,
      {
        status: "error",
        mt: "1rem",
        borderRadius: "md",
        children: [
          /* @__PURE__ */ S(mb, {}),
          t
        ]
      }
    ),
    /* @__PURE__ */ K(
      Rt,
      {
        mt: "1rem",
        gap: "0.5rem",
        justifyContent: {
          base: "center",
          md: "space-around"
        },
        children: [
          /* @__PURE__ */ S(
            Hi,
            {
              variant: s,
              onClick: v,
              isDisabled: !d,
              isLoading: u,
              children: a ?? c.upload
            }
          ),
          d && /* @__PURE__ */ S(
            Hi,
            {
              variant: l,
              onClick: () => f(null),
              isDisabled: u,
              children: i ?? c.cancel
            }
          )
        ]
      }
    )
  ] });
}), sF = A.memo(({ id: e, isDisabled: r, items: t, onChangeType: n }) => {
  var i;
  const [o, a] = A.useState(0);
  return /* @__PURE__ */ K("div", { children: [
    /* @__PURE__ */ S(
      xp,
      {
        columns: {
          base: 1,
          lg: 2
        },
        columnGap: {
          base: "2rem"
        },
        rowGap: {
          base: "2rem"
        },
        children: (i = t[o]) == null ? void 0 : i.input
      }
    ),
    /* @__PURE__ */ S(
      vb,
      {
        id: e,
        isDisabled: r,
        onChange: (s) => {
          a(Number(s)), n && n(s);
        },
        value: o.toString(),
        children: /* @__PURE__ */ S(bb, { direction: "row", children: t.map((s, l) => /* @__PURE__ */ S(
          yb,
          {
            size: "md",
            value: l.toString(),
            children: s.title
          },
          l
        )) })
      }
    )
  ] });
}), _2 = {
  default: {
    bg: "white",
    boxShadow: "sm",
    border: "1px solid",
    borderColor: "gray.100"
  },
  elevated: {
    bg: "white",
    boxShadow: "md",
    border: "none"
  },
  outline: {
    bg: "white",
    boxShadow: "none",
    border: "1px solid",
    borderColor: "gray.200"
  },
  filled: {
    bg: "gray.50",
    boxShadow: "none",
    border: "none"
  }
}, k2 = ot(({ variant: e = "default", children: r, ...t }, n) => /* @__PURE__ */ S(
  je,
  {
    ref: n,
    borderRadius: "lg",
    overflow: "hidden",
    transition: "box-shadow 0.2s",
    _hover: { boxShadow: "md" },
    ..._2[e],
    ...t,
    children: r
  }
));
k2.displayName = "Card";
const E2 = ot(({ children: e, ...r }, t) => /* @__PURE__ */ S(
  je,
  {
    ref: t,
    display: "flex",
    flexDirection: "column",
    gap: 1.5,
    p: 6,
    ...r,
    children: e
  }
));
E2.displayName = "CardHeader";
const M2 = ot(({ children: e, ...r }, t) => /* @__PURE__ */ S(
  wb,
  {
    ref: t,
    as: "h3",
    size: "lg",
    fontWeight: "semibold",
    lineHeight: "none",
    letterSpacing: "tight",
    ...r,
    children: e
  }
));
M2.displayName = "CardTitle";
const A2 = ot(({ children: e, ...r }, t) => /* @__PURE__ */ S(
  gt,
  {
    ref: t,
    fontSize: "sm",
    color: "gray.500",
    ...r,
    children: e
  }
));
A2.displayName = "CardDescription";
const P2 = ot(({ children: e, ...r }, t) => /* @__PURE__ */ S(
  je,
  {
    ref: t,
    p: 6,
    ...r,
    children: e
  }
));
P2.displayName = "CardContent";
const R2 = ot(({ children: e, ...r }, t) => /* @__PURE__ */ S(
  je,
  {
    ref: t,
    display: "flex",
    alignItems: "center",
    p: 6,
    pt: 0,
    ...r,
    children: e
  }
));
R2.displayName = "CardFooter";
const O2 = Vr(({ isOpen: e, onClose: r, title: t, message: n, confirmMethod: o, confirmMessage: a, cancelMessage: i, confirmType: s = "red", cancelType: l = "blue", cancelMethod: u }) => {
  const c = Zo();
  return /* @__PURE__ */ K(
    Ip,
    {
      trapFocus: !1,
      closeOnOverlayClick: !1,
      isOpen: e,
      onClose: r,
      isCentered: !0,
      size: "md",
      children: [
        /* @__PURE__ */ S(Dp, {}),
        /* @__PURE__ */ K(_p, { children: [
          /* @__PURE__ */ S(Cb, { textAlign: "center", children: t }),
          u ? /* @__PURE__ */ S(kp, {}) : null,
          /* @__PURE__ */ S(Ep, { children: n }),
          /* @__PURE__ */ K(Sb, { justifyContent: "center", children: [
            /* @__PURE__ */ S(
              Pt,
              {
                id: "confirmDialogConfirmActionButton",
                colorScheme: s,
                mr: 3,
                onClick: () => {
                  o(), r();
                },
                children: a ?? c.confirm
              }
            ),
            /* @__PURE__ */ S(
              Pt,
              {
                id: "confirmDialogCancelActionButton",
                colorScheme: l,
                mr: 3,
                onClick: () => {
                  u == null || u(), r();
                },
                children: i ?? c.cancel
              }
            )
          ] })
        ] })
      ]
    }
  );
});
O2.displayName = "ConfirmDialog";
const T2 = A.memo(({ value: e, "aria-label": r, ...t }) => {
  const n = A.useCallback(() => {
    navigator.clipboard.writeText(e);
  }, [e]);
  return /* @__PURE__ */ S(
    Zn,
    {
      onClick: n,
      "aria-label": r || "Copy to clipboard",
      icon: /* @__PURE__ */ S(rD, {}),
      bg: j.tertiary[1],
      color: "white",
      borderRadius: "full",
      p: "10px",
      transition: "transform 0.2s",
      _active: {
        transform: "scale(1.1)"
      },
      _hover: {
        bg: j.tertiary[2]
      },
      ...t
    }
  );
});
T2.displayName = "CopyToClipboardButton";
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function xn(e, r) {
  return typeof e == "function" ? e(r) : e;
}
function jt(e, r) {
  return (t) => {
    r.setState((n) => ({
      ...n,
      [e]: xn(t, n[e])
    }));
  };
}
function el(e) {
  return e instanceof Function;
}
function F2(e) {
  return Array.isArray(e) && e.every((r) => typeof r == "number");
}
function N2(e, r) {
  const t = [], n = (o) => {
    o.forEach((a) => {
      t.push(a);
      const i = r(a);
      i != null && i.length && n(i);
    });
  };
  return n(e), t;
}
function me(e, r, t) {
  let n = [], o;
  return (a) => {
    let i;
    t.key && t.debug && (i = Date.now());
    const s = e(a);
    if (!(s.length !== n.length || s.some((c, d) => n[d] !== c)))
      return o;
    n = s;
    let u;
    if (t.key && t.debug && (u = Date.now()), o = r(...s), t == null || t.onChange == null || t.onChange(o), t.key && t.debug && t != null && t.debug()) {
      const c = Math.round((Date.now() - i) * 100) / 100, d = Math.round((Date.now() - u) * 100) / 100, f = d / 16, p = (h, g) => {
        for (h = String(h); h.length < g; )
          h = " " + h;
        return h;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(c, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, t == null ? void 0 : t.key);
    }
    return o;
  };
}
function ve(e, r, t, n) {
  return {
    debug: () => {
      var o;
      return (o = e == null ? void 0 : e.debugAll) != null ? o : e[r];
    },
    key: process.env.NODE_ENV === "development" && t,
    onChange: n
  };
}
function L2(e, r, t, n) {
  const o = () => {
    var i;
    return (i = a.getValue()) != null ? i : e.options.renderFallbackValue;
  }, a = {
    id: `${r.id}_${t.id}`,
    row: r,
    column: t,
    getValue: () => r.getValue(n),
    renderValue: o,
    getContext: me(() => [e, t, r, a], (i, s, l, u) => ({
      table: i,
      column: s,
      row: l,
      cell: u,
      getValue: u.getValue,
      renderValue: u.renderValue
    }), ve(e.options, "debugCells", "cell.getContext"))
  };
  return e._features.forEach((i) => {
    i.createCell == null || i.createCell(a, t, r, e);
  }, {}), a;
}
function W2(e, r, t, n) {
  var o, a;
  const s = {
    ...e._getDefaultColumnDef(),
    ...r
  }, l = s.accessorKey;
  let u = (o = (a = s.id) != null ? a : l ? l.replace(".", "_") : void 0) != null ? o : typeof s.header == "string" ? s.header : void 0, c;
  if (s.accessorFn ? c = s.accessorFn : l && (l.includes(".") ? c = (f) => {
    let p = f;
    for (const g of l.split(".")) {
      var h;
      p = (h = p) == null ? void 0 : h[g], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${g}" in deeply nested key "${l}" returned undefined.`);
    }
    return p;
  } : c = (f) => f[s.accessorKey]), !u)
    throw process.env.NODE_ENV !== "production" ? new Error(s.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(u)}`,
    accessorFn: c,
    parent: n,
    depth: t,
    columnDef: s,
    columns: [],
    getFlatColumns: me(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, ve(e.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: me(() => [e._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let h = d.columns.flatMap((g) => g.getLeafColumns());
        return f(h);
      }
      return [d];
    }, ve(e.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of e._features)
    f.createColumn == null || f.createColumn(d, e);
  return d;
}
const It = "debugHeaders";
function hp(e, r, t) {
  var n;
  let a = {
    id: (n = t.id) != null ? n : r.id,
    column: r,
    index: t.index,
    isPlaceholder: !!t.isPlaceholder,
    placeholderId: t.placeholderId,
    depth: t.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const i = [], s = (l) => {
        l.subHeaders && l.subHeaders.length && l.subHeaders.map(s), i.push(l);
      };
      return s(a), i;
    },
    getContext: () => ({
      table: e,
      header: a,
      column: r
    })
  };
  return e._features.forEach((i) => {
    i.createHeader == null || i.createHeader(a, e);
  }), a;
}
const B2 = {
  createTable: (e) => {
    e.getHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, n, o) => {
      var a, i;
      const s = (a = n == null ? void 0 : n.map((d) => t.find((f) => f.id === d)).filter(Boolean)) != null ? a : [], l = (i = o == null ? void 0 : o.map((d) => t.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], u = t.filter((d) => !(n != null && n.includes(d.id)) && !(o != null && o.includes(d.id)));
      return Di(r, [...s, ...u, ...l], e);
    }, ve(e.options, It, "getHeaderGroups")), e.getCenterHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, n, o) => (t = t.filter((a) => !(n != null && n.includes(a.id)) && !(o != null && o.includes(a.id))), Di(r, t, e, "center")), ve(e.options, It, "getCenterHeaderGroups")), e.getLeftHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.left], (r, t, n) => {
      var o;
      const a = (o = n == null ? void 0 : n.map((i) => t.find((s) => s.id === i)).filter(Boolean)) != null ? o : [];
      return Di(r, a, e, "left");
    }, ve(e.options, It, "getLeftHeaderGroups")), e.getRightHeaderGroups = me(() => [e.getAllColumns(), e.getVisibleLeafColumns(), e.getState().columnPinning.right], (r, t, n) => {
      var o;
      const a = (o = n == null ? void 0 : n.map((i) => t.find((s) => s.id === i)).filter(Boolean)) != null ? o : [];
      return Di(r, a, e, "right");
    }, ve(e.options, It, "getRightHeaderGroups")), e.getFooterGroups = me(() => [e.getHeaderGroups()], (r) => [...r].reverse(), ve(e.options, It, "getFooterGroups")), e.getLeftFooterGroups = me(() => [e.getLeftHeaderGroups()], (r) => [...r].reverse(), ve(e.options, It, "getLeftFooterGroups")), e.getCenterFooterGroups = me(() => [e.getCenterHeaderGroups()], (r) => [...r].reverse(), ve(e.options, It, "getCenterFooterGroups")), e.getRightFooterGroups = me(() => [e.getRightHeaderGroups()], (r) => [...r].reverse(), ve(e.options, It, "getRightFooterGroups")), e.getFlatHeaders = me(() => [e.getHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, It, "getFlatHeaders")), e.getLeftFlatHeaders = me(() => [e.getLeftHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, It, "getLeftFlatHeaders")), e.getCenterFlatHeaders = me(() => [e.getCenterHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, It, "getCenterFlatHeaders")), e.getRightFlatHeaders = me(() => [e.getRightHeaderGroups()], (r) => r.map((t) => t.headers).flat(), ve(e.options, It, "getRightFlatHeaders")), e.getCenterLeafHeaders = me(() => [e.getCenterFlatHeaders()], (r) => r.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ve(e.options, It, "getCenterLeafHeaders")), e.getLeftLeafHeaders = me(() => [e.getLeftFlatHeaders()], (r) => r.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ve(e.options, It, "getLeftLeafHeaders")), e.getRightLeafHeaders = me(() => [e.getRightFlatHeaders()], (r) => r.filter((t) => {
      var n;
      return !((n = t.subHeaders) != null && n.length);
    }), ve(e.options, It, "getRightLeafHeaders")), e.getLeafHeaders = me(() => [e.getLeftHeaderGroups(), e.getCenterHeaderGroups(), e.getRightHeaderGroups()], (r, t, n) => {
      var o, a, i, s, l, u;
      return [...(o = (a = r[0]) == null ? void 0 : a.headers) != null ? o : [], ...(i = (s = t[0]) == null ? void 0 : s.headers) != null ? i : [], ...(l = (u = n[0]) == null ? void 0 : u.headers) != null ? l : []].map((c) => c.getLeafHeaders()).flat();
    }, ve(e.options, It, "getLeafHeaders"));
  }
};
function Di(e, r, t, n) {
  var o, a;
  let i = 0;
  const s = function(f, p) {
    p === void 0 && (p = 1), i = Math.max(i, p), f.filter((h) => h.getIsVisible()).forEach((h) => {
      var g;
      (g = h.columns) != null && g.length && s(h.columns, p + 1);
    }, 0);
  };
  s(e);
  let l = [];
  const u = (f, p) => {
    const h = {
      depth: p,
      id: [n, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, g = [];
    f.forEach((m) => {
      const v = [...g].reverse()[0], y = m.column.depth === h.depth;
      let C, I = !1;
      if (y && m.column.parent ? C = m.column.parent : (C = m.column, I = !0), v && (v == null ? void 0 : v.column) === C)
        v.subHeaders.push(m);
      else {
        const b = hp(t, C, {
          id: [n, p, C.id, m == null ? void 0 : m.id].filter(Boolean).join("_"),
          isPlaceholder: I,
          placeholderId: I ? `${g.filter((D) => D.column === C).length}` : void 0,
          depth: p,
          index: g.length
        });
        b.subHeaders.push(m), g.push(b);
      }
      h.headers.push(m), m.headerGroup = h;
    }), l.push(h), p > 0 && u(g, p - 1);
  }, c = r.map((f, p) => hp(t, f, {
    depth: i,
    index: p
  }));
  u(c, i - 1), l.reverse();
  const d = (f) => f.filter((h) => h.column.getIsVisible()).map((h) => {
    let g = 0, m = 0, v = [0];
    h.subHeaders && h.subHeaders.length ? (v = [], d(h.subHeaders).forEach((C) => {
      let {
        colSpan: I,
        rowSpan: b
      } = C;
      g += I, v.push(b);
    })) : g = 1;
    const y = Math.min(...v);
    return m = m + y, h.colSpan = g, h.rowSpan = m, {
      colSpan: g,
      rowSpan: m
    };
  });
  return d((o = (a = l[0]) == null ? void 0 : a.headers) != null ? o : []), l;
}
const V2 = (e, r, t, n, o, a, i) => {
  let s = {
    id: r,
    index: n,
    original: t,
    depth: o,
    parentId: i,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (l) => {
      if (s._valuesCache.hasOwnProperty(l))
        return s._valuesCache[l];
      const u = e.getColumn(l);
      if (u != null && u.accessorFn)
        return s._valuesCache[l] = u.accessorFn(s.original, n), s._valuesCache[l];
    },
    getUniqueValues: (l) => {
      if (s._uniqueValuesCache.hasOwnProperty(l))
        return s._uniqueValuesCache[l];
      const u = e.getColumn(l);
      if (u != null && u.accessorFn)
        return u.columnDef.getUniqueValues ? (s._uniqueValuesCache[l] = u.columnDef.getUniqueValues(s.original, n), s._uniqueValuesCache[l]) : (s._uniqueValuesCache[l] = [s.getValue(l)], s._uniqueValuesCache[l]);
    },
    renderValue: (l) => {
      var u;
      return (u = s.getValue(l)) != null ? u : e.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => N2(s.subRows, (l) => l.subRows),
    getParentRow: () => s.parentId ? e.getRow(s.parentId, !0) : void 0,
    getParentRows: () => {
      let l = [], u = s;
      for (; ; ) {
        const c = u.getParentRow();
        if (!c) break;
        l.push(c), u = c;
      }
      return l.reverse();
    },
    getAllCells: me(() => [e.getAllLeafColumns()], (l) => l.map((u) => L2(e, s, u, u.id)), ve(e.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: me(() => [s.getAllCells()], (l) => l.reduce((u, c) => (u[c.column.id] = c, u), {}), ve(e.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let l = 0; l < e._features.length; l++) {
    const u = e._features[l];
    u == null || u.createRow == null || u.createRow(s, e);
  }
  return s;
}, G2 = {
  createColumn: (e, r) => {
    e._getFacetedRowModel = r.options.getFacetedRowModel && r.options.getFacetedRowModel(r, e.id), e.getFacetedRowModel = () => e._getFacetedRowModel ? e._getFacetedRowModel() : r.getPreFilteredRowModel(), e._getFacetedUniqueValues = r.options.getFacetedUniqueValues && r.options.getFacetedUniqueValues(r, e.id), e.getFacetedUniqueValues = () => e._getFacetedUniqueValues ? e._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getFacetedMinMaxValues = r.options.getFacetedMinMaxValues && r.options.getFacetedMinMaxValues(r, e.id), e.getFacetedMinMaxValues = () => {
      if (e._getFacetedMinMaxValues)
        return e._getFacetedMinMaxValues();
    };
  }
}, Um = (e, r, t) => {
  var n;
  const o = t.toLowerCase();
  return !!(!((n = e.getValue(r)) == null || (n = n.toString()) == null || (n = n.toLowerCase()) == null) && n.includes(o));
};
Um.autoRemove = (e) => hr(e);
const Jm = (e, r, t) => {
  var n;
  return !!(!((n = e.getValue(r)) == null || (n = n.toString()) == null) && n.includes(t));
};
Jm.autoRemove = (e) => hr(e);
const Qm = (e, r, t) => {
  var n;
  return ((n = e.getValue(r)) == null || (n = n.toString()) == null ? void 0 : n.toLowerCase()) === (t == null ? void 0 : t.toLowerCase());
};
Qm.autoRemove = (e) => hr(e);
const qm = (e, r, t) => {
  var n;
  return (n = e.getValue(r)) == null ? void 0 : n.includes(t);
};
qm.autoRemove = (e) => hr(e) || !(e != null && e.length);
const Km = (e, r, t) => !t.some((n) => {
  var o;
  return !((o = e.getValue(r)) != null && o.includes(n));
});
Km.autoRemove = (e) => hr(e) || !(e != null && e.length);
const ev = (e, r, t) => t.some((n) => {
  var o;
  return (o = e.getValue(r)) == null ? void 0 : o.includes(n);
});
ev.autoRemove = (e) => hr(e) || !(e != null && e.length);
const tv = (e, r, t) => e.getValue(r) === t;
tv.autoRemove = (e) => hr(e);
const rv = (e, r, t) => e.getValue(r) == t;
rv.autoRemove = (e) => hr(e);
const Bc = (e, r, t) => {
  let [n, o] = t;
  const a = e.getValue(r);
  return a >= n && a <= o;
};
Bc.resolveFilterValue = (e) => {
  let [r, t] = e, n = typeof r != "number" ? parseFloat(r) : r, o = typeof t != "number" ? parseFloat(t) : t, a = r === null || Number.isNaN(n) ? -1 / 0 : n, i = t === null || Number.isNaN(o) ? 1 / 0 : o;
  if (a > i) {
    const s = a;
    a = i, i = s;
  }
  return [a, i];
};
Bc.autoRemove = (e) => hr(e) || hr(e[0]) && hr(e[1]);
const Jr = {
  includesString: Um,
  includesStringSensitive: Jm,
  equalsString: Qm,
  arrIncludes: qm,
  arrIncludesAll: Km,
  arrIncludesSome: ev,
  equals: tv,
  weakEquals: rv,
  inNumberRange: Bc
};
function hr(e) {
  return e == null || e === "";
}
const Y2 = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (e) => ({
    columnFilters: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnFiltersChange: jt("columnFilters", e),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (e, r) => {
    e.getAutoFilterFn = () => {
      const t = r.getCoreRowModel().flatRows[0], n = t == null ? void 0 : t.getValue(e.id);
      return typeof n == "string" ? Jr.includesString : typeof n == "number" ? Jr.inNumberRange : typeof n == "boolean" || n !== null && typeof n == "object" ? Jr.equals : Array.isArray(n) ? Jr.arrIncludes : Jr.weakEquals;
    }, e.getFilterFn = () => {
      var t, n;
      return el(e.columnDef.filterFn) ? e.columnDef.filterFn : e.columnDef.filterFn === "auto" ? e.getAutoFilterFn() : (
        // @ts-ignore
        (t = (n = r.options.filterFns) == null ? void 0 : n[e.columnDef.filterFn]) != null ? t : Jr[e.columnDef.filterFn]
      );
    }, e.getCanFilter = () => {
      var t, n, o;
      return ((t = e.columnDef.enableColumnFilter) != null ? t : !0) && ((n = r.options.enableColumnFilters) != null ? n : !0) && ((o = r.options.enableFilters) != null ? o : !0) && !!e.accessorFn;
    }, e.getIsFiltered = () => e.getFilterIndex() > -1, e.getFilterValue = () => {
      var t;
      return (t = r.getState().columnFilters) == null || (t = t.find((n) => n.id === e.id)) == null ? void 0 : t.value;
    }, e.getFilterIndex = () => {
      var t, n;
      return (t = (n = r.getState().columnFilters) == null ? void 0 : n.findIndex((o) => o.id === e.id)) != null ? t : -1;
    }, e.setFilterValue = (t) => {
      r.setColumnFilters((n) => {
        const o = e.getFilterFn(), a = n == null ? void 0 : n.find((c) => c.id === e.id), i = xn(t, a ? a.value : void 0);
        if (gp(o, i, e)) {
          var s;
          return (s = n == null ? void 0 : n.filter((c) => c.id !== e.id)) != null ? s : [];
        }
        const l = {
          id: e.id,
          value: i
        };
        if (a) {
          var u;
          return (u = n == null ? void 0 : n.map((c) => c.id === e.id ? l : c)) != null ? u : [];
        }
        return n != null && n.length ? [...n, l] : [l];
      });
    };
  },
  createRow: (e, r) => {
    e.columnFilters = {}, e.columnFiltersMeta = {};
  },
  createTable: (e) => {
    e.setColumnFilters = (r) => {
      const t = e.getAllLeafColumns(), n = (o) => {
        var a;
        return (a = xn(r, o)) == null ? void 0 : a.filter((i) => {
          const s = t.find((l) => l.id === i.id);
          if (s) {
            const l = s.getFilterFn();
            if (gp(l, i.value, s))
              return !1;
          }
          return !0;
        });
      };
      e.options.onColumnFiltersChange == null || e.options.onColumnFiltersChange(n);
    }, e.resetColumnFilters = (r) => {
      var t, n;
      e.setColumnFilters(r ? [] : (t = (n = e.initialState) == null ? void 0 : n.columnFilters) != null ? t : []);
    }, e.getPreFilteredRowModel = () => e.getCoreRowModel(), e.getFilteredRowModel = () => (!e._getFilteredRowModel && e.options.getFilteredRowModel && (e._getFilteredRowModel = e.options.getFilteredRowModel(e)), e.options.manualFiltering || !e._getFilteredRowModel ? e.getPreFilteredRowModel() : e._getFilteredRowModel());
  }
};
function gp(e, r, t) {
  return (e && e.autoRemove ? e.autoRemove(r, t) : !1) || typeof r > "u" || typeof r == "string" && !r;
}
const H2 = (e, r, t) => t.reduce((n, o) => {
  const a = o.getValue(e);
  return n + (typeof a == "number" ? a : 0);
}, 0), z2 = (e, r, t) => {
  let n;
  return t.forEach((o) => {
    const a = o.getValue(e);
    a != null && (n > a || n === void 0 && a >= a) && (n = a);
  }), n;
}, $2 = (e, r, t) => {
  let n;
  return t.forEach((o) => {
    const a = o.getValue(e);
    a != null && (n < a || n === void 0 && a >= a) && (n = a);
  }), n;
}, X2 = (e, r, t) => {
  let n, o;
  return t.forEach((a) => {
    const i = a.getValue(e);
    i != null && (n === void 0 ? i >= i && (n = o = i) : (n > i && (n = i), o < i && (o = i)));
  }), [n, o];
}, j2 = (e, r) => {
  let t = 0, n = 0;
  if (r.forEach((o) => {
    let a = o.getValue(e);
    a != null && (a = +a) >= a && (++t, n += a);
  }), t) return n / t;
}, Z2 = (e, r) => {
  if (!r.length)
    return;
  const t = r.map((a) => a.getValue(e));
  if (!F2(t))
    return;
  if (t.length === 1)
    return t[0];
  const n = Math.floor(t.length / 2), o = t.sort((a, i) => a - i);
  return t.length % 2 !== 0 ? o[n] : (o[n - 1] + o[n]) / 2;
}, U2 = (e, r) => Array.from(new Set(r.map((t) => t.getValue(e))).values()), J2 = (e, r) => new Set(r.map((t) => t.getValue(e))).size, Q2 = (e, r) => r.length, $l = {
  sum: H2,
  min: z2,
  max: $2,
  extent: X2,
  mean: j2,
  median: Z2,
  unique: U2,
  uniqueCount: J2,
  count: Q2
}, q2 = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (e) => {
      var r, t;
      return (r = (t = e.getValue()) == null || t.toString == null ? void 0 : t.toString()) != null ? r : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (e) => ({
    grouping: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGroupingChange: jt("grouping", e),
    groupedColumnMode: "reorder"
  }),
  createColumn: (e, r) => {
    e.toggleGrouping = () => {
      r.setGrouping((t) => t != null && t.includes(e.id) ? t.filter((n) => n !== e.id) : [...t ?? [], e.id]);
    }, e.getCanGroup = () => {
      var t, n;
      return ((t = e.columnDef.enableGrouping) != null ? t : !0) && ((n = r.options.enableGrouping) != null ? n : !0) && (!!e.accessorFn || !!e.columnDef.getGroupingValue);
    }, e.getIsGrouped = () => {
      var t;
      return (t = r.getState().grouping) == null ? void 0 : t.includes(e.id);
    }, e.getGroupedIndex = () => {
      var t;
      return (t = r.getState().grouping) == null ? void 0 : t.indexOf(e.id);
    }, e.getToggleGroupingHandler = () => {
      const t = e.getCanGroup();
      return () => {
        t && e.toggleGrouping();
      };
    }, e.getAutoAggregationFn = () => {
      const t = r.getCoreRowModel().flatRows[0], n = t == null ? void 0 : t.getValue(e.id);
      if (typeof n == "number")
        return $l.sum;
      if (Object.prototype.toString.call(n) === "[object Date]")
        return $l.extent;
    }, e.getAggregationFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return el(e.columnDef.aggregationFn) ? e.columnDef.aggregationFn : e.columnDef.aggregationFn === "auto" ? e.getAutoAggregationFn() : (t = (n = r.options.aggregationFns) == null ? void 0 : n[e.columnDef.aggregationFn]) != null ? t : $l[e.columnDef.aggregationFn];
    };
  },
  createTable: (e) => {
    e.setGrouping = (r) => e.options.onGroupingChange == null ? void 0 : e.options.onGroupingChange(r), e.resetGrouping = (r) => {
      var t, n;
      e.setGrouping(r ? [] : (t = (n = e.initialState) == null ? void 0 : n.grouping) != null ? t : []);
    }, e.getPreGroupedRowModel = () => e.getFilteredRowModel(), e.getGroupedRowModel = () => (!e._getGroupedRowModel && e.options.getGroupedRowModel && (e._getGroupedRowModel = e.options.getGroupedRowModel(e)), e.options.manualGrouping || !e._getGroupedRowModel ? e.getPreGroupedRowModel() : e._getGroupedRowModel());
  },
  createRow: (e, r) => {
    e.getIsGrouped = () => !!e.groupingColumnId, e.getGroupingValue = (t) => {
      if (e._groupingValuesCache.hasOwnProperty(t))
        return e._groupingValuesCache[t];
      const n = r.getColumn(t);
      return n != null && n.columnDef.getGroupingValue ? (e._groupingValuesCache[t] = n.columnDef.getGroupingValue(e.original), e._groupingValuesCache[t]) : e.getValue(t);
    }, e._groupingValuesCache = {};
  },
  createCell: (e, r, t, n) => {
    e.getIsGrouped = () => r.getIsGrouped() && r.id === t.groupingColumnId, e.getIsPlaceholder = () => !e.getIsGrouped() && r.getIsGrouped(), e.getIsAggregated = () => {
      var o;
      return !e.getIsGrouped() && !e.getIsPlaceholder() && !!((o = t.subRows) != null && o.length);
    };
  }
};
function K2(e, r, t) {
  if (!(r != null && r.length) || !t)
    return e;
  const n = e.filter((a) => !r.includes(a.id));
  return t === "remove" ? n : [...r.map((a) => e.find((i) => i.id === a)).filter(Boolean), ...n];
}
const eT = {
  getInitialState: (e) => ({
    columnOrder: [],
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnOrderChange: jt("columnOrder", e)
  }),
  createColumn: (e, r) => {
    e.getIndex = me((t) => [ka(r, t)], (t) => t.findIndex((n) => n.id === e.id), ve(r.options, "debugColumns", "getIndex")), e.getIsFirstColumn = (t) => {
      var n;
      return ((n = ka(r, t)[0]) == null ? void 0 : n.id) === e.id;
    }, e.getIsLastColumn = (t) => {
      var n;
      const o = ka(r, t);
      return ((n = o[o.length - 1]) == null ? void 0 : n.id) === e.id;
    };
  },
  createTable: (e) => {
    e.setColumnOrder = (r) => e.options.onColumnOrderChange == null ? void 0 : e.options.onColumnOrderChange(r), e.resetColumnOrder = (r) => {
      var t;
      e.setColumnOrder(r ? [] : (t = e.initialState.columnOrder) != null ? t : []);
    }, e._getOrderColumnsFn = me(() => [e.getState().columnOrder, e.getState().grouping, e.options.groupedColumnMode], (r, t, n) => (o) => {
      let a = [];
      if (!(r != null && r.length))
        a = o;
      else {
        const i = [...r], s = [...o];
        for (; s.length && i.length; ) {
          const l = i.shift(), u = s.findIndex((c) => c.id === l);
          u > -1 && a.push(s.splice(u, 1)[0]);
        }
        a = [...a, ...s];
      }
      return K2(a, t, n);
    }, ve(e.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Xl = () => ({
  left: [],
  right: []
}), tT = {
  getInitialState: (e) => ({
    columnPinning: Xl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnPinningChange: jt("columnPinning", e)
  }),
  createColumn: (e, r) => {
    e.pin = (t) => {
      const n = e.getLeafColumns().map((o) => o.id).filter(Boolean);
      r.setColumnPinning((o) => {
        var a, i;
        if (t === "right") {
          var s, l;
          return {
            left: ((s = o == null ? void 0 : o.left) != null ? s : []).filter((d) => !(n != null && n.includes(d))),
            right: [...((l = o == null ? void 0 : o.right) != null ? l : []).filter((d) => !(n != null && n.includes(d))), ...n]
          };
        }
        if (t === "left") {
          var u, c;
          return {
            left: [...((u = o == null ? void 0 : o.left) != null ? u : []).filter((d) => !(n != null && n.includes(d))), ...n],
            right: ((c = o == null ? void 0 : o.right) != null ? c : []).filter((d) => !(n != null && n.includes(d)))
          };
        }
        return {
          left: ((a = o == null ? void 0 : o.left) != null ? a : []).filter((d) => !(n != null && n.includes(d))),
          right: ((i = o == null ? void 0 : o.right) != null ? i : []).filter((d) => !(n != null && n.includes(d)))
        };
      });
    }, e.getCanPin = () => e.getLeafColumns().some((n) => {
      var o, a, i;
      return ((o = n.columnDef.enablePinning) != null ? o : !0) && ((a = (i = r.options.enableColumnPinning) != null ? i : r.options.enablePinning) != null ? a : !0);
    }), e.getIsPinned = () => {
      const t = e.getLeafColumns().map((s) => s.id), {
        left: n,
        right: o
      } = r.getState().columnPinning, a = t.some((s) => n == null ? void 0 : n.includes(s)), i = t.some((s) => o == null ? void 0 : o.includes(s));
      return a ? "left" : i ? "right" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const o = e.getIsPinned();
      return o ? (t = (n = r.getState().columnPinning) == null || (n = n[o]) == null ? void 0 : n.indexOf(e.id)) != null ? t : -1 : 0;
    };
  },
  createRow: (e, r) => {
    e.getCenterVisibleCells = me(() => [e._getAllVisibleCells(), r.getState().columnPinning.left, r.getState().columnPinning.right], (t, n, o) => {
      const a = [...n ?? [], ...o ?? []];
      return t.filter((i) => !a.includes(i.column.id));
    }, ve(r.options, "debugRows", "getCenterVisibleCells")), e.getLeftVisibleCells = me(() => [e._getAllVisibleCells(), r.getState().columnPinning.left], (t, n) => (n ?? []).map((a) => t.find((i) => i.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "left"
    })), ve(r.options, "debugRows", "getLeftVisibleCells")), e.getRightVisibleCells = me(() => [e._getAllVisibleCells(), r.getState().columnPinning.right], (t, n) => (n ?? []).map((a) => t.find((i) => i.column.id === a)).filter(Boolean).map((a) => ({
      ...a,
      position: "right"
    })), ve(r.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (e) => {
    e.setColumnPinning = (r) => e.options.onColumnPinningChange == null ? void 0 : e.options.onColumnPinningChange(r), e.resetColumnPinning = (r) => {
      var t, n;
      return e.setColumnPinning(r ? Xl() : (t = (n = e.initialState) == null ? void 0 : n.columnPinning) != null ? t : Xl());
    }, e.getIsSomeColumnsPinned = (r) => {
      var t;
      const n = e.getState().columnPinning;
      if (!r) {
        var o, a;
        return !!((o = n.left) != null && o.length || (a = n.right) != null && a.length);
      }
      return !!((t = n[r]) != null && t.length);
    }, e.getLeftLeafColumns = me(() => [e.getAllLeafColumns(), e.getState().columnPinning.left], (r, t) => (t ?? []).map((n) => r.find((o) => o.id === n)).filter(Boolean), ve(e.options, "debugColumns", "getLeftLeafColumns")), e.getRightLeafColumns = me(() => [e.getAllLeafColumns(), e.getState().columnPinning.right], (r, t) => (t ?? []).map((n) => r.find((o) => o.id === n)).filter(Boolean), ve(e.options, "debugColumns", "getRightLeafColumns")), e.getCenterLeafColumns = me(() => [e.getAllLeafColumns(), e.getState().columnPinning.left, e.getState().columnPinning.right], (r, t, n) => {
      const o = [...t ?? [], ...n ?? []];
      return r.filter((a) => !o.includes(a.id));
    }, ve(e.options, "debugColumns", "getCenterLeafColumns"));
  }
}, _i = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, jl = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), rT = {
  getDefaultColumnDef: () => _i,
  getInitialState: (e) => ({
    columnSizing: {},
    columnSizingInfo: jl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: jt("columnSizing", e),
    onColumnSizingInfoChange: jt("columnSizingInfo", e)
  }),
  createColumn: (e, r) => {
    e.getSize = () => {
      var t, n, o;
      const a = r.getState().columnSizing[e.id];
      return Math.min(Math.max((t = e.columnDef.minSize) != null ? t : _i.minSize, (n = a ?? e.columnDef.size) != null ? n : _i.size), (o = e.columnDef.maxSize) != null ? o : _i.maxSize);
    }, e.getStart = me((t) => [t, ka(r, t), r.getState().columnSizing], (t, n) => n.slice(0, e.getIndex(t)).reduce((o, a) => o + a.getSize(), 0), ve(r.options, "debugColumns", "getStart")), e.getAfter = me((t) => [t, ka(r, t), r.getState().columnSizing], (t, n) => n.slice(e.getIndex(t) + 1).reduce((o, a) => o + a.getSize(), 0), ve(r.options, "debugColumns", "getAfter")), e.resetSize = () => {
      r.setColumnSizing((t) => {
        let {
          [e.id]: n,
          ...o
        } = t;
        return o;
      });
    }, e.getCanResize = () => {
      var t, n;
      return ((t = e.columnDef.enableResizing) != null ? t : !0) && ((n = r.options.enableColumnResizing) != null ? n : !0);
    }, e.getIsResizing = () => r.getState().columnSizingInfo.isResizingColumn === e.id;
  },
  createHeader: (e, r) => {
    e.getSize = () => {
      let t = 0;
      const n = (o) => {
        if (o.subHeaders.length)
          o.subHeaders.forEach(n);
        else {
          var a;
          t += (a = o.column.getSize()) != null ? a : 0;
        }
      };
      return n(e), t;
    }, e.getStart = () => {
      if (e.index > 0) {
        const t = e.headerGroup.headers[e.index - 1];
        return t.getStart() + t.getSize();
      }
      return 0;
    }, e.getResizeHandler = (t) => {
      const n = r.getColumn(e.column.id), o = n == null ? void 0 : n.getCanResize();
      return (a) => {
        if (!n || !o || (a.persist == null || a.persist(), Zl(a) && a.touches && a.touches.length > 1))
          return;
        const i = e.getSize(), s = e ? e.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[n.id, n.getSize()]], l = Zl(a) ? Math.round(a.touches[0].clientX) : a.clientX, u = {}, c = (v, y) => {
          typeof y == "number" && (r.setColumnSizingInfo((C) => {
            var I, b;
            const D = r.options.columnResizeDirection === "rtl" ? -1 : 1, x = (y - ((I = C == null ? void 0 : C.startOffset) != null ? I : 0)) * D, _ = Math.max(x / ((b = C == null ? void 0 : C.startSize) != null ? b : 0), -0.999999);
            return C.columnSizingStart.forEach((E) => {
              let [R, L] = E;
              u[R] = Math.round(Math.max(L + L * _, 0) * 100) / 100;
            }), {
              ...C,
              deltaOffset: x,
              deltaPercentage: _
            };
          }), (r.options.columnResizeMode === "onChange" || v === "end") && r.setColumnSizing((C) => ({
            ...C,
            ...u
          })));
        }, d = (v) => c("move", v), f = (v) => {
          c("end", v), r.setColumnSizingInfo((y) => ({
            ...y,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = t || typeof document < "u" ? document : null, h = {
          moveHandler: (v) => d(v.clientX),
          upHandler: (v) => {
            p == null || p.removeEventListener("mousemove", h.moveHandler), p == null || p.removeEventListener("mouseup", h.upHandler), f(v.clientX);
          }
        }, g = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), d(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var y;
            p == null || p.removeEventListener("touchmove", g.moveHandler), p == null || p.removeEventListener("touchend", g.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), f((y = v.touches[0]) == null ? void 0 : y.clientX);
          }
        }, m = nT() ? {
          passive: !1
        } : !1;
        Zl(a) ? (p == null || p.addEventListener("touchmove", g.moveHandler, m), p == null || p.addEventListener("touchend", g.upHandler, m)) : (p == null || p.addEventListener("mousemove", h.moveHandler, m), p == null || p.addEventListener("mouseup", h.upHandler, m)), r.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: l,
          startSize: i,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: s,
          isResizingColumn: n.id
        }));
      };
    };
  },
  createTable: (e) => {
    e.setColumnSizing = (r) => e.options.onColumnSizingChange == null ? void 0 : e.options.onColumnSizingChange(r), e.setColumnSizingInfo = (r) => e.options.onColumnSizingInfoChange == null ? void 0 : e.options.onColumnSizingInfoChange(r), e.resetColumnSizing = (r) => {
      var t;
      e.setColumnSizing(r ? {} : (t = e.initialState.columnSizing) != null ? t : {});
    }, e.resetHeaderSizeInfo = (r) => {
      var t;
      e.setColumnSizingInfo(r ? jl() : (t = e.initialState.columnSizingInfo) != null ? t : jl());
    }, e.getTotalSize = () => {
      var r, t;
      return (r = (t = e.getHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, o) => n + o.getSize(), 0)) != null ? r : 0;
    }, e.getLeftTotalSize = () => {
      var r, t;
      return (r = (t = e.getLeftHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, o) => n + o.getSize(), 0)) != null ? r : 0;
    }, e.getCenterTotalSize = () => {
      var r, t;
      return (r = (t = e.getCenterHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, o) => n + o.getSize(), 0)) != null ? r : 0;
    }, e.getRightTotalSize = () => {
      var r, t;
      return (r = (t = e.getRightHeaderGroups()[0]) == null ? void 0 : t.headers.reduce((n, o) => n + o.getSize(), 0)) != null ? r : 0;
    };
  }
};
let ki = null;
function nT() {
  if (typeof ki == "boolean") return ki;
  let e = !1;
  try {
    const r = {
      get passive() {
        return e = !0, !1;
      }
    }, t = () => {
    };
    window.addEventListener("test", t, r), window.removeEventListener("test", t);
  } catch {
    e = !1;
  }
  return ki = e, ki;
}
function Zl(e) {
  return e.type === "touchstart";
}
const oT = {
  getInitialState: (e) => ({
    columnVisibility: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onColumnVisibilityChange: jt("columnVisibility", e)
  }),
  createColumn: (e, r) => {
    e.toggleVisibility = (t) => {
      e.getCanHide() && r.setColumnVisibility((n) => ({
        ...n,
        [e.id]: t ?? !e.getIsVisible()
      }));
    }, e.getIsVisible = () => {
      var t, n;
      const o = e.columns;
      return (t = o.length ? o.some((a) => a.getIsVisible()) : (n = r.getState().columnVisibility) == null ? void 0 : n[e.id]) != null ? t : !0;
    }, e.getCanHide = () => {
      var t, n;
      return ((t = e.columnDef.enableHiding) != null ? t : !0) && ((n = r.options.enableHiding) != null ? n : !0);
    }, e.getToggleVisibilityHandler = () => (t) => {
      e.toggleVisibility == null || e.toggleVisibility(t.target.checked);
    };
  },
  createRow: (e, r) => {
    e._getAllVisibleCells = me(() => [e.getAllCells(), r.getState().columnVisibility], (t) => t.filter((n) => n.column.getIsVisible()), ve(r.options, "debugRows", "_getAllVisibleCells")), e.getVisibleCells = me(() => [e.getLeftVisibleCells(), e.getCenterVisibleCells(), e.getRightVisibleCells()], (t, n, o) => [...t, ...n, ...o], ve(r.options, "debugRows", "getVisibleCells"));
  },
  createTable: (e) => {
    const r = (t, n) => me(() => [n(), n().filter((o) => o.getIsVisible()).map((o) => o.id).join("_")], (o) => o.filter((a) => a.getIsVisible == null ? void 0 : a.getIsVisible()), ve(e.options, "debugColumns", t));
    e.getVisibleFlatColumns = r("getVisibleFlatColumns", () => e.getAllFlatColumns()), e.getVisibleLeafColumns = r("getVisibleLeafColumns", () => e.getAllLeafColumns()), e.getLeftVisibleLeafColumns = r("getLeftVisibleLeafColumns", () => e.getLeftLeafColumns()), e.getRightVisibleLeafColumns = r("getRightVisibleLeafColumns", () => e.getRightLeafColumns()), e.getCenterVisibleLeafColumns = r("getCenterVisibleLeafColumns", () => e.getCenterLeafColumns()), e.setColumnVisibility = (t) => e.options.onColumnVisibilityChange == null ? void 0 : e.options.onColumnVisibilityChange(t), e.resetColumnVisibility = (t) => {
      var n;
      e.setColumnVisibility(t ? {} : (n = e.initialState.columnVisibility) != null ? n : {});
    }, e.toggleAllColumnsVisible = (t) => {
      var n;
      t = (n = t) != null ? n : !e.getIsAllColumnsVisible(), e.setColumnVisibility(e.getAllLeafColumns().reduce((o, a) => ({
        ...o,
        [a.id]: t || !(a.getCanHide != null && a.getCanHide())
      }), {}));
    }, e.getIsAllColumnsVisible = () => !e.getAllLeafColumns().some((t) => !(t.getIsVisible != null && t.getIsVisible())), e.getIsSomeColumnsVisible = () => e.getAllLeafColumns().some((t) => t.getIsVisible == null ? void 0 : t.getIsVisible()), e.getToggleAllColumnsVisibilityHandler = () => (t) => {
      var n;
      e.toggleAllColumnsVisible((n = t.target) == null ? void 0 : n.checked);
    };
  }
};
function ka(e, r) {
  return r ? r === "center" ? e.getCenterVisibleLeafColumns() : r === "left" ? e.getLeftVisibleLeafColumns() : e.getRightVisibleLeafColumns() : e.getVisibleLeafColumns();
}
const aT = {
  createTable: (e) => {
    e._getGlobalFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, "__global__"), e.getGlobalFacetedRowModel = () => e.options.manualFiltering || !e._getGlobalFacetedRowModel ? e.getPreFilteredRowModel() : e._getGlobalFacetedRowModel(), e._getGlobalFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, "__global__"), e.getGlobalFacetedUniqueValues = () => e._getGlobalFacetedUniqueValues ? e._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), e._getGlobalFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, "__global__"), e.getGlobalFacetedMinMaxValues = () => {
      if (e._getGlobalFacetedMinMaxValues)
        return e._getGlobalFacetedMinMaxValues();
    };
  }
}, iT = {
  getInitialState: (e) => ({
    globalFilter: void 0,
    ...e
  }),
  getDefaultOptions: (e) => ({
    onGlobalFilterChange: jt("globalFilter", e),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (r) => {
      var t;
      const n = (t = e.getCoreRowModel().flatRows[0]) == null || (t = t._getAllCellsByColumnId()[r.id]) == null ? void 0 : t.getValue();
      return typeof n == "string" || typeof n == "number";
    }
  }),
  createColumn: (e, r) => {
    e.getCanGlobalFilter = () => {
      var t, n, o, a;
      return ((t = e.columnDef.enableGlobalFilter) != null ? t : !0) && ((n = r.options.enableGlobalFilter) != null ? n : !0) && ((o = r.options.enableFilters) != null ? o : !0) && ((a = r.options.getColumnCanGlobalFilter == null ? void 0 : r.options.getColumnCanGlobalFilter(e)) != null ? a : !0) && !!e.accessorFn;
    };
  },
  createTable: (e) => {
    e.getGlobalAutoFilterFn = () => Jr.includesString, e.getGlobalFilterFn = () => {
      var r, t;
      const {
        globalFilterFn: n
      } = e.options;
      return el(n) ? n : n === "auto" ? e.getGlobalAutoFilterFn() : (r = (t = e.options.filterFns) == null ? void 0 : t[n]) != null ? r : Jr[n];
    }, e.setGlobalFilter = (r) => {
      e.options.onGlobalFilterChange == null || e.options.onGlobalFilterChange(r);
    }, e.resetGlobalFilter = (r) => {
      e.setGlobalFilter(r ? void 0 : e.initialState.globalFilter);
    };
  }
}, sT = {
  getInitialState: (e) => ({
    expanded: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onExpandedChange: jt("expanded", e),
    paginateExpandedRows: !0
  }),
  createTable: (e) => {
    let r = !1, t = !1;
    e._autoResetExpanded = () => {
      var n, o;
      if (!r) {
        e._queue(() => {
          r = !0;
        });
        return;
      }
      if ((n = (o = e.options.autoResetAll) != null ? o : e.options.autoResetExpanded) != null ? n : !e.options.manualExpanding) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetExpanded(), t = !1;
        });
      }
    }, e.setExpanded = (n) => e.options.onExpandedChange == null ? void 0 : e.options.onExpandedChange(n), e.toggleAllRowsExpanded = (n) => {
      n ?? !e.getIsAllRowsExpanded() ? e.setExpanded(!0) : e.setExpanded({});
    }, e.resetExpanded = (n) => {
      var o, a;
      e.setExpanded(n ? {} : (o = (a = e.initialState) == null ? void 0 : a.expanded) != null ? o : {});
    }, e.getCanSomeRowsExpand = () => e.getPrePaginationRowModel().flatRows.some((n) => n.getCanExpand()), e.getToggleAllRowsExpandedHandler = () => (n) => {
      n.persist == null || n.persist(), e.toggleAllRowsExpanded();
    }, e.getIsSomeRowsExpanded = () => {
      const n = e.getState().expanded;
      return n === !0 || Object.values(n).some(Boolean);
    }, e.getIsAllRowsExpanded = () => {
      const n = e.getState().expanded;
      return typeof n == "boolean" ? n === !0 : !(!Object.keys(n).length || e.getRowModel().flatRows.some((o) => !o.getIsExpanded()));
    }, e.getExpandedDepth = () => {
      let n = 0;
      return (e.getState().expanded === !0 ? Object.keys(e.getRowModel().rowsById) : Object.keys(e.getState().expanded)).forEach((a) => {
        const i = a.split(".");
        n = Math.max(n, i.length);
      }), n;
    }, e.getPreExpandedRowModel = () => e.getSortedRowModel(), e.getExpandedRowModel = () => (!e._getExpandedRowModel && e.options.getExpandedRowModel && (e._getExpandedRowModel = e.options.getExpandedRowModel(e)), e.options.manualExpanding || !e._getExpandedRowModel ? e.getPreExpandedRowModel() : e._getExpandedRowModel());
  },
  createRow: (e, r) => {
    e.toggleExpanded = (t) => {
      r.setExpanded((n) => {
        var o;
        const a = n === !0 ? !0 : !!(n != null && n[e.id]);
        let i = {};
        if (n === !0 ? Object.keys(r.getRowModel().rowsById).forEach((s) => {
          i[s] = !0;
        }) : i = n, t = (o = t) != null ? o : !a, !a && t)
          return {
            ...i,
            [e.id]: !0
          };
        if (a && !t) {
          const {
            [e.id]: s,
            ...l
          } = i;
          return l;
        }
        return n;
      });
    }, e.getIsExpanded = () => {
      var t;
      const n = r.getState().expanded;
      return !!((t = r.options.getIsRowExpanded == null ? void 0 : r.options.getIsRowExpanded(e)) != null ? t : n === !0 || n != null && n[e.id]);
    }, e.getCanExpand = () => {
      var t, n, o;
      return (t = r.options.getRowCanExpand == null ? void 0 : r.options.getRowCanExpand(e)) != null ? t : ((n = r.options.enableExpanding) != null ? n : !0) && !!((o = e.subRows) != null && o.length);
    }, e.getIsAllParentsExpanded = () => {
      let t = !0, n = e;
      for (; t && n.parentId; )
        n = r.getRow(n.parentId, !0), t = n.getIsExpanded();
      return t;
    }, e.getToggleExpandedHandler = () => {
      const t = e.getCanExpand();
      return () => {
        t && e.toggleExpanded();
      };
    };
  }
}, Ru = 0, Ou = 10, Ul = () => ({
  pageIndex: Ru,
  pageSize: Ou
}), lT = {
  getInitialState: (e) => ({
    ...e,
    pagination: {
      ...Ul(),
      ...e == null ? void 0 : e.pagination
    }
  }),
  getDefaultOptions: (e) => ({
    onPaginationChange: jt("pagination", e)
  }),
  createTable: (e) => {
    let r = !1, t = !1;
    e._autoResetPageIndex = () => {
      var n, o;
      if (!r) {
        e._queue(() => {
          r = !0;
        });
        return;
      }
      if ((n = (o = e.options.autoResetAll) != null ? o : e.options.autoResetPageIndex) != null ? n : !e.options.manualPagination) {
        if (t) return;
        t = !0, e._queue(() => {
          e.resetPageIndex(), t = !1;
        });
      }
    }, e.setPagination = (n) => {
      const o = (a) => xn(n, a);
      return e.options.onPaginationChange == null ? void 0 : e.options.onPaginationChange(o);
    }, e.resetPagination = (n) => {
      var o;
      e.setPagination(n ? Ul() : (o = e.initialState.pagination) != null ? o : Ul());
    }, e.setPageIndex = (n) => {
      e.setPagination((o) => {
        let a = xn(n, o.pageIndex);
        const i = typeof e.options.pageCount > "u" || e.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : e.options.pageCount - 1;
        return a = Math.max(0, Math.min(a, i)), {
          ...o,
          pageIndex: a
        };
      });
    }, e.resetPageIndex = (n) => {
      var o, a;
      e.setPageIndex(n ? Ru : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageIndex) != null ? o : Ru);
    }, e.resetPageSize = (n) => {
      var o, a;
      e.setPageSize(n ? Ou : (o = (a = e.initialState) == null || (a = a.pagination) == null ? void 0 : a.pageSize) != null ? o : Ou);
    }, e.setPageSize = (n) => {
      e.setPagination((o) => {
        const a = Math.max(1, xn(n, o.pageSize)), i = o.pageSize * o.pageIndex, s = Math.floor(i / a);
        return {
          ...o,
          pageIndex: s,
          pageSize: a
        };
      });
    }, e.setPageCount = (n) => e.setPagination((o) => {
      var a;
      let i = xn(n, (a = e.options.pageCount) != null ? a : -1);
      return typeof i == "number" && (i = Math.max(-1, i)), {
        ...o,
        pageCount: i
      };
    }), e.getPageOptions = me(() => [e.getPageCount()], (n) => {
      let o = [];
      return n && n > 0 && (o = [...new Array(n)].fill(null).map((a, i) => i)), o;
    }, ve(e.options, "debugTable", "getPageOptions")), e.getCanPreviousPage = () => e.getState().pagination.pageIndex > 0, e.getCanNextPage = () => {
      const {
        pageIndex: n
      } = e.getState().pagination, o = e.getPageCount();
      return o === -1 ? !0 : o === 0 ? !1 : n < o - 1;
    }, e.previousPage = () => e.setPageIndex((n) => n - 1), e.nextPage = () => e.setPageIndex((n) => n + 1), e.firstPage = () => e.setPageIndex(0), e.lastPage = () => e.setPageIndex(e.getPageCount() - 1), e.getPrePaginationRowModel = () => e.getExpandedRowModel(), e.getPaginationRowModel = () => (!e._getPaginationRowModel && e.options.getPaginationRowModel && (e._getPaginationRowModel = e.options.getPaginationRowModel(e)), e.options.manualPagination || !e._getPaginationRowModel ? e.getPrePaginationRowModel() : e._getPaginationRowModel()), e.getPageCount = () => {
      var n;
      return (n = e.options.pageCount) != null ? n : Math.ceil(e.getRowCount() / e.getState().pagination.pageSize);
    }, e.getRowCount = () => {
      var n;
      return (n = e.options.rowCount) != null ? n : e.getPrePaginationRowModel().rows.length;
    };
  }
}, Jl = () => ({
  top: [],
  bottom: []
}), uT = {
  getInitialState: (e) => ({
    rowPinning: Jl(),
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowPinningChange: jt("rowPinning", e)
  }),
  createRow: (e, r) => {
    e.pin = (t, n, o) => {
      const a = n ? e.getLeafRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], i = o ? e.getParentRows().map((l) => {
        let {
          id: u
        } = l;
        return u;
      }) : [], s = /* @__PURE__ */ new Set([...i, e.id, ...a]);
      r.setRowPinning((l) => {
        var u, c;
        if (t === "bottom") {
          var d, f;
          return {
            top: ((d = l == null ? void 0 : l.top) != null ? d : []).filter((g) => !(s != null && s.has(g))),
            bottom: [...((f = l == null ? void 0 : l.bottom) != null ? f : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)]
          };
        }
        if (t === "top") {
          var p, h;
          return {
            top: [...((p = l == null ? void 0 : l.top) != null ? p : []).filter((g) => !(s != null && s.has(g))), ...Array.from(s)],
            bottom: ((h = l == null ? void 0 : l.bottom) != null ? h : []).filter((g) => !(s != null && s.has(g)))
          };
        }
        return {
          top: ((u = l == null ? void 0 : l.top) != null ? u : []).filter((g) => !(s != null && s.has(g))),
          bottom: ((c = l == null ? void 0 : l.bottom) != null ? c : []).filter((g) => !(s != null && s.has(g)))
        };
      });
    }, e.getCanPin = () => {
      var t;
      const {
        enableRowPinning: n,
        enablePinning: o
      } = r.options;
      return typeof n == "function" ? n(e) : (t = n ?? o) != null ? t : !0;
    }, e.getIsPinned = () => {
      const t = [e.id], {
        top: n,
        bottom: o
      } = r.getState().rowPinning, a = t.some((s) => n == null ? void 0 : n.includes(s)), i = t.some((s) => o == null ? void 0 : o.includes(s));
      return a ? "top" : i ? "bottom" : !1;
    }, e.getPinnedIndex = () => {
      var t, n;
      const o = e.getIsPinned();
      if (!o) return -1;
      const a = (t = r._getPinnedRows(o)) == null ? void 0 : t.map((i) => {
        let {
          id: s
        } = i;
        return s;
      });
      return (n = a == null ? void 0 : a.indexOf(e.id)) != null ? n : -1;
    };
  },
  createTable: (e) => {
    e.setRowPinning = (r) => e.options.onRowPinningChange == null ? void 0 : e.options.onRowPinningChange(r), e.resetRowPinning = (r) => {
      var t, n;
      return e.setRowPinning(r ? Jl() : (t = (n = e.initialState) == null ? void 0 : n.rowPinning) != null ? t : Jl());
    }, e.getIsSomeRowsPinned = (r) => {
      var t;
      const n = e.getState().rowPinning;
      if (!r) {
        var o, a;
        return !!((o = n.top) != null && o.length || (a = n.bottom) != null && a.length);
      }
      return !!((t = n[r]) != null && t.length);
    }, e._getPinnedRows = me((r) => [e.getRowModel().rows, e.getState().rowPinning[r], r], (r, t, n) => {
      var o;
      return ((o = e.options.keepPinnedRows) == null || o ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (t ?? []).map((i) => {
          const s = e.getRow(i, !0);
          return s.getIsAllParentsExpanded() ? s : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (t ?? []).map((i) => r.find((s) => s.id === i))
      )).filter(Boolean).map((i) => ({
        ...i,
        position: n
      }));
    }, ve(e.options, "debugRows", "_getPinnedRows")), e.getTopRows = () => e._getPinnedRows("top"), e.getBottomRows = () => e._getPinnedRows("bottom"), e.getCenterRows = me(() => [e.getRowModel().rows, e.getState().rowPinning.top, e.getState().rowPinning.bottom], (r, t, n) => {
      const o = /* @__PURE__ */ new Set([...t ?? [], ...n ?? []]);
      return r.filter((a) => !o.has(a.id));
    }, ve(e.options, "debugRows", "getCenterRows"));
  }
}, cT = {
  getInitialState: (e) => ({
    rowSelection: {},
    ...e
  }),
  getDefaultOptions: (e) => ({
    onRowSelectionChange: jt("rowSelection", e),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (e) => {
    e.setRowSelection = (r) => e.options.onRowSelectionChange == null ? void 0 : e.options.onRowSelectionChange(r), e.resetRowSelection = (r) => {
      var t;
      return e.setRowSelection(r ? {} : (t = e.initialState.rowSelection) != null ? t : {});
    }, e.toggleAllRowsSelected = (r) => {
      e.setRowSelection((t) => {
        r = typeof r < "u" ? r : !e.getIsAllRowsSelected();
        const n = {
          ...t
        }, o = e.getPreGroupedRowModel().flatRows;
        return r ? o.forEach((a) => {
          a.getCanSelect() && (n[a.id] = !0);
        }) : o.forEach((a) => {
          delete n[a.id];
        }), n;
      });
    }, e.toggleAllPageRowsSelected = (r) => e.setRowSelection((t) => {
      const n = typeof r < "u" ? r : !e.getIsAllPageRowsSelected(), o = {
        ...t
      };
      return e.getRowModel().rows.forEach((a) => {
        Tu(o, a.id, n, !0, e);
      }), o;
    }), e.getPreSelectedRowModel = () => e.getCoreRowModel(), e.getSelectedRowModel = me(() => [e.getState().rowSelection, e.getCoreRowModel()], (r, t) => Object.keys(r).length ? Ql(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ve(e.options, "debugTable", "getSelectedRowModel")), e.getFilteredSelectedRowModel = me(() => [e.getState().rowSelection, e.getFilteredRowModel()], (r, t) => Object.keys(r).length ? Ql(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ve(e.options, "debugTable", "getFilteredSelectedRowModel")), e.getGroupedSelectedRowModel = me(() => [e.getState().rowSelection, e.getSortedRowModel()], (r, t) => Object.keys(r).length ? Ql(e, t) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, ve(e.options, "debugTable", "getGroupedSelectedRowModel")), e.getIsAllRowsSelected = () => {
      const r = e.getFilteredRowModel().flatRows, {
        rowSelection: t
      } = e.getState();
      let n = !!(r.length && Object.keys(t).length);
      return n && r.some((o) => o.getCanSelect() && !t[o.id]) && (n = !1), n;
    }, e.getIsAllPageRowsSelected = () => {
      const r = e.getPaginationRowModel().flatRows.filter((o) => o.getCanSelect()), {
        rowSelection: t
      } = e.getState();
      let n = !!r.length;
      return n && r.some((o) => !t[o.id]) && (n = !1), n;
    }, e.getIsSomeRowsSelected = () => {
      var r;
      const t = Object.keys((r = e.getState().rowSelection) != null ? r : {}).length;
      return t > 0 && t < e.getFilteredRowModel().flatRows.length;
    }, e.getIsSomePageRowsSelected = () => {
      const r = e.getPaginationRowModel().flatRows;
      return e.getIsAllPageRowsSelected() ? !1 : r.filter((t) => t.getCanSelect()).some((t) => t.getIsSelected() || t.getIsSomeSelected());
    }, e.getToggleAllRowsSelectedHandler = () => (r) => {
      e.toggleAllRowsSelected(r.target.checked);
    }, e.getToggleAllPageRowsSelectedHandler = () => (r) => {
      e.toggleAllPageRowsSelected(r.target.checked);
    };
  },
  createRow: (e, r) => {
    e.toggleSelected = (t, n) => {
      const o = e.getIsSelected();
      r.setRowSelection((a) => {
        var i;
        if (t = typeof t < "u" ? t : !o, e.getCanSelect() && o === t)
          return a;
        const s = {
          ...a
        };
        return Tu(s, e.id, t, (i = n == null ? void 0 : n.selectChildren) != null ? i : !0, r), s;
      });
    }, e.getIsSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Vc(e, t);
    }, e.getIsSomeSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Fu(e, t) === "some";
    }, e.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: t
      } = r.getState();
      return Fu(e, t) === "all";
    }, e.getCanSelect = () => {
      var t;
      return typeof r.options.enableRowSelection == "function" ? r.options.enableRowSelection(e) : (t = r.options.enableRowSelection) != null ? t : !0;
    }, e.getCanSelectSubRows = () => {
      var t;
      return typeof r.options.enableSubRowSelection == "function" ? r.options.enableSubRowSelection(e) : (t = r.options.enableSubRowSelection) != null ? t : !0;
    }, e.getCanMultiSelect = () => {
      var t;
      return typeof r.options.enableMultiRowSelection == "function" ? r.options.enableMultiRowSelection(e) : (t = r.options.enableMultiRowSelection) != null ? t : !0;
    }, e.getToggleSelectedHandler = () => {
      const t = e.getCanSelect();
      return (n) => {
        var o;
        t && e.toggleSelected((o = n.target) == null ? void 0 : o.checked);
      };
    };
  }
}, Tu = (e, r, t, n, o) => {
  var a;
  const i = o.getRow(r, !0);
  t ? (i.getCanMultiSelect() || Object.keys(e).forEach((s) => delete e[s]), i.getCanSelect() && (e[r] = !0)) : delete e[r], n && (a = i.subRows) != null && a.length && i.getCanSelectSubRows() && i.subRows.forEach((s) => Tu(e, s.id, t, n, o));
};
function Ql(e, r) {
  const t = e.getState().rowSelection, n = [], o = {}, a = function(i, s) {
    return i.map((l) => {
      var u;
      const c = Vc(l, t);
      if (c && (n.push(l), o[l.id] = l), (u = l.subRows) != null && u.length && (l = {
        ...l,
        subRows: a(l.subRows)
      }), c)
        return l;
    }).filter(Boolean);
  };
  return {
    rows: a(r.rows),
    flatRows: n,
    rowsById: o
  };
}
function Vc(e, r) {
  var t;
  return (t = r[e.id]) != null ? t : !1;
}
function Fu(e, r, t) {
  var n;
  if (!((n = e.subRows) != null && n.length)) return !1;
  let o = !0, a = !1;
  return e.subRows.forEach((i) => {
    if (!(a && !o) && (i.getCanSelect() && (Vc(i, r) ? a = !0 : o = !1), i.subRows && i.subRows.length)) {
      const s = Fu(i, r);
      s === "all" ? a = !0 : (s === "some" && (a = !0), o = !1);
    }
  }), o ? "all" : a ? "some" : !1;
}
const Nu = /([0-9]+)/gm, dT = (e, r, t) => nv(An(e.getValue(t)).toLowerCase(), An(r.getValue(t)).toLowerCase()), fT = (e, r, t) => nv(An(e.getValue(t)), An(r.getValue(t))), pT = (e, r, t) => Gc(An(e.getValue(t)).toLowerCase(), An(r.getValue(t)).toLowerCase()), hT = (e, r, t) => Gc(An(e.getValue(t)), An(r.getValue(t))), gT = (e, r, t) => {
  const n = e.getValue(t), o = r.getValue(t);
  return n > o ? 1 : n < o ? -1 : 0;
}, mT = (e, r, t) => Gc(e.getValue(t), r.getValue(t));
function Gc(e, r) {
  return e === r ? 0 : e > r ? 1 : -1;
}
function An(e) {
  return typeof e == "number" ? isNaN(e) || e === 1 / 0 || e === -1 / 0 ? "" : String(e) : typeof e == "string" ? e : "";
}
function nv(e, r) {
  const t = e.split(Nu).filter(Boolean), n = r.split(Nu).filter(Boolean);
  for (; t.length && n.length; ) {
    const o = t.shift(), a = n.shift(), i = parseInt(o, 10), s = parseInt(a, 10), l = [i, s].sort();
    if (isNaN(l[0])) {
      if (o > a)
        return 1;
      if (a > o)
        return -1;
      continue;
    }
    if (isNaN(l[1]))
      return isNaN(i) ? -1 : 1;
    if (i > s)
      return 1;
    if (s > i)
      return -1;
  }
  return t.length - n.length;
}
const ma = {
  alphanumeric: dT,
  alphanumericCaseSensitive: fT,
  text: pT,
  textCaseSensitive: hT,
  datetime: gT,
  basic: mT
}, vT = {
  getInitialState: (e) => ({
    sorting: [],
    ...e
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (e) => ({
    onSortingChange: jt("sorting", e),
    isMultiSortEvent: (r) => r.shiftKey
  }),
  createColumn: (e, r) => {
    e.getAutoSortingFn = () => {
      const t = r.getFilteredRowModel().flatRows.slice(10);
      let n = !1;
      for (const o of t) {
        const a = o == null ? void 0 : o.getValue(e.id);
        if (Object.prototype.toString.call(a) === "[object Date]")
          return ma.datetime;
        if (typeof a == "string" && (n = !0, a.split(Nu).length > 1))
          return ma.alphanumeric;
      }
      return n ? ma.text : ma.basic;
    }, e.getAutoSortDir = () => {
      const t = r.getFilteredRowModel().flatRows[0];
      return typeof (t == null ? void 0 : t.getValue(e.id)) == "string" ? "asc" : "desc";
    }, e.getSortingFn = () => {
      var t, n;
      if (!e)
        throw new Error();
      return el(e.columnDef.sortingFn) ? e.columnDef.sortingFn : e.columnDef.sortingFn === "auto" ? e.getAutoSortingFn() : (t = (n = r.options.sortingFns) == null ? void 0 : n[e.columnDef.sortingFn]) != null ? t : ma[e.columnDef.sortingFn];
    }, e.toggleSorting = (t, n) => {
      const o = e.getNextSortingOrder(), a = typeof t < "u" && t !== null;
      r.setSorting((i) => {
        const s = i == null ? void 0 : i.find((p) => p.id === e.id), l = i == null ? void 0 : i.findIndex((p) => p.id === e.id);
        let u = [], c, d = a ? t : o === "desc";
        if (i != null && i.length && e.getCanMultiSort() && n ? s ? c = "toggle" : c = "add" : i != null && i.length && l !== i.length - 1 ? c = "replace" : s ? c = "toggle" : c = "replace", c === "toggle" && (a || o || (c = "remove")), c === "add") {
          var f;
          u = [...i, {
            id: e.id,
            desc: d
          }], u.splice(0, u.length - ((f = r.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else c === "toggle" ? u = i.map((p) => p.id === e.id ? {
          ...p,
          desc: d
        } : p) : c === "remove" ? u = i.filter((p) => p.id !== e.id) : u = [{
          id: e.id,
          desc: d
        }];
        return u;
      });
    }, e.getFirstSortDir = () => {
      var t, n;
      return ((t = (n = e.columnDef.sortDescFirst) != null ? n : r.options.sortDescFirst) != null ? t : e.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, e.getNextSortingOrder = (t) => {
      var n, o;
      const a = e.getFirstSortDir(), i = e.getIsSorted();
      return i ? i !== a && ((n = r.options.enableSortingRemoval) == null || n) && // If enableSortRemove, enable in general
      (!(t && (o = r.options.enableMultiRemove) != null) || o) ? !1 : i === "desc" ? "asc" : "desc" : a;
    }, e.getCanSort = () => {
      var t, n;
      return ((t = e.columnDef.enableSorting) != null ? t : !0) && ((n = r.options.enableSorting) != null ? n : !0) && !!e.accessorFn;
    }, e.getCanMultiSort = () => {
      var t, n;
      return (t = (n = e.columnDef.enableMultiSort) != null ? n : r.options.enableMultiSort) != null ? t : !!e.accessorFn;
    }, e.getIsSorted = () => {
      var t;
      const n = (t = r.getState().sorting) == null ? void 0 : t.find((o) => o.id === e.id);
      return n ? n.desc ? "desc" : "asc" : !1;
    }, e.getSortIndex = () => {
      var t, n;
      return (t = (n = r.getState().sorting) == null ? void 0 : n.findIndex((o) => o.id === e.id)) != null ? t : -1;
    }, e.clearSorting = () => {
      r.setSorting((t) => t != null && t.length ? t.filter((n) => n.id !== e.id) : []);
    }, e.getToggleSortingHandler = () => {
      const t = e.getCanSort();
      return (n) => {
        t && (n.persist == null || n.persist(), e.toggleSorting == null || e.toggleSorting(void 0, e.getCanMultiSort() ? r.options.isMultiSortEvent == null ? void 0 : r.options.isMultiSortEvent(n) : !1));
      };
    };
  },
  createTable: (e) => {
    e.setSorting = (r) => e.options.onSortingChange == null ? void 0 : e.options.onSortingChange(r), e.resetSorting = (r) => {
      var t, n;
      e.setSorting(r ? [] : (t = (n = e.initialState) == null ? void 0 : n.sorting) != null ? t : []);
    }, e.getPreSortedRowModel = () => e.getGroupedRowModel(), e.getSortedRowModel = () => (!e._getSortedRowModel && e.options.getSortedRowModel && (e._getSortedRowModel = e.options.getSortedRowModel(e)), e.options.manualSorting || !e._getSortedRowModel ? e.getPreSortedRowModel() : e._getSortedRowModel());
  }
}, bT = [
  B2,
  oT,
  eT,
  tT,
  G2,
  Y2,
  aT,
  //depends on ColumnFaceting
  iT,
  //depends on ColumnFiltering
  vT,
  q2,
  //depends on RowSorting
  sT,
  lT,
  uT,
  cT,
  rT
];
function yT(e) {
  var r, t;
  process.env.NODE_ENV !== "production" && (e.debugAll || e.debugTable) && console.info("Creating Table Instance...");
  const n = [...bT, ...(r = e._features) != null ? r : []];
  let o = {
    _features: n
  };
  const a = o._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(o)), {}), i = (f) => o.options.mergeOptions ? o.options.mergeOptions(a, f) : {
    ...a,
    ...f
  };
  let l = {
    ...{},
    ...(t = e.initialState) != null ? t : {}
  };
  o._features.forEach((f) => {
    var p;
    l = (p = f.getInitialState == null ? void 0 : f.getInitialState(l)) != null ? p : l;
  });
  const u = [];
  let c = !1;
  const d = {
    _features: n,
    options: {
      ...a,
      ...e
    },
    initialState: l,
    _queue: (f) => {
      u.push(f), c || (c = !0, Promise.resolve().then(() => {
        for (; u.length; )
          u.shift()();
        c = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      o.setState(o.initialState);
    },
    setOptions: (f) => {
      const p = xn(f, o.options);
      o.options = i(p);
    },
    getState: () => o.options.state,
    setState: (f) => {
      o.options.onStateChange == null || o.options.onStateChange(f);
    },
    _getRowId: (f, p, h) => {
      var g;
      return (g = o.options.getRowId == null ? void 0 : o.options.getRowId(f, p, h)) != null ? g : `${h ? [h.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (o._getCoreRowModel || (o._getCoreRowModel = o.options.getCoreRowModel(o)), o._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => o.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let h = (p ? o.getPrePaginationRowModel() : o.getRowModel()).rowsById[f];
      if (!h && (h = o.getCoreRowModel().rowsById[f], !h))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return h;
    },
    _getDefaultColumnDef: me(() => [o.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (h) => {
          const g = h.header.column.columnDef;
          return g.accessorKey ? g.accessorKey : g.accessorFn ? g.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (h) => {
          var g, m;
          return (g = (m = h.renderValue()) == null || m.toString == null ? void 0 : m.toString()) != null ? g : null;
        },
        ...o._features.reduce((h, g) => Object.assign(h, g.getDefaultColumnDef == null ? void 0 : g.getDefaultColumnDef()), {}),
        ...f
      };
    }, ve(e, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => o.options.columns,
    getAllColumns: me(() => [o._getColumnDefs()], (f) => {
      const p = function(h, g, m) {
        return m === void 0 && (m = 0), h.map((v) => {
          const y = W2(o, v, m, g), C = v;
          return y.columns = C.columns ? p(C.columns, y, m + 1) : [], y;
        });
      };
      return p(f);
    }, ve(e, "debugColumns", "getAllColumns")),
    getAllFlatColumns: me(() => [o.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), ve(e, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: me(() => [o.getAllFlatColumns()], (f) => f.reduce((p, h) => (p[h.id] = h, p), {}), ve(e, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: me(() => [o.getAllColumns(), o._getOrderColumnsFn()], (f, p) => {
      let h = f.flatMap((g) => g.getLeafColumns());
      return p(h);
    }, ve(e, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = o._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(o, d);
  for (let f = 0; f < o._features.length; f++) {
    const p = o._features[f];
    p == null || p.createTable == null || p.createTable(o);
  }
  return o;
}
function wT() {
  return (e) => me(() => [e.options.data], (r) => {
    const t = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, n = function(o, a, i) {
      a === void 0 && (a = 0);
      const s = [];
      for (let u = 0; u < o.length; u++) {
        const c = V2(e, e._getRowId(o[u], u, i), o[u], u, a, void 0, i == null ? void 0 : i.id);
        if (t.flatRows.push(c), t.rowsById[c.id] = c, s.push(c), e.options.getSubRows) {
          var l;
          c.originalSubRows = e.options.getSubRows(o[u], u), (l = c.originalSubRows) != null && l.length && (c.subRows = n(c.originalSubRows, a + 1, c));
        }
      }
      return s;
    };
    return t.rows = n(r), t;
  }, ve(e.options, "debugTable", "getRowModel", () => e._autoResetPageIndex()));
}
function CT(e) {
  const r = [], t = (n) => {
    var o;
    r.push(n), (o = n.subRows) != null && o.length && n.getIsExpanded() && n.subRows.forEach(t);
  };
  return e.rows.forEach(t), {
    rows: r,
    flatRows: e.flatRows,
    rowsById: e.rowsById
  };
}
function ST(e) {
  return (r) => me(() => [r.getState().pagination, r.getPrePaginationRowModel(), r.options.paginateExpandedRows ? void 0 : r.getState().expanded], (t, n) => {
    if (!n.rows.length)
      return n;
    const {
      pageSize: o,
      pageIndex: a
    } = t;
    let {
      rows: i,
      flatRows: s,
      rowsById: l
    } = n;
    const u = o * a, c = u + o;
    i = i.slice(u, c);
    let d;
    r.options.paginateExpandedRows ? d = {
      rows: i,
      flatRows: s,
      rowsById: l
    } : d = CT({
      rows: i,
      flatRows: s,
      rowsById: l
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, ve(r.options, "debugTable", "getPaginationRowModel"));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function mp(e, r) {
  return e ? xT(e) ? /* @__PURE__ */ U.createElement(e, r) : e : null;
}
function xT(e) {
  return IT(e) || typeof e == "function" || DT(e);
}
function IT(e) {
  return typeof e == "function" && (() => {
    const r = Object.getPrototypeOf(e);
    return r.prototype && r.prototype.isReactComponent;
  })();
}
function DT(e) {
  return typeof e == "object" && typeof e.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(e.$$typeof.description);
}
function _T(e) {
  const r = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...e
  }, [t] = U.useState(() => ({
    current: yT(r)
  })), [n, o] = U.useState(() => t.current.initialState);
  return t.current.setOptions((a) => ({
    ...a,
    ...e,
    state: {
      ...n,
      ...e.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (i) => {
      o(i), e.onStateChange == null || e.onStateChange(i);
    }
  })), t.current;
}
const Lu = {
  initialConfig: {
    page: 1,
    pageIndex: 0,
    pageSize: 25
  },
  pages: [10, 25, 50, 100]
}, kT = (e, r) => {
  if (r <= 7) {
    const t = [];
    for (let n = 0; n < r; n++)
      t.push(n);
    return t;
  } else
    return e <= 3 ? [0, 1, 2, 3, 4, "...", r - 1] : e <= r - 1 && e >= r - 5 ? [0, "...", r - 6, r - 5, r - 4, r - 3, r - 2, r - 1] : [0, "...", e - 2, e - 1, e, e + 1, e + 2, "...", r - 1];
};
function ET({ table: e, pagination: r, setPagination: t, pageCount: n, isDisabled: o, total: a, page: i, page_size: s, setPage: l, setPageSize: u, showPageNumbers: c }) {
  const [d] = xb("(min-width: 1024px)"), f = c ?? d, p = i && s ? i - 1 : r.pageIndex, h = Ve(() => kT(p, n), [p, n]);
  return Ye(() => {
    i !== void 0 && s !== void 0 && (e.setPageIndex(i - 1), e.setPageSize(s));
  }, [i, s, e]), /* @__PURE__ */ K(
    Rt,
    {
      width: "fit-content",
      alignSelf: "end",
      justifyContent: "end",
      my: "1rem",
      gap: "0.7rem",
      children: [
        /* @__PURE__ */ S(
          Pt,
          {
            isDisabled: o || i === 1,
            onClick: () => {
              l && u ? l(1) : e.firstPage();
            },
            disabled: !e.getCanPreviousPage(),
            children: "<<"
          }
        ),
        /* @__PURE__ */ S(
          Pt,
          {
            isDisabled: o || i === 1,
            onClick: () => {
              l && u && i ? l(i - 1) : e.previousPage();
            },
            disabled: !e.getCanPreviousPage(),
            children: "<"
          }
        ),
        f ? h.map((g, m) => g === "..." ? /* @__PURE__ */ S(
          gt,
          {
            alignSelf: "center",
            mx: "2",
            children: "..."
          },
          `ellipsis-${m}`
        ) : /* @__PURE__ */ S(
          Pt,
          {
            id: `paginatorPage-${g}`,
            isDisabled: o,
            bg: p === g ? j.tertiary[3] : "initial",
            onClick: () => {
              l && u ? l(g + 1) : e.setPageIndex(g);
            },
            children: g + 1
          },
          `page-${g}`
        )) : null,
        /* @__PURE__ */ S(
          Pt,
          {
            id: "paginatorNextPage",
            isDisabled: o || n === i,
            onClick: () => {
              l && u && i ? l(i + 1) : e.nextPage();
            },
            disabled: !e.getCanNextPage(),
            children: ">"
          }
        ),
        /* @__PURE__ */ S(
          Pt,
          {
            isDisabled: o || n === i,
            onClick: () => {
              l && u ? l(Math.ceil(a / r.pageSize)) : e.lastPage();
            },
            disabled: !e.getCanNextPage(),
            children: ">>"
          }
        ),
        /* @__PURE__ */ K(Po, { children: [
          /* @__PURE__ */ S(
            Ro,
            {
              isDisabled: o,
              shadow: "base",
              as: Pt,
              rightIcon: /* @__PURE__ */ S(Va, {}),
              children: r.pageSize
            }
          ),
          /* @__PURE__ */ S(
            Oo,
            {
              onClick: (g) => {
                const m = g.target;
                m.value && (l && u ? (l(1), u(Number(m.value))) : (e.setPageSize(Number(m.value)), e.firstPage()));
              },
              children: Lu.pages.map((g, m) => /* @__PURE__ */ S(
                To,
                {
                  value: g,
                  children: g
                },
                `${g}-${m}`
              ))
            }
          )
        ] })
      ]
    }
  );
}
var MT = /* @__PURE__ */ ((e) => (e.ASC = "ASC", e.DESC = "DESC", e))(MT || {});
const vp = {
  fontSize: {
    badge: { base: "0.55rem", lg: "0.65rem" },
    tag: { base: "0.6rem", lg: "0.75rem" },
    text: { base: "0.65rem", lg: "0.8rem" },
    button: { base: "0.7rem", lg: "0.8rem" },
    icon: { base: "0.8rem", lg: "0.9rem" }
  },
  size: {
    badge: "sm",
    tag: "sm",
    button: "sm",
    spinner: "xs"
  },
  fontWeight: {
    normal: 600,
    bold: 700
  },
  gap: {
    small: ".3rem",
    medium: "1rem"
  },
  padding: {
    button: "0.3rem",
    buttonWithText: "0.3rem 0.5rem",
    iconOnlyButton: "0.3rem 0.6rem"
  }
};
function lF({ id: e, data: r, total: t, page: n, page_size: o, setPage: a, setPageSize: i, columns: s, isLoading: l = !1, isFetching: u = !1, noDataDisclaimer: c, sort_by: d, sort_type: f, setSortBy: p, setSortType: h, enableRowSelection: g, rowSelection: m, onRowSelectionChange: v, getRowId: y, paginationType: C = "API", enableColumnResizing: I = !1, columnResizeMode: b = "onChange" }) {
  const [D, x] = Se({
    pageIndex: Lu.initialConfig.pageIndex,
    pageSize: Lu.initialConfig.pageSize
  }), _ = Ve(() => Math.ceil((t || r.length) / D.pageSize), [t, r, D]);
  Ye(() => {
    n && o && C == "API" ? x({
      pageIndex: 0,
      pageSize: o
    }) : n && o && x({
      pageIndex: n - 1,
      pageSize: o
    });
  }, [n, o]);
  const E = _T({
    columns: s,
    data: r,
    pageCount: _,
    getCoreRowModel: wT(),
    getPaginationRowModel: ST(),
    onPaginationChange: x,
    autoResetAll: !1,
    paginateExpandedRows: !1,
    enableRowSelection: g,
    onRowSelectionChange: v,
    getRowId: y,
    enableColumnResizing: I,
    columnResizeMode: b,
    state: {
      pagination: D,
      rowSelection: m || {}
    }
  }), R = ye(null), L = /* @__PURE__ */ S(
    Ib,
    {
      alignContent: "start",
      placeContent: "start",
      justifyContent: "start",
      rowGap: "1rem",
      children: l ? [...Array(D.pageSize).keys()].map((G, V) => /* @__PURE__ */ K(
        fl,
        {
          maxW: "100vw",
          transition: ".2s ease-in",
          _hover: { backgroundColor: j.neutro[1] },
          children: [
            g && /* @__PURE__ */ S(
              li,
              {
                padding: "1rem 0.4rem",
                width: "40px",
                children: /* @__PURE__ */ S(
                  Ca,
                  {
                    height: "20px",
                    width: "20px"
                  }
                )
              }
            ),
            [...Array(s.length).keys()].map((O, N) => /* @__PURE__ */ S(
              li,
              {
                fontSize: vp.fontSize.text,
                textAlign: "left",
                paddingY: "1rem",
                paddingX: "0.4rem",
                overflow: "hidden",
                flexWrap: "wrap",
                children: /* @__PURE__ */ S(Ca, { height: "25px" })
              },
              `${O}-${N}`
            ))
          ]
        },
        `${G}-${V}`
      )) : E.getRowModel().rows.map((G) => /* @__PURE__ */ K(
        fl,
        {
          maxW: "100vw",
          ref: R,
          transition: ".2s ease-in",
          _hover: { backgroundColor: j.neutro[1] },
          children: [
            g && /* @__PURE__ */ S(
              li,
              {
                padding: "1rem 0.4rem",
                width: "40px",
                children: /* @__PURE__ */ S(
                  Kc,
                  {
                    isChecked: G.getIsSelected(),
                    isDisabled: !G.getCanSelect(),
                    onChange: G.getToggleSelectedHandler()
                  }
                )
              }
            ),
            G.getVisibleCells().map((V) => {
              const O = V.column.columnDef.meta;
              return /* @__PURE__ */ S(
                li,
                {
                  isNumeric: O == null ? void 0 : O.isNumeric,
                  fontSize: vp.fontSize.text,
                  textAlign: "left",
                  padding: "1rem 0.4rem",
                  overflow: "hidden",
                  flexWrap: "wrap",
                  width: I ? `${V.column.getSize() / E.getCenterTotalSize() * 100}%` : void 0,
                  children: l ? /* @__PURE__ */ S(Ca, { height: "25px" }) : mp(V.column.columnDef.cell, V.getContext())
                },
                V.id
              );
            })
          ]
        },
        G.id
      ))
    }
  );
  return /* @__PURE__ */ K(
    Rt,
    {
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: !r.length && c ? 0 : {
        base: "",
        md: "500px",
        lg: "600px"
      },
      overflowX: "auto",
      maxW: "100%",
      children: [
        /* @__PURE__ */ K(
          Db,
          {
            id: e,
            children: [
              /* @__PURE__ */ S(_b, { children: E.getHeaderGroups().map((G) => /* @__PURE__ */ K(fl, { children: [
                g && /* @__PURE__ */ S(ed, { padding: "1rem 0.4rem", children: /* @__PURE__ */ S(
                  Kc,
                  {
                    isChecked: E.getIsAllRowsSelected(),
                    isIndeterminate: E.getIsSomeRowsSelected(),
                    onChange: E.getToggleAllRowsSelectedHandler()
                  }
                ) }),
                G.headers.map((V) => {
                  const O = V.column.columnDef.meta;
                  return /* @__PURE__ */ K(
                    ed,
                    {
                      userSelect: "none",
                      fontSize: { base: ".7rem" },
                      textAlign: "left",
                      _hover: { backgroundColor: j.neutro[1] },
                      isNumeric: O == null ? void 0 : O.isNumeric,
                      padding: "1rem 0.4rem",
                      position: I ? "relative" : void 0,
                      width: I ? `${V.getSize() / E.getCenterTotalSize() * 100}%` : void 0,
                      cursor: p && h && V.column.id !== "actions" ? "pointer" : "initial",
                      onClick: () => {
                        V.column.id !== "actions" && p && h && (d === V.column.id ? f === "DESC" ? h(
                          "ASC"
                          /* ASC */
                        ) : (h(null), p("")) : (h(
                          "DESC"
                          /* DESC */
                        ), p(V.column.id)));
                      },
                      children: [
                        mp(V.column.columnDef.header, V.getContext()),
                        /* @__PURE__ */ S(td.span, { pl: "4", children: d === V.column.id ? f === "DESC" ? /* @__PURE__ */ S(JI, { "aria-label": "sorted descending" }) : /* @__PURE__ */ S(QI, { "aria-label": "sorted ascending" }) : null }),
                        I && V.column.getCanResize() && /* @__PURE__ */ S(
                          td.div,
                          {
                            onMouseDown: V.getResizeHandler(),
                            onTouchStart: V.getResizeHandler(),
                            position: "absolute",
                            right: "0",
                            top: "0",
                            height: "100%",
                            width: "4px",
                            cursor: "col-resize",
                            userSelect: "none",
                            bg: V.column.getIsResizing() ? "blue.400" : "transparent",
                            _hover: { bg: "blue.300" },
                            onClick: (N) => N.stopPropagation()
                          }
                        )
                      ]
                    },
                    V.id
                  );
                })
              ] }, G.id)) }),
              L
            ]
          }
        ),
        !u && !l && !r.length && c ? c : null,
        /* @__PURE__ */ S(
          ET,
          {
            total: t,
            page: n,
            page_size: o,
            setPage: a,
            setPageSize: i,
            isDisabled: r.length ? l : !0,
            pageCount: _,
            setPagination: x,
            pagination: D,
            table: E
          }
        )
      ]
    }
  );
}
const AT = Vr(({ children: e, ...r }) => /* @__PURE__ */ S(
  je,
  {
    as: "span",
    display: "inline",
    fontWeight: 600,
    color: j.tertiary[1],
    sx: {
      "& a": {
        color: "inherit",
        textDecoration: "none",
        "&:hover": {
          textDecoration: "underline"
        }
      }
    },
    ...r,
    children: e
  }
));
AT.displayName = "Link";
const PT = ot(({ children: e, label: r, menuProps: t, menuListProps: n, icon: o, hideIcon: a = !1, ...i }, s) => /* @__PURE__ */ K(Po, { ...t, children: [
  /* @__PURE__ */ S(
    Ro,
    {
      as: Hi,
      ref: s,
      rightIcon: a ? void 0 : o ?? /* @__PURE__ */ S(KI, {}),
      ...i,
      children: r
    }
  ),
  /* @__PURE__ */ S(
    Oo,
    {
      zIndex: 1500,
      ...n,
      children: e
    }
  )
] }));
PT.displayName = "MenuButton";
const RT = ot((e, r) => /* @__PURE__ */ S(
  To,
  {
    ref: r,
    ...e
  }
));
RT.displayName = "MenuItem";
const OT = Vr(({ previewType: e, previewUrl: r, button: t }) => {
  const n = kb();
  return !e || !r ? t(n, !e || !r) : /* @__PURE__ */ K(Wu, { children: [
    t(n, !e || !r),
    /* @__PURE__ */ K(
      Ip,
      {
        isOpen: n.isOpen,
        onClose: n.onClose,
        isCentered: !0,
        size: "full",
        closeOnOverlayClick: !0,
        children: [
          /* @__PURE__ */ S(
            Dp,
            {
              bg: "blackAlpha.600",
              backdropFilter: "blur(10px)"
            }
          ),
          /* @__PURE__ */ K(
            _p,
            {
              bg: "transparent",
              boxShadow: "none",
              w: e === "image" ? "fit-content" : "85vw",
              h: "95vh",
              m: "auto",
              borderRadius: 0,
              children: [
                /* @__PURE__ */ S(
                  kp,
                  {
                    color: "white",
                    bg: "blackAlpha.600",
                    _hover: { bg: "blackAlpha.800" },
                    zIndex: 1,
                    size: "lg",
                    top: 4,
                    right: -8
                  }
                ),
                /* @__PURE__ */ S(
                  Ep,
                  {
                    p: 4,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "100%",
                    height: "100%",
                    children: e === "image" ? /* @__PURE__ */ S(
                      Eb,
                      {
                        src: r,
                        alt: "Vista previa del gasto",
                        maxW: "100%",
                        maxH: "100%",
                        objectFit: "contain"
                      }
                    ) : /* @__PURE__ */ S(
                      "iframe",
                      {
                        src: r,
                        title: "Vista previa del PDF",
                        width: "100%",
                        height: "100%",
                        style: {
                          border: "none",
                          backgroundColor: "white",
                          borderRadius: "8px"
                        }
                      }
                    )
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
});
OT.displayName = "PreviewModalComponent";
const TT = {
  sm: {
    height: "4px"
  },
  md: {
    height: "8px"
  },
  lg: {
    height: "12px"
  }
}, FT = Mp`
  0% {
    left: -35%;
    right: 100%;
  }
  60% {
    left: 100%;
    right: -90%;
  }
  100% {
    left: 100%;
    right: -90%;
  }
`, NT = Mp`
  0% {
    left: -200%;
    right: 100%;
  }
  60% {
    left: 107%;
    right: -8%;
  }
  100% {
    left: 107%;
    right: -8%;
  }
`, LT = (e) => {
  switch (e) {
    case "success":
      return j.primary[2];
    case "warning":
      return j.orange[1];
    case "danger":
      return j.error[1];
    case "tertiary":
      return j.tertiary[1];
    case "gradient":
      return `linear-gradient(90deg, ${j.primary[2]} 0%, ${j.tertiary[1]} 100%)`;
    case "default":
    default:
      return j.primary[2];
  }
}, WT = Vr(
  ot(({ variant: e = "default", size: r = "sm", isIndeterminate: t = !0, ...n }, o) => {
    const a = LT(e), i = TT[r], s = e === "gradient";
    return /* @__PURE__ */ S(
      je,
      {
        ref: o,
        position: "relative",
        width: "100%",
        height: i.height,
        bg: j.neutro[3],
        borderRadius: "full",
        overflow: "hidden",
        ...n,
        children: t && /* @__PURE__ */ K(Wu, { children: [
          /* @__PURE__ */ S(
            je,
            {
              position: "absolute",
              top: 0,
              height: "100%",
              bg: s ? void 0 : a,
              bgGradient: s ? a : void 0,
              borderRadius: "full",
              animation: `${FT} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`,
              willChange: "left, right"
            }
          ),
          /* @__PURE__ */ S(
            je,
            {
              position: "absolute",
              top: 0,
              height: "100%",
              bg: s ? void 0 : a,
              bgGradient: s ? a : void 0,
              borderRadius: "full",
              animation: `${NT} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`,
              willChange: "left, right"
            }
          )
        ] })
      }
    );
  })
);
WT.displayName = "LinearLoader";
const BT = Vr(({ children: e, title: r, isLoading: t }) => /* @__PURE__ */ S(
  Rt,
  {
    display: "flex",
    boxSize: "full",
    bg: "#F9FAFB",
    alignItems: "center",
    justifyContent: "center",
    shadow: "md",
    my: "1rem",
    children: /* @__PURE__ */ S(
      je,
      {
        mx: "auto",
        textAlign: {
          base: "left",
          md: "center"
        },
        rounded: "md",
        shadow: "base",
        w: "full",
        children: /* @__PURE__ */ S(je, { children: /* @__PURE__ */ S(
          xp,
          {
            gap: "24px",
            rounded: "md",
            textAlign: "left",
            children: /* @__PURE__ */ S(
              je,
              {
                bg: "white",
                _dark: {
                  bg: "gray.800"
                },
                pt: 10,
                rounded: "md",
                children: /* @__PURE__ */ K(Rt, { direction: "column", children: [
                  /* @__PURE__ */ S(
                    je,
                    {
                      px: 10,
                      pb: 5,
                      children: /* @__PURE__ */ S(Ca, { isLoaded: !t, children: /* @__PURE__ */ S(
                        gt,
                        {
                          mb: 2,
                          fontSize: "3xl",
                          fontWeight: ["bold", "extrabold"],
                          color: "gray.900",
                          _dark: {
                            color: "gray.50"
                          },
                          lineHeight: "tight",
                          children: r
                        }
                      ) })
                    }
                  ),
                  /* @__PURE__ */ S(
                    je,
                    {
                      px: 10,
                      pt: 5,
                      pb: "1.5rem",
                      bg: "gray.50",
                      _dark: {
                        bg: "gray.900"
                      },
                      children: /* @__PURE__ */ S(Ca, { isLoaded: !t, children: e })
                    }
                  )
                ] })
              }
            )
          }
        ) })
      }
    )
  }
));
BT.displayName = "ProfileDisplayer";
const VT = Vr(
  ot(({ children: e, ...r }, t) => /* @__PURE__ */ S(
    Mb,
    {
      ref: t,
      fontWeight: "semibold",
      fontSize: "0.9rem",
      px: 6,
      py: 2,
      color: "gray.600",
      bg: "transparent",
      borderTop: "none",
      borderLeft: "none",
      borderRight: "none",
      _selected: {
        color: j.secondary[1],
        borderColor: j.secondary[2],
        borderBottom: "2.5px solid",
        borderBottomColor: j.secondary[2],
        borderTop: "none",
        borderLeft: "none",
        borderRight: "none",
        fontWeight: "bold",
        bg: "transparent"
      },
      _hover: {
        color: j.secondary[1],
        bg: "transparent"
      },
      ...r,
      children: e
    }
  ))
);
VT.displayName = "StyledTab";
const GT = Vr(({ children: e, ...r }) => /* @__PURE__ */ S(
  gt,
  {
    as: "h2",
    fontSize: {
      base: "1.5rem",
      md: "1.9rem"
    },
    textAlign: {
      base: "center",
      md: "start"
    },
    fontWeight: 600,
    mb: "0.5rem",
    ...r,
    children: e
  }
));
GT.displayName = "Title";
const uF = ({ children: e, theme: r = Pb, texts: t, ...n }) => /* @__PURE__ */ S(
  Ab,
  {
    theme: r,
    ...n,
    children: /* @__PURE__ */ S(eD, { texts: t, children: e })
  }
);
export {
  eF as AsyncSelectField,
  Hi as Button,
  k2 as Card,
  P2 as CardContent,
  A2 as CardDescription,
  R2 as CardFooter,
  E2 as CardHeader,
  M2 as CardTitle,
  O2 as ConfirmDialog,
  T2 as CopyToClipboardButton,
  QT as CurrencyField,
  Zm as DATE_PICKER_PORTAL_ID,
  lF as DataTable,
  dp as DateField,
  oF as DateRangeField,
  nF as DateRangePicker,
  aF as ExpenseFileInput,
  tF as FileField,
  iF as FileUploadArea,
  Nb as IconButton,
  WT as LinearLoader,
  AT as Link,
  PT as MenuButton,
  RT as MenuItem,
  sF as MultipleTypeField,
  Lu as PAGINATION_CONFIG,
  ET as Paginator,
  rF as PhoneField,
  OT as PreviewModalComponent,
  BT as ProfileDisplayer,
  KT as SelectField,
  MT as SortType,
  VT as StyledTab,
  wa as Text,
  JT as TextField,
  GT as Title,
  ng as TooltipInfo,
  uF as ZummaProvider,
  eD as ZummaTextsProvider,
  Dr as buttonStyles,
  j as colors,
  ht as datePickerHeaderStyles,
  og as defaultZummaTexts,
  nr as field,
  Xe as fontSize,
  io as fontWeight,
  Yt as formColors,
  fF as inputContainerHeight,
  tr as inputHeight,
  pF as inputPadding,
  ao as inputWidth,
  hF as padding,
  dn as requiredAsteriskColor,
  Is as rounded,
  gF as specialBoxStyles,
  vp as tableStyles,
  Zo as useZummaTexts,
  Pb as zummaTheme
};
